import { defineComponent as ue, ref as q, computed as O, watch as be, nextTick as mr, openBlock as E, createBlock as K, Teleport as ko, createVNode as ve, Transition as yr, withCtx as fe, createElementBlock as I, withModifiers as Oo, createElementVNode as R, normalizeClass as X, normalizeStyle as it, renderSlot as we, createCommentVNode as B, resolveDynamicComponent as Co, Fragment as Ae, renderList as Re, toDisplayString as _e, TransitionGroup as pv, withDirectives as ze, vShow as zc, onMounted as It, onUnmounted as Nr, unref as w, toValue as Pe, getCurrentInstance as Lr, provide as wn, isRef as Xe, onBeforeUnmount as vv, inject as En, reactive as Tn, resolveDirective as So, mergeModels as Ne, useModel as Be, normalizeProps as he, guardReactiveProps as ct, mergeProps as ie, vModelDynamic as hv, vModelText as Dn, toRefs as mv, watchEffect as Uc, withKeys as Ps, toRef as xa, createTextVNode as Br, resolveComponent as rr, toHandlers as gv, vModelCheckbox as Hc, vModelSelect as yv, vModelRadio as bv, h as Xr, shallowRef as _v, isReactive as xs, isVNode as wv, createApp as Ls } from "vue";
const Wc = () => {
  const e = document.querySelector("html"), t = e.getAttribute("scroll-disabled") === "true";
  e.style.overflow = t ? "" : "clip", e.setAttribute("scroll-disabled", `${!t}`);
}, Ev = { class: "modal-header-wrapper" }, Tv = { class: "modal-body" }, Dv = {
  key: 0,
  class: "modal-footer"
}, $v = /* @__PURE__ */ ue({
  __name: "Modal",
  props: {
    maxWidth: {},
    closeEnabled: { type: Boolean, default: !0 },
    forceMobileFull: { type: Boolean }
  },
  emits: ["modal:open", "modal:close"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = q(!1), i = q(!1), o = q(), s = O(() => {
      var p, d, m;
      return {
        "--md-max-width": (p = n.maxWidth) == null ? void 0 : p.md,
        "--lg-max-width": (d = n.maxWidth) == null ? void 0 : d.lg,
        "--xl-max-width": (m = n.maxWidth) == null ? void 0 : m.xl
      };
    }), l = r;
    be(() => a.value, Wc);
    const u = () => {
      a.value = !0, l("modal:open");
    }, c = () => {
      a.value = !1, l("modal:close");
    }, f = () => {
      a.value = !a.value, l(`modal:${a.value ? "open" : "close"}`);
    };
    return be(a, () => {
      mr(() => {
        i.value = a.value ? n.forceMobileFull || o.value.clientHeight >= window.innerHeight * 0.75 : !1;
      });
    }), t({ active: a, openModal: u, closeModal: c, toggleModal: f }), (p, d) => (E(), K(ko, { to: "body" }, [
      ve(yr, { name: "modal" }, {
        default: fe(() => [
          a.value ? (E(), I("div", {
            key: 0,
            class: "modal-backdrop",
            onClick: d[0] || (d[0] = Oo((m) => p.closeEnabled && c(), ["self"]))
          }, [
            R("div", {
              ref_key: "modalContainer",
              ref: o,
              class: X(["modal-container", [
                p.$attrs.class,
                {
                  "mobile-full": i.value
                }
              ]]),
              style: it({ ...s.value })
            }, [
              R("div", {
                class: X(["modal-header", { "has-title": p.$slots.header }])
              }, [
                R("div", Ev, [
                  we(p.$slots, "header", {}, void 0, !0)
                ]),
                p.closeEnabled ? (E(), I("button", {
                  key: 0,
                  type: "button",
                  class: "btn-close m-cgg-icon--cross",
                  "aria-label": "Fechar",
                  onClick: c
                })) : B("", !0)
              ], 2),
              R("div", Tv, [
                we(p.$slots, "body", {}, void 0, !0)
              ]),
              p.$slots.footer ? (E(), I("div", Dv, [
                we(p.$slots, "footer", {}, void 0, !0)
              ])) : B("", !0)
            ], 6)
          ])) : B("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
const ye = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
}, kv = /* @__PURE__ */ ye($v, [["__scopeId", "data-v-57ee6a95"]]), Ov = /* @__PURE__ */ ue({
  __name: "Drawer",
  props: {
    defaultActive: { type: Boolean, default: !1 },
    type: { default: "vertical-bottom" },
    maxWidth: { default: () => ({
      md: "min(calc(100% - 48px), 768px)",
      lg: "min(calc(100% - 48px), 1024px)",
      xl: "1024px"
    }) },
    position: {},
    height: {},
    backdrop: { type: Boolean, default: !1 },
    disableDocumentScroll: { type: Boolean },
    overlapMenu: { type: Boolean }
  },
  emits: ["close", "open"],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = O(() => ({
      "--md-max-width": n.maxWidth.md,
      "--lg-max-width": n.maxWidth.lg,
      "--xl-max-width": n.maxWidth.xl
    })), i = q(n.defaultActive), o = r, s = () => {
      i.value = !0, o("open");
    }, l = () => {
      i.value = !1, o("close");
    };
    return t({ active: i, openDrawer: s, closeDrawer: l, toggleDrawer: () => {
      i.value = !i.value, o(i.value ? "open" : "close");
    } }), be(i, () => {
      n.disableDocumentScroll && Wc();
    }), (c, f) => (E(), K(ko, { to: "body" }, [
      ve(yr, { name: "fade" }, {
        default: fe(() => [
          c.backdrop && i.value ? (E(), I("div", {
            key: 0,
            class: X(["drawer-backdrop", { "overlap-menu": c.overlapMenu }]),
            onClick: l
          }, null, 2)) : B("", !0)
        ]),
        _: 1
      }),
      ve(yr, { name: "slide" }, {
        default: fe(() => [
          i.value ? (E(), I("div", {
            key: 0,
            class: X(["drawer-container", [
              `drawer-${c.type}`,
              { active: i.value, "overlap-menu": c.overlapMenu }
            ]]),
            style: it({ height: c.height, ...c.position, ...a.value })
          }, [
            we(c.$slots, "default", {}, void 0, !0)
          ], 6)) : B("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
const Cv = /* @__PURE__ */ ye(Ov, [["__scopeId", "data-v-4cd40511"]]), Sv = {
  key: 0,
  class: "spinner"
}, Av = {
  key: 1,
  class: "text-wrapper"
}, Mv = {
  key: 1,
  class: "text"
}, Iv = /* @__PURE__ */ ue({
  __name: "CjaButton",
  props: {
    type: { default: "primary" },
    color: { default: "blue" },
    textAlign: { default: "center" },
    size: { default: "md" },
    shadow: { type: Boolean },
    iconRight: {},
    iconLeft: {},
    iconOnly: { type: Boolean },
    loading: { type: Boolean },
    href: {},
    to: {},
    target: {},
    altAnchor: {}
  },
  setup(e) {
    return (t, r) => (E(), K(Co(t.href || t.to ? t.altAnchor || "a" : "button"), {
      class: X(["cja-btn", [
        `btn-${t.type}`,
        `btn-size-${t.size}`,
        `btn-color-${t.color}`,
        `btn-align-${t.textAlign}`,
        { "btn-loading": t.loading, "btn-shadow": t.shadow, "icon-only": t.iconOnly }
      ]]),
      href: t.href || t.to,
      target: t.target
    }, {
      default: fe(() => [
        ve(yr, {
          name: "fade",
          mode: "out-in"
        }, {
          default: fe(() => [
            t.loading ? (E(), I("div", Sv)) : (E(), I("div", Av, [
              t.iconLeft ? (E(), I("span", {
                key: 0,
                class: X(t.iconLeft)
              }, null, 2)) : B("", !0),
              t.iconOnly ? B("", !0) : (E(), I("span", Mv, [
                we(t.$slots, "default", {}, void 0, !0)
              ])),
              t.iconRight ? (E(), I("span", {
                key: 2,
                class: X(t.iconRight)
              }, null, 2)) : B("", !0)
            ]))
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["href", "target", "class"]));
  }
});
const Pv = /* @__PURE__ */ ye(Iv, [["__scopeId", "data-v-9cc47a60"]]), xv = /* @__PURE__ */ ue({
  __name: "LoadingSpinner",
  props: {
    size: { default: 80 },
    border: { default: 7 }
  },
  setup(e) {
    return (t, r) => (E(), I("div", {
      class: "spinner",
      style: it({
        width: `${t.size}px`,
        height: `${t.size}px`,
        borderWidth: `${t.border}px`
      })
    }, null, 4));
  }
});
const Lv = /* @__PURE__ */ ye(xv, [["__scopeId", "data-v-926de719"]]), Rv = { class: "content-tabs" }, Fv = { class: "control-container" }, Vv = ["onClick"], Nv = { class: "content-container" }, Bv = /* @__PURE__ */ ue({
  __name: "ContentTabs",
  props: {
    defaultTab: {},
    tabs: {}
  },
  emits: ["tab:changed"],
  setup(e, { expose: t }) {
    const n = q(e.defaultTab);
    return t({ activeTab: n }), (a, i) => (E(), I("div", Rv, [
      R("div", Fv, [
        (E(!0), I(Ae, null, Re(a.tabs, (o, s) => (E(), I("button", {
          key: s,
          class: X({ active: n.value == s }),
          onClick: (l) => {
            n.value = s, a.$emit("tab:changed", s);
          }
        }, _e(o), 11, Vv))), 128))
      ]),
      R("div", Nv, [
        ve(pv, { name: "fade" }, {
          default: fe(() => [
            (E(!0), I(Ae, null, Re(a.tabs, (o, s) => ze((E(), I("div", {
              key: s,
              class: X(`tab-${s}`)
            }, [
              we(a.$slots, s, {}, void 0, !0)
            ], 2)), [
              [zc, n.value == s]
            ])), 128))
          ]),
          _: 3
        })
      ])
    ]));
  }
});
const Yv = /* @__PURE__ */ ye(Bv, [["__scopeId", "data-v-71b2a607"]]), jv = { class: "text-container" }, zv = {
  key: 0,
  class: "title"
}, Uv = {
  key: 1,
  class: "description"
}, Hv = {
  key: 0,
  class: "btn-container"
}, Wv = /* @__PURE__ */ ue({
  __name: "InfoMessage",
  props: {
    toggle: { type: Boolean },
    color: {},
    border: { type: Boolean, default: !0 }
  },
  emits: ["btn:close"],
  setup(e) {
    const t = q(!0);
    return (r, n) => t.value && r.toggle || !r.toggle ? (E(), I("div", {
      key: 0,
      class: X(["info-message", [
        `color-${r.color}`,
        { "has-icon": r.$slots.icon, "has-toggle": r.toggle, "has-border": r.border }
      ]])
    }, [
      we(r.$slots, "icon", {}, void 0, !0),
      R("div", jv, [
        r.$slots.title ? (E(), I("div", zv, [
          we(r.$slots, "title", {}, void 0, !0)
        ])) : B("", !0),
        r.$slots.description ? (E(), I("div", Uv, [
          we(r.$slots, "description", {}, void 0, !0)
        ])) : B("", !0)
      ]),
      r.toggle ? (E(), I("div", Hv, [
        R("button", {
          class: "m-cgg-icon--cross",
          onClick: n[0] || (n[0] = (a) => {
            t.value = !1, r.$emit("btn:close");
          }),
          "aria-label": "Fechar"
        })
      ])) : B("", !0)
    ], 2)) : B("", !0);
  }
});
const qv = /* @__PURE__ */ ye(Wv, [["__scopeId", "data-v-5d945bfc"]]), Kv = {};
function Gv(e, t) {
  return we(e.$slots, "default");
}
const si = /* @__PURE__ */ ye(Kv, [["render", Gv]]);
const Zv = {}, Xv = { class: "grid-container" };
function Jv(e, t) {
  return E(), I("div", Xv, [
    we(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Qv = /* @__PURE__ */ ye(Zv, [["render", Jv], ["__scopeId", "data-v-305677d8"]]), eh = /* @__PURE__ */ ue({
  __name: "GridItem",
  props: {
    sizeSm: { default: 4 },
    offsetSm: {},
    sizeMd: { default: 4 },
    offsetMd: {},
    sizeLg: { default: 12 },
    offsetLg: {},
    sizeXl: { default: 12 },
    offsetXl: {}
  },
  setup(e) {
    return (t, r) => (E(), I("div", {
      class: X({
        [`grid-item-sm-${t.sizeSm}`]: t.sizeSm,
        [`grid-item-sm-offset-${t.offsetSm}`]: t.offsetSm,
        [`grid-item-md-${t.sizeMd}`]: t.sizeMd,
        [`grid-item-md-offset-${t.offsetMd}`]: t.offsetMd,
        [`grid-item-lg-${t.sizeLg}`]: t.sizeLg,
        [`grid-item-lg-offset-${t.offsetLg}`]: t.offsetLg,
        [`grid-item-xl-${t.sizeXl}`]: t.sizeXl,
        [`grid-item-xl-offset-${t.offsetXl}`]: t.offsetXl
      })
    }, [
      we(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const th = /* @__PURE__ */ ye(eh, [["__scopeId", "data-v-81f79d81"]]), rh = { class: "header-wrapper" }, nh = /* @__PURE__ */ ue({
  __name: "CollapseContainer",
  props: {
    active: { type: Boolean, default: !1 },
    scrollToContent: {}
  },
  emits: [
    "toggle:collapse",
    "open:collapse",
    "close:collapse"
  ],
  setup(e, { expose: t, emit: r }) {
    const n = e, a = q(n.active), i = q(), o = q(), s = r, l = () => {
      a.value = !a.value, s("toggle:collapse", a.value);
    }, u = () => {
      a.value = !0, s("open:collapse");
    }, c = () => {
      a.value = !1, s("close:collapse");
    }, f = () => {
      i.value.style.height = "0", requestAnimationFrame(() => {
        i.value && o.value && (i.value.style.height = `${o.value.clientHeight}px`, setTimeout(() => {
          i.value.style.height = "";
        }, 200), a.value && n.scrollToContent && setTimeout(() => {
          var d;
          (d = n.scrollToContent) == null || d.element.scrollTo({
            top: o.value.offsetTop,
            left: 0,
            behavior: "smooth"
          });
        }, 250));
      });
    }, p = () => {
      i.value.style.height = `${o.value.clientHeight}px`, requestAnimationFrame(() => {
        i.value.style.height = "0";
      });
    };
    return t({ toggleCollapse: l, openCollapse: u, closeCollapse: c }), (d, m) => (E(), I("div", {
      class: X(["collapse-container", { active: a.value }])
    }, [
      R("div", {
        class: "collapse-header",
        onClick: l
      }, [
        R("div", rh, [
          we(d.$slots, "header", {}, void 0, !0)
        ]),
        m[0] || (m[0] = R("span", { class: "m-cgg-icon--chevron-down" }, null, -1))
      ]),
      ve(yr, {
        name: "slide",
        onEnter: f,
        onLeave: p
      }, {
        default: fe(() => [
          ze(R("div", {
            ref_key: "contentContainer",
            ref: i,
            class: "content-container"
          }, [
            R("div", {
              ref_key: "contentWrapper",
              ref: o,
              class: "content-wrapper"
            }, [
              we(d.$slots, "content", {}, void 0, !0)
            ], 512)
          ], 512), [
            [zc, a.value]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
});
const ah = /* @__PURE__ */ ye(nh, [["__scopeId", "data-v-bb0def8c"]]), ih = /* @__PURE__ */ ue({
  __name: "FixedContainer",
  props: {
    active: { type: Boolean, default: !0 },
    scrollThreshold: { default: 0 },
    scrollLimitEl: {},
    fixWidth: { type: Boolean, default: !0 },
    size: {},
    position: {}
  },
  setup(e, { expose: t }) {
    const r = e, n = q(!1), a = q(), i = q(""), o = q(), s = q(""), l = q(), u = () => {
      if (r.scrollLimitEl) {
        const p = r.scrollLimitEl.offsetTop + r.scrollLimitEl.clientHeight - o.value.clientHeight + r.scrollThreshold;
        window.scrollY >= p ? l.value = `translateY(${p - window.scrollY}px)` : l.value = null;
      }
    }, c = () => {
      if (a.value && r.active) {
        n.value = window.scrollY > a.value.offsetTop + r.scrollThreshold;
        const p = o.value.clientHeight;
        i.value = n.value ? `${p}px` : "", u();
      } else
        n.value = !1, i.value = "";
    }, f = () => {
      s.value = r.active && a.value ? `${a.value.offsetWidth}px` : "";
    };
    return be(
      () => r.active,
      () => {
        r.fixWidth && f();
      }
    ), It(() => {
      window.addEventListener("scroll", c), c(), r.fixWidth && (window.addEventListener("resize", f), f());
    }), Nr(() => {
      window.removeEventListener("scroll", c), window.removeEventListener("resize", f);
    }), t({ positionFixed: n }), (p, d) => p.active ? (E(), I("div", {
      key: 0,
      class: "fixed-container",
      style: it({ height: i.value }),
      ref_key: "fixedContainer",
      ref: a
    }, [
      R("div", {
        class: X(["fixed-wrapper", { "position-fixed": n.value }]),
        style: it({
          ...p.size,
          ...p.position,
          transform: l.value,
          maxWidth: s.value
        }),
        ref_key: "fixedWrapper",
        ref: o
      }, [
        we(p.$slots, "default", {}, void 0, !0)
      ], 6)
    ], 4)) : we(p.$slots, "default", { key: 1 }, void 0, !0);
  }
});
const oh = /* @__PURE__ */ ye(ih, [["__scopeId", "data-v-13a78fcc"]]), Ui = {
  1: 10,
  7: 10,
  20: 10,
  27: 9,
  30: 10,
  31: 9,
  32: 9,
  33: 9,
  34: 9,
  36: 9,
  39: 10,
  40: 10,
  41: 9,
  43: 11,
  44: 10,
  45: 8,
  46: 7,
  47: 8,
  48: 9,
  49: 10,
  51: 9,
  52: 10,
  53: 8,
  54: 8,
  55: 11,
  56: 9,
  57: 10,
  58: 7,
  60: 7,
  61: 9,
  62: 11,
  63: 10,
  64: 9,
  65: 8,
  66: 9,
  81: 11,
  82: 8,
  84: 9,
  86: 11,
  90: 10,
  91: 10,
  92: 10,
  93: 9,
  94: 7,
  95: 10,
  98: 11,
  211: 7,
  212: 9,
  213: 9,
  216: 8,
  218: 10,
  220: 7,
  221: 9,
  222: 8,
  223: 8,
  224: 9,
  225: 8,
  226: 8,
  227: 8,
  228: 8,
  229: 8,
  230: 8,
  231: 9,
  232: 8,
  233: 9,
  234: 8,
  235: 6,
  236: 8,
  237: 9,
  238: 7,
  239: 7,
  240: 9,
  241: 7,
  242: 9,
  243: 7,
  244: 9,
  245: 9,
  246: 7,
  248: 7,
  249: 7,
  250: 9,
  251: 9,
  252: 9,
  253: 10,
  254: 10,
  255: 7,
  256: 7,
  257: 8,
  258: 12,
  260: 9,
  261: 7,
  262: 9,
  263: 9,
  264: 7,
  265: 9,
  266: 8,
  267: 7,
  268: 8,
  269: 7,
  290: 4,
  291: 7,
  297: 7,
  298: 5,
  299: 6,
  350: 8,
  351: 9,
  352: 9,
  353: 9,
  354: 7,
  355: 9,
  356: 8,
  357: 8,
  358: 11,
  359: 9,
  370: 8,
  371: 8,
  372: 8,
  373: 8,
  374: 6,
  375: 9,
  376: 6,
  377: 8,
  378: 10,
  379: 10,
  380: 9,
  381: 9,
  382: 8,
  383: 8,
  385: 9,
  386: 9,
  387: 8,
  389: 8,
  420: 9,
  421: 9,
  423: 7,
  500: 5,
  501: 7,
  502: 8,
  503: 8,
  504: 8,
  505: 8,
  506: 8,
  507: 8,
  508: 6,
  509: 8,
  590: 6,
  591: 9,
  592: 7,
  593: 9,
  594: 9,
  595: 9,
  596: 9,
  597: 7,
  598: 8,
  599: 7,
  670: 7,
  672: 6,
  673: 7,
  674: 7,
  675: 8,
  676: 5,
  677: 7,
  678: 5,
  679: 7,
  680: 7,
  681: 6,
  682: 5,
  683: 4,
  685: 7,
  686: 8,
  687: 6,
  688: 5,
  689: 8,
  690: 5,
  691: 7,
  692: 7,
  850: 13,
  852: 8,
  853: 8,
  855: 9,
  856: 9,
  870: 9,
  880: 10,
  886: 9,
  960: 7,
  961: 8,
  962: 9,
  963: 7,
  964: 10,
  965: 8,
  966: 9,
  967: 9,
  968: 8,
  970: 9,
  971: 9,
  972: 9,
  973: 8,
  974: 8,
  975: 7,
  976: 8,
  977: 10,
  992: 9,
  993: 8,
  994: 9,
  995: 9,
  996: 9,
  998: 9,
  1242: 10,
  1246: 10,
  1264: 10,
  1268: 10,
  1284: 7,
  1340: 10,
  1345: 7,
  1441: 10,
  1473: 10,
  1649: 10,
  1664: 10,
  1670: 7,
  1671: 10,
  1684: 10,
  1721: 10,
  1758: 7,
  1767: 10,
  1784: 7,
  1809: 10,
  1868: 7,
  1869: 10,
  1876: 10
};
function sh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Yr(e) {
  this._maxSize = e, this.clear();
}
Yr.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Yr.prototype.get = function(e) {
  return this._values[e];
};
Yr.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var lh = /[^.^\]^[]+|(?=\[\]|\.\.)/g, qc = /^\d+$/, uh = /^\d/, ch = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, dh = /^\s*(['"]?)(.*?)(\1)\s*$/, Ao = 512, Rs = new Yr(Ao), Fs = new Yr(Ao), Vs = new Yr(Ao), Mr = {
  Cache: Yr,
  split: Hi,
  normalizePath: $i,
  setter: function(e) {
    var t = $i(e);
    return Fs.get(e) || Fs.set(e, function(n, a) {
      for (var i = 0, o = t.length, s = n; i < o - 1; ) {
        var l = t[i];
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return n;
        s = s[t[i++]];
      }
      s[t[i]] = a;
    });
  },
  getter: function(e, t) {
    var r = $i(e);
    return Vs.get(e) || Vs.set(e, function(a) {
      for (var i = 0, o = r.length; i < o; )
        if (a != null || !t)
          a = a[r[i++]];
        else
          return;
      return a;
    });
  },
  join: function(e) {
    return e.reduce(function(t, r) {
      return t + (Mo(r) || qc.test(r) ? "[" + r + "]" : (t ? "." : "") + r);
    }, "");
  },
  forEach: function(e, t, r) {
    fh(Array.isArray(e) ? e : Hi(e), t, r);
  }
};
function $i(e) {
  return Rs.get(e) || Rs.set(
    e,
    Hi(e).map(function(t) {
      return t.replace(dh, "$2");
    })
  );
}
function Hi(e) {
  return e.match(lh) || [""];
}
function fh(e, t, r) {
  var n = e.length, a, i, o, s;
  for (i = 0; i < n; i++)
    a = e[i], a && (hh(a) && (a = '"' + a + '"'), s = Mo(a), o = !s && /^\d+$/.test(a), t.call(r, a, s, o, i, e));
}
function Mo(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function ph(e) {
  return e.match(uh) && !e.match(qc);
}
function vh(e) {
  return ch.test(e);
}
function hh(e) {
  return !Mo(e) && (ph(e) || vh(e));
}
const mh = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, li = (e) => e.match(mh) || [], ui = (e) => e[0].toUpperCase() + e.slice(1), Io = (e, t) => li(e).join(t).toLowerCase(), Kc = (e) => li(e).reduce(
  (t, r) => `${t}${t ? r[0].toUpperCase() + r.slice(1).toLowerCase() : r.toLowerCase()}`,
  ""
), gh = (e) => ui(Kc(e)), yh = (e) => Io(e, "_"), bh = (e) => Io(e, "-"), _h = (e) => ui(Io(e, " ")), wh = (e) => li(e).map(ui).join(" ");
var ki = {
  words: li,
  upperFirst: ui,
  camelCase: Kc,
  pascalCase: gh,
  snakeCase: yh,
  kebabCase: bh,
  sentenceCase: _h,
  titleCase: wh
}, Po = { exports: {} };
Po.exports = function(e) {
  return Gc(Eh(e), e);
};
Po.exports.array = Gc;
function Gc(e, t) {
  var r = e.length, n = new Array(r), a = {}, i = r, o = Th(t), s = Dh(e);
  for (t.forEach(function(u) {
    if (!s.has(u[0]) || !s.has(u[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); i--; )
    a[i] || l(e[i], i, /* @__PURE__ */ new Set());
  return n;
  function l(u, c, f) {
    if (f.has(u)) {
      var p;
      try {
        p = ", node was:" + JSON.stringify(u);
      } catch {
        p = "";
      }
      throw new Error("Cyclic dependency" + p);
    }
    if (!s.has(u))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(u));
    if (!a[c]) {
      a[c] = !0;
      var d = o.get(u) || /* @__PURE__ */ new Set();
      if (d = Array.from(d), c = d.length) {
        f.add(u);
        do {
          var m = d[--c];
          l(m, s.get(m), f);
        } while (c);
        f.delete(u);
      }
      n[--r] = u;
    }
  }
}
function Eh(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, n = e.length; r < n; r++) {
    var a = e[r];
    t.add(a[0]), t.add(a[1]);
  }
  return Array.from(t);
}
function Th(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++) {
    var a = e[r];
    t.has(a[0]) || t.set(a[0], /* @__PURE__ */ new Set()), t.has(a[1]) || t.set(a[1], /* @__PURE__ */ new Set()), t.get(a[0]).add(a[1]);
  }
  return t;
}
function Dh(e) {
  for (var t = /* @__PURE__ */ new Map(), r = 0, n = e.length; r < n; r++)
    t.set(e[r], r);
  return t;
}
var $h = Po.exports;
const kh = /* @__PURE__ */ sh($h), Oh = Object.prototype.toString, Ch = Error.prototype.toString, Sh = RegExp.prototype.toString, Ah = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Mh = /^Symbol\((.*)\)(.*)$/;
function Ih(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function Ns(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const r = typeof e;
  if (r === "number")
    return Ih(e);
  if (r === "string")
    return t ? `"${e}"` : e;
  if (r === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol")
    return Ah.call(e).replace(Mh, "Symbol($1)");
  const n = Oh.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + Ch.call(e) + "]" : n === "RegExp" ? Sh.call(e) : null;
}
function ar(e, t) {
  let r = Ns(e, t);
  return r !== null ? r : JSON.stringify(e, function(n, a) {
    let i = Ns(this[n], t);
    return i !== null ? i : a;
  }, 2);
}
function Zc(e) {
  return e == null ? [] : [].concat(e);
}
let Xc, Jc, Qc, Ph = /\$\{\s*(\w+)\s*\}/g;
Xc = Symbol.toStringTag;
class Bs {
  constructor(t, r, n, a) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[Xc] = "Error", this.name = "ValidationError", this.value = r, this.path = n, this.type = a, this.errors = [], this.inner = [], Zc(t).forEach((i) => {
      if (at.isError(i)) {
        this.errors.push(...i.errors);
        const o = i.inner.length ? i.inner : [i];
        this.inner.push(...o);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
Jc = Symbol.hasInstance;
Qc = Symbol.toStringTag;
class at extends Error {
  static formatError(t, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = Object.assign({}, r, {
      path: n
    })), typeof t == "string" ? t.replace(Ph, (a, i) => ar(r[i])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, n, a, i) {
    const o = new Bs(t, r, n, a);
    if (i)
      return o;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[Qc] = "Error", this.name = o.name, this.message = o.message, this.type = o.type, this.value = o.value, this.path = o.path, this.errors = o.errors, this.inner = o.inner, Error.captureStackTrace && Error.captureStackTrace(this, at);
  }
  static [Jc](t) {
    return Bs[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}
let Ut = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: n
  }) => {
    const a = n != null && n !== r ? ` (cast from the value \`${ar(n, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${ar(r, !0)}\`` + a : `${e} must match the configured type. The validated value was: \`${ar(r, !0)}\`` + a;
  }
}, rt = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, fr = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Wi = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, qi = {
  isValue: "${path} field must be ${value}"
}, Ki = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, La = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, xh = {
  notType: (e) => {
    const {
      path: t,
      value: r,
      spec: n
    } = e, a = n.types.length;
    if (Array.isArray(r)) {
      if (r.length < a)
        return `${t} tuple value has too few items, expected a length of ${a} but got ${r.length} for value: \`${ar(r, !0)}\``;
      if (r.length > a)
        return `${t} tuple value has too many items, expected a length of ${a} but got ${r.length} for value: \`${ar(r, !0)}\``;
    }
    return at.formatError(Ut.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Ut,
  string: rt,
  number: fr,
  date: Wi,
  object: Ki,
  array: La,
  boolean: qi,
  tuple: xh
});
const ha = (e) => e && e.__isYupSchema__;
class Ha {
  static fromOptions(t, r) {
    if (!r.then && !r.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: a,
      otherwise: i
    } = r, o = typeof n == "function" ? n : (...s) => s.every((l) => l === n);
    return new Ha(t, (s, l) => {
      var u;
      let c = o(...s) ? a : i;
      return (u = c == null ? void 0 : c(l)) != null ? u : l;
    });
  }
  constructor(t, r) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = r;
  }
  resolve(t, r) {
    let n = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)
    )), a = this.fn(n, t, r);
    if (a === void 0 || // @ts-ignore this can be base
    a === t)
      return t;
    if (!ha(a))
      throw new TypeError("conditions must return a schema object");
    return a.resolve(r);
  }
}
const Da = {
  context: "$",
  value: "."
};
class jr {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Da.context, this.isValue = this.key[0] === Da.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? Da.context : this.isValue ? Da.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && Mr.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, n) {
    let a = this.isContext ? n : this.isValue ? t : r;
    return this.getter && (a = this.getter(a || {})), this.map && (a = this.map(a)), a;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
jr.prototype.__isYupRef = !0;
const Ft = (e) => e == null;
function Gr(e) {
  function t({
    value: r,
    path: n = "",
    options: a,
    originalValue: i,
    schema: o
  }, s, l) {
    const {
      name: u,
      test: c,
      params: f,
      message: p,
      skipAbsent: d
    } = e;
    let {
      parent: m,
      context: g,
      abortEarly: h = o.spec.abortEarly,
      disableStackTrace: y = o.spec.disableStackTrace
    } = a;
    function _(N) {
      return jr.isRef(N) ? N.getValue(r, m, g) : N;
    }
    function $(N = {}) {
      const L = Object.assign({
        value: r,
        originalValue: i,
        label: o.spec.label,
        path: N.path || n,
        spec: o.spec,
        disableStackTrace: N.disableStackTrace || y
      }, f, N.params);
      for (const J of Object.keys(L))
        L[J] = _(L[J]);
      const U = new at(at.formatError(N.message || p, L), r, L.path, N.type || u, L.disableStackTrace);
      return U.params = L, U;
    }
    const v = h ? s : l;
    let D = {
      path: n,
      parent: m,
      type: u,
      from: a.from,
      createError: $,
      resolve: _,
      options: a,
      originalValue: i,
      schema: o
    };
    const k = (N) => {
      at.isError(N) ? v(N) : N ? l(null) : v($());
    }, T = (N) => {
      at.isError(N) ? v(N) : s(N);
    };
    if (d && Ft(r))
      return k(!0);
    let V;
    try {
      var H;
      if (V = c.call(D, r, D), typeof ((H = V) == null ? void 0 : H.then) == "function") {
        if (a.sync)
          throw new Error(`Validation test of type: "${D.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(V).then(k, T);
      }
    } catch (N) {
      T(N);
      return;
    }
    k(V);
  }
  return t.OPTIONS = e, t;
}
function Lh(e, t, r, n = r) {
  let a, i, o;
  return t ? (Mr.forEach(t, (s, l, u) => {
    let c = l ? s.slice(1, s.length - 1) : s;
    e = e.resolve({
      context: n,
      parent: a,
      value: r
    });
    let f = e.type === "tuple", p = u ? parseInt(c, 10) : 0;
    if (e.innerType || f) {
      if (f && !u)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
      if (r && p >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
      a = r, r = r && r[p], e = f ? e.spec.types[p] : e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[c])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e.type}")`);
      a = r, r = r && r[c], e = e.fields[c];
    }
    i = c, o = l ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: a,
    parentPath: i
  }) : {
    parent: a,
    parentPath: t,
    schema: e
  };
}
class Wa extends Set {
  describe() {
    const t = [];
    for (const r of this.values())
      t.push(jr.isRef(r) ? r.describe() : r);
    return t;
  }
  resolveAll(t) {
    let r = [];
    for (const n of this.values())
      r.push(t(n));
    return r;
  }
  clone() {
    return new Wa(this.values());
  }
  merge(t, r) {
    const n = this.clone();
    return t.forEach((a) => n.add(a)), r.forEach((a) => n.delete(a)), n;
  }
}
function Jr(e, t = /* @__PURE__ */ new Map()) {
  if (ha(e) || !e || typeof e != "object")
    return e;
  if (t.has(e))
    return t.get(e);
  let r;
  if (e instanceof Date)
    r = new Date(e.getTime()), t.set(e, r);
  else if (e instanceof RegExp)
    r = new RegExp(e), t.set(e, r);
  else if (Array.isArray(e)) {
    r = new Array(e.length), t.set(e, r);
    for (let n = 0; n < e.length; n++)
      r[n] = Jr(e[n], t);
  } else if (e instanceof Map) {
    r = /* @__PURE__ */ new Map(), t.set(e, r);
    for (const [n, a] of e.entries())
      r.set(n, Jr(a, t));
  } else if (e instanceof Set) {
    r = /* @__PURE__ */ new Set(), t.set(e, r);
    for (const n of e)
      r.add(Jr(n, t));
  } else if (e instanceof Object) {
    r = {}, t.set(e, r);
    for (const [n, a] of Object.entries(e))
      r[n] = Jr(a, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return r;
}
class bt {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Wa(), this._blacklist = new Wa(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Ut.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((r) => {
      r.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeCheck = this._typeCheck, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.internalTests = Object.assign({}, this.internalTests), r.exclusiveTests = Object.assign({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = Jr(Object.assign({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = r, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, n = t.clone();
    const a = Object.assign({}, r.spec, n.spec);
    return n.spec = a, n.internalTests = Object.assign({}, r.internalTests, n.internalTests), n._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((i) => {
      t.tests.forEach((o) => {
        i.test(o.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((a, i) => i.resolve(a, t), r), r = r.resolve(t);
    }
    return r;
  }
  resolveOptions(t) {
    var r, n, a, i;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (r = t.strict) != null ? r : this.spec.strict,
      abortEarly: (n = t.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (a = t.recursive) != null ? a : this.spec.recursive,
      disableStackTrace: (i = t.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, r = {}) {
    let n = this.resolve(Object.assign({
      value: t
    }, r)), a = r.assert === "ignore-optionality", i = n._cast(t, r);
    if (r.assert !== !1 && !n.isType(i)) {
      if (a && Ft(i))
        return i;
      let o = ar(t), s = ar(i);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${o} 
` + (s !== o ? `result of cast: ${s}` : ""));
    }
    return i;
  }
  _cast(t, r) {
    let n = t === void 0 ? t : this.transforms.reduce((a, i) => i.call(this, a, t, this), t);
    return n === void 0 && (n = this.getDefault(r)), n;
  }
  _validate(t, r = {}, n, a) {
    let {
      path: i,
      originalValue: o = t,
      strict: s = this.spec.strict
    } = r, l = t;
    s || (l = this._cast(l, Object.assign({
      assert: !1
    }, r)));
    let u = [];
    for (let c of Object.values(this.internalTests))
      c && u.push(c);
    this.runTests({
      path: i,
      value: l,
      originalValue: o,
      options: r,
      tests: u
    }, n, (c) => {
      if (c.length)
        return a(c, l);
      this.runTests({
        path: i,
        value: l,
        originalValue: o,
        options: r,
        tests: this.tests
      }, n, a);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, r, n) {
    let a = !1, {
      tests: i,
      value: o,
      originalValue: s,
      path: l,
      options: u
    } = t, c = (g) => {
      a || (a = !0, r(g, o));
    }, f = (g) => {
      a || (a = !0, n(g, o));
    }, p = i.length, d = [];
    if (!p)
      return f([]);
    let m = {
      value: o,
      originalValue: s,
      path: l,
      options: u,
      schema: this
    };
    for (let g = 0; g < i.length; g++) {
      const h = i[g];
      h(m, c, function(_) {
        _ && (Array.isArray(_) ? d.push(..._) : d.push(_)), --p <= 0 && f(d);
      });
    }
  }
  asNestedTest({
    key: t,
    index: r,
    parent: n,
    parentPath: a,
    originalParent: i,
    options: o
  }) {
    const s = t ?? r;
    if (s == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof s == "number";
    let u = n[s];
    const c = Object.assign({}, o, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: u,
      originalValue: i[s],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: s,
      path: l || s.includes(".") ? `${a || ""}[${l ? s : `"${s}"`}]` : (a ? `${a}.` : "") + t
    });
    return (f, p, d) => this.resolve(c)._validate(u, c, p, d);
  }
  validate(t, r) {
    var n;
    let a = this.resolve(Object.assign({}, r, {
      value: t
    })), i = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : a.spec.disableStackTrace;
    return new Promise((o, s) => a._validate(t, r, (l, u) => {
      at.isError(l) && (l.value = u), s(l);
    }, (l, u) => {
      l.length ? s(new at(l, u, void 0, void 0, i)) : o(u);
    }));
  }
  validateSync(t, r) {
    var n;
    let a = this.resolve(Object.assign({}, r, {
      value: t
    })), i, o = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : a.spec.disableStackTrace;
    return a._validate(t, Object.assign({}, r, {
      sync: !0
    }), (s, l) => {
      throw at.isError(s) && (s.value = l), s;
    }, (s, l) => {
      if (s.length)
        throw new at(s, t, void 0, void 0, o);
      i = l;
    }), i;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (n) => {
      if (at.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (n) {
      if (at.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault(t) {
    let r = this.spec.default;
    return r == null ? r : typeof r == "function" ? r.call(this, t) : Jr(r);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, r) {
    const n = this.clone({
      nullable: t
    });
    return n.internalTests.nullable = Gr({
      message: r,
      name: "nullable",
      test(a) {
        return a === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(t, r) {
    const n = this.clone({
      optional: t
    });
    return n.internalTests.optionality = Gr({
      message: r,
      name: "optionality",
      test(a) {
        return a === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = Ut.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = Ut.notNull) {
    return this.nullability(!1, t);
  }
  required(t = Ut.required) {
    return this.clone().withMutation((r) => r.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = Ut.default), typeof r.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), a = Gr(r), i = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === r.name && (i || o.OPTIONS.test === a.OPTIONS.test))), n.tests.push(a), n;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let n = this.clone(), a = Zc(t).map((i) => new jr(i));
    return a.forEach((i) => {
      i.isSibling && n.deps.push(i.key);
    }), n.conditions.push(typeof r == "function" ? new Ha(a, r) : Ha.fromOptions(a, r)), n;
  }
  typeError(t) {
    let r = this.clone();
    return r.internalTests.typeError = Gr({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), r;
  }
  oneOf(t, r = Ut.oneOf) {
    let n = this.clone();
    return t.forEach((a) => {
      n._whitelist.add(a), n._blacklist.delete(a);
    }), n.internalTests.whiteList = Gr({
      message: r,
      name: "oneOf",
      skipAbsent: !0,
      test(a) {
        let i = this.schema._whitelist, o = i.resolveAll(this.resolve);
        return o.includes(a) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(t, r = Ut.notOneOf) {
    let n = this.clone();
    return t.forEach((a) => {
      n._blacklist.add(a), n._whitelist.delete(a);
    }), n.internalTests.blacklist = Gr({
      message: r,
      name: "notOneOf",
      test(a) {
        let i = this.schema._blacklist, o = i.resolveAll(this.resolve);
        return o.includes(a) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), {
      label: n,
      meta: a,
      optional: i,
      nullable: o
    } = r.spec;
    return {
      meta: a,
      label: n,
      optional: i,
      nullable: o,
      default: r.getDefault(t),
      type: r.type,
      oneOf: r._whitelist.describe(),
      notOneOf: r._blacklist.describe(),
      tests: r.tests.map((l) => ({
        name: l.OPTIONS.name,
        params: l.OPTIONS.params
      })).filter((l, u, c) => c.findIndex((f) => f.name === l.name) === u)
    };
  }
}
bt.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  bt.prototype[`${e}At`] = function(t, r, n = {}) {
    const {
      parent: a,
      parentPath: i,
      schema: o
    } = Lh(this, t, r, n.context);
    return o[e](a && a[i], Object.assign({}, n, {
      parent: a,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  bt.prototype[e] = bt.prototype.oneOf;
for (const e of ["not", "nope"])
  bt.prototype[e] = bt.prototype.notOneOf;
function ed() {
  return new td();
}
class td extends bt {
  constructor() {
    super({
      type: "boolean",
      check(t) {
        return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => {
        if (n.spec.coerce && !n.isType(t)) {
          if (/^(true|1)$/i.test(String(t)))
            return !0;
          if (/^(false|0)$/i.test(String(t)))
            return !1;
        }
        return t;
      });
    });
  }
  isTrue(t = qi.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(r) {
        return Ft(r) || r === !0;
      }
    });
  }
  isFalse(t = qi.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(r) {
        return Ft(r) || r === !1;
      }
    });
  }
  default(t) {
    return super.default(t);
  }
  defined(t) {
    return super.defined(t);
  }
  optional() {
    return super.optional();
  }
  required(t) {
    return super.required(t);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(t) {
    return super.nonNullable(t);
  }
  strip(t) {
    return super.strip(t);
  }
}
ed.prototype = td.prototype;
const Rh = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Fh(e) {
  const t = Gi(e);
  if (!t)
    return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let r = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (r = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (r = 0 - r)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + r, t.second, t.millisecond);
}
function Gi(e) {
  var t, r;
  const n = Rh.exec(e);
  return n ? {
    year: tr(n[1]),
    month: tr(n[2], 1) - 1,
    day: tr(n[3], 1),
    hour: tr(n[4]),
    minute: tr(n[5]),
    second: tr(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      tr(n[7].substring(0, 3))
    ) : 0,
    precision: (t = (r = n[7]) == null ? void 0 : r.length) != null ? t : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: tr(n[10]),
    minuteOffset: tr(n[11])
  } : null;
}
function tr(e, t = 0) {
  return Number(e) || t;
}
let Vh = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), Nh = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), Bh = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Yh = "^\\d{4}-\\d{2}-\\d{2}", jh = "\\d{2}:\\d{2}:\\d{2}", zh = "(([+-]\\d{2}(:?\\d{2})?)|Z)", Uh = new RegExp(`${Yh}T${jh}(\\.\\d+)?${zh}$`), Hh = (e) => Ft(e) || e === e.trim(), Wh = {}.toString();
function zr() {
  return new rd();
}
class rd extends bt {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => {
        if (!n.spec.coerce || n.isType(t) || Array.isArray(t))
          return t;
        const a = t != null && t.toString ? t.toString() : t;
        return a === Wh ? t : a;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((r) => r.test({
      message: t || Ut.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t));
  }
  length(t, r = rt.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(t);
      }
    });
  }
  min(t, r = rt.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(t);
      }
    });
  }
  max(t, r = rt.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let n = !1, a, i;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: a,
      name: i
    } = r : a = r), this.test({
      name: i || "matches",
      message: a || rt.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (o) => o === "" && n || o.search(t) !== -1
    });
  }
  email(t = rt.email) {
    return this.matches(Vh, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = rt.url) {
    return this.matches(Nh, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = rt.uuid) {
    return this.matches(Bh, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let r = "", n, a;
    return t && (typeof t == "object" ? {
      message: r = "",
      allowOffset: n = !1,
      precision: a = void 0
    } = t : r = t), this.matches(Uh, {
      name: "datetime",
      message: r || rt.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: r || rt.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || n)
          return !0;
        const o = Gi(i);
        return o ? !!o.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: r || rt.datetime_precision,
      params: {
        precision: a
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || a == null)
          return !0;
        const o = Gi(i);
        return o ? o.precision === a : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = rt.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: Hh
    });
  }
  lowercase(t = rt.lowercase) {
    return this.transform((r) => Ft(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => Ft(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = rt.uppercase) {
    return this.transform((r) => Ft(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => Ft(r) || r === r.toUpperCase()
    });
  }
}
zr.prototype = rd.prototype;
let qh = (e) => e != +e;
function nd() {
  return new ad();
}
class ad extends bt {
  constructor() {
    super({
      type: "number",
      check(t) {
        return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !qh(t);
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => {
        if (!n.spec.coerce)
          return t;
        let a = t;
        if (typeof a == "string") {
          if (a = a.replace(/\s/g, ""), a === "")
            return NaN;
          a = +a;
        }
        return n.isType(a) || a === null ? a : parseFloat(a);
      });
    });
  }
  min(t, r = fr.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n >= this.resolve(t);
      }
    });
  }
  max(t, r = fr.max) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n <= this.resolve(t);
      }
    });
  }
  lessThan(t, r = fr.lessThan) {
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      skipAbsent: !0,
      test(n) {
        return n < this.resolve(t);
      }
    });
  }
  moreThan(t, r = fr.moreThan) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      skipAbsent: !0,
      test(n) {
        return n > this.resolve(t);
      }
    });
  }
  positive(t = fr.positive) {
    return this.moreThan(0, t);
  }
  negative(t = fr.negative) {
    return this.lessThan(0, t);
  }
  integer(t = fr.integer) {
    return this.test({
      name: "integer",
      message: t,
      skipAbsent: !0,
      test: (r) => Number.isInteger(r)
    });
  }
  truncate() {
    return this.transform((t) => Ft(t) ? t : t | 0);
  }
  round(t) {
    var r;
    let n = ["ceil", "floor", "round", "trunc"];
    if (t = ((r = t) == null ? void 0 : r.toLowerCase()) || "round", t === "trunc")
      return this.truncate();
    if (n.indexOf(t.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform((a) => Ft(a) ? a : Math[t](a));
  }
}
nd.prototype = ad.prototype;
let id = /* @__PURE__ */ new Date(""), Kh = (e) => Object.prototype.toString.call(e) === "[object Date]";
function xo() {
  return new ma();
}
class ma extends bt {
  constructor() {
    super({
      type: "date",
      check(t) {
        return Kh(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => !n.spec.coerce || n.isType(t) || t === null ? t : (t = Fh(t), isNaN(t) ? ma.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, r) {
    let n;
    if (jr.isRef(t))
      n = t;
    else {
      let a = this.cast(t);
      if (!this._typeCheck(a))
        throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = a;
    }
    return n;
  }
  min(t, r = Wi.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(a) {
        return a >= this.resolve(n);
      }
    });
  }
  max(t, r = Wi.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(a) {
        return a <= this.resolve(n);
      }
    });
  }
}
ma.INVALID_DATE = id;
xo.prototype = ma.prototype;
xo.INVALID_DATE = id;
function Gh(e, t = []) {
  let r = [], n = /* @__PURE__ */ new Set(), a = new Set(t.map(([o, s]) => `${o}-${s}`));
  function i(o, s) {
    let l = Mr.split(o)[0];
    n.add(l), a.has(`${s}-${l}`) || r.push([s, l]);
  }
  for (const o of Object.keys(e)) {
    let s = e[o];
    n.add(o), jr.isRef(s) && s.isSibling ? i(s.path, o) : ha(s) && "deps" in s && s.deps.forEach((l) => i(l, o));
  }
  return kh.array(Array.from(n), r).reverse();
}
function Ys(e, t) {
  let r = 1 / 0;
  return e.some((n, a) => {
    var i;
    if ((i = t.path) != null && i.includes(n))
      return r = a, !0;
  }), r;
}
function od(e) {
  return (t, r) => Ys(e, t) - Ys(e, r);
}
const sd = (e, t, r) => {
  if (typeof e != "string")
    return e;
  let n = e;
  try {
    n = JSON.parse(e);
  } catch {
  }
  return r.isType(n) ? n : e;
};
function Ra(e) {
  if ("fields" in e) {
    const t = {};
    for (const [r, n] of Object.entries(e.fields))
      t[r] = Ra(n);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = Ra(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Ra)
  }) : "optional" in e ? e.optional() : e;
}
const Zh = (e, t) => {
  const r = [...Mr.normalizePath(t)];
  if (r.length === 1)
    return r[0] in e;
  let n = r.pop(), a = Mr.getter(Mr.join(r), !0)(e);
  return !!(a && n in a);
};
let js = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Xh(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((n) => r.indexOf(n) === -1);
}
const Jh = od([]);
function ld(e) {
  return new ud(e);
}
class ud extends bt {
  constructor(t) {
    super({
      type: "object",
      check(r) {
        return js(r) || typeof r == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Jh, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, r = {}) {
    var n;
    let a = super._cast(t, r);
    if (a === void 0)
      return this.getDefault(r);
    if (!this._typeCheck(a))
      return a;
    let i = this.fields, o = (n = r.stripUnknown) != null ? n : this.spec.noUnknown, s = [].concat(this._nodes, Object.keys(a).filter((f) => !this._nodes.includes(f))), l = {}, u = Object.assign({}, r, {
      parent: l,
      __validating: r.__validating || !1
    }), c = !1;
    for (const f of s) {
      let p = i[f], d = f in a;
      if (p) {
        let m, g = a[f];
        u.path = (r.path ? `${r.path}.` : "") + f, p = p.resolve({
          value: g,
          context: r.context,
          parent: l
        });
        let h = p instanceof bt ? p.spec : void 0, y = h == null ? void 0 : h.strict;
        if (h != null && h.strip) {
          c = c || f in a;
          continue;
        }
        m = !r.__validating || !y ? (
          // TODO: use _cast, this is double resolving
          p.cast(a[f], u)
        ) : a[f], m !== void 0 && (l[f] = m);
      } else
        d && !o && (l[f] = a[f]);
      (d !== f in l || l[f] !== a[f]) && (c = !0);
    }
    return c ? l : a;
  }
  _validate(t, r = {}, n, a) {
    let {
      from: i = [],
      originalValue: o = t,
      recursive: s = this.spec.recursive
    } = r;
    r.from = [{
      schema: this,
      value: o
    }, ...i], r.__validating = !0, r.originalValue = o, super._validate(t, r, n, (l, u) => {
      if (!s || !js(u)) {
        a(l, u);
        return;
      }
      o = o || u;
      let c = [];
      for (let f of this._nodes) {
        let p = this.fields[f];
        !p || jr.isRef(p) || c.push(p.asNestedTest({
          options: r,
          key: f,
          parent: u,
          parentPath: r.path,
          originalParent: o
        }));
      }
      this.runTests({
        tests: c,
        value: u,
        originalValue: o,
        options: r
      }, n, (f) => {
        a(f.sort(this._sortErrors).concat(l), u);
      });
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = Object.assign({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), n = r.fields;
    for (let [a, i] of Object.entries(this.fields)) {
      const o = n[a];
      n[a] = o === void 0 ? i : o;
    }
    return r.withMutation((a) => (
      // XXX: excludes here is wrong
      a.setFields(n, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let r = {};
    return this._nodes.forEach((n) => {
      var a;
      const i = this.fields[n];
      let o = t;
      (a = o) != null && a.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[n]
      })), r[n] = i && "getDefault" in i ? i.getDefault(o) : void 0;
    }), r;
  }
  setFields(t, r) {
    let n = this.clone();
    return n.fields = t, n._nodes = Gh(t, r), n._sortErrors = od(Object.keys(t)), r && (n._excludedEdges = r), n;
  }
  shape(t, r = []) {
    return this.clone().withMutation((n) => {
      let a = n._excludedEdges;
      return r.length && (Array.isArray(r[0]) || (r = [r]), a = [...n._excludedEdges, ...r]), n.setFields(Object.assign(n.fields, t), a);
    });
  }
  partial() {
    const t = {};
    for (const [r, n] of Object.entries(this.fields))
      t[r] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(t);
  }
  deepPartial() {
    return Ra(this);
  }
  pick(t) {
    const r = {};
    for (const n of t)
      this.fields[n] && (r[n] = this.fields[n]);
    return this.setFields(r, this._excludedEdges.filter(([n, a]) => t.includes(n) && t.includes(a)));
  }
  omit(t) {
    const r = [];
    for (const n of Object.keys(this.fields))
      t.includes(n) || r.push(n);
    return this.pick(r);
  }
  from(t, r, n) {
    let a = Mr.getter(t, !0);
    return this.transform((i) => {
      if (!i)
        return i;
      let o = i;
      return Zh(i, t) && (o = Object.assign({}, i), n || delete o[t], o[r] = a(i)), o;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(sd);
  }
  noUnknown(t = !0, r = Ki.noUnknown) {
    typeof t != "boolean" && (r = t, t = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(a) {
        if (a == null)
          return !0;
        const i = Xh(this.schema, a);
        return !t || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = t, n;
  }
  unknown(t = !0, r = Ki.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => {
      if (!r)
        return r;
      const n = {};
      for (const a of Object.keys(r))
        n[t(a)] = r[a];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(ki.camelCase);
  }
  snakeCase() {
    return this.transformKeys(ki.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => ki.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), n = super.describe(t);
    n.fields = {};
    for (const [i, o] of Object.entries(r.fields)) {
      var a;
      let s = t;
      (a = s) != null && a.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[i]
      })), n.fields[i] = o.describe(s);
    }
    return n;
  }
}
ld.prototype = ud.prototype;
function cd(e) {
  return new dd(e);
}
class dd extends bt {
  constructor(t) {
    super({
      type: "array",
      spec: {
        types: t
      },
      check(r) {
        return Array.isArray(r);
      }
    }), this.innerType = void 0, this.innerType = t;
  }
  _cast(t, r) {
    const n = super._cast(t, r);
    if (!this._typeCheck(n) || !this.innerType)
      return n;
    let a = !1;
    const i = n.map((o, s) => {
      const l = this.innerType.cast(o, Object.assign({}, r, {
        path: `${r.path || ""}[${s}]`
      }));
      return l !== o && (a = !0), l;
    });
    return a ? i : n;
  }
  _validate(t, r = {}, n, a) {
    var i;
    let o = this.innerType, s = (i = r.recursive) != null ? i : this.spec.recursive;
    r.originalValue != null && r.originalValue, super._validate(t, r, n, (l, u) => {
      var c;
      if (!s || !o || !this._typeCheck(u)) {
        a(l, u);
        return;
      }
      let f = new Array(u.length);
      for (let d = 0; d < u.length; d++) {
        var p;
        f[d] = o.asNestedTest({
          options: r,
          index: d,
          parent: u,
          parentPath: r.path,
          originalParent: (p = r.originalValue) != null ? p : t
        });
      }
      this.runTests({
        value: u,
        tests: f,
        originalValue: (c = r.originalValue) != null ? c : t,
        options: r
      }, n, (d) => a(d.concat(l), u));
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.innerType = this.innerType, r;
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(sd);
  }
  concat(t) {
    let r = super.concat(t);
    return r.innerType = this.innerType, t.innerType && (r.innerType = r.innerType ? (
      // @ts-expect-error Lazy doesn't have concat and will break
      r.innerType.concat(t.innerType)
    ) : t.innerType), r;
  }
  of(t) {
    let r = this.clone();
    if (!ha(t))
      throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + ar(t));
    return r.innerType = t, r.spec = Object.assign({}, r.spec, {
      types: t
    }), r;
  }
  length(t, r = La.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(t);
      }
    });
  }
  min(t, r) {
    return r = r || La.min, this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      // FIXME(ts): Array<typeof T>
      test(n) {
        return n.length >= this.resolve(t);
      }
    });
  }
  max(t, r) {
    return r = r || La.max, this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(t);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((t, r) => this._typeCheck(t) ? t : r == null ? [] : [].concat(r));
  }
  compact(t) {
    let r = t ? (n, a, i) => !t(n, a, i) : (n) => !!n;
    return this.transform((n) => n != null ? n.filter(r) : n);
  }
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), n = super.describe(t);
    if (r.innerType) {
      var a;
      let i = t;
      (a = i) != null && a.value && (i = Object.assign({}, i, {
        parent: i.value,
        value: i.value[0]
      })), n.innerType = r.innerType.describe(i);
    }
    return n;
  }
}
cd.prototype = dd.prototype;
function Qh(e) {
  return new Lo(e);
}
class Lo {
  constructor(t) {
    this.type = "lazy", this.__isYupSchema__ = !0, this.spec = void 0, this._resolve = (r, n = {}) => {
      let a = this.builder(r, n);
      if (!ha(a))
        throw new TypeError("lazy() functions must return a valid schema");
      return this.spec.optional && (a = a.optional()), a.resolve(n);
    }, this.builder = t, this.spec = {
      meta: void 0,
      optional: !1
    };
  }
  clone(t) {
    const r = new Lo(this.builder);
    return r.spec = Object.assign({}, this.spec, t), r;
  }
  optionality(t) {
    return this.clone({
      optional: t
    });
  }
  optional() {
    return this.optionality(!0);
  }
  resolve(t) {
    return this._resolve(t.value, t);
  }
  cast(t, r) {
    return this._resolve(t, r).cast(t, r);
  }
  asNestedTest(t) {
    let {
      key: r,
      index: n,
      parent: a,
      options: i
    } = t, o = a[n ?? r];
    return this._resolve(o, Object.assign({}, i, {
      value: o,
      parent: a
    })).asNestedTest(t);
  }
  validate(t, r) {
    return this._resolve(t, r).validate(t, r);
  }
  validateSync(t, r) {
    return this._resolve(t, r).validateSync(t, r);
  }
  validateAt(t, r, n) {
    return this._resolve(r, n).validateAt(t, r, n);
  }
  validateSyncAt(t, r, n) {
    return this._resolve(r, n).validateSyncAt(t, r, n);
  }
  isValid(t, r) {
    return this._resolve(t, r).isValid(t, r);
  }
  isValidSync(t, r) {
    return this._resolve(t, r).isValidSync(t, r);
  }
  describe(t) {
    return t ? this.resolve(t).describe(t) : {
      type: "lazy",
      meta: this.spec.meta,
      label: void 0
    };
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
}
const em = (e, t) => {
  let r = zr().transform((n) => n || void 0);
  return e.required && (r = r.required(e.required)), t != null && t.minLength && e.minLength && (r = r.min(t.minLength, e.minLength)), t != null && t.maxLength && e.maxLength && (r = r.max(t.maxLength, e.maxLength)), r;
}, tm = (e, t) => {
  let r = ed();
  return e.required && (r = r.required(e.required)), t != null && t.strictValue && e.strictValue && (r = r.oneOf([t.strictValue], e.strictValue)), r;
}, rm = (e) => {
  let t = zr().transform((r) => r || void 0).test(
    "emailTest",
    e.email,
    (r) => r ? /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(r) : !0
  ).email(e.email);
  return e.required && (t = t.required(e.required)), t;
}, nm = (e, t) => {
  let r = nd().transform((n) => isNaN(n) ? void 0 : n);
  return e.required && (r = r.required(e.required)), (t == null ? void 0 : t.min) != null && e.min && (r = r.min(t.min, e.min)), (t == null ? void 0 : t.max) != null && e.max && (r = r.max(t.max, e.max)), (t == null ? void 0 : t.lessThan) != null && e.lessThan && (r = r.lessThan(t.lessThan, e.lessThan)), (t == null ? void 0 : t.moreThan) != null && e.moreThan && (r = r.moreThan(t.moreThan, e.moreThan)), r;
}, am = (e, t) => Qh(() => {
  let r = zr().transform((n) => n || void 0).test(
    "phoneTest",
    e.phone,
    (n) => n && t.countryCode.value == "351" ? /^2\d{1}|(9(1|2|3|6))\d{7}/.test(n) : !0
  ).length(Ui[t.countryCode.value], e.phone);
  return e.required && (r = r.required(e.required)), r;
}), im = (e) => {
  let t = zr().transform((r) => r || void 0).min(8, e.zipcode);
  return e.required && (t = t.required(e.required)), t;
}, om = (e, t) => {
  let r = ld({
    extension: zr().matches((t == null ? void 0 : t.extension) || /(png|jpg|pdf)/g, e.extension)
  });
  if (e.required && (r = r.test(
    "fileRequired",
    e.required,
    (n) => n ? n.src ? !0 : !!n.file : !1
  )), e.size && (t != null && t.size)) {
    const n = {
      kb: 1e3,
      mb: 1048576
    };
    r = r.test(
      "fileSize",
      e.size,
      (a) => {
        var i, o, s;
        return a != null && a.file && ((i = t.size) != null && i.collectionType) ? ((o = a.file) == null ? void 0 : o.size) < n[(s = t.size) == null ? void 0 : s.collectionType] * t.size.value : !1;
      }
    );
  }
  return r;
}, sm = (e, t) => {
  const r = (t == null ? void 0 : t.format) == "mm/yyyy" ? 2 : 3, n = (t == null ? void 0 : t.format) == "mm/yyyy" ? 1 : 2;
  let a = xo().transform(
    (i, o) => (
      // ogV as "phone_number" is still as of yet unexplained
      o == "phone_number" || o instanceof Date ? i : o
    )
  ).transform((i) => {
    if (i.split) {
      const o = i.split("/");
      if (o.length == r && o[n].length == 4)
        return new Date(o.reverse().join("-"));
    }
    return i;
  }).typeError(e.invalid).test(
    "dateTest",
    e.invalid,
    (i, o) => o.originalValue.split("/").length == r && o.originalValue.split("/")[n].length == 4
  );
  return e.required && (a = a.required(e.required)), t != null && t.minDate && e.minDate && (a = a.min(t.minDate, e.minDate)), t != null && t.maxDate && e.maxDate && (a = a.max(t.maxDate, e.maxDate)), a;
}, lm = (e) => {
  let t = zr().transform((r) => r || void 0).min(9, e.invalid).test("nifTest", e.invalid, (r) => {
    if (!r)
      return !1;
    var n = r.toString().split(""), a = (Number(n[7]) * 2 + Number(n[6]) * 3 + Number(n[5]) * 4 + Number(n[4]) * 5 + Number(n[3]) * 6 + Number(n[2]) * 7 + Number(n[1]) * 8 + Number(n[0]) * 9) % 11;
    return Number(n[8]) == (a == 0 || a == 1 ? 0 : 11 - a);
  });
  return e.required && (t = t.required(e.required)), t;
}, um = (e, t) => {
  let r = cd();
  return e.required && (r = r.required(e.required).min(1, e.required)), t != null && t.minLength && e.minLength && (r = r.min(t.minLength, e.minLength)), t != null && t.maxLength && e.maxLength && (r = r.max(t.maxLength, e.maxLength)), r;
}, x4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  array: um,
  boolean: tm,
  date: sm,
  email: rm,
  file: om,
  nifRequired: lm,
  number: nm,
  phone: am,
  string: em,
  zipcode: im
}, Symbol.toStringTag, { value: "Module" })), L4 = (e, t) => {
  const r = new Date(e.split("/").reverse().join("-"));
  switch (t) {
    case "datetime":
      return r;
    case "iso":
      return r.toISOString();
    case "miliseconds":
      return r.getTime();
    case "object":
      return {
        day: r.getDate(),
        month: r.getMonth(),
        year: r.getFullYear()
      };
  }
}, R4 = (e) => {
  const t = q(!1), r = q(!1), n = () => {
    var s;
    const o = (s = e.fields) == null ? void 0 : s.filter((l) => l.value);
    o == null || o.forEach(async (l) => await l.value.validate()), t.value = (o == null ? void 0 : o.every((l) => l.value.meta.valid)) ?? !0;
  }, a = () => {
    var o, s;
    t.value ? (e.submitLock && !r.value || !e.submitLock) && (r.value = !0, (o = e.onSubmit) == null || o.call(e), r.value = !1) : (s = e.onError) == null || s.call(e);
  };
  return {
    validForm: t,
    validate: n,
    submit: () => {
      n(), e.forceValidation ? setTimeout(() => {
        n(), a();
      }, 1) : a();
    },
    submitLock: r
  };
}, F4 = (e) => JSON.parse(e, (t, r) => {
  if (r === "true" || r === "false")
    return r === "true";
  if ((Number(r) || r === "0") && typeof r != "boolean")
    return Number(r);
  if (r !== "undefined")
    return r === "null" ? null : r;
}), V4 = (e) => {
  const t = new URL("calendar/render", "https://www.google.com"), r = (a) => a.trim(), n = (a) => {
    const i = new Date(a).toISOString().replaceAll(/:/g, "").replaceAll(/-/g, "").replaceAll(/\.\d{3}(?=Z)/g, "");
    return e.allDay && i.replaceAll(/T\d{6}(?=Z)/g, ""), i;
  };
  return t.searchParams.set("action", "TEMPLATE"), t.searchParams.set("text", r(e.title)), e.description && t.searchParams.set("details", r(e.description)), e.location && t.searchParams.set("location", r(e.location)), t.searchParams.set(
    "dates",
    `${n(e.dateStart)}/${n(e.dateEnd)}`
  ), t.toString();
}, zs = (e) => {
  if (!e)
    return;
  let t = e.parentElement;
  for (; t; ) {
    const { overflowY: r } = window.getComputedStyle(t);
    if (r === "auto" || r === "scroll")
      return t;
    t = t.parentElement;
  }
  return document.documentElement;
}, N4 = (e, t) => fetch(new URL("/core/apis/data/updateForm", e), {
  method: "PUT",
  body: JSON.stringify(
    Object.fromEntries(
      Object.entries({
        eventType: t.eventType || "STEP_CHANGED",
        isActionEvent: !0,
        journeyId: t.journeyId,
        stepName: t.stepName,
        isCompleted: t.isCompleted || !1,
        sentToDialer: t.sentToDialer || !0,
        lastStepNumber: t.step,
        lastStepType: t.formType,
        lastStepUrl: window.location.pathname + window.location.search + window.location.hash,
        data: JSON.stringify({
          ...t.payload,
          formType: t.formType
        })
      }).filter(([r, n]) => n != null)
    )
  )
}), B4 = (e, t) => fetch(new URL("/core/apis/data/verifyConsent", e), {
  method: "POST",
  body: JSON.stringify({
    email: t.email,
    currentPageUrl: location.origin + location.pathname,
    journeyId: t.journeyId
  })
}), Y4 = (e, t) => {
  const r = new URL(window.location.href);
  return r.searchParams.has(e) ? (() => {
    const n = r.searchParams.getAll(e).map((a) => decodeURIComponent(a));
    switch (t && (r.searchParams.delete(e), history.replaceState(history.state, "", r.toString())), n.length) {
      case 0:
        return;
      case 1:
        return n[0];
      default:
        return n;
    }
  })() : void 0;
}, j4 = (e) => {
  const t = new URL(window.location.href);
  t.searchParams.has(e) && (t.searchParams.delete(e), history.replaceState(history.state, "", t.toString()));
}, z4 = (e) => {
  const t = new FormData();
  return t.append(
    "path",
    `${e.basePath}/${e.journeyId}/${e.fileName}.${e.extension}`
  ), t.append("file", e.file), t.append("bucketName", e.bucketName), fetch(`${e.apiUrl}/core/apis/data/saveFileToS3`, {
    method: "POST",
    body: t
  });
}, U4 = (e, t) => ({
  trackStepEvent: (o) => {
    e == null || e.trackEvent({
      event: `${t.location} Step`,
      eventDetails: {
        category: t.category,
        value: o.stepName,
        noninteraction: !1,
        location: t.location,
        action: o.action,
        properties: {
          stepName: o.stepName,
          stepNumber: o.stepNumber,
          stepDetails: o.stepDetails,
          formType: t.formType
        }
      }
    });
  },
  trackResultsLoad: (o) => {
    e == null || e.trackEvent({
      event: "Impressions",
      eventDetails: {
        category: t.category,
        location: t.location,
        action: "Results Impressions",
        loadTime: o.time || 0,
        properties: {
          list: o.listing
        },
        ecommerce: {
          impressions: o.products.map((s, l) => ({
            name: s.cardTitle,
            id: s.productId,
            brand: s.provider,
            position: l + 1,
            category: t.category,
            list: o.listing,
            price: "5.00",
            quantity: 1
          }))
        }
      }
    });
  },
  trackPurchase: (o) => {
    e == null || e.trackEvent({
      event: "purchase",
      eventDetails: {
        label: o.product.cardTitle,
        source: `Conversion - ${o.source}`,
        category: t.category,
        location: t.location,
        action: "Results Purchase",
        properties: {
          list: o.listing
        },
        ecommerce: {
          purchase: {
            actionField: {
              id: Math.floor(
                Math.random() * (999999999999 - Math.pow(10, 11)) + Math.pow(10, 11)
              ),
              revenue: "5.00",
              action: "purchase"
            },
            products: (() => {
              switch (t.category) {
                case "energy":
                  return [
                    {
                      name: o.product.cardTitle,
                      id: o.product.productId,
                      brand: o.product.provider,
                      position: o.product.index + 1,
                      dimension3: o.source,
                      category: t.category,
                      list: o.listing,
                      price: "5.00",
                      quantity: 1
                    }
                  ];
                case "mortgage":
                  return [
                    {
                      name: o.product.name,
                      id: o.product.cggId,
                      brand: o.product.provider.name,
                      position: o.index,
                      scoreValue: null,
                      approvalRate: "unavailable",
                      dimension3: o.source,
                      dimension6: `apr:${o.product.attributes.taeg}, totalRepayment:${o.product.attributes.mtic}, monthlyRepayment:${o.product.attributes.installment}`,
                      category: t.category,
                      list: o.listing,
                      price: "5.00",
                      quantity: 1
                    }
                  ];
                default:
                  return console.error(
                    `Unrecognized category ${t.category}, implement vertical specific gtm product`
                  ), [{}];
              }
            })()
          }
        }
      }
    });
  },
  trackDetail: (o) => {
    e == null || e.trackEvent({
      event: "productDetail",
      eventDetails: {
        category: t.category,
        location: t.location,
        action: "Results Detail",
        properties: {
          list: o.listing
        },
        ecommerce: {
          detail: {
            actionField: {
              list: o.listing,
              action: "detail"
            },
            products: [
              {
                name: o.product.cardTitle,
                id: o.product.productId,
                brand: o.product.provider,
                position: o.product.index + 1,
                category: t.category,
                list: o.listing,
                price: "5.00",
                quantity: 1
              }
            ]
          }
        }
      }
    });
  }
}), H4 = (e, t) => (e.replaceRoutes = (r) => {
  if (window.sessionStorage.getItem(t.sessionRoutesToken) != r) {
    const n = t.routeGetter(r);
    e.getRoutes().forEach((a) => {
      a.name && e.removeRoute(a.name);
    }), n.forEach((a) => {
      e.addRoute(a);
    }), window.sessionStorage.setItem(t.sessionRoutesToken, r), e.currentRoute.value.name && e.replace({ name: e.currentRoute.value.name });
  }
}, e.nextStep = () => {
  const r = e.getRoutes().find(
    (n) => n.meta.step == e.currentRoute.value.meta.step + 1
  );
  r && e.push(r.path);
}, e.previousStep = () => {
  const r = e.getRoutes().find(
    (n) => n.meta.step == e.currentRoute.value.meta.step - 1
  );
  r && e.push(r.path);
}, e.skipStep = (r) => {
  const n = e.getRoutes().find(
    (a) => a.meta.step == e.currentRoute.value.meta.step + 1 + r
  );
  n && e.push(n.path);
}, e.beforeEach((r, n) => {
  var a, i;
  r.meta.animation = ((a = n.meta) == null ? void 0 : a.step) < ((i = r.meta) == null ? void 0 : i.step) ? "slide-right" : "slide-left";
}), e), W4 = (e) => ({
  state: () => ({
    journeyId: void 0,
    data: { ...e.data },
    ...e.state
  }),
  actions: {
    changeJourneyID(t) {
      this.journeyId = t;
    },
    changeData(t, r = "data") {
      var a;
      const n = this[r][t.key];
      n && (n.value = t.value, n.options && (n.label = Array.isArray(t.value) ? n.value.map(
        (i) => {
          var o;
          return (o = n.options.find((s) => s.value == i)) == null ? void 0 : o.label;
        }
      ) : (a = n.options.find((i) => i.value == t.value)) == null ? void 0 : a.label));
    },
    ...e.actions
  }
}), cm = () => {
  let e = q();
  const t = () => {
    var r;
    e.value = ((r = document == null ? void 0 : document.querySelector("#page-header")) == null ? void 0 : r.offsetHeight) ?? 0;
  };
  return It(() => {
    t(), window.addEventListener("resize", t);
  }), {
    headerHeight: e
  };
}, q4 = (e, t = 2) => {
  const { format: r } = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: t
  });
  return r(e || 0).replace(",00", "");
}, K4 = (e, t = 2) => `${e.toLocaleString("de-DE", {
  maximumFractionDigits: t
})}%`, G4 = (e, t) => {
  const r = new Date(e).toLocaleDateString("pt");
  return t == "MM/YYYY" ? r.slice(3) : r;
}, Z4 = (e) => e < 0 ? e * -1 : e, X4 = (e, t) => Object.fromEntries(
  Object.entries(t).map(
    ([r, n]) => {
      let a = [];
      return [
        r,
        Object.fromEntries(
          n.map((i, o, s) => {
            const l = e[i];
            return l.fields !== void 0 && (a = a.concat(
              typeof l.fields == "function" ? l.fields(r) : l.fields
            )), [
              i,
              {
                step: {
                  current: o + 1,
                  max: s.length
                },
                component: typeof l.component == "function" ? l.component(r) : l.component,
                fields: a
              }
            ];
          })
        )
      ];
    }
  )
), J4 = (e, t) => fetch(new URL("/core/apis/data/applyProductData", e), {
  method: "POST",
  body: JSON.stringify({
    action: "OPEN_APPLICATION_FORM",
    intent: "apply",
    journeyId: t.journeyId,
    path: t.path,
    position: t.index,
    offerSelected: t.productName,
    cggId: t.productId,
    providerCggId: t.providerId,
    has_been_clicked: !0
  })
}), dm = /* @__PURE__ */ ue({
  __name: "StickyContainer",
  props: {
    top: {},
    bottom: {},
    left: {},
    right: {}
  },
  setup(e, { expose: t }) {
    const { headerHeight: r } = cm(), n = q(), a = q();
    let i;
    return It(() => {
      i = new IntersectionObserver(
        (o) => {
          o.forEach((s) => {
            a.value = a.value !== void 0 ? !a.value : s.isIntersecting ? !0 : void 0;
          });
        },
        {
          rootMargin: `0px 0px -${window.innerHeight - (e.top || r.value)}px 0px`
        }
      ), i.observe(n.value);
    }), t({ sticky: a }), (o, s) => (E(), I("div", {
      ref_key: "stickyContainer",
      ref: n,
      class: X(["sticky-container", { sticky: a.value }]),
      style: it({
        top: `${o.top ?? w(r)}px`,
        bottom: o.bottom != null ? `${o.bottom}px` : void 0,
        left: o.left !== void 0 ? `${o.left}px` : void 0,
        right: o.right !== void 0 ? `${o.right}px` : void 0
      })
    }, [
      we(o.$slots, "default", {}, void 0, !0)
    ], 6));
  }
});
const fm = /* @__PURE__ */ ye(dm, [["__scopeId", "data-v-9ccf1143"]]);
var pm = Object.create, fd = Object.defineProperty, vm = Object.getOwnPropertyDescriptor, Ro = Object.getOwnPropertyNames, hm = Object.getPrototypeOf, mm = Object.prototype.hasOwnProperty, gm = (e, t) => function() {
  return e && (t = (0, e[Ro(e)[0]])(e = 0)), t;
}, ym = (e, t) => function() {
  return t || (0, e[Ro(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, bm = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of Ro(t))
      !mm.call(e, a) && a !== r && fd(e, a, { get: () => t[a], enumerable: !(n = vm(t, a)) || n.enumerable });
  return e;
}, _m = (e, t, r) => (r = e != null ? pm(hm(e)) : {}, bm(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? fd(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), ga = gm({
  "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.0_@types+node@22.10.1__@swc+core@1.5.29_jiti@2.0.0_p_swvvp2d4pgn6xuiiec4l4x2i7a/node_modules/tsup/assets/esm_shims.js"() {
  }
}), wm = ym({
  "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js"(e, t) {
    ga(), t.exports = n;
    function r(i) {
      return i instanceof Buffer ? Buffer.from(i) : new i.constructor(i.buffer.slice(), i.byteOffset, i.length);
    }
    function n(i) {
      if (i = i || {}, i.circles)
        return a(i);
      const o = /* @__PURE__ */ new Map();
      if (o.set(Date, (f) => new Date(f)), o.set(Map, (f, p) => new Map(l(Array.from(f), p))), o.set(Set, (f, p) => new Set(l(Array.from(f), p))), i.constructorHandlers)
        for (const f of i.constructorHandlers)
          o.set(f[0], f[1]);
      let s = null;
      return i.proto ? c : u;
      function l(f, p) {
        const d = Object.keys(f), m = new Array(d.length);
        for (let g = 0; g < d.length; g++) {
          const h = d[g], y = f[h];
          typeof y != "object" || y === null ? m[h] = y : y.constructor !== Object && (s = o.get(y.constructor)) ? m[h] = s(y, p) : ArrayBuffer.isView(y) ? m[h] = r(y) : m[h] = p(y);
        }
        return m;
      }
      function u(f) {
        if (typeof f != "object" || f === null)
          return f;
        if (Array.isArray(f))
          return l(f, u);
        if (f.constructor !== Object && (s = o.get(f.constructor)))
          return s(f, u);
        const p = {};
        for (const d in f) {
          if (Object.hasOwnProperty.call(f, d) === !1)
            continue;
          const m = f[d];
          typeof m != "object" || m === null ? p[d] = m : m.constructor !== Object && (s = o.get(m.constructor)) ? p[d] = s(m, u) : ArrayBuffer.isView(m) ? p[d] = r(m) : p[d] = u(m);
        }
        return p;
      }
      function c(f) {
        if (typeof f != "object" || f === null)
          return f;
        if (Array.isArray(f))
          return l(f, c);
        if (f.constructor !== Object && (s = o.get(f.constructor)))
          return s(f, c);
        const p = {};
        for (const d in f) {
          const m = f[d];
          typeof m != "object" || m === null ? p[d] = m : m.constructor !== Object && (s = o.get(m.constructor)) ? p[d] = s(m, c) : ArrayBuffer.isView(m) ? p[d] = r(m) : p[d] = c(m);
        }
        return p;
      }
    }
    function a(i) {
      const o = [], s = [], l = /* @__PURE__ */ new Map();
      if (l.set(Date, (d) => new Date(d)), l.set(Map, (d, m) => new Map(c(Array.from(d), m))), l.set(Set, (d, m) => new Set(c(Array.from(d), m))), i.constructorHandlers)
        for (const d of i.constructorHandlers)
          l.set(d[0], d[1]);
      let u = null;
      return i.proto ? p : f;
      function c(d, m) {
        const g = Object.keys(d), h = new Array(g.length);
        for (let y = 0; y < g.length; y++) {
          const _ = g[y], $ = d[_];
          if (typeof $ != "object" || $ === null)
            h[_] = $;
          else if ($.constructor !== Object && (u = l.get($.constructor)))
            h[_] = u($, m);
          else if (ArrayBuffer.isView($))
            h[_] = r($);
          else {
            const v = o.indexOf($);
            v !== -1 ? h[_] = s[v] : h[_] = m($);
          }
        }
        return h;
      }
      function f(d) {
        if (typeof d != "object" || d === null)
          return d;
        if (Array.isArray(d))
          return c(d, f);
        if (d.constructor !== Object && (u = l.get(d.constructor)))
          return u(d, f);
        const m = {};
        o.push(d), s.push(m);
        for (const g in d) {
          if (Object.hasOwnProperty.call(d, g) === !1)
            continue;
          const h = d[g];
          if (typeof h != "object" || h === null)
            m[g] = h;
          else if (h.constructor !== Object && (u = l.get(h.constructor)))
            m[g] = u(h, f);
          else if (ArrayBuffer.isView(h))
            m[g] = r(h);
          else {
            const y = o.indexOf(h);
            y !== -1 ? m[g] = s[y] : m[g] = f(h);
          }
        }
        return o.pop(), s.pop(), m;
      }
      function p(d) {
        if (typeof d != "object" || d === null)
          return d;
        if (Array.isArray(d))
          return c(d, p);
        if (d.constructor !== Object && (u = l.get(d.constructor)))
          return u(d, p);
        const m = {};
        o.push(d), s.push(m);
        for (const g in d) {
          const h = d[g];
          if (typeof h != "object" || h === null)
            m[g] = h;
          else if (h.constructor !== Object && (u = l.get(h.constructor)))
            m[g] = u(h, p);
          else if (ArrayBuffer.isView(h))
            m[g] = r(h);
          else {
            const y = o.indexOf(h);
            y !== -1 ? m[g] = s[y] : m[g] = p(h);
          }
        }
        return o.pop(), s.pop(), m;
      }
    }
  }
});
ga();
ga();
ga();
var pd = typeof navigator < "u", G = typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : {};
typeof G.chrome < "u" && G.chrome.devtools;
pd && (G.self, G.top);
var Us;
typeof navigator < "u" && ((Us = navigator.userAgent) == null || Us.toLowerCase().includes("electron"));
ga();
var Em = _m(wm(), 1), Tm = /(?:^|[-_/])(\w)/g;
function Dm(e, t) {
  return t ? t.toUpperCase() : "";
}
function $m(e) {
  return e && `${e}`.replace(Tm, Dm);
}
function km(e, t) {
  let r = e.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
  r.endsWith(`index${t}`) && (r = r.replace(`/index${t}`, t));
  const n = r.lastIndexOf("/"), a = r.substring(n + 1);
  if (t) {
    const i = a.lastIndexOf(t);
    return a.substring(0, i);
  }
  return "";
}
var Hs = (0, Em.default)({ circles: !0 });
const Om = {
  trailing: !0
};
function nn(e, t = 25, r = {}) {
  if (r = { ...Om, ...r }, !Number.isFinite(t))
    throw new TypeError("Expected `wait` to be a finite number");
  let n, a, i = [], o, s;
  const l = (u, c) => (o = Cm(e, u, c), o.finally(() => {
    if (o = null, r.trailing && s && !a) {
      const f = l(u, s);
      return s = null, f;
    }
  }), o);
  return function(...u) {
    return o ? (r.trailing && (s = u), o) : new Promise((c) => {
      const f = !a && r.leading;
      clearTimeout(a), a = setTimeout(() => {
        a = null;
        const p = r.leading ? n : l(this, u);
        for (const d of i)
          d(p);
        i = [];
      }, t), f ? (n = l(this, u), c(n)) : i.push(c);
    });
  };
}
async function Cm(e, t, r) {
  return await e.apply(t, r);
}
function Zi(e, t = {}, r) {
  for (const n in e) {
    const a = e[n], i = r ? `${r}:${n}` : n;
    typeof a == "object" && a !== null ? Zi(a, t, i) : typeof a == "function" && (t[i] = a);
  }
  return t;
}
const Sm = { run: (e) => e() }, Am = () => Sm, vd = typeof console.createTask < "u" ? console.createTask : Am;
function Mm(e, t) {
  const r = t.shift(), n = vd(r);
  return e.reduce(
    (a, i) => a.then(() => n.run(() => i(...t))),
    Promise.resolve()
  );
}
function Im(e, t) {
  const r = t.shift(), n = vd(r);
  return Promise.all(e.map((a) => n.run(() => a(...t))));
}
function Oi(e, t) {
  for (const r of [...e])
    r(t);
}
class Pm {
  constructor() {
    this._hooks = {}, this._before = void 0, this._after = void 0, this._deprecatedMessages = void 0, this._deprecatedHooks = {}, this.hook = this.hook.bind(this), this.callHook = this.callHook.bind(this), this.callHookWith = this.callHookWith.bind(this);
  }
  hook(t, r, n = {}) {
    if (!t || typeof r != "function")
      return () => {
      };
    const a = t;
    let i;
    for (; this._deprecatedHooks[t]; )
      i = this._deprecatedHooks[t], t = i.to;
    if (i && !n.allowDeprecated) {
      let o = i.message;
      o || (o = `${a} hook has been deprecated` + (i.to ? `, please use ${i.to}` : "")), this._deprecatedMessages || (this._deprecatedMessages = /* @__PURE__ */ new Set()), this._deprecatedMessages.has(o) || (console.warn(o), this._deprecatedMessages.add(o));
    }
    if (!r.name)
      try {
        Object.defineProperty(r, "name", {
          get: () => "_" + t.replace(/\W+/g, "_") + "_hook_cb",
          configurable: !0
        });
      } catch {
      }
    return this._hooks[t] = this._hooks[t] || [], this._hooks[t].push(r), () => {
      r && (this.removeHook(t, r), r = void 0);
    };
  }
  hookOnce(t, r) {
    let n, a = (...i) => (typeof n == "function" && n(), n = void 0, a = void 0, r(...i));
    return n = this.hook(t, a), n;
  }
  removeHook(t, r) {
    if (this._hooks[t]) {
      const n = this._hooks[t].indexOf(r);
      n !== -1 && this._hooks[t].splice(n, 1), this._hooks[t].length === 0 && delete this._hooks[t];
    }
  }
  deprecateHook(t, r) {
    this._deprecatedHooks[t] = typeof r == "string" ? { to: r } : r;
    const n = this._hooks[t] || [];
    delete this._hooks[t];
    for (const a of n)
      this.hook(t, a);
  }
  deprecateHooks(t) {
    Object.assign(this._deprecatedHooks, t);
    for (const r in t)
      this.deprecateHook(r, t[r]);
  }
  addHooks(t) {
    const r = Zi(t), n = Object.keys(r).map(
      (a) => this.hook(a, r[a])
    );
    return () => {
      for (const a of n.splice(0, n.length))
        a();
    };
  }
  removeHooks(t) {
    const r = Zi(t);
    for (const n in r)
      this.removeHook(n, r[n]);
  }
  removeAllHooks() {
    for (const t in this._hooks)
      delete this._hooks[t];
  }
  callHook(t, ...r) {
    return r.unshift(t), this.callHookWith(Mm, t, ...r);
  }
  callHookParallel(t, ...r) {
    return r.unshift(t), this.callHookWith(Im, t, ...r);
  }
  callHookWith(t, r, ...n) {
    const a = this._before || this._after ? { name: r, args: n, context: {} } : void 0;
    this._before && Oi(this._before, a);
    const i = t(
      r in this._hooks ? [...this._hooks[r]] : [],
      n
    );
    return i instanceof Promise ? i.finally(() => {
      this._after && a && Oi(this._after, a);
    }) : (this._after && a && Oi(this._after, a), i);
  }
  beforeEach(t) {
    return this._before = this._before || [], this._before.push(t), () => {
      if (this._before !== void 0) {
        const r = this._before.indexOf(t);
        r !== -1 && this._before.splice(r, 1);
      }
    };
  }
  afterEach(t) {
    return this._after = this._after || [], this._after.push(t), () => {
      if (this._after !== void 0) {
        const r = this._after.indexOf(t);
        r !== -1 && this._after.splice(r, 1);
      }
    };
  }
}
function hd() {
  return new Pm();
}
var xm = Object.create, md = Object.defineProperty, Lm = Object.getOwnPropertyDescriptor, Fo = Object.getOwnPropertyNames, Rm = Object.getPrototypeOf, Fm = Object.prototype.hasOwnProperty, Vm = (e, t) => function() {
  return e && (t = (0, e[Fo(e)[0]])(e = 0)), t;
}, gd = (e, t) => function() {
  return t || (0, e[Fo(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Nm = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of Fo(t))
      !Fm.call(e, a) && a !== r && md(e, a, { get: () => t[a], enumerable: !(n = Lm(t, a)) || n.enumerable });
  return e;
}, Bm = (e, t, r) => (r = e != null ? xm(Rm(e)) : {}, Nm(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? md(r, "default", { value: e, enumerable: !0 }) : r,
  e
)), x = Vm({
  "../../node_modules/.pnpm/tsup@8.3.5_@microsoft+api-extractor@7.48.0_@types+node@22.10.1__@swc+core@1.5.29_jiti@2.0.0_p_swvvp2d4pgn6xuiiec4l4x2i7a/node_modules/tsup/assets/esm_shims.js"() {
  }
}), Ym = gd({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js"(e, t) {
    x(), function(r) {
      var n = {
        // latin
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "Ae",
        Å: "A",
        Æ: "AE",
        Ç: "C",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        Ð: "D",
        Ñ: "N",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "Oe",
        Ő: "O",
        Ø: "O",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "Ue",
        Ű: "U",
        Ý: "Y",
        Þ: "TH",
        ß: "ss",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "ae",
        å: "a",
        æ: "ae",
        ç: "c",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        ð: "d",
        ñ: "n",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "oe",
        ő: "o",
        ø: "o",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "ue",
        ű: "u",
        ý: "y",
        þ: "th",
        ÿ: "y",
        "ẞ": "SS",
        // language specific
        // Arabic
        ا: "a",
        أ: "a",
        إ: "i",
        آ: "aa",
        ؤ: "u",
        ئ: "e",
        ء: "a",
        ب: "b",
        ت: "t",
        ث: "th",
        ج: "j",
        ح: "h",
        خ: "kh",
        د: "d",
        ذ: "th",
        ر: "r",
        ز: "z",
        س: "s",
        ش: "sh",
        ص: "s",
        ض: "dh",
        ط: "t",
        ظ: "z",
        ع: "a",
        غ: "gh",
        ف: "f",
        ق: "q",
        ك: "k",
        ل: "l",
        م: "m",
        ن: "n",
        ه: "h",
        و: "w",
        ي: "y",
        ى: "a",
        ة: "h",
        ﻻ: "la",
        ﻷ: "laa",
        ﻹ: "lai",
        ﻵ: "laa",
        // Persian additional characters than Arabic
        گ: "g",
        چ: "ch",
        پ: "p",
        ژ: "zh",
        ک: "k",
        ی: "y",
        // Arabic diactrics
        "َ": "a",
        "ً": "an",
        "ِ": "e",
        "ٍ": "en",
        "ُ": "u",
        "ٌ": "on",
        "ْ": "",
        // Arabic numbers
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        // Persian numbers
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        // Burmese consonants
        က: "k",
        ခ: "kh",
        ဂ: "g",
        ဃ: "ga",
        င: "ng",
        စ: "s",
        ဆ: "sa",
        ဇ: "z",
        "စျ": "za",
        ည: "ny",
        ဋ: "t",
        ဌ: "ta",
        ဍ: "d",
        ဎ: "da",
        ဏ: "na",
        တ: "t",
        ထ: "ta",
        ဒ: "d",
        ဓ: "da",
        န: "n",
        ပ: "p",
        ဖ: "pa",
        ဗ: "b",
        ဘ: "ba",
        မ: "m",
        ယ: "y",
        ရ: "ya",
        လ: "l",
        ဝ: "w",
        သ: "th",
        ဟ: "h",
        ဠ: "la",
        အ: "a",
        // consonant character combos
        "ြ": "y",
        "ျ": "ya",
        "ွ": "w",
        "ြွ": "yw",
        "ျွ": "ywa",
        "ှ": "h",
        // independent vowels
        ဧ: "e",
        "၏": "-e",
        ဣ: "i",
        ဤ: "-i",
        ဉ: "u",
        ဦ: "-u",
        ဩ: "aw",
        "သြော": "aw",
        ဪ: "aw",
        // numbers
        "၀": "0",
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9",
        // virama and tone marks which are silent in transliteration
        "္": "",
        "့": "",
        "း": "",
        // Czech
        č: "c",
        ď: "d",
        ě: "e",
        ň: "n",
        ř: "r",
        š: "s",
        ť: "t",
        ů: "u",
        ž: "z",
        Č: "C",
        Ď: "D",
        Ě: "E",
        Ň: "N",
        Ř: "R",
        Š: "S",
        Ť: "T",
        Ů: "U",
        Ž: "Z",
        // Dhivehi
        ހ: "h",
        ށ: "sh",
        ނ: "n",
        ރ: "r",
        ބ: "b",
        ޅ: "lh",
        ކ: "k",
        އ: "a",
        ވ: "v",
        މ: "m",
        ފ: "f",
        ދ: "dh",
        ތ: "th",
        ލ: "l",
        ގ: "g",
        ޏ: "gn",
        ސ: "s",
        ޑ: "d",
        ޒ: "z",
        ޓ: "t",
        ޔ: "y",
        ޕ: "p",
        ޖ: "j",
        ޗ: "ch",
        ޘ: "tt",
        ޙ: "hh",
        ޚ: "kh",
        ޛ: "th",
        ޜ: "z",
        ޝ: "sh",
        ޞ: "s",
        ޟ: "d",
        ޠ: "t",
        ޡ: "z",
        ޢ: "a",
        ޣ: "gh",
        ޤ: "q",
        ޥ: "w",
        "ަ": "a",
        "ާ": "aa",
        "ި": "i",
        "ީ": "ee",
        "ު": "u",
        "ޫ": "oo",
        "ެ": "e",
        "ޭ": "ey",
        "ޮ": "o",
        "ޯ": "oa",
        "ް": "",
        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        ა: "a",
        ბ: "b",
        გ: "g",
        დ: "d",
        ე: "e",
        ვ: "v",
        ზ: "z",
        თ: "t",
        ი: "i",
        კ: "k",
        ლ: "l",
        მ: "m",
        ნ: "n",
        ო: "o",
        პ: "p",
        ჟ: "zh",
        რ: "r",
        ს: "s",
        ტ: "t",
        უ: "u",
        ფ: "p",
        ქ: "k",
        ღ: "gh",
        ყ: "q",
        შ: "sh",
        ჩ: "ch",
        ც: "ts",
        ძ: "dz",
        წ: "ts",
        ჭ: "ch",
        ხ: "kh",
        ჯ: "j",
        ჰ: "h",
        // Greek
        α: "a",
        β: "v",
        γ: "g",
        δ: "d",
        ε: "e",
        ζ: "z",
        η: "i",
        θ: "th",
        ι: "i",
        κ: "k",
        λ: "l",
        μ: "m",
        ν: "n",
        ξ: "ks",
        ο: "o",
        π: "p",
        ρ: "r",
        σ: "s",
        τ: "t",
        υ: "y",
        φ: "f",
        χ: "x",
        ψ: "ps",
        ω: "o",
        ά: "a",
        έ: "e",
        ί: "i",
        ό: "o",
        ύ: "y",
        ή: "i",
        ώ: "o",
        ς: "s",
        ϊ: "i",
        ΰ: "y",
        ϋ: "y",
        ΐ: "i",
        Α: "A",
        Β: "B",
        Γ: "G",
        Δ: "D",
        Ε: "E",
        Ζ: "Z",
        Η: "I",
        Θ: "TH",
        Ι: "I",
        Κ: "K",
        Λ: "L",
        Μ: "M",
        Ν: "N",
        Ξ: "KS",
        Ο: "O",
        Π: "P",
        Ρ: "R",
        Σ: "S",
        Τ: "T",
        Υ: "Y",
        Φ: "F",
        Χ: "X",
        Ψ: "PS",
        Ω: "O",
        Ά: "A",
        Έ: "E",
        Ί: "I",
        Ό: "O",
        Ύ: "Y",
        Ή: "I",
        Ώ: "O",
        Ϊ: "I",
        Ϋ: "Y",
        // Latvian
        ā: "a",
        // 'č': 'c', // duplicate
        ē: "e",
        ģ: "g",
        ī: "i",
        ķ: "k",
        ļ: "l",
        ņ: "n",
        // 'š': 's', // duplicate
        ū: "u",
        // 'ž': 'z', // duplicate
        Ā: "A",
        // 'Č': 'C', // duplicate
        Ē: "E",
        Ģ: "G",
        Ī: "I",
        Ķ: "k",
        Ļ: "L",
        Ņ: "N",
        // 'Š': 'S', // duplicate
        Ū: "U",
        // 'Ž': 'Z', // duplicate
        // Macedonian
        Ќ: "Kj",
        ќ: "kj",
        Љ: "Lj",
        љ: "lj",
        Њ: "Nj",
        њ: "nj",
        Тс: "Ts",
        тс: "ts",
        // Polish
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        // 'ó': 'o', // duplicate
        ś: "s",
        ź: "z",
        ż: "z",
        Ą: "A",
        Ć: "C",
        Ę: "E",
        Ł: "L",
        Ń: "N",
        Ś: "S",
        Ź: "Z",
        Ż: "Z",
        // Ukranian
        Є: "Ye",
        І: "I",
        Ї: "Yi",
        Ґ: "G",
        є: "ye",
        і: "i",
        ї: "yi",
        ґ: "g",
        // Romanian
        ă: "a",
        Ă: "A",
        ș: "s",
        Ș: "S",
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        ț: "t",
        Ț: "T",
        ţ: "t",
        Ţ: "T",
        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "yo",
        ж: "zh",
        з: "z",
        и: "i",
        й: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "kh",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "sh",
        ъ: "",
        ы: "y",
        ь: "",
        э: "e",
        ю: "yu",
        я: "ya",
        А: "A",
        Б: "B",
        В: "V",
        Г: "G",
        Д: "D",
        Е: "E",
        Ё: "Yo",
        Ж: "Zh",
        З: "Z",
        И: "I",
        Й: "I",
        К: "K",
        Л: "L",
        М: "M",
        Н: "N",
        О: "O",
        П: "P",
        Р: "R",
        С: "S",
        Т: "T",
        У: "U",
        Ф: "F",
        Х: "Kh",
        Ц: "C",
        Ч: "Ch",
        Ш: "Sh",
        Щ: "Sh",
        Ъ: "",
        Ы: "Y",
        Ь: "",
        Э: "E",
        Ю: "Yu",
        Я: "Ya",
        // Serbian
        ђ: "dj",
        ј: "j",
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        ћ: "c",
        џ: "dz",
        Ђ: "Dj",
        Ј: "j",
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        Ћ: "C",
        Џ: "Dz",
        // Slovak
        ľ: "l",
        ĺ: "l",
        ŕ: "r",
        Ľ: "L",
        Ĺ: "L",
        Ŕ: "R",
        // Turkish
        ş: "s",
        Ş: "S",
        ı: "i",
        İ: "I",
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        ğ: "g",
        Ğ: "G",
        // Vietnamese
        ả: "a",
        Ả: "A",
        ẳ: "a",
        Ẳ: "A",
        ẩ: "a",
        Ẩ: "A",
        đ: "d",
        Đ: "D",
        ẹ: "e",
        Ẹ: "E",
        ẽ: "e",
        Ẽ: "E",
        ẻ: "e",
        Ẻ: "E",
        ế: "e",
        Ế: "E",
        ề: "e",
        Ề: "E",
        ệ: "e",
        Ệ: "E",
        ễ: "e",
        Ễ: "E",
        ể: "e",
        Ể: "E",
        ỏ: "o",
        ọ: "o",
        Ọ: "o",
        ố: "o",
        Ố: "O",
        ồ: "o",
        Ồ: "O",
        ổ: "o",
        Ổ: "O",
        ộ: "o",
        Ộ: "O",
        ỗ: "o",
        Ỗ: "O",
        ơ: "o",
        Ơ: "O",
        ớ: "o",
        Ớ: "O",
        ờ: "o",
        Ờ: "O",
        ợ: "o",
        Ợ: "O",
        ỡ: "o",
        Ỡ: "O",
        Ở: "o",
        ở: "o",
        ị: "i",
        Ị: "I",
        ĩ: "i",
        Ĩ: "I",
        ỉ: "i",
        Ỉ: "i",
        ủ: "u",
        Ủ: "U",
        ụ: "u",
        Ụ: "U",
        ũ: "u",
        Ũ: "U",
        ư: "u",
        Ư: "U",
        ứ: "u",
        Ứ: "U",
        ừ: "u",
        Ừ: "U",
        ự: "u",
        Ự: "U",
        ữ: "u",
        Ữ: "U",
        ử: "u",
        Ử: "ư",
        ỷ: "y",
        Ỷ: "y",
        ỳ: "y",
        Ỳ: "Y",
        ỵ: "y",
        Ỵ: "Y",
        ỹ: "y",
        Ỹ: "Y",
        ạ: "a",
        Ạ: "A",
        ấ: "a",
        Ấ: "A",
        ầ: "a",
        Ầ: "A",
        ậ: "a",
        Ậ: "A",
        ẫ: "a",
        Ẫ: "A",
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        ắ: "a",
        Ắ: "A",
        ằ: "a",
        Ằ: "A",
        ặ: "a",
        Ặ: "A",
        ẵ: "a",
        Ẵ: "A",
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",
        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",
        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",
        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",
        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",
        // symbols
        "“": '"',
        "”": '"',
        "‘": "'",
        "’": "'",
        "∂": "d",
        ƒ: "f",
        "™": "(TM)",
        "©": "(C)",
        œ: "oe",
        Œ: "OE",
        "®": "(R)",
        "†": "+",
        "℠": "(SM)",
        "…": "...",
        "˚": "o",
        º: "o",
        ª: "a",
        "•": "*",
        "၊": ",",
        "။": ".",
        // currency
        $: "USD",
        "€": "EUR",
        "₢": "BRN",
        "₣": "FRF",
        "£": "GBP",
        "₤": "ITL",
        "₦": "NGN",
        "₧": "ESP",
        "₩": "KRW",
        "₪": "ILS",
        "₫": "VND",
        "₭": "LAK",
        "₮": "MNT",
        "₯": "GRD",
        "₱": "ARS",
        "₲": "PYG",
        "₳": "ARA",
        "₴": "UAH",
        "₵": "GHS",
        "¢": "cent",
        "¥": "CNY",
        元: "CNY",
        円: "YEN",
        "﷼": "IRR",
        "₠": "EWE",
        "฿": "THB",
        "₨": "INR",
        "₹": "INR",
        "₰": "PF",
        "₺": "TRY",
        "؋": "AFN",
        "₼": "AZN",
        лв: "BGN",
        "៛": "KHR",
        "₡": "CRC",
        "₸": "KZT",
        ден: "MKD",
        zł: "PLN",
        "₽": "RUB",
        "₾": "GEL"
      }, a = [
        // burmese
        "်",
        // Dhivehi
        "ް"
      ], i = {
        // Burmese
        // dependent vowels
        "ာ": "a",
        "ါ": "a",
        "ေ": "e",
        "ဲ": "e",
        "ိ": "i",
        "ီ": "i",
        "ို": "o",
        "ု": "u",
        "ူ": "u",
        "ေါင်": "aung",
        "ော": "aw",
        "ော်": "aw",
        "ေါ": "aw",
        "ေါ်": "aw",
        "်": "်",
        // this is special case but the character will be converted to latin in the code
        "က်": "et",
        "ိုက်": "aik",
        "ောက်": "auk",
        "င်": "in",
        "ိုင်": "aing",
        "ောင်": "aung",
        "စ်": "it",
        "ည်": "i",
        "တ်": "at",
        "ိတ်": "eik",
        "ုတ်": "ok",
        "ွတ်": "ut",
        "ေတ်": "it",
        "ဒ်": "d",
        "ိုဒ်": "ok",
        "ုဒ်": "ait",
        "န်": "an",
        "ာန်": "an",
        "ိန်": "ein",
        "ုန်": "on",
        "ွန်": "un",
        "ပ်": "at",
        "ိပ်": "eik",
        "ုပ်": "ok",
        "ွပ်": "ut",
        "န်ုပ်": "nub",
        "မ်": "an",
        "ိမ်": "ein",
        "ုမ်": "on",
        "ွမ်": "un",
        "ယ်": "e",
        "ိုလ်": "ol",
        "ဉ်": "in",
        "ံ": "an",
        "ိံ": "ein",
        "ုံ": "on",
        // Dhivehi
        "ައް": "ah",
        "ަށް": "ah"
      }, o = {
        en: {},
        // default language
        az: {
          // Azerbaijani
          ç: "c",
          ə: "e",
          ğ: "g",
          ı: "i",
          ö: "o",
          ş: "s",
          ü: "u",
          Ç: "C",
          Ə: "E",
          Ğ: "G",
          İ: "I",
          Ö: "O",
          Ş: "S",
          Ü: "U"
        },
        cs: {
          // Czech
          č: "c",
          ď: "d",
          ě: "e",
          ň: "n",
          ř: "r",
          š: "s",
          ť: "t",
          ů: "u",
          ž: "z",
          Č: "C",
          Ď: "D",
          Ě: "E",
          Ň: "N",
          Ř: "R",
          Š: "S",
          Ť: "T",
          Ů: "U",
          Ž: "Z"
        },
        fi: {
          // Finnish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        hu: {
          // Hungarian
          ä: "a",
          // ok
          Ä: "A",
          // ok
          // 'á': 'a', duplicate see charMap/latin
          // 'Á': 'A', duplicate see charMap/latin
          ö: "o",
          // ok
          Ö: "O",
          // ok
          // 'ő': 'o', duplicate see charMap/latin
          // 'Ő': 'O', duplicate see charMap/latin
          ü: "u",
          Ü: "U",
          ű: "u",
          Ű: "U"
        },
        lt: {
          // Lithuanian
          ą: "a",
          č: "c",
          ę: "e",
          ė: "e",
          į: "i",
          š: "s",
          ų: "u",
          ū: "u",
          ž: "z",
          Ą: "A",
          Č: "C",
          Ę: "E",
          Ė: "E",
          Į: "I",
          Š: "S",
          Ų: "U",
          Ū: "U"
        },
        lv: {
          // Latvian
          ā: "a",
          č: "c",
          ē: "e",
          ģ: "g",
          ī: "i",
          ķ: "k",
          ļ: "l",
          ņ: "n",
          š: "s",
          ū: "u",
          ž: "z",
          Ā: "A",
          Č: "C",
          Ē: "E",
          Ģ: "G",
          Ī: "i",
          Ķ: "k",
          Ļ: "L",
          Ņ: "N",
          Š: "S",
          Ū: "u",
          Ž: "Z"
        },
        pl: {
          // Polish
          ą: "a",
          ć: "c",
          ę: "e",
          ł: "l",
          ń: "n",
          ó: "o",
          ś: "s",
          ź: "z",
          ż: "z",
          Ą: "A",
          Ć: "C",
          Ę: "e",
          Ł: "L",
          Ń: "N",
          Ó: "O",
          Ś: "S",
          Ź: "Z",
          Ż: "Z"
        },
        sv: {
          // Swedish
          // 'å': 'a', duplicate see charMap/latin
          // 'Å': 'A', duplicate see charMap/latin
          ä: "a",
          // ok
          Ä: "A",
          // ok
          ö: "o",
          // ok
          Ö: "O"
          // ok
        },
        sk: {
          // Slovak
          ä: "a",
          Ä: "A"
        },
        sr: {
          // Serbian
          љ: "lj",
          њ: "nj",
          Љ: "Lj",
          Њ: "Nj",
          đ: "dj",
          Đ: "Dj"
        },
        tr: {
          // Turkish
          Ü: "U",
          Ö: "O",
          ü: "u",
          ö: "o"
        }
      }, s = {
        ar: {
          "∆": "delta",
          "∞": "la-nihaya",
          "♥": "hob",
          "&": "wa",
          "|": "aw",
          "<": "aqal-men",
          ">": "akbar-men",
          "∑": "majmou",
          "¤": "omla"
        },
        az: {},
        ca: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "amor",
          "&": "i",
          "|": "o",
          "<": "menys que",
          ">": "mes que",
          "∑": "suma dels",
          "¤": "moneda"
        },
        cs: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "nebo",
          "<": "mensi nez",
          ">": "vetsi nez",
          "∑": "soucet",
          "¤": "mena"
        },
        de: {
          "∆": "delta",
          "∞": "unendlich",
          "♥": "Liebe",
          "&": "und",
          "|": "oder",
          "<": "kleiner als",
          ">": "groesser als",
          "∑": "Summe von",
          "¤": "Waehrung"
        },
        dv: {
          "∆": "delta",
          "∞": "kolunulaa",
          "♥": "loabi",
          "&": "aai",
          "|": "noonee",
          "<": "ah vure kuda",
          ">": "ah vure bodu",
          "∑": "jumula",
          "¤": "faisaa"
        },
        en: {
          "∆": "delta",
          "∞": "infinity",
          "♥": "love",
          "&": "and",
          "|": "or",
          "<": "less than",
          ">": "greater than",
          "∑": "sum",
          "¤": "currency"
        },
        es: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "y",
          "|": "u",
          "<": "menos que",
          ">": "mas que",
          "∑": "suma de los",
          "¤": "moneda"
        },
        fa: {
          "∆": "delta",
          "∞": "bi-nahayat",
          "♥": "eshgh",
          "&": "va",
          "|": "ya",
          "<": "kamtar-az",
          ">": "bishtar-az",
          "∑": "majmooe",
          "¤": "vahed"
        },
        fi: {
          "∆": "delta",
          "∞": "aarettomyys",
          "♥": "rakkaus",
          "&": "ja",
          "|": "tai",
          "<": "pienempi kuin",
          ">": "suurempi kuin",
          "∑": "summa",
          "¤": "valuutta"
        },
        fr: {
          "∆": "delta",
          "∞": "infiniment",
          "♥": "Amour",
          "&": "et",
          "|": "ou",
          "<": "moins que",
          ">": "superieure a",
          "∑": "somme des",
          "¤": "monnaie"
        },
        ge: {
          "∆": "delta",
          "∞": "usasruloba",
          "♥": "siqvaruli",
          "&": "da",
          "|": "an",
          "<": "naklebi",
          ">": "meti",
          "∑": "jami",
          "¤": "valuta"
        },
        gr: {},
        hu: {
          "∆": "delta",
          "∞": "vegtelen",
          "♥": "szerelem",
          "&": "es",
          "|": "vagy",
          "<": "kisebb mint",
          ">": "nagyobb mint",
          "∑": "szumma",
          "¤": "penznem"
        },
        it: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amore",
          "&": "e",
          "|": "o",
          "<": "minore di",
          ">": "maggiore di",
          "∑": "somma",
          "¤": "moneta"
        },
        lt: {
          "∆": "delta",
          "∞": "begalybe",
          "♥": "meile",
          "&": "ir",
          "|": "ar",
          "<": "maziau nei",
          ">": "daugiau nei",
          "∑": "suma",
          "¤": "valiuta"
        },
        lv: {
          "∆": "delta",
          "∞": "bezgaliba",
          "♥": "milestiba",
          "&": "un",
          "|": "vai",
          "<": "mazak neka",
          ">": "lielaks neka",
          "∑": "summa",
          "¤": "valuta"
        },
        my: {
          "∆": "kwahkhyaet",
          "∞": "asaonasme",
          "♥": "akhyait",
          "&": "nhin",
          "|": "tho",
          "<": "ngethaw",
          ">": "kyithaw",
          "∑": "paungld",
          "¤": "ngwekye"
        },
        mk: {},
        nl: {
          "∆": "delta",
          "∞": "oneindig",
          "♥": "liefde",
          "&": "en",
          "|": "of",
          "<": "kleiner dan",
          ">": "groter dan",
          "∑": "som",
          "¤": "valuta"
        },
        pl: {
          "∆": "delta",
          "∞": "nieskonczonosc",
          "♥": "milosc",
          "&": "i",
          "|": "lub",
          "<": "mniejsze niz",
          ">": "wieksze niz",
          "∑": "suma",
          "¤": "waluta"
        },
        pt: {
          "∆": "delta",
          "∞": "infinito",
          "♥": "amor",
          "&": "e",
          "|": "ou",
          "<": "menor que",
          ">": "maior que",
          "∑": "soma",
          "¤": "moeda"
        },
        ro: {
          "∆": "delta",
          "∞": "infinit",
          "♥": "dragoste",
          "&": "si",
          "|": "sau",
          "<": "mai mic ca",
          ">": "mai mare ca",
          "∑": "suma",
          "¤": "valuta"
        },
        ru: {
          "∆": "delta",
          "∞": "beskonechno",
          "♥": "lubov",
          "&": "i",
          "|": "ili",
          "<": "menshe",
          ">": "bolshe",
          "∑": "summa",
          "¤": "valjuta"
        },
        sk: {
          "∆": "delta",
          "∞": "nekonecno",
          "♥": "laska",
          "&": "a",
          "|": "alebo",
          "<": "menej ako",
          ">": "viac ako",
          "∑": "sucet",
          "¤": "mena"
        },
        sr: {},
        tr: {
          "∆": "delta",
          "∞": "sonsuzluk",
          "♥": "ask",
          "&": "ve",
          "|": "veya",
          "<": "kucuktur",
          ">": "buyuktur",
          "∑": "toplam",
          "¤": "para birimi"
        },
        uk: {
          "∆": "delta",
          "∞": "bezkinechnist",
          "♥": "lubov",
          "&": "i",
          "|": "abo",
          "<": "menshe",
          ">": "bilshe",
          "∑": "suma",
          "¤": "valjuta"
        },
        vn: {
          "∆": "delta",
          "∞": "vo cuc",
          "♥": "yeu",
          "&": "va",
          "|": "hoac",
          "<": "nho hon",
          ">": "lon hon",
          "∑": "tong",
          "¤": "tien te"
        }
      }, l = [";", "?", ":", "@", "&", "=", "+", "$", ",", "/"].join(""), u = [";", "?", ":", "@", "&", "=", "+", "$", ","].join(""), c = [".", "!", "~", "*", "'", "(", ")"].join(""), f = function(h, y) {
        var _ = "-", $ = "", v = "", D = !0, k = {}, T, C, V, H, N, L, U, J, W, Q, Y, pe, se, P, ae = "";
        if (typeof h != "string")
          return "";
        if (typeof y == "string" && (_ = y), U = s.en, J = o.en, typeof y == "object") {
          T = y.maintainCase || !1, k = y.custom && typeof y.custom == "object" ? y.custom : k, V = +y.truncate > 1 && y.truncate || !1, H = y.uric || !1, N = y.uricNoSlash || !1, L = y.mark || !1, D = !(y.symbols === !1 || y.lang === !1), _ = y.separator || _, H && (ae += l), N && (ae += u), L && (ae += c), U = y.lang && s[y.lang] && D ? s[y.lang] : D ? s.en : {}, J = y.lang && o[y.lang] ? o[y.lang] : y.lang === !1 || y.lang === !0 ? {} : o.en, y.titleCase && typeof y.titleCase.length == "number" && Array.prototype.toString.call(y.titleCase) ? (y.titleCase.forEach(function(z) {
            k[z + ""] = z + "";
          }), C = !0) : C = !!y.titleCase, y.custom && typeof y.custom.length == "number" && Array.prototype.toString.call(y.custom) && y.custom.forEach(function(z) {
            k[z + ""] = z + "";
          }), Object.keys(k).forEach(function(z) {
            var ge;
            z.length > 1 ? ge = new RegExp("\\b" + d(z) + "\\b", "gi") : ge = new RegExp(d(z), "gi"), h = h.replace(ge, k[z]);
          });
          for (Y in k)
            ae += Y;
        }
        for (ae += _, ae = d(ae), h = h.replace(/(^\s+|\s+$)/g, ""), se = !1, P = !1, Q = 0, pe = h.length; Q < pe; Q++)
          Y = h[Q], m(Y, k) ? se = !1 : J[Y] ? (Y = se && J[Y].match(/[A-Za-z0-9]/) ? " " + J[Y] : J[Y], se = !1) : Y in n ? (Q + 1 < pe && a.indexOf(h[Q + 1]) >= 0 ? (v += Y, Y = "") : P === !0 ? (Y = i[v] + n[Y], v = "") : Y = se && n[Y].match(/[A-Za-z0-9]/) ? " " + n[Y] : n[Y], se = !1, P = !1) : Y in i ? (v += Y, Y = "", Q === pe - 1 && (Y = i[v]), P = !0) : /* process symbol chars */ U[Y] && !(H && l.indexOf(Y) !== -1) && !(N && u.indexOf(Y) !== -1) ? (Y = se || $.substr(-1).match(/[A-Za-z0-9]/) ? _ + U[Y] : U[Y], Y += h[Q + 1] !== void 0 && h[Q + 1].match(/[A-Za-z0-9]/) ? _ : "", se = !0) : (P === !0 ? (Y = i[v] + Y, v = "", P = !1) : se && (/[A-Za-z0-9]/.test(Y) || $.substr(-1).match(/A-Za-z0-9]/)) && (Y = " " + Y), se = !1), $ += Y.replace(new RegExp("[^\\w\\s" + ae + "_-]", "g"), _);
        return C && ($ = $.replace(/(\w)(\S*)/g, function(z, ge, ee) {
          var me = ge.toUpperCase() + (ee !== null ? ee : "");
          return Object.keys(k).indexOf(me.toLowerCase()) < 0 ? me : me.toLowerCase();
        })), $ = $.replace(/\s+/g, _).replace(new RegExp("\\" + _ + "+", "g"), _).replace(new RegExp("(^\\" + _ + "+|\\" + _ + "+$)", "g"), ""), V && $.length > V && (W = $.charAt(V) === _, $ = $.slice(0, V), W || ($ = $.slice(0, $.lastIndexOf(_)))), !T && !C && ($ = $.toLowerCase()), $;
      }, p = function(h) {
        return function(_) {
          return f(_, h);
        };
      }, d = function(h) {
        return h.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
      }, m = function(g, h) {
        for (var y in h)
          if (h[y] === g)
            return !0;
      };
      if (typeof t < "u" && t.exports)
        t.exports = f, t.exports.createSlug = p;
      else if (typeof define < "u" && define.amd)
        define([], function() {
          return f;
        });
      else
        try {
          if (r.getSlug || r.createSlug)
            throw "speakingurl: globals exists /(getSlug|createSlug)/";
          r.getSlug = f, r.createSlug = p;
        } catch {
        }
    }(e);
  }
}), jm = gd({
  "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js"(e, t) {
    x(), t.exports = Ym();
  }
});
x();
x();
x();
x();
x();
x();
x();
x();
function zm(e) {
  var t;
  const r = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
  return r === "index" && ((t = e.__file) != null && t.endsWith("index.vue")) ? "" : r;
}
function Um(e) {
  const t = e.__file;
  if (t)
    return $m(km(t, ".vue"));
}
function Ws(e, t) {
  return e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t, t;
}
function ci(e) {
  if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__)
    return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  if (e.root)
    return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function Hm(e) {
  const { app: t, uid: r, instance: n } = e;
  try {
    if (n.__VUE_DEVTOOLS_NEXT_UID__)
      return n.__VUE_DEVTOOLS_NEXT_UID__;
    const a = await ci(t);
    if (!a)
      return null;
    const i = a.rootInstance === n;
    return `${a.id}:${i ? "root" : r}`;
  } catch {
  }
}
function yd(e) {
  var t, r;
  const n = (t = e.subTree) == null ? void 0 : t.type, a = ci(e);
  return a ? ((r = a == null ? void 0 : a.types) == null ? void 0 : r.Fragment) === n : !1;
}
function di(e) {
  var t, r, n;
  const a = zm((e == null ? void 0 : e.type) || {});
  if (a)
    return a;
  if ((e == null ? void 0 : e.root) === e)
    return "Root";
  for (const o in (r = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : r.components)
    if (e.parent.type.components[o] === (e == null ? void 0 : e.type))
      return Ws(e, o);
  for (const o in (n = e.appContext) == null ? void 0 : n.components)
    if (e.appContext.components[o] === (e == null ? void 0 : e.type))
      return Ws(e, o);
  const i = Um((e == null ? void 0 : e.type) || {});
  return i || "Anonymous Component";
}
function Xi(e, t) {
  return t = t || `${e.id}:root`, e.instanceMap.get(t) || e.instanceMap.get(":root");
}
function Wm() {
  const e = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    get width() {
      return e.right - e.left;
    },
    get height() {
      return e.bottom - e.top;
    }
  };
  return e;
}
var $a;
function qm(e) {
  return $a || ($a = document.createRange()), $a.selectNode(e), $a.getBoundingClientRect();
}
function Km(e) {
  const t = Wm();
  if (!e.children)
    return t;
  for (let r = 0, n = e.children.length; r < n; r++) {
    const a = e.children[r];
    let i;
    if (a.component)
      i = Rr(a.component);
    else if (a.el) {
      const o = a.el;
      o.nodeType === 1 || o.getBoundingClientRect ? i = o.getBoundingClientRect() : o.nodeType === 3 && o.data.trim() && (i = qm(o));
    }
    i && Gm(t, i);
  }
  return t;
}
function Gm(e, t) {
  return (!e.top || t.top < e.top) && (e.top = t.top), (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom), (!e.left || t.left < e.left) && (e.left = t.left), (!e.right || t.right > e.right) && (e.right = t.right), e;
}
var qs = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: 0,
  height: 0
};
function Rr(e) {
  const t = e.subTree.el;
  return typeof window > "u" ? qs : yd(e) ? Km(e.subTree) : (t == null ? void 0 : t.nodeType) === 1 ? t == null ? void 0 : t.getBoundingClientRect() : e.subTree.component ? Rr(e.subTree.component) : qs;
}
x();
function Vo(e) {
  return yd(e) ? Zm(e.subTree) : e.subTree ? [e.subTree.el] : [];
}
function Zm(e) {
  if (!e.children)
    return [];
  const t = [];
  return e.children.forEach((r) => {
    r.component ? t.push(...Vo(r.component)) : r != null && r.el && t.push(r.el);
  }), t;
}
var bd = "__vue-devtools-component-inspector__", _d = "__vue-devtools-component-inspector__card__", wd = "__vue-devtools-component-inspector__name__", Ed = "__vue-devtools-component-inspector__indicator__", Td = {
  display: "block",
  zIndex: 2147483640,
  position: "fixed",
  backgroundColor: "#42b88325",
  border: "1px solid #42b88350",
  borderRadius: "5px",
  transition: "all 0.1s ease-in",
  pointerEvents: "none"
}, Xm = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "5px 8px",
  borderRadius: "4px",
  textAlign: "left",
  position: "absolute",
  left: 0,
  color: "#e9e9e9",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  backgroundColor: "#42b883",
  boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
}, Jm = {
  display: "inline-block",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: "12px",
  opacity: 0.7
};
function $n() {
  return document.getElementById(bd);
}
function Qm() {
  return document.getElementById(_d);
}
function eg() {
  return document.getElementById(Ed);
}
function tg() {
  return document.getElementById(wd);
}
function No(e) {
  return {
    left: `${Math.round(e.left * 100) / 100}px`,
    top: `${Math.round(e.top * 100) / 100}px`,
    width: `${Math.round(e.width * 100) / 100}px`,
    height: `${Math.round(e.height * 100) / 100}px`
  };
}
function Bo(e) {
  var t;
  const r = document.createElement("div");
  r.id = (t = e.elementId) != null ? t : bd, Object.assign(r.style, {
    ...Td,
    ...No(e.bounds),
    ...e.style
  });
  const n = document.createElement("span");
  n.id = _d, Object.assign(n.style, {
    ...Xm,
    top: e.bounds.top < 35 ? 0 : "-35px"
  });
  const a = document.createElement("span");
  a.id = wd, a.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`;
  const i = document.createElement("i");
  return i.id = Ed, i.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`, Object.assign(i.style, Jm), n.appendChild(a), n.appendChild(i), r.appendChild(n), document.body.appendChild(r), r;
}
function Yo(e) {
  const t = $n(), r = Qm(), n = tg(), a = eg();
  t && (Object.assign(t.style, {
    ...Td,
    ...No(e.bounds)
  }), Object.assign(r.style, {
    top: e.bounds.top < 35 ? 0 : "-35px"
  }), n.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`, a.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`);
}
function rg(e) {
  const t = Rr(e);
  if (!t.width && !t.height)
    return;
  const r = di(e);
  $n() ? Yo({ bounds: t, name: r }) : Bo({ bounds: t, name: r });
}
function Dd() {
  const e = $n();
  e && (e.style.display = "none");
}
var Ji = null;
function Qi(e) {
  const t = e.target;
  if (t) {
    const r = t.__vueParentComponent;
    if (r && (Ji = r, r.vnode.el)) {
      const a = Rr(r), i = di(r);
      $n() ? Yo({ bounds: a, name: i }) : Bo({ bounds: a, name: i });
    }
  }
}
function ng(e, t) {
  var r;
  if (e.preventDefault(), e.stopPropagation(), Ji) {
    const n = (r = qe.value) == null ? void 0 : r.app;
    Hm({
      app: n,
      uid: n.uid,
      instance: Ji
    }).then((a) => {
      t(a);
    });
  }
}
var qa = null;
function ag() {
  Dd(), window.removeEventListener("mouseover", Qi), window.removeEventListener("click", qa, !0), qa = null;
}
function ig() {
  return window.addEventListener("mouseover", Qi), new Promise((e) => {
    function t(r) {
      r.preventDefault(), r.stopPropagation(), ng(r, (n) => {
        window.removeEventListener("click", t, !0), qa = null, window.removeEventListener("mouseover", Qi);
        const a = $n();
        a && (a.style.display = "none"), e(JSON.stringify({ id: n }));
      });
    }
    qa = t, window.addEventListener("click", t, !0);
  });
}
function og(e) {
  const t = Xi(qe.value, e.id);
  if (t) {
    const [r] = Vo(t);
    if (typeof r.scrollIntoView == "function")
      r.scrollIntoView({
        behavior: "smooth"
      });
    else {
      const n = Rr(t), a = document.createElement("div"), i = {
        ...No(n),
        position: "absolute"
      };
      Object.assign(a.style, i), document.body.appendChild(a), a.scrollIntoView({
        behavior: "smooth"
      }), setTimeout(() => {
        document.body.removeChild(a);
      }, 2e3);
    }
    setTimeout(() => {
      const n = Rr(t);
      if (n.width || n.height) {
        const a = di(t), i = $n();
        i ? Yo({ ...e, name: a, bounds: n }) : Bo({ ...e, name: a, bounds: n }), setTimeout(() => {
          i && (i.style.display = "none");
        }, 1500);
      }
    }, 1200);
  }
}
x();
var Ks, Gs;
(Gs = (Ks = G).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null || (Ks.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
function sg(e) {
  let t = 0;
  const r = setInterval(() => {
    G.__VUE_INSPECTOR__ && (clearInterval(r), t += 30, e()), t >= /* 5s */
    5e3 && clearInterval(r);
  }, 30);
}
function lg() {
  const e = G.__VUE_INSPECTOR__, t = e.openInEditor;
  e.openInEditor = async (...r) => {
    e.disable(), t(...r);
  };
}
function ug() {
  return new Promise((e) => {
    function t() {
      lg(), e(G.__VUE_INSPECTOR__);
    }
    G.__VUE_INSPECTOR__ ? t() : sg(() => {
      t();
    });
  });
}
x();
x();
function cg(e) {
  return !!(e && e.__v_isReadonly);
}
function $d(e) {
  return cg(e) ? $d(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Ci(e) {
  return !!(e && e.__v_isRef === !0);
}
function Hn(e) {
  const t = e && e.__v_raw;
  return t ? Hn(t) : e;
}
var dg = class {
  constructor() {
    this.refEditor = new fg();
  }
  set(e, t, r, n) {
    const a = Array.isArray(t) ? t : t.split(".");
    for (; a.length > 1; ) {
      const s = a.shift();
      e instanceof Map && (e = e.get(s)), e instanceof Set ? e = Array.from(e.values())[s] : e = e[s], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    const i = a[0], o = this.refEditor.get(e)[i];
    n ? n(e, i, r) : this.refEditor.isRef(o) ? this.refEditor.set(o, r) : e[i] = r;
  }
  get(e, t) {
    const r = Array.isArray(t) ? t : t.split(".");
    for (let n = 0; n < r.length; n++)
      if (e instanceof Map ? e = e.get(r[n]) : e = e[r[n]], this.refEditor.isRef(e) && (e = this.refEditor.get(e)), !e)
        return;
    return e;
  }
  has(e, t, r = !1) {
    if (typeof e > "u")
      return !1;
    const n = Array.isArray(t) ? t.slice() : t.split("."), a = r ? 2 : 1;
    for (; e && n.length > a; ) {
      const i = n.shift();
      e = e[i], this.refEditor.isRef(e) && (e = this.refEditor.get(e));
    }
    return e != null && Object.prototype.hasOwnProperty.call(e, n[0]);
  }
  createDefaultSetCallback(e) {
    return (t, r, n) => {
      if ((e.remove || e.newKey) && (Array.isArray(t) ? t.splice(r, 1) : Hn(t) instanceof Map ? t.delete(r) : Hn(t) instanceof Set ? t.delete(Array.from(t.values())[r]) : Reflect.deleteProperty(t, r)), !e.remove) {
        const a = t[e.newKey || r];
        this.refEditor.isRef(a) ? this.refEditor.set(a, n) : Hn(t) instanceof Map ? t.set(e.newKey || r, n) : Hn(t) instanceof Set ? t.add(n) : t[e.newKey || r] = n;
      }
    };
  }
}, fg = class {
  set(e, t) {
    if (Ci(e))
      e.value = t;
    else {
      if (e instanceof Set && Array.isArray(t)) {
        e.clear(), t.forEach((a) => e.add(a));
        return;
      }
      const r = Object.keys(t);
      if (e instanceof Map) {
        const a = new Set(e.keys());
        r.forEach((i) => {
          e.set(i, Reflect.get(t, i)), a.delete(i);
        }), a.forEach((i) => e.delete(i));
        return;
      }
      const n = new Set(Object.keys(e));
      r.forEach((a) => {
        Reflect.set(e, a, Reflect.get(t, a)), n.delete(a);
      }), n.forEach((a) => Reflect.deleteProperty(e, a));
    }
  }
  get(e) {
    return Ci(e) ? e.value : e;
  }
  isRef(e) {
    return Ci(e) || $d(e);
  }
};
x();
x();
x();
var pg = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function vg() {
  if (!pd || typeof localStorage > "u" || localStorage === null)
    return {
      recordingState: !1,
      mouseEventEnabled: !1,
      keyboardEventEnabled: !1,
      componentEventEnabled: !1,
      performanceEventEnabled: !1,
      selected: ""
    };
  const e = localStorage.getItem(pg);
  return e ? JSON.parse(e) : {
    recordingState: !1,
    mouseEventEnabled: !1,
    keyboardEventEnabled: !1,
    componentEventEnabled: !1,
    performanceEventEnabled: !1,
    selected: ""
  };
}
x();
x();
x();
var Zs, Xs;
(Xs = (Zs = G).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null || (Zs.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
var hg = new Proxy(G.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
  get(e, t, r) {
    return Reflect.get(e, t, r);
  }
});
function mg(e, t) {
  Le.timelineLayersState[t.id] = !1, hg.push({
    ...e,
    descriptorId: t.id,
    appRecord: ci(t.app)
  });
}
var Js, Qs;
(Qs = (Js = G).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null || (Js.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
var jo = new Proxy(G.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
  get(e, t, r) {
    return Reflect.get(e, t, r);
  }
}), kd = nn(() => {
  kn.hooks.callHook("sendInspectorToClient", Od());
});
function gg(e, t) {
  var r, n;
  jo.push({
    options: e,
    descriptor: t,
    treeFilterPlaceholder: (r = e.treeFilterPlaceholder) != null ? r : "Search tree...",
    stateFilterPlaceholder: (n = e.stateFilterPlaceholder) != null ? n : "Search state...",
    treeFilter: "",
    selectedNodeId: "",
    appRecord: ci(t.app)
  }), kd();
}
function Od() {
  return jo.filter((e) => e.descriptor.app === qe.value.app).filter((e) => e.descriptor.id !== "components").map((e) => {
    var t;
    const r = e.descriptor, n = e.options;
    return {
      id: n.id,
      label: n.label,
      logo: r.logo,
      icon: `custom-ic-baseline-${(t = n == null ? void 0 : n.icon) == null ? void 0 : t.replace(/_/g, "-")}`,
      packageName: r.packageName,
      homepage: r.homepage,
      pluginId: r.id
    };
  });
}
function Fa(e, t) {
  return jo.find((r) => r.options.id === e && (t ? r.descriptor.app === t : !0));
}
function yg() {
  const e = hd();
  e.hook("addInspector", ({ inspector: n, plugin: a }) => {
    gg(n, a.descriptor);
  });
  const t = nn(async ({ inspectorId: n, plugin: a }) => {
    var i;
    if (!n || !((i = a == null ? void 0 : a.descriptor) != null && i.app) || Le.highPerfModeEnabled)
      return;
    const o = Fa(n, a.descriptor.app), s = {
      app: a.descriptor.app,
      inspectorId: n,
      filter: (o == null ? void 0 : o.treeFilter) || "",
      rootNodes: []
    };
    await new Promise((l) => {
      e.callHookWith(
        async (u) => {
          await Promise.all(u.map((c) => c(s))), l();
        },
        "getInspectorTree"
        /* GET_INSPECTOR_TREE */
      );
    }), e.callHookWith(
      async (l) => {
        await Promise.all(l.map((u) => u({
          inspectorId: n,
          rootNodes: s.rootNodes
        })));
      },
      "sendInspectorTreeToClient"
      /* SEND_INSPECTOR_TREE_TO_CLIENT */
    );
  }, 120);
  e.hook("sendInspectorTree", t);
  const r = nn(async ({ inspectorId: n, plugin: a }) => {
    var i;
    if (!n || !((i = a == null ? void 0 : a.descriptor) != null && i.app) || Le.highPerfModeEnabled)
      return;
    const o = Fa(n, a.descriptor.app), s = {
      app: a.descriptor.app,
      inspectorId: n,
      nodeId: (o == null ? void 0 : o.selectedNodeId) || "",
      state: null
    }, l = {
      currentTab: `custom-inspector:${n}`
    };
    s.nodeId && await new Promise((u) => {
      e.callHookWith(
        async (c) => {
          await Promise.all(c.map((f) => f(s, l))), u();
        },
        "getInspectorState"
        /* GET_INSPECTOR_STATE */
      );
    }), e.callHookWith(
      async (u) => {
        await Promise.all(u.map((c) => c({
          inspectorId: n,
          nodeId: s.nodeId,
          state: s.state
        })));
      },
      "sendInspectorStateToClient"
      /* SEND_INSPECTOR_STATE_TO_CLIENT */
    );
  }, 120);
  return e.hook("sendInspectorState", r), e.hook("customInspectorSelectNode", ({ inspectorId: n, nodeId: a, plugin: i }) => {
    const o = Fa(n, i.descriptor.app);
    o && (o.selectedNodeId = a);
  }), e.hook("timelineLayerAdded", ({ options: n, plugin: a }) => {
    mg(n, a.descriptor);
  }), e.hook("timelineEventAdded", ({ options: n, plugin: a }) => {
    var i;
    const o = ["performance", "component-event", "keyboard", "mouse"];
    Le.highPerfModeEnabled || !((i = Le.timelineLayersState) != null && i[a.descriptor.id]) && !o.includes(n.layerId) || e.callHookWith(
      async (s) => {
        await Promise.all(s.map((l) => l(n)));
      },
      "sendTimelineEventToClient"
      /* SEND_TIMELINE_EVENT_TO_CLIENT */
    );
  }), e.hook("getComponentInstances", async ({ app: n }) => {
    const a = n.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (!a)
      return null;
    const i = a.id.toString();
    return [...a.instanceMap].filter(([s]) => s.split(":")[0] === i).map(([, s]) => s);
  }), e.hook("getComponentBounds", async ({ instance: n }) => Rr(n)), e.hook("getComponentName", ({ instance: n }) => di(n)), e.hook("componentHighlight", ({ uid: n }) => {
    const a = qe.value.instanceMap.get(n);
    a && rg(a);
  }), e.hook("componentUnhighlight", () => {
    Dd();
  }), e;
}
var el, tl;
(tl = (el = G).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null || (el.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
var rl, nl;
(nl = (rl = G).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null || (rl.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
var al, il;
(il = (al = G).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null || (al.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "");
var ol, sl;
(sl = (ol = G).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null || (ol.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
var ll, ul;
(ul = (ll = G).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null || (ll.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
var Cr = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function bg() {
  return {
    connected: !1,
    clientConnected: !1,
    vitePluginDetected: !0,
    appRecords: [],
    activeAppRecordId: "",
    tabs: [],
    commands: [],
    highPerfModeEnabled: !0,
    devtoolsClientDetected: {},
    perfUniqueGroupId: 0,
    timelineLayersState: vg()
  };
}
var cl, dl;
(dl = (cl = G)[Cr]) != null || (cl[Cr] = bg());
var _g = nn((e) => {
  kn.hooks.callHook("devtoolsStateUpdated", { state: e });
});
nn((e, t) => {
  kn.hooks.callHook("devtoolsConnectedUpdated", { state: e, oldState: t });
});
var fi = new Proxy(G.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
  get(e, t, r) {
    return t === "value" ? G.__VUE_DEVTOOLS_KIT_APP_RECORDS__ : G.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
  }
}), qe = new Proxy(G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
  get(e, t, r) {
    return t === "value" ? G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ : t === "id" ? G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ : G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
  }
});
function Cd() {
  _g({
    ...G[Cr],
    appRecords: fi.value,
    activeAppRecordId: qe.id,
    tabs: G.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
    commands: G.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
  });
}
function wg(e) {
  G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e, Cd();
}
function Eg(e) {
  G.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e, Cd();
}
var Le = new Proxy(G[Cr], {
  get(e, t) {
    return t === "appRecords" ? fi : t === "activeAppRecordId" ? qe.id : t === "tabs" ? G.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ : t === "commands" ? G.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ : G[Cr][t];
  },
  deleteProperty(e, t) {
    return delete e[t], !0;
  },
  set(e, t, r) {
    return { ...G[Cr] }, e[t] = r, G[Cr][t] = r, !0;
  }
});
function Tg(e = {}) {
  var t, r, n;
  const { file: a, host: i, baseUrl: o = window.location.origin, line: s = 0, column: l = 0 } = e;
  if (a) {
    if (i === "chrome-extension") {
      const u = a.replace(/\\/g, "\\\\"), c = (r = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null ? r : "/";
      fetch(`${c}__open-in-editor?file=${encodeURI(a)}`).then((f) => {
        if (!f.ok) {
          const p = `Opening component ${u} failed`;
          console.log(`%c${p}`, "color:red");
        }
      });
    } else if (Le.vitePluginDetected) {
      const u = (n = G.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? n : o;
      G.__VUE_INSPECTOR__.openInEditor(u, a, s, l);
    }
  }
}
x();
x();
x();
x();
x();
var fl, pl;
(pl = (fl = G).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null || (fl.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
var zo = new Proxy(G.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
  get(e, t, r) {
    return Reflect.get(e, t, r);
  }
});
function eo(e) {
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = e[r].defaultValue;
  }), t;
}
function Uo(e) {
  return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
}
function Dg(e) {
  var t, r, n;
  const a = (r = (t = zo.find((i) => {
    var o;
    return i[0].id === e && !!((o = i[0]) != null && o.settings);
  })) == null ? void 0 : t[0]) != null ? r : null;
  return (n = a == null ? void 0 : a.settings) != null ? n : null;
}
function Sd(e, t) {
  var r, n, a;
  const i = Uo(e);
  if (i) {
    const o = localStorage.getItem(i);
    if (o)
      return JSON.parse(o);
  }
  if (e) {
    const o = (n = (r = zo.find((s) => s[0].id === e)) == null ? void 0 : r[0]) != null ? n : null;
    return eo((a = o == null ? void 0 : o.settings) != null ? a : {});
  }
  return eo(t);
}
function $g(e, t) {
  const r = Uo(e);
  localStorage.getItem(r) || localStorage.setItem(r, JSON.stringify(eo(t)));
}
function kg(e, t, r) {
  const n = Uo(e), a = localStorage.getItem(n), i = JSON.parse(a || "{}"), o = {
    ...i,
    [t]: r
  };
  localStorage.setItem(n, JSON.stringify(o)), kn.hooks.callHookWith(
    (s) => {
      s.forEach((l) => l({
        pluginId: e,
        key: t,
        oldValue: i[t],
        newValue: r,
        settings: o
      }));
    },
    "setPluginSettings"
    /* SET_PLUGIN_SETTINGS */
  );
}
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
var vl, hl, gt = (hl = (vl = G).__VUE_DEVTOOLS_HOOK) != null ? hl : vl.__VUE_DEVTOOLS_HOOK = hd(), Og = {
  vueAppInit(e) {
    gt.hook("app:init", e);
  },
  vueAppUnmount(e) {
    gt.hook("app:unmount", e);
  },
  vueAppConnected(e) {
    gt.hook("app:connected", e);
  },
  componentAdded(e) {
    return gt.hook("component:added", e);
  },
  componentEmit(e) {
    return gt.hook("component:emit", e);
  },
  componentUpdated(e) {
    return gt.hook("component:updated", e);
  },
  componentRemoved(e) {
    return gt.hook("component:removed", e);
  },
  setupDevtoolsPlugin(e) {
    gt.hook("devtools-plugin:setup", e);
  },
  perfStart(e) {
    return gt.hook("perf:start", e);
  },
  perfEnd(e) {
    return gt.hook("perf:end", e);
  }
}, Ad = {
  on: Og,
  setupDevToolsPlugin(e, t) {
    return gt.callHook("devtools-plugin:setup", e, t);
  }
}, Cg = class {
  constructor({ plugin: e, ctx: t }) {
    this.hooks = t.hooks, this.plugin = e;
  }
  get on() {
    return {
      // component inspector
      visitComponentTree: (e) => {
        this.hooks.hook("visitComponentTree", e);
      },
      inspectComponent: (e) => {
        this.hooks.hook("inspectComponent", e);
      },
      editComponentState: (e) => {
        this.hooks.hook("editComponentState", e);
      },
      // custom inspector
      getInspectorTree: (e) => {
        this.hooks.hook("getInspectorTree", e);
      },
      getInspectorState: (e) => {
        this.hooks.hook("getInspectorState", e);
      },
      editInspectorState: (e) => {
        this.hooks.hook("editInspectorState", e);
      },
      // timeline
      inspectTimelineEvent: (e) => {
        this.hooks.hook("inspectTimelineEvent", e);
      },
      timelineCleared: (e) => {
        this.hooks.hook("timelineCleared", e);
      },
      // settings
      setPluginSettings: (e) => {
        this.hooks.hook("setPluginSettings", e);
      }
    };
  }
  // component inspector
  notifyComponentUpdate(e) {
    var t;
    if (Le.highPerfModeEnabled)
      return;
    const r = Od().find((n) => n.packageName === this.plugin.descriptor.packageName);
    if (r != null && r.id) {
      if (e) {
        const n = [
          e.appContext.app,
          e.uid,
          (t = e.parent) == null ? void 0 : t.uid,
          e
        ];
        gt.callHook("component:updated", ...n);
      } else
        gt.callHook(
          "component:updated"
          /* COMPONENT_UPDATED */
        );
      this.hooks.callHook("sendInspectorState", { inspectorId: r.id, plugin: this.plugin });
    }
  }
  // custom inspector
  addInspector(e) {
    this.hooks.callHook("addInspector", { inspector: e, plugin: this.plugin }), this.plugin.descriptor.settings && $g(e.id, this.plugin.descriptor.settings);
  }
  sendInspectorTree(e) {
    Le.highPerfModeEnabled || this.hooks.callHook("sendInspectorTree", { inspectorId: e, plugin: this.plugin });
  }
  sendInspectorState(e) {
    Le.highPerfModeEnabled || this.hooks.callHook("sendInspectorState", { inspectorId: e, plugin: this.plugin });
  }
  selectInspectorNode(e, t) {
    this.hooks.callHook("customInspectorSelectNode", { inspectorId: e, nodeId: t, plugin: this.plugin });
  }
  visitComponentTree(e) {
    return this.hooks.callHook("visitComponentTree", e);
  }
  // timeline
  now() {
    return Le.highPerfModeEnabled ? 0 : Date.now();
  }
  addTimelineLayer(e) {
    this.hooks.callHook("timelineLayerAdded", { options: e, plugin: this.plugin });
  }
  addTimelineEvent(e) {
    Le.highPerfModeEnabled || this.hooks.callHook("timelineEventAdded", { options: e, plugin: this.plugin });
  }
  // settings
  getSettings(e) {
    return Sd(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
  }
  // utilities
  getComponentInstances(e) {
    return this.hooks.callHook("getComponentInstances", { app: e });
  }
  getComponentBounds(e) {
    return this.hooks.callHook("getComponentBounds", { instance: e });
  }
  getComponentName(e) {
    return this.hooks.callHook("getComponentName", { instance: e });
  }
  highlightElement(e) {
    const t = e.__VUE_DEVTOOLS_NEXT_UID__;
    return this.hooks.callHook("componentHighlight", { uid: t });
  }
  unhighlightElement() {
    return this.hooks.callHook(
      "componentUnhighlight"
      /* COMPONENT_UNHIGHLIGHT */
    );
  }
}, Sg = Cg;
x();
x();
x();
x();
var Ag = "__vue_devtool_undefined__", Mg = "__vue_devtool_infinity__", Ig = "__vue_devtool_negative_infinity__", Pg = "__vue_devtool_nan__";
x();
x();
var xg = {
  [Ag]: "undefined",
  [Pg]: "NaN",
  [Mg]: "Infinity",
  [Ig]: "-Infinity"
};
Object.entries(xg).reduce((e, [t, r]) => (e[r] = t, e), {});
x();
x();
x();
x();
x();
var ml, gl;
(gl = (ml = G).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null || (ml.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set());
function Lg(e, t) {
  return Ad.setupDevToolsPlugin(e, t);
}
function Rg(e, t) {
  const [r, n] = e;
  if (r.app !== t)
    return;
  const a = new Sg({
    plugin: {
      setupFn: n,
      descriptor: r
    },
    ctx: kn
  });
  r.packageName === "vuex" && a.on.editInspectorState((i) => {
    a.sendInspectorState(i.inspectorId);
  }), n(a);
}
function Md(e) {
  G.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) || Le.highPerfModeEnabled || (G.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e), zo.forEach((t) => {
    Rg(t, e);
  }));
}
x();
x();
var na = "__VUE_DEVTOOLS_ROUTER__", an = "__VUE_DEVTOOLS_ROUTER_INFO__", yl, bl;
(bl = (yl = G)[an]) != null || (yl[an] = {
  currentRoute: null,
  routes: []
});
var _l, wl;
(wl = (_l = G)[na]) != null || (_l[na] = {});
new Proxy(G[an], {
  get(e, t) {
    return G[an][t];
  }
});
new Proxy(G[na], {
  get(e, t) {
    if (t === "value")
      return G[na];
  }
});
function Fg(e) {
  const t = /* @__PURE__ */ new Map();
  return ((e == null ? void 0 : e.getRoutes()) || []).filter((r) => !t.has(r.path) && t.set(r.path, 1));
}
function Ho(e) {
  return e.map((t) => {
    let { path: r, name: n, children: a, meta: i } = t;
    return a != null && a.length && (a = Ho(a)), {
      path: r,
      name: n,
      children: a,
      meta: i
    };
  });
}
function Vg(e) {
  if (e) {
    const { fullPath: t, hash: r, href: n, path: a, name: i, matched: o, params: s, query: l } = e;
    return {
      fullPath: t,
      hash: r,
      href: n,
      path: a,
      name: i,
      params: s,
      query: l,
      matched: Ho(o)
    };
  }
  return e;
}
function Ng(e, t) {
  function r() {
    var n;
    const a = (n = e.app) == null ? void 0 : n.config.globalProperties.$router, i = Vg(a == null ? void 0 : a.currentRoute.value), o = Ho(Fg(a)), s = console.warn;
    console.warn = () => {
    }, G[an] = {
      currentRoute: i ? Hs(i) : {},
      routes: Hs(o)
    }, G[na] = a, console.warn = s;
  }
  r(), Ad.on.componentUpdated(nn(() => {
    var n;
    ((n = t.value) == null ? void 0 : n.app) === e.app && (r(), !Le.highPerfModeEnabled && kn.hooks.callHook("routerInfoUpdated", { state: G[an] }));
  }, 200));
}
function Bg(e) {
  return {
    // get inspector tree
    async getInspectorTree(t) {
      const r = {
        ...t,
        app: qe.value.app,
        rootNodes: []
      };
      return await new Promise((n) => {
        e.callHookWith(
          async (a) => {
            await Promise.all(a.map((i) => i(r))), n();
          },
          "getInspectorTree"
          /* GET_INSPECTOR_TREE */
        );
      }), r.rootNodes;
    },
    // get inspector state
    async getInspectorState(t) {
      const r = {
        ...t,
        app: qe.value.app,
        state: null
      }, n = {
        currentTab: `custom-inspector:${t.inspectorId}`
      };
      return await new Promise((a) => {
        e.callHookWith(
          async (i) => {
            await Promise.all(i.map((o) => o(r, n))), a();
          },
          "getInspectorState"
          /* GET_INSPECTOR_STATE */
        );
      }), r.state;
    },
    // edit inspector state
    editInspectorState(t) {
      const r = new dg(), n = {
        ...t,
        app: qe.value.app,
        set: (a, i = t.path, o = t.state.value, s) => {
          r.set(a, i, o, s || r.createDefaultSetCallback(t.state));
        }
      };
      e.callHookWith(
        (a) => {
          a.forEach((i) => i(n));
        },
        "editInspectorState"
        /* EDIT_INSPECTOR_STATE */
      );
    },
    // send inspector state
    sendInspectorState(t) {
      const r = Fa(t);
      e.callHook("sendInspectorState", { inspectorId: t, plugin: {
        descriptor: r.descriptor,
        setupFn: () => ({})
      } });
    },
    // inspect component inspector
    inspectComponentInspector() {
      return ig();
    },
    // cancel inspect component inspector
    cancelInspectComponentInspector() {
      return ag();
    },
    // get component render code
    getComponentRenderCode(t) {
      const r = Xi(qe.value, t);
      if (r)
        return (r == null ? void 0 : r.type) instanceof Function ? r.type.toString() : r.render.toString();
    },
    // scroll to component
    scrollToComponent(t) {
      return og({ id: t });
    },
    // open in editor
    openInEditor: Tg,
    // get vue inspector
    getVueInspector: ug,
    // toggle app
    toggleApp(t) {
      const r = fi.value.find((n) => n.id === t);
      r && (Eg(t), wg(r), Ng(r, qe), kd(), Md(r.app));
    },
    // inspect dom
    inspectDOM(t) {
      const r = Xi(qe.value, t);
      if (r) {
        const [n] = Vo(r);
        n && (G.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = n);
      }
    },
    updatePluginSettings(t, r, n) {
      kg(t, r, n);
    },
    getPluginSettings(t) {
      return {
        options: Dg(t),
        values: Sd(t)
      };
    }
  };
}
x();
var El, Tl;
(Tl = (El = G).__VUE_DEVTOOLS_ENV__) != null || (El.__VUE_DEVTOOLS_ENV__ = {
  vitePluginDetected: !1
});
var Dl = yg(), $l, kl;
(kl = ($l = G).__VUE_DEVTOOLS_KIT_CONTEXT__) != null || ($l.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
  hooks: Dl,
  get state() {
    return {
      ...Le,
      activeAppRecordId: qe.id,
      activeAppRecord: qe.value,
      appRecords: fi.value
    };
  },
  api: Bg(Dl)
});
var kn = G.__VUE_DEVTOOLS_KIT_CONTEXT__;
x();
Bm(jm(), 1);
var Ol, Cl;
(Cl = (Ol = G).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null || (Ol.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
  id: 0,
  appIds: /* @__PURE__ */ new Set()
});
x();
function Yg(e) {
  Le.highPerfModeEnabled = e ?? !Le.highPerfModeEnabled, !e && qe.value && Md(qe.value.app);
}
x();
x();
x();
function jg(e) {
  Le.devtoolsClientDetected = {
    ...Le.devtoolsClientDetected,
    ...e
  };
  const t = Object.values(Le.devtoolsClientDetected).some(Boolean);
  Yg(!t);
}
var Sl, Al;
(Al = (Sl = G).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null || (Sl.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = jg);
x();
x();
x();
x();
x();
x();
x();
var zg = class {
  constructor() {
    this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
  }
  set(e, t) {
    this.keyToValue.set(e, t), this.valueToKey.set(t, e);
  }
  getByKey(e) {
    return this.keyToValue.get(e);
  }
  getByValue(e) {
    return this.valueToKey.get(e);
  }
  clear() {
    this.keyToValue.clear(), this.valueToKey.clear();
  }
}, Id = class {
  constructor(e) {
    this.generateIdentifier = e, this.kv = new zg();
  }
  register(e, t) {
    this.kv.getByValue(e) || (t || (t = this.generateIdentifier(e)), this.kv.set(t, e));
  }
  clear() {
    this.kv.clear();
  }
  getIdentifier(e) {
    return this.kv.getByValue(e);
  }
  getValue(e) {
    return this.kv.getByKey(e);
  }
}, Ug = class extends Id {
  constructor() {
    super((e) => e.name), this.classToAllowedProps = /* @__PURE__ */ new Map();
  }
  register(e, t) {
    typeof t == "object" ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps), super.register(e, t.identifier)) : super.register(e, t);
  }
  getAllowedProps(e) {
    return this.classToAllowedProps.get(e);
  }
};
x();
x();
function Hg(e) {
  if ("values" in Object)
    return Object.values(e);
  const t = [];
  for (const r in e)
    e.hasOwnProperty(r) && t.push(e[r]);
  return t;
}
function Wg(e, t) {
  const r = Hg(e);
  if ("find" in r)
    return r.find(t);
  const n = r;
  for (let a = 0; a < n.length; a++) {
    const i = n[a];
    if (t(i))
      return i;
  }
}
function on(e, t) {
  Object.entries(e).forEach(([r, n]) => t(n, r));
}
function Va(e, t) {
  return e.indexOf(t) !== -1;
}
function Ml(e, t) {
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (t(n))
      return n;
  }
}
var qg = class {
  constructor() {
    this.transfomers = {};
  }
  register(e) {
    this.transfomers[e.name] = e;
  }
  findApplicable(e) {
    return Wg(this.transfomers, (t) => t.isApplicable(e));
  }
  findByName(e) {
    return this.transfomers[e];
  }
};
x();
x();
var Kg = (e) => Object.prototype.toString.call(e).slice(8, -1), Pd = (e) => typeof e > "u", Gg = (e) => e === null, aa = (e) => typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype, to = (e) => aa(e) && Object.keys(e).length === 0, br = (e) => Array.isArray(e), Zg = (e) => typeof e == "string", Xg = (e) => typeof e == "number" && !isNaN(e), Jg = (e) => typeof e == "boolean", Qg = (e) => e instanceof RegExp, ia = (e) => e instanceof Map, oa = (e) => e instanceof Set, xd = (e) => Kg(e) === "Symbol", e0 = (e) => e instanceof Date && !isNaN(e.valueOf()), t0 = (e) => e instanceof Error, Il = (e) => typeof e == "number" && isNaN(e), r0 = (e) => Jg(e) || Gg(e) || Pd(e) || Xg(e) || Zg(e) || xd(e), n0 = (e) => typeof e == "bigint", a0 = (e) => e === 1 / 0 || e === -1 / 0, i0 = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView), o0 = (e) => e instanceof URL;
x();
var Ld = (e) => e.replace(/\./g, "\\."), Si = (e) => e.map(String).map(Ld).join("."), Kn = (e) => {
  const t = [];
  let r = "";
  for (let a = 0; a < e.length; a++) {
    let i = e.charAt(a);
    if (i === "\\" && e.charAt(a + 1) === ".") {
      r += ".", a++;
      continue;
    }
    if (i === ".") {
      t.push(r), r = "";
      continue;
    }
    r += i;
  }
  const n = r;
  return t.push(n), t;
};
x();
function zt(e, t, r, n) {
  return {
    isApplicable: e,
    annotation: t,
    transform: r,
    untransform: n
  };
}
var Rd = [
  zt(Pd, "undefined", () => null, () => {
  }),
  zt(n0, "bigint", (e) => e.toString(), (e) => typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e)),
  zt(e0, "Date", (e) => e.toISOString(), (e) => new Date(e)),
  zt(t0, "Error", (e, t) => {
    const r = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach((n) => {
      r[n] = e[n];
    }), r;
  }, (e, t) => {
    const r = new Error(e.message);
    return r.name = e.name, r.stack = e.stack, t.allowedErrorProps.forEach((n) => {
      r[n] = e[n];
    }), r;
  }),
  zt(Qg, "regexp", (e) => "" + e, (e) => {
    const t = e.slice(1, e.lastIndexOf("/")), r = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, r);
  }),
  zt(
    oa,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (e) => [...e.values()],
    (e) => new Set(e)
  ),
  zt(ia, "map", (e) => [...e.entries()], (e) => new Map(e)),
  zt((e) => Il(e) || a0(e), "number", (e) => Il(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity", Number),
  zt((e) => e === 0 && 1 / e === -1 / 0, "number", () => "-0", Number),
  zt(o0, "URL", (e) => e.toString(), (e) => new URL(e))
];
function pi(e, t, r, n) {
  return {
    isApplicable: e,
    annotation: t,
    transform: r,
    untransform: n
  };
}
var Fd = pi((e, t) => xd(e) ? !!t.symbolRegistry.getIdentifier(e) : !1, (e, t) => ["symbol", t.symbolRegistry.getIdentifier(e)], (e) => e.description, (e, t, r) => {
  const n = r.symbolRegistry.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown symbol");
  return n;
}), s0 = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce((e, t) => (e[t.name] = t, e), {}), Vd = pi(i0, (e) => ["typed-array", e.constructor.name], (e) => [...e], (e, t) => {
  const r = s0[t[1]];
  if (!r)
    throw new Error("Trying to deserialize unknown typed array");
  return new r(e);
});
function Nd(e, t) {
  return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
}
var Bd = pi(Nd, (e, t) => ["class", t.classRegistry.getIdentifier(e.constructor)], (e, t) => {
  const r = t.classRegistry.getAllowedProps(e.constructor);
  if (!r)
    return { ...e };
  const n = {};
  return r.forEach((a) => {
    n[a] = e[a];
  }), n;
}, (e, t, r) => {
  const n = r.classRegistry.getValue(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(n.prototype), e);
}), Yd = pi((e, t) => !!t.customTransformerRegistry.findApplicable(e), (e, t) => ["custom", t.customTransformerRegistry.findApplicable(e).name], (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e), (e, t, r) => {
  const n = r.customTransformerRegistry.findByName(t[1]);
  if (!n)
    throw new Error("Trying to deserialize unknown custom value");
  return n.deserialize(e);
}), l0 = [Bd, Fd, Yd, Vd], Pl = (e, t) => {
  const r = Ml(l0, (a) => a.isApplicable(e, t));
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation(e, t)
    };
  const n = Ml(Rd, (a) => a.isApplicable(e, t));
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation
    };
}, jd = {};
Rd.forEach((e) => {
  jd[e.annotation] = e;
});
var u0 = (e, t, r) => {
  if (br(t))
    switch (t[0]) {
      case "symbol":
        return Fd.untransform(e, t, r);
      case "class":
        return Bd.untransform(e, t, r);
      case "custom":
        return Yd.untransform(e, t, r);
      case "typed-array":
        return Vd.untransform(e, t, r);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    const n = jd[t];
    if (!n)
      throw new Error("Unknown transformation: " + t);
    return n.untransform(e, r);
  }
};
x();
var Qr = (e, t) => {
  const r = e.keys();
  for (; t > 0; )
    r.next(), t--;
  return r.next().value;
};
function zd(e) {
  if (Va(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Va(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Va(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var c0 = (e, t) => {
  zd(t);
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (oa(e))
      e = Qr(e, +n);
    else if (ia(e)) {
      const a = +n, i = +t[++r] == 0 ? "key" : "value", o = Qr(e, a);
      switch (i) {
        case "key":
          e = o;
          break;
        case "value":
          e = e.get(o);
          break;
      }
    } else
      e = e[n];
  }
  return e;
}, ro = (e, t, r) => {
  if (zd(t), t.length === 0)
    return r(e);
  let n = e;
  for (let i = 0; i < t.length - 1; i++) {
    const o = t[i];
    if (br(n)) {
      const s = +o;
      n = n[s];
    } else if (aa(n))
      n = n[o];
    else if (oa(n)) {
      const s = +o;
      n = Qr(n, s);
    } else if (ia(n)) {
      if (i === t.length - 2)
        break;
      const l = +o, u = +t[++i] == 0 ? "key" : "value", c = Qr(n, l);
      switch (u) {
        case "key":
          n = c;
          break;
        case "value":
          n = n.get(c);
          break;
      }
    }
  }
  const a = t[t.length - 1];
  if (br(n) ? n[+a] = r(n[+a]) : aa(n) && (n[a] = r(n[a])), oa(n)) {
    const i = Qr(n, +a), o = r(i);
    i !== o && (n.delete(i), n.add(o));
  }
  if (ia(n)) {
    const i = +t[t.length - 2], o = Qr(n, i);
    switch (+a == 0 ? "key" : "value") {
      case "key": {
        const l = r(o);
        n.set(l, n.get(o)), l !== o && n.delete(o);
        break;
      }
      case "value": {
        n.set(o, r(n.get(o)));
        break;
      }
    }
  }
  return e;
};
function no(e, t, r = []) {
  if (!e)
    return;
  if (!br(e)) {
    on(e, (i, o) => no(i, t, [...r, ...Kn(o)]));
    return;
  }
  const [n, a] = e;
  a && on(a, (i, o) => {
    no(i, t, [...r, ...Kn(o)]);
  }), t(n, r);
}
function d0(e, t, r) {
  return no(t, (n, a) => {
    e = ro(e, a, (i) => u0(i, n, r));
  }), e;
}
function f0(e, t) {
  function r(n, a) {
    const i = c0(e, Kn(a));
    n.map(Kn).forEach((o) => {
      e = ro(e, o, () => i);
    });
  }
  if (br(t)) {
    const [n, a] = t;
    n.forEach((i) => {
      e = ro(e, Kn(i), () => e);
    }), a && on(a, r);
  } else
    on(t, r);
  return e;
}
var p0 = (e, t) => aa(e) || br(e) || ia(e) || oa(e) || Nd(e, t);
function v0(e, t, r) {
  const n = r.get(e);
  n ? n.push(t) : r.set(e, [t]);
}
function h0(e, t) {
  const r = {};
  let n;
  return e.forEach((a) => {
    if (a.length <= 1)
      return;
    t || (a = a.map((s) => s.map(String)).sort((s, l) => s.length - l.length));
    const [i, ...o] = a;
    i.length === 0 ? n = o.map(Si) : r[Si(i)] = o.map(Si);
  }), n ? to(r) ? [n] : [n, r] : to(r) ? void 0 : r;
}
var Ud = (e, t, r, n, a = [], i = [], o = /* @__PURE__ */ new Map()) => {
  var s;
  const l = r0(e);
  if (!l) {
    v0(e, a, t);
    const m = o.get(e);
    if (m)
      return n ? {
        transformedValue: null
      } : m;
  }
  if (!p0(e, r)) {
    const m = Pl(e, r), g = m ? {
      transformedValue: m.value,
      annotations: [m.type]
    } : {
      transformedValue: e
    };
    return l || o.set(e, g), g;
  }
  if (Va(i, e))
    return {
      transformedValue: null
    };
  const u = Pl(e, r), c = (s = u == null ? void 0 : u.value) != null ? s : e, f = br(c) ? [] : {}, p = {};
  on(c, (m, g) => {
    if (g === "__proto__" || g === "constructor" || g === "prototype")
      throw new Error(`Detected property ${g}. This is a prototype pollution risk, please remove it from your object.`);
    const h = Ud(m, t, r, n, [...a, g], [...i, e], o);
    f[g] = h.transformedValue, br(h.annotations) ? p[g] = h.annotations : aa(h.annotations) && on(h.annotations, (y, _) => {
      p[Ld(g) + "." + _] = y;
    });
  });
  const d = to(p) ? {
    transformedValue: f,
    annotations: u ? [u.type] : void 0
  } : {
    transformedValue: f,
    annotations: u ? [u.type, p] : p
  };
  return l || o.set(e, d), d;
};
x();
x();
function Hd(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function xl(e) {
  return Hd(e) === "Array";
}
function m0(e) {
  if (Hd(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function g0(e, t, r, n, a) {
  const i = {}.propertyIsEnumerable.call(n, t) ? "enumerable" : "nonenumerable";
  i === "enumerable" && (e[t] = r), a && i === "nonenumerable" && Object.defineProperty(e, t, {
    value: r,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function ao(e, t = {}) {
  if (xl(e))
    return e.map((a) => ao(a, t));
  if (!m0(e))
    return e;
  const r = Object.getOwnPropertyNames(e), n = Object.getOwnPropertySymbols(e);
  return [...r, ...n].reduce((a, i) => {
    if (xl(t.props) && !t.props.includes(i))
      return a;
    const o = e[i], s = ao(o, t);
    return g0(a, i, s, e, t.nonenumerable), a;
  }, {});
}
var $e = class {
  /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */
  constructor({ dedupe: e = !1 } = {}) {
    this.classRegistry = new Ug(), this.symbolRegistry = new Id((t) => {
      var r;
      return (r = t.description) != null ? r : "";
    }), this.customTransformerRegistry = new qg(), this.allowedErrorProps = [], this.dedupe = e;
  }
  serialize(e) {
    const t = /* @__PURE__ */ new Map(), r = Ud(e, t, this, this.dedupe), n = {
      json: r.transformedValue
    };
    r.annotations && (n.meta = {
      ...n.meta,
      values: r.annotations
    });
    const a = h0(t, this.dedupe);
    return a && (n.meta = {
      ...n.meta,
      referentialEqualities: a
    }), n;
  }
  deserialize(e) {
    const { json: t, meta: r } = e;
    let n = ao(t);
    return r != null && r.values && (n = d0(n, r.values, this)), r != null && r.referentialEqualities && (n = f0(n, r.referentialEqualities)), n;
  }
  stringify(e) {
    return JSON.stringify(this.serialize(e));
  }
  parse(e) {
    return this.deserialize(JSON.parse(e));
  }
  registerClass(e, t) {
    this.classRegistry.register(e, t);
  }
  registerSymbol(e, t) {
    this.symbolRegistry.register(e, t);
  }
  registerCustom(e, t) {
    this.customTransformerRegistry.register({
      name: t,
      ...e
    });
  }
  allowErrorProps(...e) {
    this.allowedErrorProps.push(...e);
  }
};
$e.defaultInstance = new $e();
$e.serialize = $e.defaultInstance.serialize.bind($e.defaultInstance);
$e.deserialize = $e.defaultInstance.deserialize.bind($e.defaultInstance);
$e.stringify = $e.defaultInstance.stringify.bind($e.defaultInstance);
$e.parse = $e.defaultInstance.parse.bind($e.defaultInstance);
$e.registerClass = $e.defaultInstance.registerClass.bind($e.defaultInstance);
$e.registerSymbol = $e.defaultInstance.registerSymbol.bind($e.defaultInstance);
$e.registerCustom = $e.defaultInstance.registerCustom.bind($e.defaultInstance);
$e.allowErrorProps = $e.defaultInstance.allowErrorProps.bind($e.defaultInstance);
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
x();
var Ll, Rl;
(Rl = (Ll = G).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null || (Ll.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
var Fl, Vl;
(Vl = (Fl = G).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null || (Fl.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
var Nl, Bl;
(Bl = (Nl = G).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null || (Nl.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
var Yl, jl;
(jl = (Yl = G).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null || (Yl.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
var zl, Ul;
(Ul = (zl = G).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null || (zl.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
var Hl, Wl;
(Wl = (Hl = G).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null || (Hl.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null);
x();
x();
x();
x();
x();
x();
x();
/**
  * vee-validate v4.14.7
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
function gr(e) {
  return typeof e == "function";
}
function y0(e) {
  return e == null;
}
const sn = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function Wd(e) {
  return Number(e) >= 0;
}
function b0(e) {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}
function _0(e) {
  const t = e.split(".");
  if (!t.length)
    return "";
  let r = String(t[0]);
  for (let n = 1; n < t.length; n++) {
    if (Wd(t[n])) {
      r += `[${t[n]}]`;
      continue;
    }
    r += `.${t[n]}`;
  }
  return r;
}
const w0 = {};
function E0(e) {
  return w0[e];
}
function ql(e, t, r) {
  typeof r.value == "object" && (r.value = Sr(r.value)), !r.enumerable || r.get || r.set || !r.configurable || !r.writable || t === "__proto__" ? Object.defineProperty(e, t, r) : e[t] = r.value;
}
function Sr(e) {
  if (typeof e != "object")
    return e;
  var t = 0, r, n, a, i = Object.prototype.toString.call(e);
  if (i === "[object Object]" ? a = Object.create(e.__proto__ || null) : i === "[object Array]" ? a = Array(e.length) : i === "[object Set]" ? (a = /* @__PURE__ */ new Set(), e.forEach(function(o) {
    a.add(Sr(o));
  })) : i === "[object Map]" ? (a = /* @__PURE__ */ new Map(), e.forEach(function(o, s) {
    a.set(Sr(s), Sr(o));
  })) : i === "[object Date]" ? a = /* @__PURE__ */ new Date(+e) : i === "[object RegExp]" ? a = new RegExp(e.source, e.flags) : i === "[object DataView]" ? a = new e.constructor(Sr(e.buffer)) : i === "[object ArrayBuffer]" ? a = e.slice(0) : i.slice(-6) === "Array]" && (a = new e.constructor(e)), a) {
    for (n = Object.getOwnPropertySymbols(e); t < n.length; t++)
      ql(a, n[t], Object.getOwnPropertyDescriptor(e, n[t]));
    for (t = 0, n = Object.getOwnPropertyNames(e); t < n.length; t++)
      Object.hasOwnProperty.call(a, r = n[t]) && a[r] === e[r] || ql(a, r, Object.getOwnPropertyDescriptor(e, r));
  }
  return a || e;
}
const qd = Symbol("vee-validate-form"), T0 = Symbol("vee-validate-field-instance"), Kl = Symbol("Default empty value"), D0 = typeof window < "u";
function io(e) {
  return gr(e) && !!e.__locatorRef;
}
function Gn(e) {
  return !!e && gr(e.parse) && e.__type === "VVTypedSchema";
}
function oo(e) {
  return !!e && gr(e.validate);
}
function Kd(e) {
  return e === "checkbox" || e === "radio";
}
function $0(e) {
  return sn(e) || Array.isArray(e);
}
function Wo(e) {
  return /^\[.+\]$/i.test(e);
}
function k0(e) {
  return Gd(e) && e.multiple;
}
function Gd(e) {
  return e.tagName === "SELECT";
}
function O0(e) {
  return e ? !!(typeof Event < "u" && gr(Event) && e instanceof Event || e && e.srcElement) : !1;
}
function yt(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var r, n, a;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!yt(e[n], t[n]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (n of e.entries())
        if (!t.has(n[0]))
          return !1;
      for (n of e.entries())
        if (!yt(n[1], t.get(n[0])))
          return !1;
      return !0;
    }
    if (Zl(e) && Zl(t))
      return !(e.size !== t.size || e.name !== t.name || e.lastModified !== t.lastModified || e.type !== t.type);
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (n of e.entries())
        if (!t.has(n[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length)
        return !1;
      for (n = r; n-- !== 0; )
        if (e[n] !== t[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (a = Object.keys(e), r = a.length - Gl(e, a), r !== Object.keys(t).length - Gl(t, Object.keys(t)))
      return !1;
    for (n = r; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      var i = a[n];
      if (!yt(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Gl(e, t) {
  let r = 0;
  for (let a = t.length; a-- !== 0; ) {
    var n = t[a];
    e[n] === void 0 && r++;
  }
  return r;
}
function Zl(e) {
  return D0 ? e instanceof File : !1;
}
function Zd(e) {
  return Wo(e) ? e.replace(/\[|\]/gi, "") : e;
}
function ln(e, t, r) {
  return e ? Wo(t) ? e[Zd(t)] : (t || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((a, i) => $0(a) && i in a ? a[i] : r, e) : r;
}
function C0(e, t, r) {
  if (Wo(t)) {
    e[Zd(t)] = r;
    return;
  }
  const n = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let a = e;
  for (let i = 0; i < n.length; i++) {
    if (i === n.length - 1) {
      a[n[i]] = r;
      return;
    }
    (!(n[i] in a) || y0(a[n[i]])) && (a[n[i]] = Wd(n[i + 1]) ? [] : {}), a = a[n[i]];
  }
}
function Xd(e) {
  return Object.keys(e);
}
function Jd(e, t = void 0) {
  const r = Lr();
  return (r == null ? void 0 : r.provides[e]) || En(e, t);
}
function Xl(e, t, r) {
  if (Array.isArray(e)) {
    const n = [...e], a = n.findIndex((i) => yt(i, t));
    return a >= 0 ? n.splice(a, 1) : n.push(t), n;
  }
  return yt(e, t) ? r : t;
}
function S0(e, t) {
  let r, n;
  return function(...a) {
    const i = this;
    return r || (r = !0, setTimeout(() => r = !1, t), n = e.apply(i, a)), n;
  };
}
function A0(e, t) {
  return sn(t) && t.number ? b0(e) : e;
}
function Jl(e, t) {
  let r;
  return async function(...a) {
    const i = e(...a);
    r = i;
    const o = await i;
    return i !== r ? o : (r = void 0, t(o, a));
  };
}
function M0(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}
function Ai(e) {
  if (Qd(e))
    return e._value;
}
function Qd(e) {
  return "_value" in e;
}
function I0(e) {
  return e.type === "number" || e.type === "range" ? Number.isNaN(e.valueAsNumber) ? e.value : e.valueAsNumber : e.value;
}
function ef(e) {
  if (!O0(e))
    return e;
  const t = e.target;
  if (Kd(t.type) && Qd(t))
    return Ai(t);
  if (t.type === "file" && t.files) {
    const r = Array.from(t.files);
    return t.multiple ? r : r[0];
  }
  if (k0(t))
    return Array.from(t.options).filter((r) => r.selected && !r.disabled).map(Ai);
  if (Gd(t)) {
    const r = Array.from(t.options).find((n) => n.selected);
    return r ? Ai(r) : t.value;
  }
  return I0(t);
}
function tf(e) {
  const t = {};
  return Object.defineProperty(t, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), e ? sn(e) && e._$$isNormalized ? e : sn(e) ? Object.keys(e).reduce((r, n) => {
    const a = P0(e[n]);
    return e[n] !== !1 && (r[n] = Ql(a)), r;
  }, t) : typeof e != "string" ? t : e.split("|").reduce((r, n) => {
    const a = x0(n);
    return a.name && (r[a.name] = Ql(a.params)), r;
  }, t) : t;
}
function P0(e) {
  return e === !0 ? [] : Array.isArray(e) || sn(e) ? e : [e];
}
function Ql(e) {
  const t = (r) => typeof r == "string" && r[0] === "@" ? L0(r.slice(1)) : r;
  return Array.isArray(e) ? e.map(t) : e instanceof RegExp ? [e] : Object.keys(e).reduce((r, n) => (r[n] = t(e[n]), r), {});
}
const x0 = (e) => {
  let t = [];
  const r = e.split(":")[0];
  return e.includes(":") && (t = e.split(":").slice(1).join(":").split(",")), { name: r, params: t };
};
function L0(e) {
  const t = (r) => {
    var n;
    return (n = ln(r, e)) !== null && n !== void 0 ? n : r[e];
  };
  return t.__locatorRef = e, t;
}
function R0(e) {
  return Array.isArray(e) ? e.filter(io) : Xd(e).filter((t) => io(e[t])).map((t) => e[t]);
}
const F0 = {
  generateMessage: ({ field: e }) => `${e} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let V0 = Object.assign({}, F0);
const N0 = () => V0;
async function B0(e, t, r = {}) {
  const n = r == null ? void 0 : r.bails, a = {
    name: (r == null ? void 0 : r.name) || "{field}",
    rules: t,
    label: r == null ? void 0 : r.label,
    bails: n ?? !0,
    formData: (r == null ? void 0 : r.values) || {}
  }, i = await Y0(a, e);
  return Object.assign(Object.assign({}, i), { valid: !i.errors.length });
}
async function Y0(e, t) {
  const r = e.rules;
  if (Gn(r) || oo(r))
    return U0(t, Object.assign(Object.assign({}, e), { rules: r }));
  if (gr(r) || Array.isArray(r)) {
    const s = {
      field: e.label || e.name,
      name: e.name,
      label: e.label,
      form: e.formData,
      value: t
    }, l = Array.isArray(r) ? r : [r], u = l.length, c = [];
    for (let f = 0; f < u; f++) {
      const p = l[f], d = await p(t, s);
      if (!(typeof d != "string" && !Array.isArray(d) && d)) {
        if (Array.isArray(d))
          c.push(...d);
        else {
          const g = typeof d == "string" ? d : rf(s);
          c.push(g);
        }
        if (e.bails)
          return {
            errors: c
          };
      }
    }
    return {
      errors: c
    };
  }
  const n = Object.assign(Object.assign({}, e), { rules: tf(r) }), a = [], i = Object.keys(n.rules), o = i.length;
  for (let s = 0; s < o; s++) {
    const l = i[s], u = await H0(n, t, {
      name: l,
      params: n.rules[l]
    });
    if (u.error && (a.push(u.error), e.bails))
      return {
        errors: a
      };
  }
  return {
    errors: a
  };
}
function j0(e) {
  return !!e && e.name === "ValidationError";
}
function z0(e) {
  return {
    __type: "VVTypedSchema",
    async parse(r, n) {
      var a;
      try {
        return {
          output: await e.validate(r, { abortEarly: !1, context: (n == null ? void 0 : n.formData) || {} }),
          errors: []
        };
      } catch (i) {
        if (!j0(i))
          throw i;
        if (!(!((a = i.inner) === null || a === void 0) && a.length) && i.errors.length)
          return { errors: [{ path: i.path, errors: i.errors }] };
        const o = i.inner.reduce((s, l) => {
          const u = l.path || "";
          return s[u] || (s[u] = { errors: [], path: u }), s[u].errors.push(...l.errors), s;
        }, {});
        return { errors: Object.values(o) };
      }
    }
  };
}
async function U0(e, t) {
  const n = await (Gn(t.rules) ? t.rules : z0(t.rules)).parse(e, { formData: t.formData }), a = [];
  for (const i of n.errors)
    i.errors.length && a.push(...i.errors);
  return {
    value: n.value,
    errors: a
  };
}
async function H0(e, t, r) {
  const n = E0(r.name);
  if (!n)
    throw new Error(`No such validator '${r.name}' exists.`);
  const a = W0(r.params, e.formData), i = {
    field: e.label || e.name,
    name: e.name,
    label: e.label,
    value: t,
    form: e.formData,
    rule: Object.assign(Object.assign({}, r), { params: a })
  }, o = await n(t, a, i);
  return typeof o == "string" ? {
    error: o
  } : {
    error: o ? void 0 : rf(i)
  };
}
function rf(e) {
  const t = N0().generateMessage;
  return t ? t(e) : "Field is invalid";
}
function W0(e, t) {
  const r = (n) => io(n) ? n(t) : n;
  return Array.isArray(e) ? e.map(r) : Object.keys(e).reduce((n, a) => (n[a] = r(e[a]), n), {});
}
let eu = 0;
function q0(e, t) {
  const { value: r, initialValue: n, setInitialValue: a } = K0(e, t.modelValue, t.form);
  if (!t.form) {
    let p = function(d) {
      var m;
      "value" in d && (r.value = d.value), "errors" in d && u(d.errors), "touched" in d && (f.touched = (m = d.touched) !== null && m !== void 0 ? m : f.touched), "initialValue" in d && a(d.initialValue);
    };
    const { errors: l, setErrors: u } = X0(), c = eu >= Number.MAX_SAFE_INTEGER ? 0 : ++eu, f = Z0(r, n, l, t.schema);
    return {
      id: c,
      path: e,
      value: r,
      initialValue: n,
      meta: f,
      flags: { pendingUnmount: { [c]: !1 }, pendingReset: !1 },
      errors: l,
      setState: p
    };
  }
  const i = t.form.createPathState(e, {
    bails: t.bails,
    label: t.label,
    type: t.type,
    validate: t.validate,
    schema: t.schema
  }), o = O(() => i.errors);
  function s(l) {
    var u, c, f;
    "value" in l && (r.value = l.value), "errors" in l && ((u = t.form) === null || u === void 0 || u.setFieldError(w(e), l.errors)), "touched" in l && ((c = t.form) === null || c === void 0 || c.setFieldTouched(w(e), (f = l.touched) !== null && f !== void 0 ? f : !1)), "initialValue" in l && a(l.initialValue);
  }
  return {
    id: Array.isArray(i.id) ? i.id[i.id.length - 1] : i.id,
    path: e,
    value: r,
    errors: o,
    meta: i,
    initialValue: n,
    flags: i.__flags,
    setState: s
  };
}
function K0(e, t, r) {
  const n = q(w(t));
  function a() {
    return r ? ln(r.initialValues.value, w(e), w(n)) : w(n);
  }
  function i(u) {
    if (!r) {
      n.value = u;
      return;
    }
    r.setFieldInitialValue(w(e), u, !0);
  }
  const o = O(a);
  if (!r)
    return {
      value: q(a()),
      initialValue: o,
      setInitialValue: i
    };
  const s = G0(t, r, o, e);
  return r.stageInitialValue(w(e), s, !0), {
    value: O({
      get() {
        return ln(r.values, w(e));
      },
      set(u) {
        r.setFieldValue(w(e), u, !1);
      }
    }),
    initialValue: o,
    setInitialValue: i
  };
}
function G0(e, t, r, n) {
  return Xe(e) ? w(e) : e !== void 0 ? e : ln(t.values, w(n), w(r));
}
function Z0(e, t, r, n) {
  const a = O(() => {
    var o, s, l;
    return (l = (s = (o = Pe(n)) === null || o === void 0 ? void 0 : o.describe) === null || s === void 0 ? void 0 : s.call(o).required) !== null && l !== void 0 ? l : !1;
  }), i = Tn({
    touched: !1,
    pending: !1,
    valid: !0,
    required: a,
    validated: !!w(r).length,
    initialValue: O(() => w(t)),
    dirty: O(() => !yt(w(e), w(t)))
  });
  return be(r, (o) => {
    i.valid = !o.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), i;
}
function X0() {
  const e = q([]);
  return {
    errors: e,
    setErrors: (t) => {
      e.value = M0(t);
    }
  };
}
const nf = {}, Zn = {}, Xn = "vee-validate-inspector", nt = {
  error: 12405579,
  success: 448379,
  unknown: 5522283,
  white: 16777215,
  black: 0,
  blue: 218007,
  purple: 12157168,
  orange: 16099682,
  gray: 12304330
};
let xe = null, pr;
function J0(e) {
  process.env.NODE_ENV !== "production" && Lg({
    id: "vee-validate-devtools-plugin",
    label: "VeeValidate Plugin",
    packageName: "vee-validate",
    homepage: "https://vee-validate.logaretm.com/v4",
    app: e,
    logo: "https://vee-validate.logaretm.com/v4/logo.png"
  }, (t) => {
    pr = t, t.addInspector({
      id: Xn,
      icon: "rule",
      label: "vee-validate",
      noSelectionText: "Select a vee-validate node to inspect",
      actions: [
        {
          icon: "done_outline",
          tooltip: "Validate selected item",
          action: async () => {
            if (!xe) {
              console.error("There is not a valid selected vee-validate node or component");
              return;
            }
            if (xe.type === "field") {
              await xe.field.validate();
              return;
            }
            if (xe.type === "form") {
              await xe.form.validate();
              return;
            }
            xe.type === "pathState" && await xe.form.validateField(xe.state.path);
          }
        },
        {
          icon: "delete_sweep",
          tooltip: "Clear validation state of the selected item",
          action: () => {
            if (!xe) {
              console.error("There is not a valid selected vee-validate node or component");
              return;
            }
            if (xe.type === "field") {
              xe.field.resetField();
              return;
            }
            xe.type === "form" && xe.form.resetForm(), xe.type === "pathState" && xe.form.resetField(xe.state.path);
          }
        }
      ]
    }), t.on.getInspectorTree((r) => {
      if (r.inspectorId !== Xn)
        return;
      const n = Object.values(nf), a = Object.values(Zn);
      r.rootNodes = [
        ...n.map(ey),
        ...a.map((i) => ry(i))
      ];
    }), t.on.getInspectorState((r) => {
      if (r.inspectorId !== Xn)
        return;
      const { form: n, field: a, state: i, type: o } = ny(r.nodeId);
      if (t.unhighlightElement(), n && o === "form") {
        r.state = ay(n), xe = { type: "form", form: n }, t.highlightElement(n._vm);
        return;
      }
      if (i && o === "pathState" && n) {
        r.state = tu(i), xe = { type: "pathState", state: i, form: n };
        return;
      }
      if (a && o === "field") {
        r.state = tu({
          errors: a.errors.value,
          dirty: a.meta.dirty,
          valid: a.meta.valid,
          touched: a.meta.touched,
          value: a.value.value,
          initialValue: a.meta.initialValue
        }), xe = { field: a, type: "field" }, t.highlightElement(a._vm);
        return;
      }
      xe = null, t.unhighlightElement();
    });
  });
}
const so = S0(() => {
  setTimeout(async () => {
    await mr(), pr == null || pr.sendInspectorState(Xn), pr == null || pr.sendInspectorTree(Xn);
  }, 100);
}, 100);
function Q0(e) {
  const t = Lr();
  if (!pr) {
    const r = t == null ? void 0 : t.appContext.app;
    if (!r)
      return;
    J0(r);
  }
  Zn[e.id] = Object.assign({}, e), Zn[e.id]._vm = t, Nr(() => {
    delete Zn[e.id], so();
  }), so();
}
function ey(e) {
  const { textColor: t, bgColor: r } = of(e.meta.value.valid), n = {};
  Object.values(e.getAllPathStates()).forEach((o) => {
    C0(n, Pe(o.path), ty(o, e));
  });
  function a(o, s = []) {
    const l = [...s].pop();
    return "id" in o ? Object.assign(Object.assign({}, o), { label: l || o.label }) : sn(o) ? {
      id: `${s.join(".")}`,
      label: l || "",
      children: Object.keys(o).map((u) => a(o[u], [...s, u]))
    } : Array.isArray(o) ? {
      id: `${s.join(".")}`,
      label: `${l}[]`,
      children: o.map((u, c) => a(u, [...s, String(c)]))
    } : { id: "", label: "", children: [] };
  }
  const { children: i } = a(n);
  return {
    id: qo(e),
    label: e.name,
    children: i,
    tags: [
      {
        label: "Form",
        textColor: t,
        backgroundColor: r
      },
      {
        label: `${e.getAllPathStates().length} fields`,
        textColor: nt.white,
        backgroundColor: nt.unknown
      }
    ]
  };
}
function ty(e, t) {
  return {
    id: qo(t, e),
    label: Pe(e.path),
    tags: af(e.multiple, e.fieldsCount, e.type, e.valid, t)
  };
}
function ry(e, t) {
  return {
    id: qo(t, e),
    label: w(e.name),
    tags: af(!1, 1, e.type, e.meta.valid, t)
  };
}
function af(e, t, r, n, a) {
  const { textColor: i, bgColor: o } = of(n);
  return [
    e ? void 0 : {
      label: "Field",
      textColor: i,
      backgroundColor: o
    },
    a ? void 0 : {
      label: "Standalone",
      textColor: nt.black,
      backgroundColor: nt.gray
    },
    r === "checkbox" ? {
      label: "Checkbox",
      textColor: nt.white,
      backgroundColor: nt.blue
    } : void 0,
    r === "radio" ? {
      label: "Radio",
      textColor: nt.white,
      backgroundColor: nt.purple
    } : void 0,
    e ? {
      label: "Multiple",
      textColor: nt.black,
      backgroundColor: nt.orange
    } : void 0
  ].filter(Boolean);
}
function qo(e, t) {
  const r = t ? "path" in t ? "pathState" : "field" : "form", n = t ? "path" in t ? t == null ? void 0 : t.path : Pe(t == null ? void 0 : t.name) : "", a = { f: e == null ? void 0 : e.formId, ff: (t == null ? void 0 : t.id) || n, type: r };
  return btoa(encodeURIComponent(JSON.stringify(a)));
}
function ny(e) {
  try {
    const t = JSON.parse(decodeURIComponent(atob(e))), r = nf[t.f];
    if (!r && t.ff) {
      const a = Zn[t.ff];
      return a ? {
        type: t.type,
        field: a
      } : {};
    }
    if (!r)
      return {};
    const n = r.getPathState(t.ff);
    return {
      type: t.type,
      form: r,
      state: n
    };
  } catch {
  }
  return {};
}
function tu(e) {
  return {
    "Field state": [
      { key: "errors", value: e.errors },
      {
        key: "initialValue",
        value: e.initialValue
      },
      {
        key: "currentValue",
        value: e.value
      },
      {
        key: "touched",
        value: e.touched
      },
      {
        key: "dirty",
        value: e.dirty
      },
      {
        key: "valid",
        value: e.valid
      }
    ]
  };
}
function ay(e) {
  const { errorBag: t, meta: r, values: n, isSubmitting: a, isValidating: i, submitCount: o } = e;
  return {
    "Form state": [
      {
        key: "submitCount",
        value: o.value
      },
      {
        key: "isSubmitting",
        value: a.value
      },
      {
        key: "isValidating",
        value: i.value
      },
      {
        key: "touched",
        value: r.value.touched
      },
      {
        key: "dirty",
        value: r.value.dirty
      },
      {
        key: "valid",
        value: r.value.valid
      },
      {
        key: "initialValues",
        value: r.value.initialValues
      },
      {
        key: "currentValues",
        value: n
      },
      {
        key: "errors",
        value: Xd(t.value).reduce((s, l) => {
          var u;
          const c = (u = t.value[l]) === null || u === void 0 ? void 0 : u[0];
          return c && (s[l] = c), s;
        }, {})
      }
    ]
  };
}
function of(e) {
  return {
    bgColor: e ? nt.success : nt.error,
    textColor: e ? nt.black : nt.white
  };
}
function Ke(e, t, r) {
  return Kd(r == null ? void 0 : r.type) ? oy(e, t, r) : sf(e, t, r);
}
function sf(e, t, r) {
  const { initialValue: n, validateOnMount: a, bails: i, type: o, checkedValue: s, label: l, validateOnValueUpdate: u, uncheckedValue: c, controlled: f, keepValueOnUnmount: p, syncVModel: d, form: m } = iy(r), g = f ? Jd(qd) : void 0, h = m || g, y = O(() => _0(Pe(e))), _ = O(() => {
    if (Pe(h == null ? void 0 : h.schema))
      return;
    const te = w(t);
    return oo(te) || Gn(te) || gr(te) || Array.isArray(te) ? te : tf(te);
  }), $ = !gr(_.value) && Gn(Pe(t)), { id: v, value: D, initialValue: k, meta: T, setState: C, errors: V, flags: H } = q0(y, {
    modelValue: n,
    form: h,
    bails: i,
    label: l,
    type: o,
    validate: _.value ? Q : void 0,
    schema: $ ? t : void 0
  }), N = O(() => V.value[0]);
  d && sy({
    value: D,
    prop: d,
    handleChange: Y,
    shouldValidate: () => u && !H.pendingReset
  });
  const L = (j, te = !1) => {
    T.touched = !0, te && J();
  };
  async function U(j) {
    var te, de;
    if (h != null && h.validateSchema) {
      const { results: ce } = await h.validateSchema(j);
      return (te = ce[Pe(y)]) !== null && te !== void 0 ? te : { valid: !0, errors: [] };
    }
    return _.value ? B0(D.value, _.value, {
      name: Pe(y),
      label: Pe(l),
      values: (de = h == null ? void 0 : h.values) !== null && de !== void 0 ? de : {},
      bails: i
    }) : { valid: !0, errors: [] };
  }
  const J = Jl(async () => (T.pending = !0, T.validated = !0, U("validated-only")), (j) => (H.pendingUnmount[ee.id] || (C({ errors: j.errors }), T.pending = !1, T.valid = j.valid), j)), W = Jl(async () => U("silent"), (j) => (T.valid = j.valid, j));
  function Q(j) {
    return (j == null ? void 0 : j.mode) === "silent" ? W() : J();
  }
  function Y(j, te = !0) {
    const de = ef(j);
    ae(de, te);
  }
  It(() => {
    if (a)
      return J();
    (!h || !h.validateSchema) && W();
  });
  function pe(j) {
    T.touched = j;
  }
  function se(j) {
    var te;
    const de = j && "value" in j ? j.value : k.value;
    C({
      value: Sr(de),
      initialValue: Sr(de),
      touched: (te = j == null ? void 0 : j.touched) !== null && te !== void 0 ? te : !1,
      errors: (j == null ? void 0 : j.errors) || []
    }), T.pending = !1, T.validated = !1, W();
  }
  const P = Lr();
  function ae(j, te = !0) {
    D.value = P && d ? A0(j, P.props.modelModifiers) : j, (te ? J : W)();
  }
  function z(j) {
    C({ errors: Array.isArray(j) ? j : [j] });
  }
  const ge = O({
    get() {
      return D.value;
    },
    set(j) {
      ae(j, u);
    }
  }), ee = {
    id: v,
    name: y,
    label: l,
    value: ge,
    meta: T,
    errors: V,
    errorMessage: N,
    type: o,
    checkedValue: s,
    uncheckedValue: c,
    bails: i,
    keepValueOnUnmount: p,
    resetField: se,
    handleReset: () => se(),
    validate: Q,
    handleChange: Y,
    handleBlur: L,
    setState: C,
    setTouched: pe,
    setErrors: z,
    setValue: ae
  };
  if (wn(T0, ee), Xe(t) && typeof w(t) != "function" && be(t, (j, te) => {
    yt(j, te) || (T.validated ? J() : W());
  }, {
    deep: !0
  }), process.env.NODE_ENV !== "production" && (ee._vm = Lr(), be(() => Object.assign(Object.assign({ errors: V.value }, T), { value: D.value }), so, {
    deep: !0
  }), h || Q0(ee)), !h)
    return ee;
  const me = O(() => {
    const j = _.value;
    return !j || gr(j) || oo(j) || Gn(j) || Array.isArray(j) ? {} : Object.keys(j).reduce((te, de) => {
      const ce = R0(j[de]).map((Se) => Se.__locatorRef).reduce((Se, ke) => {
        const Oe = ln(h.values, ke) || h.values[ke];
        return Oe !== void 0 && (Se[ke] = Oe), Se;
      }, {});
      return Object.assign(te, ce), te;
    }, {});
  });
  return be(me, (j, te) => {
    if (!Object.keys(j).length)
      return;
    !yt(j, te) && (T.validated ? J() : W());
  }), vv(() => {
    var j;
    const te = (j = Pe(ee.keepValueOnUnmount)) !== null && j !== void 0 ? j : Pe(h.keepValuesOnUnmount), de = Pe(y);
    if (te || !h || H.pendingUnmount[ee.id]) {
      h == null || h.removePathState(de, v);
      return;
    }
    H.pendingUnmount[ee.id] = !0;
    const ce = h.getPathState(de);
    if (Array.isArray(ce == null ? void 0 : ce.id) && (ce != null && ce.multiple) ? ce != null && ce.id.includes(ee.id) : (ce == null ? void 0 : ce.id) === ee.id) {
      if (ce != null && ce.multiple && Array.isArray(ce.value)) {
        const ke = ce.value.findIndex((Oe) => yt(Oe, Pe(ee.checkedValue)));
        if (ke > -1) {
          const Oe = [...ce.value];
          Oe.splice(ke, 1), h.setFieldValue(de, Oe);
        }
        Array.isArray(ce.id) && ce.id.splice(ce.id.indexOf(ee.id), 1);
      } else
        h.unsetPathValue(Pe(y));
      h.removePathState(de, v);
    }
  }), ee;
}
function iy(e) {
  const t = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: void 0,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    syncVModel: !1,
    controlled: !0
  }), r = !!(e != null && e.syncVModel), n = typeof (e == null ? void 0 : e.syncVModel) == "string" ? e.syncVModel : (e == null ? void 0 : e.modelPropName) || "modelValue", a = r && !("initialValue" in (e || {})) ? lo(Lr(), n) : e == null ? void 0 : e.initialValue;
  if (!e)
    return Object.assign(Object.assign({}, t()), { initialValue: a });
  const i = "valueProp" in e ? e.valueProp : e.checkedValue, o = "standalone" in e ? !e.standalone : e.controlled, s = (e == null ? void 0 : e.modelPropName) || (e == null ? void 0 : e.syncVModel) || !1;
  return Object.assign(Object.assign(Object.assign({}, t()), e || {}), {
    initialValue: a,
    controlled: o ?? !0,
    checkedValue: i,
    syncVModel: s
  });
}
function oy(e, t, r) {
  const n = r != null && r.standalone ? void 0 : Jd(qd), a = r == null ? void 0 : r.checkedValue, i = r == null ? void 0 : r.uncheckedValue;
  function o(s) {
    const l = s.handleChange, u = O(() => {
      const f = Pe(s.value), p = Pe(a);
      return Array.isArray(f) ? f.findIndex((d) => yt(d, p)) >= 0 : yt(p, f);
    });
    function c(f, p = !0) {
      var d, m;
      if (u.value === ((d = f == null ? void 0 : f.target) === null || d === void 0 ? void 0 : d.checked)) {
        p && s.validate();
        return;
      }
      const g = Pe(e), h = n == null ? void 0 : n.getPathState(g), y = ef(f);
      let _ = (m = Pe(a)) !== null && m !== void 0 ? m : y;
      n && (h != null && h.multiple) && h.type === "checkbox" ? _ = Xl(ln(n.values, g) || [], _, void 0) : (r == null ? void 0 : r.type) === "checkbox" && (_ = Xl(Pe(s.value), _, Pe(i))), l(_, p);
    }
    return Object.assign(Object.assign({}, s), {
      checked: u,
      checkedValue: a,
      uncheckedValue: i,
      handleChange: c
    });
  }
  return o(sf(e, t, r));
}
function sy({ prop: e, value: t, handleChange: r, shouldValidate: n }) {
  const a = Lr();
  if (!a || !e) {
    process.env.NODE_ENV !== "production" && console.warn("Failed to setup model events because `useField` was not called in setup.");
    return;
  }
  const i = typeof e == "string" ? e : "modelValue", o = `update:${i}`;
  i in a.props && (be(t, (s) => {
    yt(s, lo(a, i)) || a.emit(o, s);
  }), be(() => lo(a, i), (s) => {
    if (s === Kl && t.value === void 0)
      return;
    const l = s === Kl ? void 0 : s;
    yt(l, t.value) || r(l, n());
  }));
}
function lo(e, t) {
  if (e)
    return e.props[t];
}
const ly = {
  key: 0,
  class: "tooltip m-cgg-icon--question"
}, uy = /* @__PURE__ */ ue({
  __name: "InputTitle",
  props: {
    title: {},
    tooltip: {},
    disabled: {},
    size: { default: "md" }
  },
  setup(e) {
    return (t, r) => {
      const n = So("tippy");
      return t.title ? (E(), I("div", {
        key: 0,
        class: X(["input-title", [`size-${t.size}`, { disabled: t.disabled }]])
      }, [
        R("span", null, _e(t.title), 1),
        t.tooltip ? ze((E(), I("span", ly, null, 512)), [
          [n, { content: t.tooltip }]
        ]) : B("", !0)
      ], 2)) : B("", !0);
    };
  }
});
const Pt = /* @__PURE__ */ ye(uy, [["__scopeId", "data-v-2674ba9f"]]), cy = /* @__PURE__ */ ue({
  __name: "InputError",
  props: {
    errorMessage: {},
    size: { default: "md" }
  },
  setup(e) {
    return (t, r) => (E(), I("div", {
      class: X(["input-error", `size-${t.size}`])
    }, _e(t.errorMessage), 3));
  }
});
const Ge = /* @__PURE__ */ ye(cy, [["__scopeId", "data-v-09cd2687"]]), dy = /* @__PURE__ */ ue({
  __name: "InputContainer",
  props: {
    layout: {}
  },
  setup(e) {
    return (t, r) => (E(), I("div", {
      class: X(["input-container", [t.layout]])
    }, [
      we(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const dt = /* @__PURE__ */ ye(dy, [["__scopeId", "data-v-45720941"]]);
var fy = Object.defineProperty, py = (e, t, r) => t in e ? fy(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Jn = (e, t, r) => py(e, typeof t != "symbol" ? t + "" : t, r);
const ru = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, nu = (e, t, r) => e.replaceAll(t, "").replace(r, ".").replace("..", ".").replace(/[^.\d]/g, ""), au = (e, t, r) => {
  var n;
  return new Intl.NumberFormat(((n = r.number) == null ? void 0 : n.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, vy = (e, t = !0, r) => {
  var n, a, i, o;
  const s = ((n = r.number) == null ? void 0 : n.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((a = r.number) == null ? void 0 : a.fraction) ?? 0;
  let u = au(0, l, r);
  const c = u.formatToParts(1000.12), f = ((i = c.find((h) => h.type === "group")) == null ? void 0 : i.value) ?? " ", p = ((o = c.find((h) => h.type === "decimal")) == null ? void 0 : o.value) ?? ".", d = nu(e, f, p);
  if (Number.isNaN(parseFloat(d)))
    return s;
  const m = d.split(".");
  if (m[1] != null && m[1].length >= 1) {
    const h = m[1].length <= l ? m[1].length : l;
    u = au(h, l, r);
  }
  let g = u.format(parseFloat(d));
  return t ? l > 0 && d.endsWith(".") && !d.slice(0, -1).includes(".") && (g += p) : g = nu(g, f, p), s + g;
};
class hy {
  constructor(t = {}) {
    Jn(this, "opts", {}), Jn(this, "memo", /* @__PURE__ */ new Map());
    const r = { ...t };
    if (r.tokens != null) {
      r.tokens = r.tokensReplace ? { ...r.tokens } : { ...ru, ...r.tokens };
      for (const n of Object.values(r.tokens))
        typeof n.pattern == "string" && (n.pattern = new RegExp(n.pattern));
    } else
      r.tokens = ru;
    Array.isArray(r.mask) && (r.mask.length > 1 ? r.mask = [...r.mask].sort((n, a) => n.length - a.length) : r.mask = r.mask[0] ?? ""), r.mask === "" && (r.mask = null), this.opts = r;
  }
  masked(t) {
    return this.process(t, this.findMask(t));
  }
  unmasked(t) {
    return this.process(t, this.findMask(t), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const r = this.findMask(t);
    if (this.opts.mask == null || r == null)
      return !1;
    const n = this.process(t, r).length;
    return typeof this.opts.mask == "string" ? n >= this.opts.mask.length : n >= r.length;
  }
  findMask(t) {
    const r = this.opts.mask;
    if (r == null)
      return null;
    if (typeof r == "string")
      return r;
    if (typeof r == "function")
      return r(t);
    const n = this.process(t, r.slice(-1).pop() ?? "", !1);
    return r.find((a) => this.process(t, a, !1).length >= n.length) ?? "";
  }
  escapeMask(t) {
    const r = [], n = [];
    return t.split("").forEach((a, i) => {
      a === "!" && t[i - 1] !== "!" ? n.push(i - n.length) : r.push(a);
    }), { mask: r.join(""), escaped: n };
  }
  process(t, r, n = !0) {
    if (this.opts.number != null)
      return vy(t, n, this.opts);
    if (r == null)
      return t;
    const a = `v=${t},mr=${r},m=${n ? 1 : 0}`;
    if (this.memo.has(a))
      return this.memo.get(a);
    const { mask: i, escaped: o } = this.escapeMask(r), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, c = this.isReversed() ? "unshift" : "push", f = this.isReversed() ? 0 : i.length - 1, p = this.isReversed() ? () => h > -1 && y > -1 : () => h < i.length && y < t.length, d = ($) => !this.isReversed() && $ <= f || this.isReversed() && $ >= f;
    let m, g = -1, h = this.isReversed() ? i.length - 1 : 0, y = this.isReversed() ? t.length - 1 : 0, _ = !1;
    for (; p(); ) {
      const $ = i.charAt(h), v = l[$], D = (v == null ? void 0 : v.transform) != null ? v.transform(t.charAt(y)) : t.charAt(y);
      if (!o.includes(h) && v != null ? (D.match(v.pattern) != null ? (s[c](D), v.repeated ? (g === -1 ? g = h : h === f && h !== g && (h = g - u), f === g && (h -= u)) : v.multiple && (_ = !0, h -= u), h += u) : v.multiple ? _ && (h += u, y -= u, _ = !1) : D === m ? m = void 0 : v.optional && (h += u, y -= u), y += u) : (n && !this.isEager() && s[c]($), D === $ && !this.isEager() ? y += u : m = $, this.isEager() || (h += u)), this.isEager())
        for (; d(h) && (l[i.charAt(h)] == null || o.includes(h)); ) {
          if (n) {
            if (s[c](i.charAt(h)), t.charAt(y) === i.charAt(h)) {
              h += u, y += u;
              continue;
            }
          } else
            i.charAt(h) === t.charAt(y) && (y += u);
          h += u;
        }
    }
    return this.memo.set(a, s.join("")), this.memo.get(a);
  }
}
const lf = (e) => JSON.parse(e.replaceAll("'", '"')), my = (e, t = {}) => {
  const r = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (r.mask = gy(e.dataset.maska)), e.dataset.maskaEager != null && (r.eager = ka(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (r.reversed = ka(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (r.tokensReplace = ka(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (r.tokens = yy(e.dataset.maskaTokens));
  const n = {};
  return e.dataset.maskaNumberLocale != null && (n.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (n.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (n.unsigned = ka(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(n).length > 0) && (r.number = n), r;
}, ka = (e) => e !== "" ? !!JSON.parse(e) : !0, gy = (e) => e.startsWith("[") && e.endsWith("]") ? lf(e) : e, yy = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return lf(e);
  const t = {};
  return e.split("|").forEach((r) => {
    const n = r.split(":");
    t[n[0]] = {
      pattern: new RegExp(n[1]),
      optional: n[2] === "optional",
      multiple: n[2] === "multiple",
      repeated: n[2] === "repeated"
    };
  }), t;
};
class by {
  constructor(t, r = {}) {
    Jn(this, "items", /* @__PURE__ */ new Map()), Jn(this, "eventAbortController"), Jn(this, "onInput", (n) => {
      if (n instanceof CustomEvent && n.type === "input" && !n.isTrusted && !n.bubbles)
        return;
      const a = n.target, i = this.items.get(a), o = "inputType" in n && n.inputType.startsWith("delete"), s = i.isEager(), l = o && s && i.unmasked(a.value) === "" ? "" : a.value;
      this.fixCursor(a, o, () => this.setValue(a, l));
    }), this.options = r, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    t.value !== "" && t.value !== this.processInput(t).masked && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const r = this.getOptions(this.options);
    for (const n of t) {
      if (!this.items.has(n)) {
        const { signal: i } = this.eventAbortController;
        n.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const a = new hy(my(n, r));
      this.items.set(n, a), queueMicrotask(() => this.updateValue(n)), n.selectionStart === null && a.isEager() && console.warn("Maska: input of `%s` type is not supported", n.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: r, preProcess: n, postProcess: a, ...i } = t;
    return i;
  }
  fixCursor(t, r, n) {
    const a = t.selectionStart, i = t.value;
    if (n(), a === null || a === i.length && !r)
      return;
    const o = t.value, s = i.slice(0, a), l = o.slice(0, a), u = this.processInput(t, s).unmasked, c = this.processInput(t, l).unmasked;
    let f = a;
    s !== l && (f += r ? o.length - i.length : u.length - c.length), t.setSelectionRange(f, f);
  }
  setValue(t, r) {
    const n = this.processInput(t, r);
    t.value = n.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((a) => a(n)) : this.options.onMaska(n)), t.dispatchEvent(new CustomEvent("maska", { detail: n })), t.dispatchEvent(new CustomEvent("input", { detail: n.masked }));
  }
  processInput(t, r) {
    const n = this.items.get(t);
    let a = r ?? t.value;
    this.options.preProcess != null && (a = this.options.preProcess(a));
    let i = n.masked(a);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: n.unmasked(a),
      completed: n.completed(a)
    };
  }
}
const Mi = /* @__PURE__ */ new WeakMap(), _y = (e, t) => {
  if (e.arg == null || e.instance == null)
    return;
  const r = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : r && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, vi = (e, t) => {
  var r;
  const n = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (n == null || (n == null ? void 0 : n.type) === "file")
    return;
  let a = {};
  if (t.value != null && (a = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (o) => {
      const s = t.modifiers.unmasked ? o.unmasked : t.modifiers.completed ? o.completed : o.masked;
      _y(t, s);
    };
    a.onMaska = a.onMaska == null ? i : Array.isArray(a.onMaska) ? [...a.onMaska, i] : [a.onMaska, i];
  }
  Mi.has(n) ? (r = Mi.get(n)) == null || r.update(a) : Mi.set(n, new by(n, a));
}, wy = ["inputmode", "aria-label"], Ey = /* @__PURE__ */ ue({
  __name: "TextInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    placeholder: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    id: {},
    disabled: {},
    inputmode: {},
    type: { default: "text" },
    autocomplete: {},
    suffix: {},
    icon: {},
    iconPosition: { default: "left" },
    maskType: {},
    numberOptions: { default: () => ({
      positiveOnly: !0,
      digits: 2
    }) }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {},
    masked: {},
    maskedModifiers: {}
  }),
  emits: ["update:modelValue", "update:masked"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), a = Be(e, "masked", {
      set: (p) => (r.inputmode != "numeric" && r.inputmode != "decimal" && r.maskType != "zipcode" && (n.value = p), p)
    });
    be(
      n,
      (p) => {
        a.value = p && (r.inputmode == "numeric" || r.inputmode == "decimal") ? Intl.NumberFormat("de").format(p) : p;
      },
      {
        immediate: !0
      }
    );
    const i = O(() => {
      if (r.inputmode == "numeric" || r.inputmode == "decimal")
        return {
          onMaska: (p) => {
            const { unmasked: d } = p;
            n.value = d && typeof d == "string" ? parseFloat(d) : void 0;
          },
          number: {
            locale: "de",
            fraction: r.inputmode == "decimal" ? r.numberOptions.digits : 0,
            unsigned: r.numberOptions.positiveOnly
          }
        };
      if (r.maskType == "zipcode")
        return {
          mask: "####-###",
          onMaska: (p) => {
            const { masked: d } = p;
            n.value = d;
          }
        };
    }), { errorMessage: o, meta: s, handleBlur: l, validate: u } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    ), c = q(), f = q();
    return It(() => {
      if (r.suffix && r.iconPosition != "right") {
        const p = parseInt(
          window.getComputedStyle(c.value).getPropertyValue("padding-right")
        ), d = f.value.getBoundingClientRect().width;
        c.value.style.paddingRight = `${Math.ceil(
          p * 2 + d
        )}px`;
      }
    }), t({ errorMessage: o, meta: s, validate: u }), (p, d) => (E(), K(dt, he(ct({ layout: p.layout })), {
      default: fe(() => [
        p.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: p.title, tooltip: p.tooltip, size: p.size, disabled: p.disabled })), null, 16)) : B("", !0),
        R("div", {
          class: X(["input-wrapper", {
            error: w(o),
            disabled: p.disabled
          }])
        }, [
          ze(R("input", ie({
            class: [`size-${p.size}`, `icon-${p.iconPosition}`, { "has-icon": p.icon }]
          }, { id: p.id, type: p.type, placeholder: p.placeholder, disabled: p.disabled, autocomplete: p.autocomplete }, {
            "onUpdate:modelValue": d[0] || (d[0] = (m) => a.value = m),
            inputmode: p.maskType == "zipcode" ? "numeric" : p.inputmode,
            onBlur: d[1] || (d[1] = (m) => w(l)(m, p.validationMode == "blur")),
            ref_key: "inputEl",
            ref: c,
            "aria-label": p.label || p.title
          }), null, 16, wy), [
            [hv, a.value],
            [w(vi), i.value]
          ]),
          p.icon ? (E(), I("div", {
            key: 0,
            class: X(["input-icon", [p.icon, `icon-${p.iconPosition}`, `size-${p.size}`]])
          }, null, 2)) : B("", !0),
          p.suffix && p.iconPosition != "right" ? (E(), I("div", {
            key: 1,
            class: X(["input-suffix", [`size-${p.size}`]]),
            ref_key: "suffixEl",
            ref: f
          }, _e(p.suffix), 3)) : B("", !0)
        ], 2),
        w(o) && p.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: p.size, errorMessage: w(o) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const uf = /* @__PURE__ */ ye(Ey, [["__scopeId", "data-v-51fe80eb"]]), Ty = ["aria-label"], Dy = /* @__PURE__ */ ue({
  __name: "TextareaInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    placeholder: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    id: {},
    disabled: {},
    rows: { default: 10 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, handleBlur: o, validate: s } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    );
    return t({ errorMessage: a, meta: i, validate: s }), (l, u) => (E(), K(dt, he(ct({ layout: l.layout })), {
      default: fe(() => [
        l.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: l.title, tooltip: l.tooltip, size: l.size, disabled: l.disabled })), null, 16)) : B("", !0),
        R("div", {
          class: X(["input-wrapper", {
            error: w(a)
          }])
        }, [
          ze(R("textarea", ie({
            class: [`size-${l.size}`]
          }, { rows: l.rows, id: l.id, disabled: l.disabled, placeholder: l.placeholder }, {
            onBlur: u[0] || (u[0] = (c) => w(o)(c, l.validationMode == "blur")),
            "onUpdate:modelValue": u[1] || (u[1] = (c) => n.value = c),
            "aria-label": l.label || l.title
          }), null, 16, Ty), [
            [Dn, n.value]
          ])
        ], 2),
        w(a) && l.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: l.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const $y = /* @__PURE__ */ ye(Dy, [["__scopeId", "data-v-615d78a1"]]);
var ot = "top", Ct = "bottom", St = "right", st = "left", Ko = "auto", ya = [ot, Ct, St, st], un = "start", sa = "end", ky = "clippingParents", cf = "viewport", Bn = "popper", Oy = "reference", iu = /* @__PURE__ */ ya.reduce(function(e, t) {
  return e.concat([t + "-" + un, t + "-" + sa]);
}, []), df = /* @__PURE__ */ [].concat(ya, [Ko]).reduce(function(e, t) {
  return e.concat([t, t + "-" + un, t + "-" + sa]);
}, []), Cy = "beforeRead", Sy = "read", Ay = "afterRead", My = "beforeMain", Iy = "main", Py = "afterMain", xy = "beforeWrite", Ly = "write", Ry = "afterWrite", Fy = [Cy, Sy, Ay, My, Iy, Py, xy, Ly, Ry];
function Zt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function _t(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Fr(e) {
  var t = _t(e).Element;
  return e instanceof t || e instanceof Element;
}
function $t(e) {
  var t = _t(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Go(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = _t(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Vy(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !$t(i) || !Zt(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function Ny(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !$t(a) || !Zt(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const By = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Vy,
  effect: Ny,
  requires: ["computeStyles"]
};
function Kt(e) {
  return e.split("-")[0];
}
var Ir = Math.max, Ka = Math.min, cn = Math.round;
function uo() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function ff() {
  return !/^((?!chrome|android).)*safari/i.test(uo());
}
function dn(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && $t(e) && (a = e.offsetWidth > 0 && cn(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && cn(n.height) / e.offsetHeight || 1);
  var o = Fr(e) ? _t(e) : window, s = o.visualViewport, l = !ff() && r, u = (n.left + (l && s ? s.offsetLeft : 0)) / a, c = (n.top + (l && s ? s.offsetTop : 0)) / i, f = n.width / a, p = n.height / i;
  return {
    width: f,
    height: p,
    top: c,
    right: u + f,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function Zo(e) {
  var t = dn(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function pf(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Go(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ir(e) {
  return _t(e).getComputedStyle(e);
}
function Yy(e) {
  return ["table", "td", "th"].indexOf(Zt(e)) >= 0;
}
function wr(e) {
  return ((Fr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function hi(e) {
  return Zt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Go(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    wr(e)
  );
}
function ou(e) {
  return !$t(e) || // https://github.com/popperjs/popper-core/issues/837
  ir(e).position === "fixed" ? null : e.offsetParent;
}
function jy(e) {
  var t = /firefox/i.test(uo()), r = /Trident/i.test(uo());
  if (r && $t(e)) {
    var n = ir(e);
    if (n.position === "fixed")
      return null;
  }
  var a = hi(e);
  for (Go(a) && (a = a.host); $t(a) && ["html", "body"].indexOf(Zt(a)) < 0; ) {
    var i = ir(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function ba(e) {
  for (var t = _t(e), r = ou(e); r && Yy(r) && ir(r).position === "static"; )
    r = ou(r);
  return r && (Zt(r) === "html" || Zt(r) === "body" && ir(r).position === "static") ? t : r || jy(e) || t;
}
function Xo(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Qn(e, t, r) {
  return Ir(e, Ka(t, r));
}
function zy(e, t, r) {
  var n = Qn(e, t, r);
  return n > r ? r : n;
}
function vf() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function hf(e) {
  return Object.assign({}, vf(), e);
}
function mf(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Uy = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, hf(typeof t != "number" ? t : mf(t, ya));
};
function Hy(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = Kt(r.placement), l = Xo(s), u = [st, St].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var f = Uy(a.padding, r), p = Zo(i), d = l === "y" ? ot : st, m = l === "y" ? Ct : St, g = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], h = o[l] - r.rects.reference[l], y = ba(i), _ = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, $ = g / 2 - h / 2, v = f[d], D = _ - p[c] - f[m], k = _ / 2 - p[c] / 2 + $, T = Qn(v, k, D), C = l;
    r.modifiersData[n] = (t = {}, t[C] = T, t.centerOffset = T - k, t);
  }
}
function Wy(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || pf(t.elements.popper, a) && (t.elements.arrow = a));
}
const qy = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hy,
  effect: Wy,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function fn(e) {
  return e.split("-")[1];
}
var Ky = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Gy(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: cn(r * a) / a || 0,
    y: cn(n * a) / a || 0
  };
}
function su(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, f = e.isFixed, p = o.x, d = p === void 0 ? 0 : p, m = o.y, g = m === void 0 ? 0 : m, h = typeof c == "function" ? c({
    x: d,
    y: g
  }) : {
    x: d,
    y: g
  };
  d = h.x, g = h.y;
  var y = o.hasOwnProperty("x"), _ = o.hasOwnProperty("y"), $ = st, v = ot, D = window;
  if (u) {
    var k = ba(r), T = "clientHeight", C = "clientWidth";
    if (k === _t(r) && (k = wr(r), ir(k).position !== "static" && s === "absolute" && (T = "scrollHeight", C = "scrollWidth")), k = k, a === ot || (a === st || a === St) && i === sa) {
      v = Ct;
      var V = f && k === D && D.visualViewport ? D.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[T]
      );
      g -= V - n.height, g *= l ? 1 : -1;
    }
    if (a === st || (a === ot || a === Ct) && i === sa) {
      $ = St;
      var H = f && k === D && D.visualViewport ? D.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[C]
      );
      d -= H - n.width, d *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: s
  }, u && Ky), L = c === !0 ? Gy({
    x: d,
    y: g
  }, _t(r)) : {
    x: d,
    y: g
  };
  if (d = L.x, g = L.y, l) {
    var U;
    return Object.assign({}, N, (U = {}, U[v] = _ ? "0" : "", U[$] = y ? "0" : "", U.transform = (D.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + g + "px)" : "translate3d(" + d + "px, " + g + "px, 0)", U));
  }
  return Object.assign({}, N, (t = {}, t[v] = _ ? g + "px" : "", t[$] = y ? d + "px" : "", t.transform = "", t));
}
function Zy(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Kt(t.placement),
    variation: fn(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, su(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, su(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Xy = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Zy,
  data: {}
};
var Oa = {
  passive: !0
};
function Jy(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, s = o === void 0 ? !0 : o, l = _t(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, Oa);
  }), s && l.addEventListener("resize", r.update, Oa), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, Oa);
    }), s && l.removeEventListener("resize", r.update, Oa);
  };
}
const Qy = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Jy,
  data: {}
};
var eb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Na(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return eb[t];
  });
}
var tb = {
  start: "end",
  end: "start"
};
function lu(e) {
  return e.replace(/start|end/g, function(t) {
    return tb[t];
  });
}
function Jo(e) {
  var t = _t(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Qo(e) {
  return dn(wr(e)).left + Jo(e).scrollLeft;
}
function rb(e, t) {
  var r = _t(e), n = wr(e), a = r.visualViewport, i = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var u = ff();
    (u || !u && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Qo(e),
    y: l
  };
}
function nb(e) {
  var t, r = wr(e), n = Jo(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Ir(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Ir(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + Qo(e), l = -n.scrollTop;
  return ir(a || r).direction === "rtl" && (s += Ir(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function es(e) {
  var t = ir(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function gf(e) {
  return ["html", "body", "#document"].indexOf(Zt(e)) >= 0 ? e.ownerDocument.body : $t(e) && es(e) ? e : gf(hi(e));
}
function ea(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = gf(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = _t(n), o = a ? [i].concat(i.visualViewport || [], es(n) ? n : []) : n, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(ea(hi(o)))
  );
}
function co(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ab(e, t) {
  var r = dn(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function uu(e, t, r) {
  return t === cf ? co(rb(e, r)) : Fr(t) ? ab(t, r) : co(nb(wr(e)));
}
function ib(e) {
  var t = ea(hi(e)), r = ["absolute", "fixed"].indexOf(ir(e).position) >= 0, n = r && $t(e) ? ba(e) : e;
  return Fr(n) ? t.filter(function(a) {
    return Fr(a) && pf(a, n) && Zt(a) !== "body";
  }) : [];
}
function ob(e, t, r, n) {
  var a = t === "clippingParents" ? ib(e) : [].concat(t), i = [].concat(a, [r]), o = i[0], s = i.reduce(function(l, u) {
    var c = uu(e, u, n);
    return l.top = Ir(c.top, l.top), l.right = Ka(c.right, l.right), l.bottom = Ka(c.bottom, l.bottom), l.left = Ir(c.left, l.left), l;
  }, uu(e, o, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function yf(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? Kt(n) : null, i = n ? fn(n) : null, o = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (a) {
    case ot:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case Ct:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case St:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case st:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = a ? Xo(a) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case un:
        l[u] = l[u] - (t[c] / 2 - r[c] / 2);
        break;
      case sa:
        l[u] = l[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function la(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, s = r.boundary, l = s === void 0 ? ky : s, u = r.rootBoundary, c = u === void 0 ? cf : u, f = r.elementContext, p = f === void 0 ? Bn : f, d = r.altBoundary, m = d === void 0 ? !1 : d, g = r.padding, h = g === void 0 ? 0 : g, y = hf(typeof h != "number" ? h : mf(h, ya)), _ = p === Bn ? Oy : Bn, $ = e.rects.popper, v = e.elements[m ? _ : p], D = ob(Fr(v) ? v : v.contextElement || wr(e.elements.popper), l, c, o), k = dn(e.elements.reference), T = yf({
    reference: k,
    element: $,
    strategy: "absolute",
    placement: a
  }), C = co(Object.assign({}, $, T)), V = p === Bn ? C : k, H = {
    top: D.top - V.top + y.top,
    bottom: V.bottom - D.bottom + y.bottom,
    left: D.left - V.left + y.left,
    right: V.right - D.right + y.right
  }, N = e.modifiersData.offset;
  if (p === Bn && N) {
    var L = N[a];
    Object.keys(H).forEach(function(U) {
      var J = [St, Ct].indexOf(U) >= 0 ? 1 : -1, W = [ot, Ct].indexOf(U) >= 0 ? "y" : "x";
      H[U] += L[W] * J;
    });
  }
  return H;
}
function sb(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? df : l, c = fn(n), f = c ? s ? iu : iu.filter(function(m) {
    return fn(m) === c;
  }) : ya, p = f.filter(function(m) {
    return u.indexOf(m) >= 0;
  });
  p.length === 0 && (p = f);
  var d = p.reduce(function(m, g) {
    return m[g] = la(e, {
      placement: g,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Kt(g)], m;
  }, {});
  return Object.keys(d).sort(function(m, g) {
    return d[m] - d[g];
  });
}
function lb(e) {
  if (Kt(e) === Ko)
    return [];
  var t = Na(e);
  return [lu(e), t, lu(t)];
}
function ub(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !0 : o, l = r.fallbackPlacements, u = r.padding, c = r.boundary, f = r.rootBoundary, p = r.altBoundary, d = r.flipVariations, m = d === void 0 ? !0 : d, g = r.allowedAutoPlacements, h = t.options.placement, y = Kt(h), _ = y === h, $ = l || (_ || !m ? [Na(h)] : lb(h)), v = [h].concat($).reduce(function(ee, me) {
      return ee.concat(Kt(me) === Ko ? sb(t, {
        placement: me,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : me);
    }, []), D = t.rects.reference, k = t.rects.popper, T = /* @__PURE__ */ new Map(), C = !0, V = v[0], H = 0; H < v.length; H++) {
      var N = v[H], L = Kt(N), U = fn(N) === un, J = [ot, Ct].indexOf(L) >= 0, W = J ? "width" : "height", Q = la(t, {
        placement: N,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), Y = J ? U ? St : st : U ? Ct : ot;
      D[W] > k[W] && (Y = Na(Y));
      var pe = Na(Y), se = [];
      if (i && se.push(Q[L] <= 0), s && se.push(Q[Y] <= 0, Q[pe] <= 0), se.every(function(ee) {
        return ee;
      })) {
        V = N, C = !1;
        break;
      }
      T.set(N, se);
    }
    if (C)
      for (var P = m ? 3 : 1, ae = function(me) {
        var j = v.find(function(te) {
          var de = T.get(te);
          if (de)
            return de.slice(0, me).every(function(ce) {
              return ce;
            });
        });
        if (j)
          return V = j, "break";
      }, z = P; z > 0; z--) {
        var ge = ae(z);
        if (ge === "break")
          break;
      }
    t.placement !== V && (t.modifiersData[n]._skip = !0, t.placement = V, t.reset = !0);
  }
}
const cb = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: ub,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function cu(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function du(e) {
  return [ot, St, Ct, st].some(function(t) {
    return e[t] >= 0;
  });
}
function db(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = la(t, {
    elementContext: "reference"
  }), s = la(t, {
    altBoundary: !0
  }), l = cu(o, n), u = cu(s, a, i), c = du(l), f = du(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const fb = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: db
};
function pb(e, t, r) {
  var n = Kt(e), a = [st, ot].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [st, St].indexOf(n) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function vb(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = df.reduce(function(c, f) {
    return c[f] = pb(f, t.rects, i), c;
  }, {}), s = o[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
const hb = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: vb
};
function mb(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = yf({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const gb = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: mb,
  data: {}
};
function yb(e) {
  return e === "x" ? "y" : "x";
}
function bb(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !1 : o, l = r.boundary, u = r.rootBoundary, c = r.altBoundary, f = r.padding, p = r.tether, d = p === void 0 ? !0 : p, m = r.tetherOffset, g = m === void 0 ? 0 : m, h = la(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), y = Kt(t.placement), _ = fn(t.placement), $ = !_, v = Xo(y), D = yb(v), k = t.modifiersData.popperOffsets, T = t.rects.reference, C = t.rects.popper, V = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, H = typeof V == "number" ? {
    mainAxis: V,
    altAxis: V
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, V), N = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var U, J = v === "y" ? ot : st, W = v === "y" ? Ct : St, Q = v === "y" ? "height" : "width", Y = k[v], pe = Y + h[J], se = Y - h[W], P = d ? -C[Q] / 2 : 0, ae = _ === un ? T[Q] : C[Q], z = _ === un ? -C[Q] : -T[Q], ge = t.elements.arrow, ee = d && ge ? Zo(ge) : {
        width: 0,
        height: 0
      }, me = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : vf(), j = me[J], te = me[W], de = Qn(0, T[Q], ee[Q]), ce = $ ? T[Q] / 2 - P - de - j - H.mainAxis : ae - de - j - H.mainAxis, Se = $ ? -T[Q] / 2 + P + de + te + H.mainAxis : z + de + te + H.mainAxis, ke = t.elements.arrow && ba(t.elements.arrow), Oe = ke ? v === "y" ? ke.clientTop || 0 : ke.clientLeft || 0 : 0, Fe = (U = N == null ? void 0 : N[v]) != null ? U : 0, ft = Y + ce - Fe - Oe, xt = Y + Se - Fe, Ue = Qn(d ? Ka(pe, ft) : pe, Y, d ? Ir(se, xt) : se);
      k[v] = Ue, L[v] = Ue - Y;
    }
    if (s) {
      var pt, wt = v === "x" ? ot : st, Et = v === "x" ? Ct : St, Ie = k[D], Ye = D === "y" ? "height" : "width", et = Ie + h[wt], He = Ie - h[Et], tt = [ot, st].indexOf(y) !== -1, vt = (pt = N == null ? void 0 : N[D]) != null ? pt : 0, ht = tt ? et : Ie - T[Ye] - C[Ye] - vt + H.altAxis, Tt = tt ? Ie + T[Ye] + C[Ye] - vt - H.altAxis : He, Lt = d && tt ? zy(ht, Ie, Tt) : Qn(d ? ht : et, Ie, d ? Tt : He);
      k[D] = Lt, L[D] = Lt - Ie;
    }
    t.modifiersData[n] = L;
  }
}
const _b = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: bb,
  requiresIfExists: ["offset"]
};
function wb(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Eb(e) {
  return e === _t(e) || !$t(e) ? Jo(e) : wb(e);
}
function Tb(e) {
  var t = e.getBoundingClientRect(), r = cn(t.width) / e.offsetWidth || 1, n = cn(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Db(e, t, r) {
  r === void 0 && (r = !1);
  var n = $t(t), a = $t(t) && Tb(t), i = wr(t), o = dn(e, a, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Zt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  es(i)) && (s = Eb(t)), $t(t) ? (l = dn(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Qo(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function $b(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function kb(e) {
  var t = $b(e);
  return Fy.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function Ob(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Cb(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var fu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function pu() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Sb(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? fu : a;
  return function(s, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, fu, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, d = {
      state: c,
      setOptions: function(y) {
        var _ = typeof y == "function" ? y(c.options) : y;
        g(), c.options = Object.assign({}, i, c.options, _), c.scrollParents = {
          reference: Fr(s) ? ea(s) : s.contextElement ? ea(s.contextElement) : [],
          popper: ea(l)
        };
        var $ = kb(Cb([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = $.filter(function(v) {
          return v.enabled;
        }), m(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var y = c.elements, _ = y.reference, $ = y.popper;
          if (pu(_, $)) {
            c.rects = {
              reference: Db(_, ba($), c.options.strategy === "fixed"),
              popper: Zo($)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(H) {
              return c.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var D = c.orderedModifiers[v], k = D.fn, T = D.options, C = T === void 0 ? {} : T, V = D.name;
              typeof k == "function" && (c = k({
                state: c,
                options: C,
                name: V,
                instance: d
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ob(function() {
        return new Promise(function(h) {
          d.forceUpdate(), h(c);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!pu(s, l))
      return d;
    d.setOptions(u).then(function(h) {
      !p && u.onFirstUpdate && u.onFirstUpdate(h);
    });
    function m() {
      c.orderedModifiers.forEach(function(h) {
        var y = h.name, _ = h.options, $ = _ === void 0 ? {} : _, v = h.effect;
        if (typeof v == "function") {
          var D = v({
            state: c,
            name: y,
            instance: d,
            options: $
          }), k = function() {
          };
          f.push(D || k);
        }
      });
    }
    function g() {
      f.forEach(function(h) {
        return h();
      }), f = [];
    }
    return d;
  };
}
var Ab = [Qy, gb, Xy, By, hb, cb, _b, qy, fb], Mb = /* @__PURE__ */ Sb({
  defaultModifiers: Ab
}), Ib = Object.defineProperty, Pb = (e, t, r) => t in e ? Ib(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ne = (e, t, r) => (Pb(e, typeof t != "symbol" ? t + "" : t, r), r), Ca = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xb = Object.prototype, Lb = xb.hasOwnProperty;
function Rb(e, t) {
  return e != null && Lb.call(e, t);
}
var Fb = Rb, Vb = Array.isArray, Bt = Vb, Nb = typeof Ca == "object" && Ca && Ca.Object === Object && Ca, _f = Nb, Bb = _f, Yb = typeof self == "object" && self && self.Object === Object && self, jb = Bb || Yb || Function("return this")(), Qt = jb, zb = Qt, Ub = zb.Symbol, mi = Ub, vu = mi, wf = Object.prototype, Hb = wf.hasOwnProperty, Wb = wf.toString, Yn = vu ? vu.toStringTag : void 0;
function qb(e) {
  var t = Hb.call(e, Yn), r = e[Yn];
  try {
    e[Yn] = void 0;
    var n = !0;
  } catch {
  }
  var a = Wb.call(e);
  return n && (t ? e[Yn] = r : delete e[Yn]), a;
}
var Kb = qb, Gb = Object.prototype, Zb = Gb.toString;
function Xb(e) {
  return Zb.call(e);
}
var Jb = Xb, hu = mi, Qb = Kb, e1 = Jb, t1 = "[object Null]", r1 = "[object Undefined]", mu = hu ? hu.toStringTag : void 0;
function n1(e) {
  return e == null ? e === void 0 ? r1 : t1 : mu && mu in Object(e) ? Qb(e) : e1(e);
}
var er = n1;
function a1(e) {
  return e != null && typeof e == "object";
}
var Yt = a1, i1 = er, o1 = Yt, s1 = "[object Symbol]";
function l1(e) {
  return typeof e == "symbol" || o1(e) && i1(e) == s1;
}
var ts = l1, u1 = Bt, c1 = ts, d1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, f1 = /^\w*$/;
function p1(e, t) {
  if (u1(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || c1(e) ? !0 : f1.test(e) || !d1.test(e) || t != null && e in Object(t);
}
var rs = p1;
function v1(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var lr = v1, h1 = er, m1 = lr, g1 = "[object AsyncFunction]", y1 = "[object Function]", b1 = "[object GeneratorFunction]", _1 = "[object Proxy]";
function w1(e) {
  if (!m1(e))
    return !1;
  var t = h1(e);
  return t == y1 || t == b1 || t == g1 || t == _1;
}
var Ur = w1, E1 = Qt, T1 = E1["__core-js_shared__"], D1 = T1, Ii = D1, gu = function() {
  var e = /[^.]+$/.exec(Ii && Ii.keys && Ii.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $1(e) {
  return !!gu && gu in e;
}
var k1 = $1, O1 = Function.prototype, C1 = O1.toString;
function S1(e) {
  if (e != null) {
    try {
      return C1.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ef = S1, A1 = Ur, M1 = k1, I1 = lr, P1 = Ef, x1 = /[\\^$.*+?()[\]{}|]/g, L1 = /^\[object .+?Constructor\]$/, R1 = Function.prototype, F1 = Object.prototype, V1 = R1.toString, N1 = F1.hasOwnProperty, B1 = RegExp(
  "^" + V1.call(N1).replace(x1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Y1(e) {
  if (!I1(e) || M1(e))
    return !1;
  var t = A1(e) ? B1 : L1;
  return t.test(P1(e));
}
var j1 = Y1;
function z1(e, t) {
  return e == null ? void 0 : e[t];
}
var U1 = z1, H1 = j1, W1 = U1;
function q1(e, t) {
  var r = W1(e, t);
  return H1(r) ? r : void 0;
}
var Hr = q1, K1 = Hr, G1 = K1(Object, "create"), gi = G1, yu = gi;
function Z1() {
  this.__data__ = yu ? yu(null) : {}, this.size = 0;
}
var X1 = Z1;
function J1(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Q1 = J1, e_ = gi, t_ = "__lodash_hash_undefined__", r_ = Object.prototype, n_ = r_.hasOwnProperty;
function a_(e) {
  var t = this.__data__;
  if (e_) {
    var r = t[e];
    return r === t_ ? void 0 : r;
  }
  return n_.call(t, e) ? t[e] : void 0;
}
var i_ = a_, o_ = gi, s_ = Object.prototype, l_ = s_.hasOwnProperty;
function u_(e) {
  var t = this.__data__;
  return o_ ? t[e] !== void 0 : l_.call(t, e);
}
var c_ = u_, d_ = gi, f_ = "__lodash_hash_undefined__";
function p_(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = d_ && t === void 0 ? f_ : t, this;
}
var v_ = p_, h_ = X1, m_ = Q1, g_ = i_, y_ = c_, b_ = v_;
function On(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
On.prototype.clear = h_;
On.prototype.delete = m_;
On.prototype.get = g_;
On.prototype.has = y_;
On.prototype.set = b_;
var __ = On;
function w_() {
  this.__data__ = [], this.size = 0;
}
var E_ = w_;
function T_(e, t) {
  return e === t || e !== e && t !== t;
}
var Cn = T_, D_ = Cn;
function $_(e, t) {
  for (var r = e.length; r--; )
    if (D_(e[r][0], t))
      return r;
  return -1;
}
var yi = $_, k_ = yi, O_ = Array.prototype, C_ = O_.splice;
function S_(e) {
  var t = this.__data__, r = k_(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : C_.call(t, r, 1), --this.size, !0;
}
var A_ = S_, M_ = yi;
function I_(e) {
  var t = this.__data__, r = M_(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var P_ = I_, x_ = yi;
function L_(e) {
  return x_(this.__data__, e) > -1;
}
var R_ = L_, F_ = yi;
function V_(e, t) {
  var r = this.__data__, n = F_(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var N_ = V_, B_ = E_, Y_ = A_, j_ = P_, z_ = R_, U_ = N_;
function Sn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Sn.prototype.clear = B_;
Sn.prototype.delete = Y_;
Sn.prototype.get = j_;
Sn.prototype.has = z_;
Sn.prototype.set = U_;
var bi = Sn, H_ = Hr, W_ = Qt, q_ = H_(W_, "Map"), ns = q_, bu = __, K_ = bi, G_ = ns;
function Z_() {
  this.size = 0, this.__data__ = {
    hash: new bu(),
    map: new (G_ || K_)(),
    string: new bu()
  };
}
var X_ = Z_;
function J_(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Q_ = J_, e2 = Q_;
function t2(e, t) {
  var r = e.__data__;
  return e2(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var _i = t2, r2 = _i;
function n2(e) {
  var t = r2(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var a2 = n2, i2 = _i;
function o2(e) {
  return i2(this, e).get(e);
}
var s2 = o2, l2 = _i;
function u2(e) {
  return l2(this, e).has(e);
}
var c2 = u2, d2 = _i;
function f2(e, t) {
  var r = d2(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var p2 = f2, v2 = X_, h2 = a2, m2 = s2, g2 = c2, y2 = p2;
function An(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
An.prototype.clear = v2;
An.prototype.delete = h2;
An.prototype.get = m2;
An.prototype.has = g2;
An.prototype.set = y2;
var as = An, Tf = as, b2 = "Expected a function";
function is(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(b2);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (is.Cache || Tf)(), r;
}
is.Cache = Tf;
var _2 = is, w2 = _2, E2 = 500;
function T2(e) {
  var t = w2(e, function(n) {
    return r.size === E2 && r.clear(), n;
  }), r = t.cache;
  return t;
}
var D2 = T2, $2 = D2, k2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, O2 = /\\(\\)?/g, C2 = $2(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(k2, function(r, n, a, i) {
    t.push(a ? i.replace(O2, "$1") : n || r);
  }), t;
}), S2 = C2;
function A2(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var M2 = A2, _u = mi, I2 = M2, P2 = Bt, x2 = ts, L2 = 1 / 0, wu = _u ? _u.prototype : void 0, Eu = wu ? wu.toString : void 0;
function Df(e) {
  if (typeof e == "string")
    return e;
  if (P2(e))
    return I2(e, Df) + "";
  if (x2(e))
    return Eu ? Eu.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -L2 ? "-0" : t;
}
var R2 = Df, F2 = R2;
function V2(e) {
  return e == null ? "" : F2(e);
}
var N2 = V2, B2 = Bt, Y2 = rs, j2 = S2, z2 = N2;
function U2(e, t) {
  return B2(e) ? e : Y2(e, t) ? [e] : j2(z2(e));
}
var $f = U2, H2 = er, W2 = Yt, q2 = "[object Arguments]";
function K2(e) {
  return W2(e) && H2(e) == q2;
}
var G2 = K2, Tu = G2, Z2 = Yt, kf = Object.prototype, X2 = kf.hasOwnProperty, J2 = kf.propertyIsEnumerable, Q2 = Tu(function() {
  return arguments;
}()) ? Tu : function(e) {
  return Z2(e) && X2.call(e, "callee") && !J2.call(e, "callee");
}, os = Q2, ew = 9007199254740991, tw = /^(?:0|[1-9]\d*)$/;
function rw(e, t) {
  var r = typeof e;
  return t = t ?? ew, !!t && (r == "number" || r != "symbol" && tw.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ss = rw, nw = 9007199254740991;
function aw(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= nw;
}
var ls = aw, iw = ts, ow = 1 / 0;
function sw(e) {
  if (typeof e == "string" || iw(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -ow ? "-0" : t;
}
var wi = sw, lw = $f, uw = os, cw = Bt, dw = ss, fw = ls, pw = wi;
function vw(e, t, r) {
  t = lw(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = pw(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && fw(a) && dw(o, a) && (cw(e) || uw(e)));
}
var Of = vw, hw = Fb, mw = Of;
function gw(e, t) {
  return e != null && mw(e, t, hw);
}
var Cf = gw, yw = er, bw = Yt, _w = "[object Date]";
function ww(e) {
  return bw(e) && yw(e) == _w;
}
var Ew = ww;
function Tw(e) {
  return function(t) {
    return e(t);
  };
}
var Sf = Tw, ua = {}, Dw = {
  get exports() {
    return ua;
  },
  set exports(e) {
    ua = e;
  }
};
(function(e, t) {
  var r = _f, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Dw, ua);
var $w = Ew, kw = Sf, Du = ua, $u = Du && Du.isDate, Ow = $u ? kw($u) : $w, Cw = Ow, Sw = er, Aw = Bt, Mw = Yt, Iw = "[object String]";
function Pw(e) {
  return typeof e == "string" || !Aw(e) && Mw(e) && Sw(e) == Iw;
}
var Wt = Pw;
function xw(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var Af = xw, Lw = bi;
function Rw() {
  this.__data__ = new Lw(), this.size = 0;
}
var Fw = Rw;
function Vw(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Nw = Vw;
function Bw(e) {
  return this.__data__.get(e);
}
var Yw = Bw;
function jw(e) {
  return this.__data__.has(e);
}
var zw = jw, Uw = bi, Hw = ns, Ww = as, qw = 200;
function Kw(e, t) {
  var r = this.__data__;
  if (r instanceof Uw) {
    var n = r.__data__;
    if (!Hw || n.length < qw - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new Ww(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var Gw = Kw, Zw = bi, Xw = Fw, Jw = Nw, Qw = Yw, eE = zw, tE = Gw;
function Mn(e) {
  var t = this.__data__ = new Zw(e);
  this.size = t.size;
}
Mn.prototype.clear = Xw;
Mn.prototype.delete = Jw;
Mn.prototype.get = Qw;
Mn.prototype.has = eE;
Mn.prototype.set = tE;
var us = Mn, rE = "__lodash_hash_undefined__";
function nE(e) {
  return this.__data__.set(e, rE), this;
}
var aE = nE;
function iE(e) {
  return this.__data__.has(e);
}
var oE = iE, sE = as, lE = aE, uE = oE;
function Ga(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new sE(); ++t < r; )
    this.add(e[t]);
}
Ga.prototype.add = Ga.prototype.push = lE;
Ga.prototype.has = uE;
var cE = Ga;
function dE(e, t) {
  return e.has(t);
}
var fE = dE, pE = cE, vE = Af, hE = fE, mE = 1, gE = 2;
function yE(e, t, r, n, a, i) {
  var o = r & mE, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var u = i.get(e), c = i.get(t);
  if (u && c)
    return u == t && c == e;
  var f = -1, p = !0, d = r & gE ? new pE() : void 0;
  for (i.set(e, t), i.set(t, e); ++f < s; ) {
    var m = e[f], g = t[f];
    if (n)
      var h = o ? n(g, m, f, t, e, i) : n(m, g, f, e, t, i);
    if (h !== void 0) {
      if (h)
        continue;
      p = !1;
      break;
    }
    if (d) {
      if (!vE(t, function(y, _) {
        if (!hE(d, _) && (m === y || a(m, y, r, n, i)))
          return d.push(_);
      })) {
        p = !1;
        break;
      }
    } else if (!(m === g || a(m, g, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
var Mf = yE, bE = Qt, _E = bE.Uint8Array, If = _E;
function wE(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var EE = wE;
function TE(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var DE = TE, ku = mi, Ou = If, $E = Cn, kE = Mf, OE = EE, CE = DE, SE = 1, AE = 2, ME = "[object Boolean]", IE = "[object Date]", PE = "[object Error]", xE = "[object Map]", LE = "[object Number]", RE = "[object RegExp]", FE = "[object Set]", VE = "[object String]", NE = "[object Symbol]", BE = "[object ArrayBuffer]", YE = "[object DataView]", Cu = ku ? ku.prototype : void 0, Pi = Cu ? Cu.valueOf : void 0;
function jE(e, t, r, n, a, i, o) {
  switch (r) {
    case YE:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case BE:
      return !(e.byteLength != t.byteLength || !i(new Ou(e), new Ou(t)));
    case ME:
    case IE:
    case LE:
      return $E(+e, +t);
    case PE:
      return e.name == t.name && e.message == t.message;
    case RE:
    case VE:
      return e == t + "";
    case xE:
      var s = OE;
    case FE:
      var l = n & SE;
      if (s || (s = CE), e.size != t.size && !l)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      n |= AE, o.set(e, t);
      var c = kE(s(e), s(t), n, a, i, o);
      return o.delete(e), c;
    case NE:
      if (Pi)
        return Pi.call(e) == Pi.call(t);
  }
  return !1;
}
var zE = jE;
function UE(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var HE = UE, WE = HE, qE = Bt;
function KE(e, t, r) {
  var n = t(e);
  return qE(e) ? n : WE(n, r(e));
}
var GE = KE;
function ZE(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var XE = ZE;
function JE() {
  return [];
}
var QE = JE, eT = XE, tT = QE, rT = Object.prototype, nT = rT.propertyIsEnumerable, Su = Object.getOwnPropertySymbols, aT = Su ? function(e) {
  return e == null ? [] : (e = Object(e), eT(Su(e), function(t) {
    return nT.call(e, t);
  }));
} : tT, iT = aT;
function oT(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var sT = oT, pn = {}, lT = {
  get exports() {
    return pn;
  },
  set exports(e) {
    pn = e;
  }
};
function uT() {
  return !1;
}
var cT = uT;
(function(e, t) {
  var r = Qt, n = cT, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || n;
  e.exports = u;
})(lT, pn);
var dT = er, fT = ls, pT = Yt, vT = "[object Arguments]", hT = "[object Array]", mT = "[object Boolean]", gT = "[object Date]", yT = "[object Error]", bT = "[object Function]", _T = "[object Map]", wT = "[object Number]", ET = "[object Object]", TT = "[object RegExp]", DT = "[object Set]", $T = "[object String]", kT = "[object WeakMap]", OT = "[object ArrayBuffer]", CT = "[object DataView]", ST = "[object Float32Array]", AT = "[object Float64Array]", MT = "[object Int8Array]", IT = "[object Int16Array]", PT = "[object Int32Array]", xT = "[object Uint8Array]", LT = "[object Uint8ClampedArray]", RT = "[object Uint16Array]", FT = "[object Uint32Array]", Ce = {};
Ce[ST] = Ce[AT] = Ce[MT] = Ce[IT] = Ce[PT] = Ce[xT] = Ce[LT] = Ce[RT] = Ce[FT] = !0;
Ce[vT] = Ce[hT] = Ce[OT] = Ce[mT] = Ce[CT] = Ce[gT] = Ce[yT] = Ce[bT] = Ce[_T] = Ce[wT] = Ce[ET] = Ce[TT] = Ce[DT] = Ce[$T] = Ce[kT] = !1;
function VT(e) {
  return pT(e) && fT(e.length) && !!Ce[dT(e)];
}
var NT = VT, BT = NT, YT = Sf, Au = ua, Mu = Au && Au.isTypedArray, jT = Mu ? YT(Mu) : BT, cs = jT, zT = sT, UT = os, HT = Bt, WT = pn, qT = ss, KT = cs, GT = Object.prototype, ZT = GT.hasOwnProperty;
function XT(e, t) {
  var r = HT(e), n = !r && UT(e), a = !r && !n && WT(e), i = !r && !n && !a && KT(e), o = r || n || a || i, s = o ? zT(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || ZT.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    qT(u, l))) && s.push(u);
  return s;
}
var Pf = XT, JT = Object.prototype;
function QT(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || JT;
  return e === r;
}
var ds = QT;
function eD(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var xf = eD, tD = xf, rD = tD(Object.keys, Object), nD = rD, aD = ds, iD = nD, oD = Object.prototype, sD = oD.hasOwnProperty;
function lD(e) {
  if (!aD(e))
    return iD(e);
  var t = [];
  for (var r in Object(e))
    sD.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var uD = lD, cD = Ur, dD = ls;
function fD(e) {
  return e != null && dD(e.length) && !cD(e);
}
var _a = fD, pD = Pf, vD = uD, hD = _a;
function mD(e) {
  return hD(e) ? pD(e) : vD(e);
}
var fs = mD, gD = GE, yD = iT, bD = fs;
function _D(e) {
  return gD(e, bD, yD);
}
var wD = _D, Iu = wD, ED = 1, TD = Object.prototype, DD = TD.hasOwnProperty;
function $D(e, t, r, n, a, i) {
  var o = r & ED, s = Iu(e), l = s.length, u = Iu(t), c = u.length;
  if (l != c && !o)
    return !1;
  for (var f = l; f--; ) {
    var p = s[f];
    if (!(o ? p in t : DD.call(t, p)))
      return !1;
  }
  var d = i.get(e), m = i.get(t);
  if (d && m)
    return d == t && m == e;
  var g = !0;
  i.set(e, t), i.set(t, e);
  for (var h = o; ++f < l; ) {
    p = s[f];
    var y = e[p], _ = t[p];
    if (n)
      var $ = o ? n(_, y, p, t, e, i) : n(y, _, p, e, t, i);
    if (!($ === void 0 ? y === _ || a(y, _, r, n, i) : $)) {
      g = !1;
      break;
    }
    h || (h = p == "constructor");
  }
  if (g && !h) {
    var v = e.constructor, D = t.constructor;
    v != D && "constructor" in e && "constructor" in t && !(typeof v == "function" && v instanceof v && typeof D == "function" && D instanceof D) && (g = !1);
  }
  return i.delete(e), i.delete(t), g;
}
var kD = $D, OD = Hr, CD = Qt, SD = OD(CD, "DataView"), AD = SD, MD = Hr, ID = Qt, PD = MD(ID, "Promise"), xD = PD, LD = Hr, RD = Qt, FD = LD(RD, "Set"), VD = FD, ND = Hr, BD = Qt, YD = ND(BD, "WeakMap"), jD = YD, fo = AD, po = ns, vo = xD, ho = VD, mo = jD, Lf = er, In = Ef, Pu = "[object Map]", zD = "[object Object]", xu = "[object Promise]", Lu = "[object Set]", Ru = "[object WeakMap]", Fu = "[object DataView]", UD = In(fo), HD = In(po), WD = In(vo), qD = In(ho), KD = In(mo), $r = Lf;
(fo && $r(new fo(new ArrayBuffer(1))) != Fu || po && $r(new po()) != Pu || vo && $r(vo.resolve()) != xu || ho && $r(new ho()) != Lu || mo && $r(new mo()) != Ru) && ($r = function(e) {
  var t = Lf(e), r = t == zD ? e.constructor : void 0, n = r ? In(r) : "";
  if (n)
    switch (n) {
      case UD:
        return Fu;
      case HD:
        return Pu;
      case WD:
        return xu;
      case qD:
        return Lu;
      case KD:
        return Ru;
    }
  return t;
});
var GD = $r, xi = us, ZD = Mf, XD = zE, JD = kD, Vu = GD, Nu = Bt, Bu = pn, QD = cs, e$ = 1, Yu = "[object Arguments]", ju = "[object Array]", Sa = "[object Object]", t$ = Object.prototype, zu = t$.hasOwnProperty;
function r$(e, t, r, n, a, i) {
  var o = Nu(e), s = Nu(t), l = o ? ju : Vu(e), u = s ? ju : Vu(t);
  l = l == Yu ? Sa : l, u = u == Yu ? Sa : u;
  var c = l == Sa, f = u == Sa, p = l == u;
  if (p && Bu(e)) {
    if (!Bu(t))
      return !1;
    o = !0, c = !1;
  }
  if (p && !c)
    return i || (i = new xi()), o || QD(e) ? ZD(e, t, r, n, a, i) : XD(e, t, l, r, n, a, i);
  if (!(r & e$)) {
    var d = c && zu.call(e, "__wrapped__"), m = f && zu.call(t, "__wrapped__");
    if (d || m) {
      var g = d ? e.value() : e, h = m ? t.value() : t;
      return i || (i = new xi()), a(g, h, r, n, i);
    }
  }
  return p ? (i || (i = new xi()), JD(e, t, r, n, a, i)) : !1;
}
var n$ = r$, a$ = n$, Uu = Yt;
function Rf(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !Uu(e) && !Uu(t) ? e !== e && t !== t : a$(e, t, r, n, Rf, a);
}
var Ff = Rf, i$ = us, o$ = Ff, s$ = 1, l$ = 2;
function u$(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var l = s[0], u = e[l], c = s[1];
    if (o && s[2]) {
      if (u === void 0 && !(l in e))
        return !1;
    } else {
      var f = new i$();
      if (n)
        var p = n(u, c, l, e, t, f);
      if (!(p === void 0 ? o$(c, u, s$ | l$, n, f) : p))
        return !1;
    }
  }
  return !0;
}
var c$ = u$, d$ = lr;
function f$(e) {
  return e === e && !d$(e);
}
var Vf = f$, p$ = Vf, v$ = fs;
function h$(e) {
  for (var t = v$(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, p$(a)];
  }
  return t;
}
var m$ = h$;
function g$(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
var Nf = g$, y$ = c$, b$ = m$, _$ = Nf;
function w$(e) {
  var t = b$(e);
  return t.length == 1 && t[0][2] ? _$(t[0][0], t[0][1]) : function(r) {
    return r === e || y$(r, e, t);
  };
}
var E$ = w$, T$ = $f, D$ = wi;
function $$(e, t) {
  t = T$(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[D$(t[r++])];
  return r && r == n ? e : void 0;
}
var Bf = $$, k$ = Bf;
function O$(e, t, r) {
  var n = e == null ? void 0 : k$(e, t);
  return n === void 0 ? r : n;
}
var Ar = O$;
function C$(e, t) {
  return e != null && t in Object(e);
}
var S$ = C$, A$ = S$, M$ = Of;
function I$(e, t) {
  return e != null && M$(e, t, A$);
}
var P$ = I$, x$ = Ff, L$ = Ar, R$ = P$, F$ = rs, V$ = Vf, N$ = Nf, B$ = wi, Y$ = 1, j$ = 2;
function z$(e, t) {
  return F$(e) && V$(t) ? N$(B$(e), t) : function(r) {
    var n = L$(r, e);
    return n === void 0 && n === t ? R$(r, e) : x$(t, n, Y$ | j$);
  };
}
var U$ = z$;
function H$(e) {
  return e;
}
var ps = H$;
function W$(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var q$ = W$, K$ = Bf;
function G$(e) {
  return function(t) {
    return K$(t, e);
  };
}
var Z$ = G$, X$ = q$, J$ = Z$, Q$ = rs, ek = wi;
function tk(e) {
  return Q$(e) ? X$(ek(e)) : J$(e);
}
var rk = tk, nk = E$, ak = U$, ik = ps, ok = Bt, sk = rk;
function lk(e) {
  return typeof e == "function" ? e : e == null ? ik : typeof e == "object" ? ok(e) ? ak(e[0], e[1]) : nk(e) : sk(e);
}
var Yf = lk;
function uk(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var l = o[e ? s : ++a];
      if (r(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var ck = uk, dk = ck, fk = dk(), jf = fk, pk = jf, vk = fs;
function hk(e, t) {
  return e && pk(e, t, vk);
}
var zf = hk, mk = _a;
function gk(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!mk(r))
      return e(r, n);
    for (var a = r.length, i = t ? a : -1, o = Object(r); (t ? i-- : ++i < a) && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var yk = gk, bk = zf, _k = yk, wk = _k(bk), Ek = wk, Tk = Ek;
function Dk(e, t) {
  var r;
  return Tk(e, function(n, a, i) {
    return r = t(n, a, i), !r;
  }), !!r;
}
var $k = Dk, kk = Cn, Ok = _a, Ck = ss, Sk = lr;
function Ak(e, t, r) {
  if (!Sk(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? Ok(r) && Ck(t, r.length) : n == "string" && t in r) ? kk(r[t], e) : !1;
}
var vs = Ak, Mk = Af, Ik = Yf, Pk = $k, xk = Bt, Lk = vs;
function Rk(e, t, r) {
  var n = xk(e) ? Mk : Pk;
  return r && Lk(e, t, r) && (t = void 0), n(e, Ik(t));
}
var Fk = Rk, Vk = er, Nk = Yt, Bk = "[object Boolean]";
function Yk(e) {
  return e === !0 || e === !1 || Nk(e) && Vk(e) == Bk;
}
var jk = Yk, zk = er, Uk = Yt, Hk = "[object Number]";
function Wk(e) {
  return typeof e == "number" || Uk(e) && zk(e) == Hk;
}
var Nt = Wk, qk = Hr, Kk = function() {
  try {
    var e = qk(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Uf = Kk, Hu = Uf;
function Gk(e, t, r) {
  t == "__proto__" && Hu ? Hu(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var Ei = Gk, Zk = Ei, Xk = Cn, Jk = Object.prototype, Qk = Jk.hasOwnProperty;
function eO(e, t, r) {
  var n = e[t];
  (!(Qk.call(e, t) && Xk(n, r)) || r === void 0 && !(t in e)) && Zk(e, t, r);
}
var tO = eO, rO = Ei, nO = zf, aO = Yf;
function iO(e, t) {
  var r = {};
  return t = aO(t), nO(e, function(n, a, i) {
    rO(r, a, t(n, a, i));
  }), r;
}
var oO = iO;
function sO(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var Hf = sO, lO = Hf, Wu = Math.max;
function uO(e, t, r) {
  return t = Wu(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = Wu(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), lO(e, this, s);
  };
}
var cO = uO;
function dO(e) {
  return function() {
    return e;
  };
}
var fO = dO, pO = fO, qu = Uf, vO = ps, hO = qu ? function(e, t) {
  return qu(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: pO(t),
    writable: !0
  });
} : vO, mO = hO, gO = 800, yO = 16, bO = Date.now;
function _O(e) {
  var t = 0, r = 0;
  return function() {
    var n = bO(), a = yO - (n - r);
    if (r = n, a > 0) {
      if (++t >= gO)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var wO = _O, EO = mO, TO = wO, DO = TO(EO), $O = DO, kO = ps, OO = cO, CO = $O;
function SO(e, t) {
  return CO(OO(e, t, kO), e + "");
}
var hs = SO;
function AO(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var MO = AO, IO = lr, PO = ds, xO = MO, LO = Object.prototype, RO = LO.hasOwnProperty;
function FO(e) {
  if (!IO(e))
    return xO(e);
  var t = PO(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !RO.call(e, n)) || r.push(n);
  return r;
}
var VO = FO, NO = Pf, BO = VO, YO = _a;
function jO(e) {
  return YO(e) ? NO(e, !0) : BO(e);
}
var ms = jO, zO = hs, UO = Cn, HO = vs, WO = ms, Wf = Object.prototype, qO = Wf.hasOwnProperty, KO = zO(function(e, t) {
  e = Object(e);
  var r = -1, n = t.length, a = n > 2 ? t[2] : void 0;
  for (a && HO(t[0], t[1], a) && (n = 1); ++r < n; )
    for (var i = t[r], o = WO(i), s = -1, l = o.length; ++s < l; ) {
      var u = o[s], c = e[u];
      (c === void 0 || UO(c, Wf[u]) && !qO.call(e, u)) && (e[u] = i[u]);
    }
  return e;
}), Ku = KO, GO = Ei, ZO = Cn;
function XO(e, t, r) {
  (r !== void 0 && !ZO(e[t], r) || r === void 0 && !(t in e)) && GO(e, t, r);
}
var qf = XO, Za = {}, JO = {
  get exports() {
    return Za;
  },
  set exports(e) {
    Za = e;
  }
};
(function(e, t) {
  var r = Qt, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i ? r.Buffer : void 0, s = o ? o.allocUnsafe : void 0;
  function l(u, c) {
    if (c)
      return u.slice();
    var f = u.length, p = s ? s(f) : new u.constructor(f);
    return u.copy(p), p;
  }
  e.exports = l;
})(JO, Za);
var Gu = If;
function QO(e) {
  var t = new e.constructor(e.byteLength);
  return new Gu(t).set(new Gu(e)), t;
}
var eC = QO, tC = eC;
function rC(e, t) {
  var r = t ? tC(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var nC = rC;
function aC(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var iC = aC, oC = lr, Zu = Object.create, sC = function() {
  function e() {
  }
  return function(t) {
    if (!oC(t))
      return {};
    if (Zu)
      return Zu(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), lC = sC, uC = xf, cC = uC(Object.getPrototypeOf, Object), Kf = cC, dC = lC, fC = Kf, pC = ds;
function vC(e) {
  return typeof e.constructor == "function" && !pC(e) ? dC(fC(e)) : {};
}
var hC = vC, mC = _a, gC = Yt;
function yC(e) {
  return gC(e) && mC(e);
}
var bC = yC, _C = er, wC = Kf, EC = Yt, TC = "[object Object]", DC = Function.prototype, $C = Object.prototype, Gf = DC.toString, kC = $C.hasOwnProperty, OC = Gf.call(Object);
function CC(e) {
  if (!EC(e) || _C(e) != TC)
    return !1;
  var t = wC(e);
  if (t === null)
    return !0;
  var r = kC.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Gf.call(r) == OC;
}
var SC = CC;
function AC(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var Zf = AC, MC = tO, IC = Ei;
function PC(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], l = n ? n(r[s], e[s], s, r, e) : void 0;
    l === void 0 && (l = e[s]), a ? IC(r, s, l) : MC(r, s, l);
  }
  return r;
}
var xC = PC, LC = xC, RC = ms;
function FC(e) {
  return LC(e, RC(e));
}
var VC = FC, Xu = qf, NC = Za, BC = nC, YC = iC, jC = hC, Ju = os, Qu = Bt, zC = bC, UC = pn, HC = Ur, WC = lr, qC = SC, KC = cs, ec = Zf, GC = VC;
function ZC(e, t, r, n, a, i, o) {
  var s = ec(e, r), l = ec(t, r), u = o.get(l);
  if (u) {
    Xu(e, r, u);
    return;
  }
  var c = i ? i(s, l, r + "", e, t, o) : void 0, f = c === void 0;
  if (f) {
    var p = Qu(l), d = !p && UC(l), m = !p && !d && KC(l);
    c = l, p || d || m ? Qu(s) ? c = s : zC(s) ? c = YC(s) : d ? (f = !1, c = NC(l, !0)) : m ? (f = !1, c = BC(l, !0)) : c = [] : qC(l) || Ju(l) ? (c = s, Ju(s) ? c = GC(s) : (!WC(s) || HC(s)) && (c = jC(l))) : f = !1;
  }
  f && (o.set(l, c), a(c, l, n, i, o), o.delete(l)), Xu(e, r, c);
}
var XC = ZC, JC = us, QC = qf, eS = jf, tS = XC, rS = lr, nS = ms, aS = Zf;
function Xf(e, t, r, n, a) {
  e !== t && eS(t, function(i, o) {
    if (a || (a = new JC()), rS(i))
      tS(e, t, o, r, Xf, n, a);
    else {
      var s = n ? n(aS(e, o), i, o + "", e, t, a) : void 0;
      s === void 0 && (s = i), QC(e, o, s);
    }
  }, nS);
}
var Jf = Xf, iS = Jf, tc = lr;
function Qf(e, t, r, n, a, i) {
  return tc(e) && tc(t) && (i.set(t, e), iS(e, t, void 0, Qf, i), i.delete(t)), e;
}
var oS = Qf, sS = hs, lS = vs;
function uS(e) {
  return sS(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && lS(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var cS = uS, dS = Jf, fS = cS, pS = fS(function(e, t, r, n) {
  dS(e, t, r, n);
}), vS = pS, hS = Hf, mS = hs, gS = oS, yS = vS, bS = mS(function(e) {
  return e.push(void 0, gS), hS(yS, void 0, e);
}), ca = bS;
function _S(e) {
  return e && e.length ? e[0] : void 0;
}
var ep = _S;
function wS(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var en = wS;
const ES = (e) => Object.prototype.toString.call(e).slice(8, -1), tn = (e) => Cw(e) && !isNaN(e.getTime()), or = (e) => ES(e) === "Object", tp = Cf, rc = (e, t) => Fk(t, (r) => Cf(e, r)), Ee = (e, t, r = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${r}${e}`;
  return e;
}, kt = (e) => Array.isArray(e), nr = (e) => kt(e) && e.length > 0, Xa = (e) => e == null ? null : document && Wt(e) ? document.querySelector(e) : e.$el ?? e, vr = (e, t, r, n = void 0) => {
  e.removeEventListener(t, r, n);
}, hr = (e, t, r, n = void 0) => (e.addEventListener(t, r, n), () => vr(e, t, r, n)), Ba = (e, t) => !!e && !!t && (e === t || e.contains(t)), Aa = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, rp = (e, ...t) => {
  const r = {};
  let n;
  for (n in e)
    t.includes(n) || (r[n] = e[n]);
  return r;
}, np = (e, t) => {
  const r = {};
  return t.forEach((n) => {
    n in e && (r[n] = e[n]);
  }), r;
};
function TS(e, t, r) {
  return Math.min(Math.max(e, t), r);
}
var Ja = {}, DS = {
  get exports() {
    return Ja;
  },
  set exports(e) {
    Ja = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var a = Number(n);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  e.exports = t.default;
})(DS, Ja);
const $S = /* @__PURE__ */ bf(Ja);
var Qa = {}, kS = {
  get exports() {
    return Qa;
  },
  set exports(e) {
    Qa = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = r;
  function r(n) {
    var a = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return a.setUTCFullYear(n.getFullYear()), n.getTime() - a.getTime();
  }
  e.exports = t.default;
})(kS, Qa);
const nc = /* @__PURE__ */ bf(Qa);
function OS(e, t) {
  var r = MS(t);
  return r.formatToParts ? SS(r, e) : AS(r, e);
}
var CS = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function SS(e, t) {
  try {
    for (var r = e.formatToParts(t), n = [], a = 0; a < r.length; a++) {
      var i = CS[r[a].type];
      i >= 0 && (n[i] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function AS(e, t) {
  var r = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var Li = {};
function MS(e) {
  if (!Li[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Li[e] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Li[e];
}
function ap(e, t, r, n, a, i, o) {
  var s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(n, a, i, o), s;
}
var ac = 36e5, IS = 6e4, Ri = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function PS(e, t, r) {
  var n, a;
  if (!e || (n = Ri.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = Ri.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), ic(i) ? -(i * ac) : NaN;
  if (n = Ri.timezoneHHMM.exec(e), n) {
    i = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return ic(i, o) ? (a = Math.abs(i) * ac + o * IS, i > 0 ? -a : a) : NaN;
  }
  if (RS(e)) {
    t = new Date(t || Date.now());
    var s = r ? t : xS(t), l = go(s, e), u = r ? l : LS(t, l, e);
    return -u;
  }
  return NaN;
}
function xS(e) {
  return ap(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function go(e, t) {
  var r = OS(e, t), n = ap(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), a = e.getTime(), i = a % 1e3;
  return a -= i >= 0 ? i : 1e3 + i, n - a;
}
function LS(e, t, r) {
  var n = e.getTime(), a = n - t, i = go(new Date(a), r);
  if (t === i)
    return t;
  a -= i - t;
  var o = go(new Date(a), r);
  return i === o ? i : Math.max(i, o);
}
function ic(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var oc = {};
function RS(e) {
  if (oc[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), oc[e] = !0, !0;
  } catch {
    return !1;
  }
}
var FS = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const VS = FS;
var Fi = 36e5, sc = 6e4, NS = 2, Qe = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: VS
};
function BS(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = t || {}, n = r.additionalDigits == null ? NS : $S(r.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = YS(e), i = jS(a.date, n), o = i.year, s = i.restDateString, l = zS(s, o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var u = l.getTime(), c = 0, f;
    if (a.time && (c = US(a.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || r.timeZone) {
      if (f = PS(a.timeZone || r.timeZone, new Date(u + c)), isNaN(f))
        return /* @__PURE__ */ new Date(NaN);
    } else
      f = nc(new Date(u + c)), f = nc(new Date(u + c + f));
    return new Date(u + c + f);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function YS(e) {
  var t = {}, r = Qe.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = Qe.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    var a = Qe.timeZone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = n;
  }
  return t;
}
function jS(e, t) {
  var r = Qe.YYY[t], n = Qe.YYYYY[t], a;
  if (a = Qe.YYYY.exec(e) || n.exec(e), a) {
    var i = a[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (a = Qe.YY.exec(e) || r.exec(e), a) {
    var o = a[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function zS(e, t) {
  if (t === null)
    return null;
  var r, n, a, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (r = Qe.MM.exec(e), r)
    return n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1, uc(t, a) ? (n.setUTCFullYear(t, a), n) : /* @__PURE__ */ new Date(NaN);
  if (r = Qe.DDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(r[1], 10);
    return qS(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Qe.MMDD.exec(e), r) {
    n = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1;
    var s = parseInt(r[2], 10);
    return uc(t, a, s) ? (n.setUTCFullYear(t, a, s), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = Qe.Www.exec(e), r)
    return i = parseInt(r[1], 10) - 1, cc(t, i) ? lc(t, i) : /* @__PURE__ */ new Date(NaN);
  if (r = Qe.WwwD.exec(e), r) {
    i = parseInt(r[1], 10) - 1;
    var l = parseInt(r[2], 10) - 1;
    return cc(t, i, l) ? lc(t, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function US(e) {
  var t, r, n;
  if (t = Qe.HH.exec(e), t)
    return r = parseFloat(t[1].replace(",", ".")), Vi(r) ? r % 24 * Fi : NaN;
  if (t = Qe.HHMM.exec(e), t)
    return r = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Vi(r, n) ? r % 24 * Fi + n * sc : NaN;
  if (t = Qe.HHMMSS.exec(e), t) {
    r = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var a = parseFloat(t[3].replace(",", "."));
    return Vi(r, n, a) ? r % 24 * Fi + n * sc + a * 1e3 : NaN;
  }
  return null;
}
function lc(e, t, r) {
  t = t || 0, r = r || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var a = n.getUTCDay() || 7, i = t * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var HS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], WS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ip(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function uc(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var n = ip(e);
    if (n && r > WS[t] || !n && r > HS[t])
      return !1;
  }
  return !0;
}
function qS(e, t) {
  if (t < 1)
    return !1;
  var r = ip(e);
  return !(r && t > 366 || !r && t > 365);
}
function cc(e, t, r) {
  return !(t < 0 || t > 52 || r != null && (r < 0 || r > 6));
}
function Vi(e, t, r) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
function Ze(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ya(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ya = function(r) {
    return typeof r;
  } : Ya = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ya(e);
}
function ur(e) {
  Ze(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Ya(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Pn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var KS = {};
function gs() {
  return KS;
}
function Vr(e, t) {
  var r, n, a, i, o, s, l, u;
  Ze(1, arguments);
  var c = gs(), f = Pn((r = (n = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = ur(e), d = p.getDay(), m = (d < f ? 7 : 0) + d - f;
  return p.setDate(p.getDate() - m), p.setHours(0, 0, 0, 0), p;
}
function dc(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var GS = 6048e5;
function ZS(e, t, r) {
  Ze(2, arguments);
  var n = Vr(e, r), a = Vr(t, r), i = n.getTime() - dc(n), o = a.getTime() - dc(a);
  return Math.round((i - o) / GS);
}
function XS(e) {
  Ze(1, arguments);
  var t = ur(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function JS(e) {
  Ze(1, arguments);
  var t = ur(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function QS(e, t) {
  return Ze(1, arguments), ZS(XS(e), JS(e), t) + 1;
}
function eA(e, t) {
  var r, n, a, i, o, s, l, u;
  Ze(1, arguments);
  var c = ur(e), f = c.getFullYear(), p = gs(), d = Pn((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = p.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(d >= 1 && d <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setFullYear(f + 1, 0, d), m.setHours(0, 0, 0, 0);
  var g = Vr(m, t), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(f, 0, d), h.setHours(0, 0, 0, 0);
  var y = Vr(h, t);
  return c.getTime() >= g.getTime() ? f + 1 : c.getTime() >= y.getTime() ? f : f - 1;
}
function tA(e, t) {
  var r, n, a, i, o, s, l, u;
  Ze(1, arguments);
  var c = gs(), f = Pn((r = (n = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), p = eA(e, t), d = /* @__PURE__ */ new Date(0);
  d.setFullYear(p, 0, f), d.setHours(0, 0, 0, 0);
  var m = Vr(d, t);
  return m;
}
var rA = 6048e5;
function nA(e, t) {
  Ze(1, arguments);
  var r = ur(e), n = Vr(r, t).getTime() - tA(r, t).getTime();
  return Math.round(n / rA) + 1;
}
function ei(e) {
  return Ze(1, arguments), Vr(e, {
    weekStartsOn: 1
  });
}
function aA(e) {
  Ze(1, arguments);
  var t = ur(e), r = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var a = ei(n), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  var o = ei(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function iA(e) {
  Ze(1, arguments);
  var t = aA(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var n = ei(r);
  return n;
}
var oA = 6048e5;
function sA(e) {
  Ze(1, arguments);
  var t = ur(e), r = ei(t).getTime() - iA(t).getTime();
  return Math.round(r / oA) + 1;
}
function Je(e, t) {
  Ze(2, arguments);
  var r = ur(e), n = Pn(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && r.setDate(r.getDate() + n), r);
}
function ti(e, t) {
  Ze(2, arguments);
  var r = ur(e), n = Pn(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return r;
  var a = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + n + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), a), r);
}
function fc(e, t) {
  Ze(2, arguments);
  var r = Pn(t);
  return ti(e, r * 12);
}
const lA = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function uA({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: r
}, n) {
  const a = [], {
    firstDayOfWeek: i,
    firstWeekday: o,
    isoWeeknumbers: s,
    weeknumbers: l,
    numDays: u,
    numWeeks: c
  } = e, f = o + (o < i ? We : 0) - i;
  let p = !0, d = !1, m = !1, g = 0;
  const h = new Intl.DateTimeFormat(n.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let y = t.numDays - f + 1, _ = t.numDays - y + 1, $ = Math.floor((y - 1) / We + 1), v = 1, D = t.numWeeks, k = 1, T = t.month, C = t.year;
  const V = /* @__PURE__ */ new Date(), H = V.getDate(), N = V.getMonth() + 1, L = V.getFullYear();
  for (let U = 1; U <= t6; U++) {
    for (let J = 1, W = i; J <= We; J++, W += W === We ? 1 - We : 1) {
      p && W === o && (y = 1, _ = e.numDays, $ = Math.floor((y - 1) / We + 1), v = Math.floor((u - y) / We + 1), D = 1, k = c, T = e.month, C = e.year, p = !1, d = !0);
      const Q = n.getDateFromParams(C, T, y, 0, 0, 0, 0), Y = n.getDateFromParams(C, T, y, 12, 0, 0, 0), pe = n.getDateFromParams(
        C,
        T,
        y,
        23,
        59,
        59,
        999
      ), se = Q, P = `${Ee(C, 4)}-${Ee(T, 2)}-${Ee(y, 2)}`, ae = J, z = We - J, ge = l[U - 1], ee = s[U - 1], me = y === H && T === N && C === L, j = d && y === 1, te = d && y === u, de = U === 1, ce = U === c, Se = J === 1, ke = J === We, Oe = gp(C, T, y);
      a.push({
        locale: n,
        id: P,
        position: ++g,
        label: y.toString(),
        ariaLabel: h.format(new Date(C, T - 1, y)),
        day: y,
        dayFromEnd: _,
        weekday: W,
        weekdayPosition: ae,
        weekdayPositionFromEnd: z,
        weekdayOrdinal: $,
        weekdayOrdinalFromEnd: v,
        week: D,
        weekFromEnd: k,
        weekPosition: U,
        weeknumber: ge,
        isoWeeknumber: ee,
        month: T,
        year: C,
        date: se,
        startDate: Q,
        endDate: pe,
        noonDate: Y,
        dayIndex: Oe,
        isToday: me,
        isFirstDay: j,
        isLastDay: te,
        isDisabled: !d,
        isFocusable: !d,
        isFocused: !1,
        inMonth: d,
        inPrevMonth: p,
        inNextMonth: m,
        onTop: de,
        onBottom: ce,
        onLeft: Se,
        onRight: ke,
        classes: [
          `id-${P}`,
          `day-${y}`,
          `day-from-end-${_}`,
          `weekday-${W}`,
          `weekday-position-${ae}`,
          `weekday-ordinal-${$}`,
          `weekday-ordinal-from-end-${v}`,
          `week-${D}`,
          `week-from-end-${k}`,
          {
            "is-today": me,
            "is-first-day": j,
            "is-last-day": te,
            "in-month": d,
            "in-prev-month": p,
            "in-next-month": m,
            "on-top": de,
            "on-bottom": ce,
            "on-left": Se,
            "on-right": ke
          }
        ]
      }), d && te ? (d = !1, m = !0, y = 1, _ = u, $ = 1, v = Math.floor((u - y) / We + 1), D = 1, k = r.numWeeks, T = r.month, C = r.year) : (y++, _--, $ = Math.floor((y - 1) / We + 1), v = Math.floor((u - y) / We + 1));
    }
    D++, k--;
  }
  return a;
}
function cA(e, t, r, n) {
  const a = e.reduce((i, o, s) => {
    const l = Math.floor(s / 7);
    let u = i[l];
    return u || (u = {
      id: `week-${l + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: t ? o.weeknumber : r ? o.isoWeeknumber : void 0,
      days: []
    }, i[l] = u), u.days.push(o), i;
  }, Array(e.length / We));
  return a.forEach((i) => {
    const o = i.days[0], s = i.days[i.days.length - 1];
    o.month === s.month ? i.title = `${n.formatDate(o.date, "MMMM YYYY")}` : o.year === s.year ? i.title = `${n.formatDate(
      o.date,
      "MMM"
    )} - ${n.formatDate(s.date, "MMM YYYY")}` : i.title = `${n.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${n.formatDate(s.date, "MMM YYYY")}`;
  }), a;
}
function dA(e, t) {
  return e.days.map((r) => ({
    label: t.formatDate(r.date, t.masks.weekdays),
    weekday: r.weekday
  }));
}
function fA(e, t) {
  return `${t}.${Ee(e, 2)}`;
}
function op(e, t, r) {
  return np(
    r.getDateParts(r.toDate(e)),
    lA[t]
  );
}
function sp({ day: e, week: t, month: r, year: n }, a, i, o) {
  if (i === "daily" && e) {
    const s = new Date(n, r - 1, e), l = Je(s, a);
    return {
      day: l.getDate(),
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  } else if (i === "weekly" && t) {
    const l = o.getMonthParts(r, n).firstDayOfMonth, u = Je(l, (t - 1 + a) * 7), c = o.getDateParts(u);
    return {
      week: c.week,
      month: c.month,
      year: c.year
    };
  } else {
    const s = new Date(n, r - 1, 1), l = ti(s, a);
    return {
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  }
}
function qt(e) {
  return e != null && e.month != null && e.year != null;
}
function yo(e, t) {
  return !qt(e) || !qt(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function ri(e, t) {
  return !qt(e) || !qt(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function pA(e, t, r) {
  return (e || !1) && !yo(e, t) && !ri(e, r);
}
function vA(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function hA(e, t, r, n) {
  if (!qt(e) || !qt(t))
    return [];
  const a = [];
  for (; !ri(e, t); )
    a.push(e), e = sp(e, 1, r, n);
  return a;
}
function lp(e) {
  const { day: t, week: r, month: n, year: a } = e;
  let i = `${a}-${Ee(n, 2)}`;
  return r && (i = `${i}-w${r}`), t && (i = `${i}-${Ee(t, 2)}`), i;
}
function mA(e, t) {
  const { month: r, year: n, showWeeknumbers: a, showIsoWeeknumbers: i } = e, o = new Date(n, r - 1, 15), s = t.getMonthParts(r, n), l = t.getPrevMonthParts(r, n), u = t.getNextMonthParts(r, n), c = uA({ monthComps: s, prevMonthComps: l, nextMonthComps: u }, t), f = cA(c, a, i, t), p = dA(f[0], t);
  return {
    id: lp(e),
    month: r,
    year: n,
    monthTitle: t.formatDate(o, t.masks.title),
    shortMonthLabel: t.formatDate(o, "MMM"),
    monthLabel: t.formatDate(o, "MMMM"),
    shortYearLabel: n.toString().substring(2),
    yearLabel: n.toString(),
    monthComps: s,
    prevMonthComps: l,
    nextMonthComps: u,
    days: c,
    weeks: f,
    weekdays: p
  };
}
function gA(e, t) {
  const { day: r, week: n, view: a, trimWeeks: i } = e, o = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (a) {
    case "daily": {
      let s = o.days.find((u) => u.inMonth);
      r ? s = o.days.find((u) => u.day === r && u.inMonth) || s : n && (s = o.days.find((u) => u.week === n && u.inMonth));
      const l = o.weeks[s.week - 1];
      o.viewWeeks = [l], o.viewDays = [s], o.week = s.week, o.weekTitle = l.title, o.day = s.day, o.dayTitle = s.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = n || 1;
      const s = o.weeks[o.week - 1];
      o.viewWeeks = [s], o.viewDays = s.days, o.weekTitle = s.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        i ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class pc {
  constructor(t, r, n) {
    ne(this, "keys", []), ne(this, "store", {}), this.size = t, this.createKey = r, this.createItem = n;
  }
  get(...t) {
    const r = this.createKey(...t);
    return this.store[r];
  }
  getOrSet(...t) {
    const r = this.createKey(...t);
    if (this.store[r])
      return this.store[r];
    const n = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const a = this.keys.shift();
      a != null && delete this.store[a];
    }
    return this.keys.push(r), this.store[r] = n, n;
  }
}
class rn {
  constructor(t, r = new ni()) {
    ne(this, "order"), ne(this, "locale"), ne(this, "start", null), ne(this, "end", null), ne(this, "repeat", null);
    var n;
    this.locale = r;
    const { start: a, end: i, span: o, order: s, repeat: l } = t;
    tn(a) && (this.start = r.getDateParts(a)), tn(i) ? this.end = r.getDateParts(i) : this.start != null && o && (this.end = r.getDateParts(Je(this.start.date, o - 1))), this.order = s ?? 0, l && (this.repeat = new ai(
      {
        from: (n = this.start) == null ? void 0 : n.date,
        ...l
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, r) {
    return (kt(t) ? t : [t]).filter((n) => n).map((n) => rn.from(n, r));
  }
  static from(t, r) {
    if (t instanceof rn)
      return t;
    const n = {
      start: null,
      end: null
    };
    return t != null && (kt(t) ? (n.start = t[0] ?? null, n.end = t[1] ?? null) : or(t) ? Object.assign(n, t) : (n.start = t, n.end = t)), n.start != null && (n.start = new Date(n.start)), n.end != null && (n.end = new Date(n.end)), new rn(n, r);
  }
  get opts() {
    const { order: t, locale: r } = this;
    return { order: t, locale: r };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: r } = this;
    return t && r && t.year === r.year && t.month === r.month && t.day === r.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var r, n;
    return ((r = this.start) == null ? void 0 : r.dayIndex) === t.dayIndex || !!((n = this.repeat) != null && n.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var r, n;
    return this.intersectsDayRange(
      ((r = t.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      ((n = t.end) == null ? void 0 : n.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, r) {
    return !(this.start && this.start.dayIndex > r || this.end && this.end.dayIndex < t);
  }
}
class yA {
  constructor() {
    ne(this, "records", {});
  }
  render(t, r, n) {
    var a, i, o, s;
    let l = null;
    const u = n[0].dayIndex, c = n[n.length - 1].dayIndex;
    return r.hasRepeat ? n.forEach((f) => {
      var p, d;
      if (r.startsOnDay(f)) {
        const m = r.daySpan < 1 / 0 ? r.daySpan : 1;
        l = {
          startDay: f.dayIndex,
          startTime: ((p = r.start) == null ? void 0 : p.time) ?? 0,
          endDay: f.dayIndex + m - 1,
          endTime: ((d = r.end) == null ? void 0 : d.time) ?? ja
        }, this.getRangeRecords(t).push(l);
      }
    }) : r.intersectsDayRange(u, c) && (l = {
      startDay: ((a = r.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      startTime: ((i = r.start) == null ? void 0 : i.time) ?? -1 / 0,
      endDay: ((o = r.end) == null ? void 0 : o.dayIndex) ?? 1 / 0,
      endTime: ((s = r.end) == null ? void 0 : s.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(l)), l;
  }
  getRangeRecords(t) {
    let r = this.records[t.key];
    return r || (r = {
      ranges: [],
      data: t
    }, this.records[t.key] = r), r.ranges;
  }
  getCell(t, r) {
    return this.getCells(r).find((i) => i.data.key === t);
  }
  cellExists(t, r) {
    const n = this.records[t];
    return n == null ? !1 : n.ranges.some(
      (a) => a.startDay <= r && a.endDay >= r
    );
  }
  getCells(t) {
    const r = Object.values(this.records), n = [], { dayIndex: a } = t;
    return r.forEach(({ data: i, ranges: o }) => {
      o.filter((s) => s.startDay <= a && s.endDay >= a).forEach((s) => {
        const l = a === s.startDay, u = a === s.endDay, c = l ? s.startTime : 0, f = new Date(t.startDate.getTime() + c), p = u ? s.endTime : ja, d = new Date(t.endDate.getTime() + p), m = c === 0 && p === ja, g = i.order || 0;
        n.push({
          ...s,
          data: i,
          onStart: l,
          onEnd: u,
          startTime: c,
          startDate: f,
          endTime: p,
          endDate: d,
          allDay: m,
          order: g
        });
      });
    }), n.sort((i, o) => i.order - o.order), n;
  }
}
const sr = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
sr.en = sr["en-US"];
sr.es = sr["es-ES"];
sr.no = sr.nb;
sr.zh = sr["zh-CN"];
const bA = Object.entries(sr).reduce(
  (e, [t, { dow: r, L: n }]) => (e[t] = {
    id: t,
    firstDayOfWeek: r,
    masks: { L: n }
  }, e),
  {}
), _A = "MMMM YYYY", wA = "W", EA = "MMM", TA = "h A", DA = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], $A = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], kA = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], OA = [
  "h:mm A"
], CA = [
  "HH:mm"
], SA = "WWW, MMM D, YYYY", AA = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], MA = "iso", IA = "YYYY-MM-DDTHH:mm:ss.SSSZ", PA = {
  title: _A,
  weekdays: wA,
  navMonths: EA,
  hours: TA,
  input: DA,
  inputDateTime: $A,
  inputDateTime24hr: kA,
  inputTime: OA,
  inputTime24hr: CA,
  dayPopover: SA,
  data: AA,
  model: MA,
  iso: IA
}, xA = 300, LA = 60, RA = 80, FA = {
  maxSwipeTime: xA,
  minHorizontalSwipeDistance: LA,
  maxVerticalSwipeDistance: RA
}, VA = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: FA,
  masks: PA,
  locales: bA,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, bo = Tn(VA), NA = O(() => oO(bo.locales, (e) => (e.masks = ca(e.masks, bo.masks), e))), _r = (e) => typeof window < "u" && tp(window.__vcalendar__, e) ? Ar(window.__vcalendar__, e) : Ar(bo, e), BA = 12, YA = 5;
function jA(e, t) {
  const r = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  Wt(e) ? n = e : tp(e, "id") && (n = e.id), n = (n || r).toLowerCase();
  const a = Object.keys(t), i = (l) => a.find((u) => u.toLowerCase() === l);
  n = i(n) || i(n.substring(0, 2)) || r;
  const o = {
    ...t["en-IE"],
    ...t[n],
    id: n,
    monthCacheSize: BA,
    pageCacheSize: YA
  };
  return or(e) ? ca(e, o) : o;
}
class ni {
  constructor(t = void 0, r) {
    ne(this, "id"), ne(this, "daysInWeek"), ne(this, "firstDayOfWeek"), ne(this, "masks"), ne(this, "timezone"), ne(this, "hourLabels"), ne(this, "dayNames"), ne(this, "dayNamesShort"), ne(this, "dayNamesShorter"), ne(this, "dayNamesNarrow"), ne(this, "monthNames"), ne(this, "monthNamesShort"), ne(this, "relativeTimeNames"), ne(this, "amPm", ["am", "pm"]), ne(this, "monthCache"), ne(this, "pageCache");
    const { id: n, firstDayOfWeek: a, masks: i, monthCacheSize: o, pageCacheSize: s } = jA(t, NA.value);
    this.monthCache = new pc(
      o,
      c6,
      d6
    ), this.pageCache = new pc(s, lp, mA), this.id = n, this.daysInWeek = We, this.firstDayOfWeek = TS(a, 1, We), this.masks = i, this.timezone = r || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Ni("long", this.id), this.dayNamesShort = Ni("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((l) => l.substring(0, 2)), this.dayNamesNarrow = Ni("narrow", this.id), this.monthNames = bc("long", this.id), this.monthNamesShort = bc("short", this.id), this.relativeTimeNames = v6(this.id);
  }
  formatDate(t, r) {
    return b6(t, r, this);
  }
  parseDate(t, r) {
    return _c(t, r, this);
  }
  toDate(t, r = {}) {
    const n = /* @__PURE__ */ new Date(NaN);
    let a = n;
    const { fillDate: i, mask: o, patch: s, rules: l } = r;
    if (Nt(t) ? (r.type = "number", a = /* @__PURE__ */ new Date(+t)) : Wt(t) ? (r.type = "string", a = t ? _c(t, o || "iso", this) : n) : tn(t) ? (r.type = "date", a = new Date(t.getTime())) : ys(t) && (r.type = "object", a = this.getDateFromParts(t)), a && (s || l)) {
      let u = this.getDateParts(a);
      if (s && i != null) {
        const c = this.getDateParts(this.toDate(i));
        u = this.getDateParts(
          this.toDate({ ...c, ...np(u, e6[s]) })
        );
      }
      l && (u = y6(u, l)), a = this.getDateFromParts(u);
    }
    return a || n;
  }
  toDateOrNull(t, r = {}) {
    const n = this.toDate(t, r);
    return isNaN(n.getTime()) ? null : n;
  }
  fromDate(t, { type: r, mask: n } = {}) {
    switch (r) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, n || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return rn.from(t, this);
  }
  ranges(t) {
    return rn.fromMany(t, this);
  }
  getDateParts(t) {
    return u6(t, this);
  }
  getDateFromParts(t) {
    return bp(t, this.timezone);
  }
  getDateFromParams(t, r, n, a, i, o, s) {
    return this.getDateFromParts({
      year: t,
      month: r,
      day: n,
      hours: a,
      minutes: i,
      seconds: o,
      milliseconds: s
    });
  }
  getPage(t) {
    const r = this.pageCache.getOrSet(t, this);
    return gA(t, r);
  }
  getMonthParts(t, r) {
    const { firstDayOfWeek: n } = this;
    return this.monthCache.getOrSet(t, r, n);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, r) {
    return t === 1 ? this.getMonthParts(12, r - 1) : this.getMonthParts(t - 1, r);
  }
  getNextMonthParts(t, r) {
    return t === 12 ? this.getMonthParts(1, r + 1) : this.getMonthParts(t + 1, r);
  }
  getHourLabels() {
    return p6().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var Zr = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(Zr || {}), up = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(up || {}), cp = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(cp || {}), dp = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(dp || {});
class zA {
  constructor(t, r, n) {
    ne(this, "validated", !0), this.type = t, this.interval = r, this.from = n, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: r } = t;
    switch (this.type) {
      case "days":
        return bs(this.from.date, r) % this.interval === 0;
      case "weeks":
        return s6(this.from.date, r) % this.interval === 0;
      case "months":
        return l6(this.from.date, r) % this.interval === 0;
      case "years":
        return yp(this.from.date, r) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class xn {
  constructor(t, r, n, a) {
    ne(this, "components", []), this.type = t, this.validator = n, this.getter = a, this.components = this.normalizeComponents(r);
  }
  static create(t, r) {
    switch (t) {
      case "days":
        return new UA(r);
      case "weekdays":
        return new HA(r);
      case "weeks":
        return new WA(r);
      case "months":
        return new qA(r);
      case "years":
        return new KA(r);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!kt(t))
      return [];
    const r = [];
    return t.forEach((n) => {
      if (!this.validator(n)) {
        console.error(
          `Component value ${n} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      r.push(n);
    }), r;
  }
  passes(t) {
    return this.getter(t).some((a) => this.components.includes(a));
  }
}
class UA extends xn {
  constructor(t) {
    super(
      "days",
      t,
      XA,
      ({ day: r, dayFromEnd: n }) => [r, -n]
    );
  }
}
class HA extends xn {
  constructor(t) {
    super(
      "weekdays",
      t,
      _o,
      ({ weekday: r }) => [r]
    );
  }
}
class WA extends xn {
  constructor(t) {
    super(
      "weeks",
      t,
      JA,
      ({ week: r, weekFromEnd: n }) => [r, -n]
    );
  }
}
class qA extends xn {
  constructor(t) {
    super("months", t, QA, ({ month: r }) => [
      r
    ]);
  }
}
class KA extends xn {
  constructor(t) {
    super("years", t, Nt, ({ year: r }) => [r]);
  }
}
class GA {
  constructor(t, r) {
    ne(this, "components"), this.type = t, this.components = this.normalizeComponents(r);
  }
  normalizeArrayConfig(t) {
    const r = [];
    return t.forEach((n, a) => {
      if (Nt(n)) {
        if (a === 0)
          return;
        if (!vc(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!_o(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], n]);
      } else
        kt(n) && r.push(...this.normalizeArrayConfig(n));
    }), r;
  }
  normalizeComponents(t) {
    const r = [];
    return t.forEach((n, a) => {
      if (Nt(n)) {
        if (a === 0)
          return;
        if (!vc(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!_o(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        r.push([t[0], n]);
      } else
        kt(n) && r.push(...this.normalizeArrayConfig(n));
    }), r;
  }
  passes(t) {
    const { weekday: r, weekdayOrdinal: n, weekdayOrdinalFromEnd: a } = t;
    return this.components.some(
      ([i, o]) => (i === n || i === -a) && r === o
    );
  }
}
class ZA {
  constructor(t) {
    ne(this, "type", "function"), ne(this, "validated", !0), this.fn = t, Ur(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class ai {
  constructor(t, r = {}, n) {
    ne(this, "validated", !0), ne(this, "config"), ne(this, "type", Zr.Any), ne(this, "from"), ne(this, "until"), ne(this, "rules", []), ne(this, "locale", new ni()), this.parent = n, r.locale && (this.locale = r.locale), this.config = t, Ur(t) ? (this.type = Zr.All, this.rules = [new ZA(t)]) : kt(t) ? (this.type = Zr.Any, this.rules = t.map((a) => new ai(a, r, this))) : or(t) ? (this.type = Zr.All, this.from = t.from ? this.locale.getDateParts(t.from) : n == null ? void 0 : n.from, this.until = t.until ? this.locale.getDateParts(t.until) : n == null ? void 0 : n.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const r = [];
    if (t.every && (Wt(t.every) && (t.every = [1, `${t.every}s`]), kt(t.every))) {
      const [n = 1, a = up.Days] = t.every;
      r.push(new zA(a, n, this.from));
    }
    return Object.values(cp).forEach((n) => {
      n in t && r.push(xn.create(n, t[n]));
    }), Object.values(dp).forEach((n) => {
      n in t && r.push(new GA(n, t[n]));
    }), t.on != null && (kt(t.on) || (t.on = [t.on]), r.push(
      new ai(t.on, { locale: this.locale }, this.parent)
    )), r;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === Zr.Any ? this.rules.some((r) => r.passes(t)) : this.rules.every((r) => r.passes(t)) : !0;
  }
}
function XA(e) {
  return Nt(e) ? e >= 1 && e <= 31 : !1;
}
function _o(e) {
  return Nt(e) ? e >= 1 && e <= 7 : !1;
}
function JA(e) {
  return Nt(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function QA(e) {
  return Nt(e) ? e >= 1 && e <= 12 : !1;
}
function vc(e) {
  return !(!Nt(e) || e < -5 || e > 5 || e === 0);
}
const e6 = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, We = 7, t6 = 6, fp = 1e3, pp = fp * 60, vp = pp * 60, ja = vp * 24, r6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], n6 = ["L", "iso"], Wn = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, hp = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, a6 = /\[([^]*?)\]/gm, hc = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return Ee(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return Ee(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return Ee(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return Ee(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return Ee(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return Ee(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return Ee(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return Ee(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return Ee(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return Ee(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Ee(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Ee(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${Ee(Math.floor(Math.abs(t) / 60), 2)}:${Ee(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, dr = /\d\d?/, i6 = /\d{3}/, o6 = /\d{4}/, jn = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, mc = () => {
}, gc = (e) => (t, r, n) => {
  const a = n[e].indexOf(
    r.charAt(0).toUpperCase() + r.substr(1).toLowerCase()
  );
  ~a && (t.month = a);
}, Te = {
  D: [
    dr,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(dr.source + jn.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [dr, mc],
  W: [jn, mc],
  M: [
    dr,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [jn, gc("monthNamesShort")],
  MMMM: [jn, gc("monthNames")],
  YY: [
    dr,
    (e, t) => {
      const n = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? n - 1 : n}${t}`;
    }
  ],
  YYYY: [
    o6,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    i6,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    dr,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    dr,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    dr,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    jn,
    (e, t, r) => {
      const n = t.toLowerCase();
      n === r.amPm[0] ? e.isPm = !1 : n === r.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const r = `${t}`.match(/([+-]|\d\d)/gi);
      if (r) {
        const n = +r[1] * 60 + parseInt(r[2], 10);
        e.timezoneOffset = r[0] === "+" ? n : -n;
      }
    }
  ]
};
Te.DD = Te.D;
Te.dd = Te.d;
Te.WWWW = Te.WWW = Te.WW = Te.W;
Te.MM = Te.M;
Te.mm = Te.m;
Te.hh = Te.H = Te.HH = Te.h;
Te.ss = Te.s;
Te.A = Te.a;
Te.ZZZZ = Te.ZZZ = Te.ZZ = Te.Z;
function mp(e, t) {
  return (nr(e) && e || [
    Wt(e) && e || "YYYY-MM-DD"
  ]).map(
    (r) => n6.reduce(
      (n, a) => n.replace(a, t.masks[a] || ""),
      r
    )
  );
}
function ys(e) {
  return or(e) && "year" in e && "month" in e && "day" in e;
}
function yc(e, t = 1) {
  const r = e.getDay() + 1, n = r >= t ? t - r : -(7 - (t - r));
  return Je(e, n);
}
function gp(e, t, r) {
  const n = Date.UTC(e, t - 1, r);
  return bs(/* @__PURE__ */ new Date(0), new Date(n));
}
function bs(e, t) {
  return Math.round((t.getTime() - e.getTime()) / ja);
}
function s6(e, t) {
  return Math.ceil(bs(yc(e), yc(t)) / 7);
}
function yp(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function l6(e, t) {
  return yp(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function bp(e, t = "") {
  const r = /* @__PURE__ */ new Date(), {
    year: n = r.getFullYear(),
    month: a = r.getMonth() + 1,
    day: i = r.getDate(),
    hours: o = 0,
    minutes: s = 0,
    seconds: l = 0,
    milliseconds: u = 0
  } = e;
  if (t) {
    const c = `${Ee(n, 4)}-${Ee(a, 2)}-${Ee(i, 2)}T${Ee(
      o,
      2
    )}:${Ee(s, 2)}:${Ee(l, 2)}.${Ee(u, 3)}`;
    return BS(c, { timeZone: t });
  }
  return new Date(n, a - 1, i, o, s, l, u);
}
function u6(e, t) {
  let r = new Date(e.getTime());
  t.timezone && (r = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), r.setMilliseconds(e.getMilliseconds()));
  const n = r.getMilliseconds(), a = r.getSeconds(), i = r.getMinutes(), o = r.getHours(), s = n + a * fp + i * pp + o * vp, l = r.getMonth() + 1, u = r.getFullYear(), c = t.getMonthParts(l, u), f = r.getDate(), p = c.numDays - f + 1, d = r.getDay() + 1, m = Math.floor((f - 1) / 7 + 1), g = Math.floor((c.numDays - f) / 7 + 1), h = Math.ceil(
    (f + Math.abs(c.firstWeekday - c.firstDayOfWeek)) / 7
  ), y = c.numWeeks - h + 1, _ = c.weeknumbers[h], $ = gp(u, l, f);
  return {
    milliseconds: n,
    seconds: a,
    minutes: i,
    hours: o,
    time: s,
    day: f,
    dayFromEnd: p,
    weekday: d,
    weekdayOrdinal: m,
    weekdayOrdinalFromEnd: g,
    week: h,
    weekFromEnd: y,
    weeknumber: _,
    month: l,
    year: u,
    date: r,
    dateTime: r.getTime(),
    dayIndex: $,
    timezoneOffset: 0,
    isValid: !0
  };
}
function c6(e, t, r) {
  return `${t}-${e}-${r}`;
}
function d6(e, t, r) {
  const n = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, a = new Date(t, e - 1, 1), i = a.getDay() + 1, o = e === 2 && n ? 29 : r6[e - 1], s = r - 1, l = QS(a, {
    weekStartsOn: s
  }), u = [], c = [];
  for (let f = 0; f < l; f++) {
    const p = Je(a, f * 7);
    u.push(nA(p, { weekStartsOn: s })), c.push(sA(p));
  }
  return {
    firstDayOfWeek: r,
    firstDayOfMonth: a,
    inLeapYear: n,
    firstWeekday: i,
    numDays: o,
    numWeeks: l,
    month: e,
    year: t,
    weeknumbers: u,
    isoWeeknumbers: c
  };
}
function f6() {
  const e = [];
  for (let a = 0; a < We; a++)
    e.push(
      bp({
        year: 2020,
        month: 1,
        day: 5 + a,
        hours: 12
      })
    );
  return e;
}
function Ni(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return f6().map((n) => r.format(n));
}
function p6() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function v6(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], r = new Intl.RelativeTimeFormat(e);
  return t.reduce((n, a) => {
    const i = r.formatToParts(100, a);
    return n[a] = i[1].unit, n;
  }, {});
}
function _p() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function bc(e, t = void 0) {
  const r = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return _p().map((n) => r.format(n));
}
function h6(e, t, r) {
  return Nt(t) ? t === e : kt(t) ? t.includes(e) : Ur(t) ? t(e, r) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function qn(e, t, r) {
  const n = [], [a, i, o] = t;
  for (let s = a; s <= i; s++)
    (r == null || h6(s, r, e)) && n.push({
      value: s,
      label: Ee(s, o)
    });
  return n;
}
function m6(e, t) {
  return {
    milliseconds: qn(
      e,
      Wn.milliseconds,
      t.milliseconds
    ),
    seconds: qn(e, Wn.seconds, t.seconds),
    minutes: qn(e, Wn.minutes, t.minutes),
    hours: qn(e, Wn.hours, t.hours)
  };
}
function g6(e, t, r, n) {
  const i = qn(e, t, n).reduce((o, s) => {
    if (s.disabled)
      return o;
    if (isNaN(o))
      return s.value;
    const l = Math.abs(o - r);
    return Math.abs(s.value - r) < l ? s.value : o;
  }, NaN);
  return isNaN(i) ? r : i;
}
function y6(e, t) {
  const r = { ...e };
  return Object.entries(t).forEach(([n, a]) => {
    const i = Wn[n], o = e[n];
    r[n] = g6(
      e,
      i,
      o,
      a
    );
  }), r;
}
function _c(e, t, r) {
  return mp(t, r).map((a) => {
    if (typeof a != "string")
      throw new Error("Invalid mask");
    let i = e;
    if (i.length > 1e3)
      return !1;
    let o = !0;
    const s = {};
    if (a.replace(hp, (c) => {
      if (Te[c]) {
        const f = Te[c], p = i.search(f[0]);
        ~p ? i.replace(f[0], (d) => (f[1](s, d, r), i = i.substr(p + d.length), d)) : o = !1;
      }
      return Te[c] ? "" : c.slice(1, c.length - 1);
    }), !o)
      return !1;
    const l = /* @__PURE__ */ new Date();
    s.hours != null && (s.isPm === !0 && +s.hours != 12 ? s.hours = +s.hours + 12 : s.isPm === !1 && +s.hours == 12 && (s.hours = 0));
    let u;
    return s.timezoneOffset != null ? (s.minutes = +(s.minutes || 0) - +s.timezoneOffset, u = new Date(
      Date.UTC(
        s.year || l.getFullYear(),
        s.month || 0,
        s.day || 1,
        s.hours || 0,
        s.minutes || 0,
        s.seconds || 0,
        s.milliseconds || 0
      )
    )) : u = r.getDateFromParts({
      year: s.year || l.getFullYear(),
      month: (s.month || 0) + 1,
      day: s.day || 1,
      hours: s.hours || 0,
      minutes: s.minutes || 0,
      seconds: s.seconds || 0,
      milliseconds: s.milliseconds || 0
    }), u;
  }).find((a) => a) || new Date(e);
}
function b6(e, t, r) {
  if (e == null)
    return "";
  let n = mp(t, r)[0];
  /Z$/.test(n) && (r.timezone = "utc");
  const a = [];
  n = n.replace(a6, (o, s) => (a.push(s), "??"));
  const i = r.getDateParts(e);
  return n = n.replace(
    hp,
    (o) => o in hc ? hc[o](i, r) : o.slice(1, o.length - 1)
  ), n.replace(/\?\?/g, () => a.shift());
}
let _6 = 0;
class wp {
  constructor(t, r, n) {
    ne(this, "key", ""), ne(this, "hashcode", ""), ne(this, "highlight", null), ne(this, "content", null), ne(this, "dot", null), ne(this, "bar", null), ne(this, "event", null), ne(this, "popover", null), ne(this, "customData", null), ne(this, "ranges"), ne(this, "hasRanges", !1), ne(this, "order", 0), ne(this, "pinPage", !1), ne(this, "maxRepeatSpan", 0), ne(this, "locale");
    const { dates: a } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++_6), this.locale = n, r.normalizeGlyphs(this), this.ranges = n.ranges(a ?? []), this.hasRanges = !!nr(this.ranges), this.maxRepeatSpan = this.ranges.filter((i) => i.hasRepeat).map((i) => i.daySpan).reduce((i, o) => Math.max(i, o), 0);
  }
  intersectsRange({ start: t, end: r }) {
    if (t == null || r == null)
      return !1;
    const n = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of n)
      if (o.intersectsDayRange(t.dayIndex, r.dayIndex))
        return !0;
    const a = this.ranges.filter((o) => o.hasRepeat);
    if (!a.length)
      return !1;
    let i = t;
    for (this.maxRepeatSpan > 1 && (i = this.locale.getDateParts(Je(i.date, -this.maxRepeatSpan))); i.dayIndex <= r.dayIndex; ) {
      for (const o of a)
        if (o.startsOnDay(i))
          return !0;
      i = this.locale.getDateParts(Je(i.date, 1));
    }
    return !1;
  }
}
function wo(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function da(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Ep(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Tp(e) {
  const { visibility: t } = e, r = t === "click", n = t === "hover", a = t === "hover-focus", i = t === "focus";
  e.autoHide = !r;
  let o = !1, s = !1;
  const l = (m) => {
    r && (Ep({
      ...e,
      target: e.target || m.currentTarget
    }), m.stopPropagation());
  }, u = (m) => {
    o || (o = !0, (n || a) && wo({
      ...e,
      target: e.target || m.currentTarget
    }));
  }, c = () => {
    o && (o = !1, (n || a && !s) && da(e));
  }, f = (m) => {
    s || (s = !0, (i || a) && wo({
      ...e,
      target: e.target || m.currentTarget
    }));
  }, p = (m) => {
    s && !Ba(m.currentTarget, m.relatedTarget) && (s = !1, (i || a && !o) && da(e));
  }, d = {};
  switch (e.visibility) {
    case "click":
      d.click = l;
      break;
    case "hover":
      d.mousemove = u, d.mouseleave = c;
      break;
    case "focus":
      d.focusin = f, d.focusout = p;
      break;
    case "hover-focus":
      d.mousemove = u, d.mouseleave = c, d.focusin = f, d.focusout = p;
      break;
  }
  return d;
}
const wc = (e) => {
  const t = Xa(e);
  if (t == null)
    return;
  const r = t.popoverHandlers;
  !r || !r.length || (r.forEach((n) => n()), delete t.popoverHandlers);
}, Ec = (e, t) => {
  const r = Xa(e);
  if (r == null)
    return;
  const n = [], a = Tp(t);
  Object.entries(a).forEach(([i, o]) => {
    n.push(hr(r, i, o));
  }), r.popoverHandlers = n;
}, Dp = {
  mounted(e, t) {
    const { value: r } = t;
    r && Ec(e, r);
  },
  updated(e, t) {
    const { oldValue: r, value: n } = t, a = r == null ? void 0 : r.visibility, i = n == null ? void 0 : n.visibility;
    a !== i && (a && (wc(e), i || da(r)), i && Ec(e, n));
  },
  unmounted(e) {
    wc(e);
  }
}, w6 = (e, t, {
  maxSwipeTime: r,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: a
}) => {
  if (!e || !e.addEventListener || !Ur(t))
    return null;
  let i = 0, o = 0, s = null, l = !1;
  function u(f) {
    const p = f.changedTouches[0];
    i = p.screenX, o = p.screenY, s = (/* @__PURE__ */ new Date()).getTime(), l = !0;
  }
  function c(f) {
    if (!l || !s)
      return;
    l = !1;
    const p = f.changedTouches[0], d = p.screenX - i, m = p.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - s < r && Math.abs(d) >= n && Math.abs(m) <= a) {
      const h = { toLeft: !1, toRight: !1 };
      d < 0 ? h.toLeft = !0 : h.toRight = !0, t(h);
    }
  }
  return hr(e, "touchstart", u, { passive: !0 }), hr(e, "touchend", c, { passive: !0 }), () => {
    vr(e, "touchstart", u), vr(e, "touchend", c);
  };
}, za = {}, E6 = (e, t = 10) => {
  za[e] = Date.now() + t;
}, T6 = (e, t) => {
  if (e in za) {
    const r = za[e];
    if (Date.now() < r)
      return;
    delete za[e];
  }
  t();
};
function $p() {
  return typeof window < "u";
}
function D6(e) {
  return $p() && e in window;
}
function $6(e) {
  const t = q(!1), r = O(() => t.value ? "dark" : "light");
  let n, a;
  function i(d) {
    t.value = d.matches;
  }
  function o() {
    D6("matchMedia") && (n = window.matchMedia("(prefers-color-scheme: dark)"), n.addEventListener("change", i), t.value = n.matches);
  }
  function s() {
    const { selector: d = ":root", darkClass: m = "dark" } = e.value, g = document.querySelector(d);
    t.value = g.classList.contains(m);
  }
  function l(d) {
    const { selector: m = ":root", darkClass: g = "dark" } = d;
    if ($p() && m && g) {
      const h = document.querySelector(m);
      h && (a = new MutationObserver(s), a.observe(h, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = h.classList.contains(g));
    }
  }
  function u() {
    f();
    const d = typeof e.value;
    d === "string" && e.value.toLowerCase() === "system" ? o() : d === "object" ? l(e.value) : t.value = !!e.value;
  }
  const c = be(() => e.value, () => u(), {
    immediate: !0
  });
  function f() {
    n && (n.removeEventListener("change", i), n = void 0), a && (a.disconnect(), a = void 0);
  }
  function p() {
    f(), c();
  }
  return Nr(() => p()), {
    isDark: t,
    displayMode: r,
    cleanup: p
  };
}
const k6 = ["base", "start", "end", "startEnd"], O6 = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], C6 = { base: {}, start: {}, end: {} };
function _s(e, t, r = C6) {
  let n = e, a = {};
  t === !0 || Wt(t) ? (n = Wt(t) ? t : n, a = { ...r }) : or(t) && (rc(t, k6) ? a = { ...t } : a = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const i = ca(
    a,
    { start: a.startEnd, end: a.startEnd },
    r
  );
  return Object.entries(i).forEach(([o, s]) => {
    let l = n;
    s === !0 || Wt(s) ? (l = Wt(s) ? s : l, i[o] = { color: l }) : or(s) && (rc(s, O6) ? i[o] = { ...s } : i[o] = {}), ca(i[o], { color: l });
  }), i;
}
class S6 {
  constructor() {
    ne(this, "type", "highlight");
  }
  normalizeConfig(t, r) {
    return _s(t, r, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: r, onEnd: n }, a) {
    const { key: i, highlight: o } = t;
    if (!o)
      return;
    const { highlights: s } = a, { base: l, start: u, end: c } = o;
    r && n ? s.push({
      ...u,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [`vc-highlight vc-highlight-bg-${u.fillMode}`, u.class],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    }) : r ? (s.push({
      ...l,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), s.push({
      ...u,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [`vc-highlight vc-highlight-bg-${u.fillMode}`, u.class],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    })) : n ? (s.push({
      ...l,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), s.push({
      ...c,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : s.push({
      ...l,
      key: `${i}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${l.fillMode}`,
        l.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${l.fillMode} vc-${l.color}`,
        l.contentClass
      ]
    });
  }
}
class ws {
  constructor(t, r) {
    ne(this, "type", ""), ne(this, "collectionType", ""), this.type = t, this.collectionType = r;
  }
  normalizeConfig(t, r) {
    return _s(t, r);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: r, onEnd: n }, a) {
    const { key: i } = t, o = t[this.type];
    if (!i || !o)
      return;
    const s = a[this.collectionType], { base: l, start: u, end: c } = o;
    r ? s.push({
      ...u,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${u.color} vc-attr`,
        u.class
      ]
    }) : n ? s.push({
      ...c,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${c.color} vc-attr`,
        c.class
      ]
    }) : s.push({
      ...l,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${l.color} vc-attr`,
        l.class
      ]
    });
  }
}
class A6 extends ws {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, r) {
    return _s("base", r);
  }
}
class M6 extends ws {
  constructor() {
    super("dot", "dots");
  }
}
class I6 extends ws {
  constructor() {
    super("bar", "bars");
  }
}
class P6 {
  constructor(t) {
    ne(this, "color"), ne(this, "renderers", [
      new A6(),
      new S6(),
      new M6(),
      new I6()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((r) => {
      const n = r.type;
      t[n] != null && (t[n] = r.normalizeConfig(this.color, t[n]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((r) => {
      r.prepareRender(t);
    }), t;
  }
  render(t, r) {
    this.renderers.forEach((n) => {
      n.render(t, r);
    });
  }
}
const kp = Symbol("__vc_base_context__"), Op = {
  color: {
    type: String,
    default: () => _r("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => _r("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function Cp(e) {
  const t = O(() => e.color ?? ""), r = O(() => e.isDark ?? !1), { displayMode: n } = $6(r), a = O(() => new P6(t.value)), i = O(() => {
    if (e.locale instanceof ni)
      return e.locale;
    const p = or(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new ni(p, e.timezone);
  }), o = O(() => i.value.masks), s = O(() => e.minDate), l = O(() => e.maxDate), u = O(() => {
    const p = e.disabledDates ? [...e.disabledDates] : [];
    return s.value != null && p.push({
      start: null,
      end: Je(i.value.toDate(s.value), -1)
    }), l.value != null && p.push({
      start: Je(i.value.toDate(l.value), 1),
      end: null
    }), i.value.ranges(p);
  }), c = O(() => new wp(
    {
      key: "disabled",
      dates: u.value,
      order: 100
    },
    a.value,
    i.value
  )), f = {
    color: t,
    isDark: r,
    displayMode: n,
    theme: a,
    locale: i,
    masks: o,
    minDate: s,
    maxDate: l,
    disabledDates: u,
    disabledAttribute: c
  };
  return wn(kp, f), f;
}
function x6(e) {
  return En(kp, () => Cp(e), !0);
}
function Sp(e) {
  return `__vc_slot_${e}__`;
}
function Ap(e, t = {}) {
  Object.keys(e).forEach((r) => {
    wn(Sp(t[r] ?? r), e[r]);
  });
}
function Mp(e) {
  return En(Sp(e), null);
}
const L6 = {
  ...Op,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => _r("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => _r("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, R6 = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], Ip = Symbol("__vc_calendar_context__");
function F6(e, { slots: t, emit: r }) {
  const n = q(null), a = q(null), i = q((/* @__PURE__ */ new Date()).getDate()), o = q(!1), s = q(Symbol()), l = q(Symbol()), u = q(e.view), c = q([]), f = q("");
  let p = null, d = null;
  Ap(t);
  const {
    theme: m,
    color: g,
    displayMode: h,
    locale: y,
    masks: _,
    minDate: $,
    maxDate: v,
    disabledAttribute: D,
    disabledDates: k
  } = x6(e), T = O(() => e.rows * e.columns), C = O(() => e.step || T.value), V = O(() => ep(c.value) ?? null), H = O(() => en(c.value) ?? null), N = O(
    () => e.minPage || ($.value ? z($.value) : null)
  ), L = O(
    () => e.maxPage || (v.value ? z(v.value) : null)
  ), U = O(() => e.navVisibility), J = O(() => !!e.showWeeknumbers), W = O(() => !!e.showIsoWeeknumbers), Q = O(() => u.value === "monthly"), Y = O(() => u.value === "weekly"), pe = O(() => u.value === "daily"), se = () => {
    o.value = !0, r("transition-start");
  }, P = () => {
    o.value = !1, r("transition-end"), p && (p.resolve(!0), p = null);
  }, ae = (S, b, M = u.value) => sp(S, b, M, y.value), z = (S) => op(S, u.value, y.value), ge = (S) => {
    !D.value || !ce.value || (S.isDisabled = ce.value.cellExists(
      D.value.key,
      S.dayIndex
    ));
  }, ee = (S) => {
    S.isFocusable = S.inMonth && S.day === i.value;
  }, me = (S, b) => {
    for (const M of S)
      for (const F of M.days)
        if (b(F) === !1)
          return;
  }, j = O(
    () => c.value.reduce((S, b) => (S.push(...b.viewDays), S), [])
  ), te = O(() => {
    const S = [];
    return (e.attributes || []).forEach((b, M) => {
      !b || !b.dates || S.push(
        new wp(
          {
            ...b,
            order: b.order || 0
          },
          m.value,
          y.value
        )
      );
    }), D.value && S.push(D.value), S;
  }), de = O(() => nr(te.value)), ce = O(() => {
    const S = new yA();
    return te.value.forEach((b) => {
      b.ranges.forEach((M) => {
        S.render(b, M, j.value);
      });
    }), S;
  }), Se = O(() => j.value.reduce((S, b) => (S[b.dayIndex] = { day: b, cells: [] }, S[b.dayIndex].cells.push(...ce.value.getCells(b)), S), {})), ke = (S, b) => {
    const M = e.showWeeknumbers || e.showIsoWeeknumbers;
    return M == null ? "" : jk(M) ? M ? "left" : "" : M.startsWith("right") ? b > 1 ? "right" : M : S > 1 ? "left" : M;
  }, Oe = () => {
    var S, b;
    if (!de.value)
      return null;
    const M = te.value.find((De) => De.pinPage) || te.value[0];
    if (!M || !M.hasRanges)
      return null;
    const [F] = M.ranges, le = ((S = F.start) == null ? void 0 : S.date) || ((b = F.end) == null ? void 0 : b.date);
    return le ? z(le) : null;
  }, Fe = () => {
    if (qt(V.value))
      return V.value;
    const S = Oe();
    return qt(S) ? S : z(/* @__PURE__ */ new Date());
  }, ft = (S, b = {}) => {
    const { view: M = u.value, position: F = 1, force: le } = b, De = F > 0 ? 1 - F : -(T.value + F);
    let Me = ae(S, De, M), je = ae(Me, T.value - 1, M);
    return le || (yo(Me, N.value) ? Me = N.value : ri(je, L.value) && (Me = ae(L.value, 1 - T.value)), je = ae(Me, T.value - 1)), { fromPage: Me, toPage: je };
  }, xt = (S, b, M = "") => {
    if (M === "none" || M === "fade")
      return M;
    if ((S == null ? void 0 : S.view) !== (b == null ? void 0 : b.view))
      return "fade";
    const F = ri(b, S), le = yo(b, S);
    return !F && !le ? "fade" : M === "slide-v" ? le ? "slide-down" : "slide-up" : le ? "slide-right" : "slide-left";
  }, Ue = (S = {}) => new Promise((b, M) => {
    const { position: F = 1, force: le = !1, transition: De } = S, Me = qt(S.page) ? S.page : Fe(), { fromPage: je } = ft(Me, {
      position: F,
      force: le
    }), Rt = [];
    for (let mt = 0; mt < T.value; mt++) {
      const Fn = ae(je, mt), Ve = mt + 1, cr = Math.ceil(Ve / e.columns), Ta = e.rows - cr + 1, Vn = Ve % e.columns || e.columns, Nn = e.columns - Vn + 1, fv = ke(Vn, Nn);
      Rt.push(
        y.value.getPage({
          ...Fn,
          view: u.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: Ve,
          row: cr,
          rowFromEnd: Ta,
          column: Vn,
          columnFromEnd: Nn,
          showWeeknumbers: J.value,
          showIsoWeeknumbers: W.value,
          weeknumberPosition: fv
        })
      );
    }
    f.value = xt(
      c.value[0],
      Rt[0],
      De
    ), c.value = Rt, f.value && f.value !== "none" ? p = {
      resolve: b,
      reject: M
    } : b(!0);
  }), pt = (S) => {
    const b = V.value ?? z(/* @__PURE__ */ new Date());
    return ae(b, S);
  }, wt = (S, b = {}) => {
    const M = qt(S) ? S : z(S);
    return Object.assign(
      b,
      ft(M, {
        ...b,
        force: !0
      })
    ), hA(
      b.fromPage,
      b.toPage,
      u.value,
      y.value
    ).map((le) => pA(le, N.value, L.value)).some((le) => le);
  }, Et = (S, b = {}) => wt(pt(S), b), Ie = O(() => Et(-C.value)), Ye = O(() => Et(C.value)), et = async (S, b = {}) => !b.force && !wt(S, b) ? !1 : (b.fromPage && !vA(b.fromPage, V.value) && (da({ id: s.value, hideDelay: 0 }), b.view && (E6("view", 10), u.value = b.view), await Ue({
    ...b,
    page: b.fromPage,
    position: 1,
    force: !0
  }), r("did-move", c.value)), !0), He = (S, b = {}) => et(pt(S), b), tt = () => He(-C.value), vt = () => He(C.value), ht = (S) => {
    const b = Q.value ? ".in-month" : "", M = `.id-${y.value.getDayId(S)}${b}`, F = `${M}.vc-focusable, ${M} .vc-focusable`, le = n.value;
    if (le) {
      const De = le.querySelector(F);
      if (De)
        return De.focus(), !0;
    }
    return !1;
  }, Tt = async (S, b = {}) => ht(S) ? !0 : (await et(S, b), ht(S)), Lt = (S, b) => {
    i.value = S.day, r("dayclick", S, b);
  }, Ln = (S, b) => {
    r("daymouseenter", S, b);
  }, Dr = (S, b) => {
    r("daymouseleave", S, b);
  }, Rn = (S, b) => {
    i.value = S.day, a.value = S, S.isFocused = !0, r("dayfocusin", S, b);
  }, qr = (S, b) => {
    a.value = null, S.isFocused = !1, r("dayfocusout", S, b);
  }, Kr = (S, b) => {
    r("daykeydown", S, b);
    const M = S.noonDate;
    let F = null;
    switch (b.key) {
      case "ArrowLeft": {
        F = Je(M, -1);
        break;
      }
      case "ArrowRight": {
        F = Je(M, 1);
        break;
      }
      case "ArrowUp": {
        F = Je(M, -7);
        break;
      }
      case "ArrowDown": {
        F = Je(M, 7);
        break;
      }
      case "Home": {
        F = Je(M, -S.weekdayPosition + 1);
        break;
      }
      case "End": {
        F = Je(M, S.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        b.altKey ? F = fc(M, -1) : F = ti(M, -1);
        break;
      }
      case "PageDown": {
        b.altKey ? F = fc(M, 1) : F = ti(M, 1);
        break;
      }
    }
    F && (b.preventDefault(), Tt(F).catch());
  }, A = (S) => {
    const b = a.value;
    b != null && Kr(b, S);
  }, Z = (S, b) => {
    r("weeknumberclick", S, b);
  };
  Ue({
    page: e.initialPage,
    position: e.initialPagePosition
  }), It(() => {
    !e.disablePageSwipe && n.value && (d = w6(
      n.value,
      ({ toLeft: S = !1, toRight: b = !1 }) => {
        S ? vt() : b && tt();
      },
      _r("touch")
    ));
  }), Nr(() => {
    c.value = [], d && d();
  }), be(
    () => y.value,
    () => {
      Ue();
    }
  ), be(
    () => T.value,
    () => Ue()
  ), be(
    () => e.view,
    () => u.value = e.view
  ), be(
    () => u.value,
    () => {
      T6("view", () => {
        Ue();
      }), r("update:view", u.value);
    }
  ), be(
    () => i.value,
    () => {
      me(c.value, (S) => ee(S));
    }
  ), Uc(() => {
    r("update:pages", c.value), me(c.value, (S) => {
      ge(S), ee(S);
    });
  });
  const oe = {
    emit: r,
    containerRef: n,
    focusedDay: a,
    inTransition: o,
    navPopoverId: s,
    dayPopoverId: l,
    view: u,
    pages: c,
    transitionName: f,
    theme: m,
    color: g,
    displayMode: h,
    locale: y,
    masks: _,
    attributes: te,
    disabledAttribute: D,
    disabledDates: k,
    attributeContext: ce,
    days: j,
    dayCells: Se,
    count: T,
    step: C,
    firstPage: V,
    lastPage: H,
    canMovePrev: Ie,
    canMoveNext: Ye,
    minPage: N,
    maxPage: L,
    isMonthly: Q,
    isWeekly: Y,
    isDaily: pe,
    navVisibility: U,
    showWeeknumbers: J,
    showIsoWeeknumbers: W,
    getDateAddress: z,
    canMove: wt,
    canMoveBy: Et,
    move: et,
    moveBy: He,
    movePrev: tt,
    moveNext: vt,
    onTransitionBeforeEnter: se,
    onTransitionAfterEnter: P,
    tryFocusDate: ht,
    focusDate: Tt,
    onKeydown: A,
    onDayKeydown: Kr,
    onDayClick: Lt,
    onDayMouseenter: Ln,
    onDayMouseleave: Dr,
    onDayFocusin: Rn,
    onDayFocusout: qr,
    onWeeknumberClick: Z
  };
  return wn(Ip, oe), oe;
}
function Wr() {
  const e = En(Ip);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const V6 = ue({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let r;
    const n = q();
    let a = null, i = null;
    const o = Tn({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function s(P) {
      P && (o.direction = P.split("-")[0]);
    }
    function l({ placement: P, options: ae }) {
      s(P || (ae == null ? void 0 : ae.placement));
    }
    const u = O(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: l
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: l
    })), c = O(() => {
      const P = o.direction === "left" || o.direction === "right";
      let ae = "";
      if (o.placement) {
        const z = o.placement.split("-");
        z.length > 1 && (ae = z[1]);
      }
      return ["start", "top", "left"].includes(ae) ? P ? "top" : "left" : ["end", "bottom", "right"].includes(ae) ? P ? "bottom" : "right" : P ? "middle" : "center";
    });
    function f() {
      i && (i.destroy(), i = null);
    }
    function p() {
      mr(() => {
        const P = Xa(o.target);
        !P || !n.value || (i && i.state.elements.reference !== P && f(), i ? i.update() : i = Mb(
          P,
          n.value,
          u.value
        ));
      });
    }
    function d(P) {
      Object.assign(o, rp(P, "force"));
    }
    function m(P, ae) {
      clearTimeout(r), P > 0 ? r = setTimeout(ae, P) : ae();
    }
    function g(P) {
      return !P || !i ? !1 : Xa(P) === i.state.elements.reference;
    }
    async function h(P = {}) {
      o.force || (P.force && (o.force = !0), m(P.showDelay ?? e.showDelay, () => {
        o.isVisible && (o.force = !1), d({
          ...P,
          isVisible: !0
        }), p();
      }));
    }
    function y(P = {}) {
      i && (P.target && !g(P.target) || o.force || (P.force && (o.force = !0), m(P.hideDelay ?? e.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function _(P = {}) {
      P.target != null && (o.isVisible && g(P.target) ? y(P) : h(P));
    }
    function $(P) {
      if (!i)
        return;
      const ae = i.state.elements.reference;
      if (!n.value || !ae)
        return;
      const z = P.target;
      Ba(n.value, z) || Ba(ae, z) || y({ force: !0 });
    }
    function v(P) {
      (P.key === "Esc" || P.key === "Escape") && y();
    }
    function D({ detail: P }) {
      !P.id || P.id !== e.id || h(P);
    }
    function k({ detail: P }) {
      !P.id || P.id !== e.id || y(P);
    }
    function T({ detail: P }) {
      !P.id || P.id !== e.id || _(P);
    }
    function C() {
      hr(document, "keydown", v), hr(document, "click", $), hr(document, "show-popover", D), hr(document, "hide-popover", k), hr(document, "toggle-popover", T);
    }
    function V() {
      vr(document, "keydown", v), vr(document, "click", $), vr(document, "show-popover", D), vr(document, "hide-popover", k), vr(document, "toggle-popover", T);
    }
    function H(P) {
      t("before-show", P);
    }
    function N(P) {
      o.force = !1, t("after-show", P);
    }
    function L(P) {
      t("before-hide", P);
    }
    function U(P) {
      o.force = !1, f(), t("after-hide", P);
    }
    function J(P) {
      P.stopPropagation();
    }
    function W() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && h();
    }
    function Q() {
      if (o.isHovered = !1, !i)
        return;
      const P = i.state.elements.reference;
      o.autoHide && !o.isFocused && (!P || P !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && y();
    }
    function Y() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && h();
    }
    function pe(P) {
      ["focus", "hover-focus"].includes(o.visibility) && (!P.relatedTarget || !Ba(n.value, P.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && y());
    }
    function se() {
      a != null && (a.disconnect(), a = null);
    }
    return be(
      () => n.value,
      (P) => {
        se(), P && (a = new ResizeObserver(() => {
          i && i.update();
        }), a.observe(P));
      }
    ), be(() => o.placement, s, {
      immediate: !0
    }), It(() => {
      C();
    }), Nr(() => {
      f(), se(), V();
    }), {
      ...mv(o),
      popoverRef: n,
      alignment: c,
      hide: y,
      setupPopper: p,
      beforeEnter: H,
      afterEnter: N,
      beforeLeave: L,
      afterLeave: U,
      onClick: J,
      onMouseOver: W,
      onMouseLeave: Q,
      onFocusIn: Y,
      onFocusOut: pe
    };
  }
}), Er = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, a] of t)
    r[n] = a;
  return r;
};
function N6(e, t, r, n, a, i) {
  return E(), I("div", {
    class: X(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...o) => e.onClick && e.onClick(...o)),
    onMouseover: t[1] || (t[1] = (...o) => e.onMouseOver && e.onMouseOver(...o)),
    onMouseleave: t[2] || (t[2] = (...o) => e.onMouseLeave && e.onMouseLeave(...o)),
    onFocusin: t[3] || (t[3] = (...o) => e.onFocusIn && e.onFocusIn(...o)),
    onFocusout: t[4] || (t[4] = (...o) => e.onFocusOut && e.onFocusOut(...o))
  }, [
    ve(yr, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: fe(() => [
        e.isVisible ? (E(), I("div", ie({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          we(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            Br(_e(e.data), 1)
          ]),
          R("span", {
            class: X([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : B("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Es = /* @__PURE__ */ Er(V6, [["render", N6]]), B6 = { class: "vc-day-popover-row" }, Y6 = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, j6 = { class: "vc-day-popover-row-label" }, z6 = /* @__PURE__ */ ue({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, r = O(() => {
      const { content: n, highlight: a, dot: i, bar: o, popover: s } = t.attribute;
      return s && s.hideIndicator ? null : n ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
      } : a ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${a.base.color}`
      } : i ? {
        class: `vc-dot vc-attr vc-${i.base.color}`
      } : o ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${o.base.color}`
      } : null;
    });
    return (n, a) => (E(), I("div", B6, [
      w(r) ? (E(), I("div", Y6, [
        R("span", {
          class: X(w(r).class)
        }, null, 2)
      ])) : B("", !0),
      R("div", j6, [
        we(n.$slots, "default", {}, () => [
          Br(_e(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), U6 = {
  inheritAttrs: !1
}, Dt = /* @__PURE__ */ ue({
  ...U6,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const r = Mp(e.name);
    return (n, a) => w(r) ? (E(), K(Co(w(r)), he(ie({ key: 0 }, n.$attrs)), null, 16)) : we(n.$slots, "default", { key: 1 });
  }
}), H6 = { class: "vc-day-popover-container" }, W6 = {
  key: 0,
  class: "vc-day-popover-header"
}, q6 = /* @__PURE__ */ ue({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: r, color: n, masks: a, locale: i } = Wr();
    function o(l, u) {
      return i.value.formatDate(l, u);
    }
    function s(l) {
      return i.value.formatDate(l.date, a.value.dayPopover);
    }
    return (l, u) => (E(), K(Es, {
      id: w(t),
      class: X([`vc-${w(n)}`, `vc-${w(r)}`])
    }, {
      default: fe(({ data: { day: c, attributes: f }, hide: p }) => [
        ve(Dt, {
          name: "day-popover",
          day: c,
          "day-title": s(c),
          attributes: f,
          format: o,
          masks: w(a),
          hide: p
        }, {
          default: fe(() => [
            R("div", H6, [
              w(a).dayPopover ? (E(), I("div", W6, _e(s(c)), 1)) : B("", !0),
              (E(!0), I(Ae, null, Re(f, (d) => (E(), K(z6, {
                key: d.key,
                attribute: d
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), K6 = {}, G6 = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, Z6 = /* @__PURE__ */ R("polyline", { points: "9 18 15 12 9 6" }, null, -1), X6 = [
  Z6
];
function J6(e, t) {
  return E(), I("svg", G6, X6);
}
const Q6 = /* @__PURE__ */ Er(K6, [["render", J6]]), eM = {}, tM = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, rM = /* @__PURE__ */ R("polyline", { points: "15 18 9 12 15 6" }, null, -1), nM = [
  rM
];
function aM(e, t) {
  return E(), I("svg", tM, nM);
}
const iM = /* @__PURE__ */ Er(eM, [["render", aM]]), oM = {}, sM = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, lM = /* @__PURE__ */ R("polyline", { points: "6 9 12 15 18 9" }, null, -1), uM = [
  lM
];
function cM(e, t) {
  return E(), I("svg", sM, uM);
}
const dM = /* @__PURE__ */ Er(oM, [["render", cM]]), fM = {}, pM = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, vM = /* @__PURE__ */ R("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), hM = [
  vM
];
function mM(e, t) {
  return E(), I("svg", pM, hM);
}
const gM = /* @__PURE__ */ Er(fM, [["render", mM]]), yM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: dM,
  IconChevronLeft: iM,
  IconChevronRight: Q6,
  IconClock: gM
}, Symbol.toStringTag, { value: "Module" })), vn = /* @__PURE__ */ ue({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, r = O(() => t.width || t.size), n = O(() => t.height || t.size), a = O(() => yM[`Icon${t.name}`]);
    return (i, o) => (E(), K(Co(w(a)), {
      width: w(r),
      height: w(n),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), bM = ["disabled"], _M = {
  key: 1,
  class: "vc-title-wrapper"
}, wM = {
  type: "button",
  class: "vc-title"
}, EM = ["disabled"], Pp = /* @__PURE__ */ ue({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: r,
      navVisibility: n,
      canMovePrev: a,
      movePrev: i,
      canMoveNext: o,
      moveNext: s
    } = Wr(), l = O(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), u = O(() => {
      const { page: g } = t;
      return {
        id: r.value,
        visibility: n.value,
        placement: l.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: g },
        isInteractive: !0
      };
    }), c = O(() => t.page.titlePosition.includes("left")), f = O(() => t.page.titlePosition.includes("right")), p = O(() => t.layout ? t.layout : c.value ? "tu-pn" : f.value ? "pn-tu" : "p-tu-n;"), d = O(() => ({
      prev: p.value.includes("p") && !t.hideArrows,
      title: p.value.includes("t") && !t.hideTitle,
      next: p.value.includes("n") && !t.hideArrows
    })), m = O(() => ({ gridTemplateColumns: p.value.split("").map((h) => {
      switch (h) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (g, h) => (E(), I("div", {
      class: X(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: it(w(m))
    }, [
      w(d).prev ? (E(), I("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !w(a),
        onClick: h[0] || (h[0] = //@ts-ignore
        (...y) => w(i) && w(i)(...y)),
        onKeydown: h[1] || (h[1] = Ps(
          //@ts-ignore
          (...y) => w(i) && w(i)(...y),
          ["space", "enter"]
        ))
      }, [
        ve(Dt, {
          name: "header-prev-button",
          disabled: !w(a)
        }, {
          default: fe(() => [
            ve(vn, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, bM)) : B("", !0),
      w(d).title ? (E(), I("div", _M, [
        ve(Dt, { name: "header-title-wrapper" }, {
          default: fe(() => [
            ze((E(), I("button", wM, [
              ve(Dt, {
                name: "header-title",
                title: e.page.title
              }, {
                default: fe(() => [
                  R("span", null, _e(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [w(Dp), w(u)]
            ])
          ]),
          _: 1
        })
      ])) : B("", !0),
      w(d).next ? (E(), I("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !w(o),
        onClick: h[2] || (h[2] = //@ts-ignore
        (...y) => w(s) && w(s)(...y)),
        onKeydown: h[3] || (h[3] = Ps(
          //@ts-ignore
          (...y) => w(s) && w(s)(...y),
          ["space", "enter"]
        ))
      }, [
        ve(Dt, {
          name: "header-next-button",
          disabled: !w(o)
        }, {
          default: fe(() => [
            ve(vn, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, EM)) : B("", !0)
    ], 6));
  }
}), xp = Symbol("__vc_page_context__");
function TM(e) {
  const { locale: t, getDateAddress: r, canMove: n } = Wr();
  function a(s, l) {
    const { month: u, year: c } = r(/* @__PURE__ */ new Date());
    return _p().map((f, p) => {
      const d = p + 1;
      return {
        month: d,
        year: s,
        id: fA(d, s),
        label: t.value.formatDate(f, l),
        ariaLabel: t.value.formatDate(f, "MMMM"),
        isActive: d === e.value.month && s === e.value.year,
        isCurrent: d === u && s === c,
        isDisabled: !n(
          { month: d, year: s },
          { position: e.value.position }
        )
      };
    });
  }
  function i(s, l) {
    const { year: u } = r(/* @__PURE__ */ new Date()), { position: c } = e.value, f = [];
    for (let p = s; p <= l; p += 1) {
      const d = [...Array(12).keys()].some(
        (m) => n({ month: m + 1, year: p }, { position: c })
      );
      f.push({
        year: p,
        id: p.toString(),
        label: p.toString(),
        ariaLabel: p.toString(),
        isActive: p === e.value.year,
        isCurrent: p === u,
        isDisabled: !d
      });
    }
    return f;
  }
  const o = { page: e, getMonthItems: a, getYearItems: i };
  return wn(xp, o), o;
}
function Lp() {
  const e = En(xp);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const DM = { class: "vc-nav-header" }, $M = ["disabled"], kM = ["disabled"], OM = { class: "vc-nav-items" }, CM = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], SM = /* @__PURE__ */ ue({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: r } = Wr(), { page: n, getMonthItems: a, getYearItems: i } = Lp(), o = q(!0), s = 12, l = q(n.value.year), u = q(p(n.value.year)), c = q(null);
    function f() {
      setTimeout(() => {
        if (c.value == null)
          return;
        const z = c.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        z && z.focus();
      }, 10);
    }
    function p(z) {
      return Math.floor(z / s);
    }
    function d() {
      o.value = !o.value;
    }
    function m(z) {
      return z * s;
    }
    function g(z) {
      return s * (z + 1) - 1;
    }
    function h() {
      Y.value && (o.value && _(), v());
    }
    function y() {
      pe.value && (o.value && $(), D());
    }
    function _() {
      l.value--;
    }
    function $() {
      l.value++;
    }
    function v() {
      u.value--;
    }
    function D() {
      u.value++;
    }
    const k = O(
      () => a(l.value, t.value.navMonths).map((z) => ({
        ...z,
        click: () => r(
          { month: z.month, year: z.year },
          { position: n.value.position }
        )
      }))
    ), T = O(
      () => a(l.value - 1, t.value.navMonths)
    ), C = O(
      () => T.value.some((z) => !z.isDisabled)
    ), V = O(
      () => a(l.value + 1, t.value.navMonths)
    ), H = O(
      () => V.value.some((z) => !z.isDisabled)
    ), N = O(
      () => i(
        m(u.value),
        g(u.value)
      ).map((z) => ({
        ...z,
        click: () => {
          l.value = z.year, o.value = !0, f();
        }
      }))
    ), L = O(
      () => i(
        m(u.value - 1),
        g(u.value - 1)
      )
    ), U = O(
      () => L.value.some((z) => !z.isDisabled)
    ), J = O(
      () => i(
        m(u.value + 1),
        g(u.value + 1)
      )
    ), W = O(
      () => J.value.some((z) => !z.isDisabled)
    ), Q = O(
      () => o.value ? k.value : N.value
    ), Y = O(
      () => o.value ? C.value : U.value
    ), pe = O(
      () => o.value ? H.value : W.value
    ), se = O(() => ep(N.value.map((z) => z.year))), P = O(() => en(N.value.map((z) => z.year))), ae = O(() => o.value ? l.value : `${se.value} - ${P.value}`);
    return Uc(() => {
      l.value = n.value.year, f();
    }), be(
      () => l.value,
      (z) => u.value = p(z)
    ), It(() => f()), (z, ge) => (E(), I("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: c
    }, [
      R("div", DM, [
        R("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !w(Y),
          onClick: h,
          onKeydown: ge[0] || (ge[0] = (ee) => w(Aa)(ee, h))
        }, [
          ve(Dt, {
            name: "nav-prev-button",
            move: h,
            disabled: !w(Y)
          }, {
            default: fe(() => [
              ve(vn, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, $M),
        R("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: d,
          onKeydown: ge[1] || (ge[1] = (ee) => w(Aa)(ee, d))
        }, _e(w(ae)), 33),
        R("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !w(pe),
          onClick: y,
          onKeydown: ge[2] || (ge[2] = (ee) => w(Aa)(ee, y))
        }, [
          ve(Dt, {
            name: "nav-next-button",
            move: y,
            disabled: !w(pe)
          }, {
            default: fe(() => [
              ve(vn, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, kM)
      ]),
      R("div", OM, [
        (E(!0), I(Ae, null, Re(w(Q), (ee) => (E(), I("button", {
          key: ee.label,
          type: "button",
          "data-id": ee.id,
          "aria-label": ee.ariaLabel,
          class: X(["vc-nav-item vc-focus", [
            ee.isActive ? "is-active" : ee.isCurrent ? "is-current" : ""
          ]]),
          disabled: ee.isDisabled,
          onClick: ee.click,
          onKeydown: (me) => w(Aa)(me, ee.click)
        }, _e(ee.label), 43, CM))), 128))
      ])
    ], 512));
  }
}), Rp = /* @__PURE__ */ ue({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return TM(xa(e, "page")), (r, n) => we(r.$slots, "default");
  }
}), AM = /* @__PURE__ */ ue({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: r, displayMode: n } = Wr();
    return (a, i) => (E(), K(Es, {
      id: w(t),
      class: X(["vc-nav-popover-container", `vc-${w(r)}`, `vc-${w(n)}`])
    }, {
      default: fe(({ data: o }) => [
        ve(Rp, {
          page: o.page
        }, {
          default: fe(() => [
            ve(Dt, { name: "nav" }, {
              default: fe(() => [
                ve(SM)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), MM = ue({
  directives: { popover: Dp },
  components: { CalendarSlot: Dt },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: r,
      attributeContext: n,
      dayPopoverId: a,
      onDayClick: i,
      onDayMouseenter: o,
      onDayMouseleave: s,
      onDayFocusin: l,
      onDayFocusout: u,
      onDayKeydown: c
    } = Wr(), f = O(() => e.day), p = O(() => n.value.getCells(f.value)), d = O(
      () => p.value.map((W) => W.data)
    ), m = O(() => ({
      ...f.value,
      attributes: d.value,
      attributeCells: p.value
    }));
    function g({ data: W }, { popovers: Q }) {
      const { key: Y, customData: pe, popover: se } = W;
      if (!se)
        return;
      const P = Ku(
        {
          key: Y,
          customData: pe,
          attribute: W
        },
        { ...se },
        {
          visibility: se.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !se.label
        }
      );
      Q.splice(0, 0, P);
    }
    const h = O(() => {
      const W = {
        ...r.value.prepareRender({}),
        popovers: []
      };
      return p.value.forEach((Q) => {
        r.value.render(Q, W), g(Q, W);
      }), W;
    }), y = O(() => h.value.highlights), _ = O(() => !!nr(y.value)), $ = O(() => h.value.content), v = O(() => h.value.dots), D = O(() => !!nr(v.value)), k = O(() => h.value.bars), T = O(() => !!nr(k.value)), C = O(() => h.value.popovers), V = O(
      () => C.value.map((W) => W.attribute)
    ), H = Mp("day-content"), N = O(() => [
      "vc-day",
      ...f.value.classes,
      { "vc-day-box-center-center": !H },
      { "is-not-in-month": !e.day.inMonth }
    ]), L = O(() => {
      let W;
      f.value.isFocusable ? W = "0" : W = "-1";
      const Q = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": f.value.isDisabled },
        Ar(en(y.value), "contentClass"),
        Ar(en($.value), "class") || ""
      ], Y = {
        ...Ar(en(y.value), "contentStyle"),
        ...Ar(en($.value), "style")
      };
      return {
        class: Q,
        style: Y,
        tabindex: W,
        "aria-label": f.value.ariaLabel,
        "aria-disabled": !!f.value.isDisabled,
        role: "button"
      };
    }), U = O(() => ({
      click(W) {
        i(m.value, W);
      },
      mouseenter(W) {
        o(m.value, W);
      },
      mouseleave(W) {
        s(m.value, W);
      },
      focusin(W) {
        l(m.value, W);
      },
      focusout(W) {
        u(m.value, W);
      },
      keydown(W) {
        c(m.value, W);
      }
    })), J = O(() => nr(C.value) ? Ku(
      {
        id: a.value,
        data: { day: f, attributes: V.value }
      },
      ...C.value
    ) : null);
    return {
      attributes: d,
      attributeCells: p,
      bars: k,
      dayClasses: N,
      dayContentProps: L,
      dayContentEvents: U,
      dayPopover: J,
      glyphs: h,
      dots: v,
      hasDots: D,
      hasBars: T,
      highlights: y,
      hasHighlights: _,
      locale: t,
      popovers: C
    };
  }
}), IM = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, PM = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, xM = { class: "vc-dots" }, LM = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, RM = { class: "vc-bars" };
function FM(e, t, r, n, a, i) {
  const o = rr("CalendarSlot"), s = So("popover");
  return E(), I("div", {
    class: X(e.dayClasses)
  }, [
    e.hasHighlights ? (E(), I("div", IM, [
      (E(!0), I(Ae, null, Re(e.highlights, ({ key: l, wrapperClass: u, class: c, style: f }) => (E(), I("div", {
        key: l,
        class: X(u)
      }, [
        R("div", {
          class: X(c),
          style: it(f)
        }, null, 6)
      ], 2))), 128))
    ])) : B("", !0),
    ve(o, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: fe(() => [
        ze((E(), I("div", ie(e.dayContentProps, gv(e.dayContentEvents, !0)), [
          Br(_e(e.day.label), 1)
        ], 16)), [
          [s, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (E(), I("div", PM, [
      R("div", xM, [
        (E(!0), I(Ae, null, Re(e.dots, ({ key: l, class: u, style: c }) => (E(), I("span", {
          key: l,
          class: X(u),
          style: it(c)
        }, null, 6))), 128))
      ])
    ])) : B("", !0),
    e.hasBars ? (E(), I("div", LM, [
      R("div", RM, [
        (E(!0), I(Ae, null, Re(e.bars, ({ key: l, class: u, style: c }) => (E(), I("span", {
          key: l,
          class: X(u),
          style: it(c)
        }, null, 6))), 128))
      ])
    ])) : B("", !0)
  ], 2);
}
const VM = /* @__PURE__ */ Er(MM, [["render", FM]]), NM = { class: "vc-weekdays" }, BM = ["onClick"], YM = {
  inheritAttrs: !1
}, jM = /* @__PURE__ */ ue({
  ...YM,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = Lp(), { onWeeknumberClick: r } = Wr();
    return (n, a) => (E(), I("div", {
      class: X([
        "vc-pane",
        `row-${w(t).row}`,
        `row-from-end-${w(t).rowFromEnd}`,
        `column-${w(t).column}`,
        `column-from-end-${w(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      ve(Pp, {
        page: w(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      R("div", {
        class: X(["vc-weeks", {
          [`vc-show-weeknumbers-${w(t).weeknumberPosition}`]: w(t).weeknumberPosition
        }])
      }, [
        R("div", NM, [
          (E(!0), I(Ae, null, Re(w(t).weekdays, ({ weekday: i, label: o }, s) => (E(), I("div", {
            key: s,
            class: X(`vc-weekday vc-weekday-${i}`)
          }, _e(o), 3))), 128))
        ]),
        (E(!0), I(Ae, null, Re(w(t).viewWeeks, (i) => (E(), I("div", {
          key: `weeknumber-${i.weeknumber}`,
          class: "vc-week"
        }, [
          w(t).weeknumberPosition ? (E(), I("div", {
            key: 0,
            class: X(["vc-weeknumber", `is-${w(t).weeknumberPosition}`])
          }, [
            R("span", {
              class: X(["vc-weeknumber-content"]),
              onClick: (o) => w(r)(i, o)
            }, _e(i.weeknumberDisplay), 9, BM)
          ], 2)) : B("", !0),
          (E(!0), I(Ae, null, Re(i.days, (o) => (E(), K(VM, {
            key: o.id,
            day: o
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), zM = ue({
  components: {
    CalendarHeader: Pp,
    CalendarPage: jM,
    CalendarNavPopover: AM,
    CalendarDayPopover: q6,
    CalendarPageProvider: Rp,
    CalendarSlot: Dt
  },
  props: L6,
  emit: R6,
  setup(e, { emit: t, slots: r }) {
    return F6(e, { emit: t, slots: r });
  }
}), UM = { class: "vc-pane-header-wrapper" };
function HM(e, t, r, n, a, i) {
  const o = rr("CalendarHeader"), s = rr("CalendarPage"), l = rr("CalendarSlot"), u = rr("CalendarPageProvider"), c = rr("CalendarDayPopover"), f = rr("CalendarNavPopover");
  return E(), I(Ae, null, [
    R("div", ie({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = Oo(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      R("div", {
        class: X(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        R("div", UM, [
          e.firstPage ? (E(), K(o, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : B("", !0)
        ]),
        ve(yr, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: fe(() => [
            (E(), I("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: it({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (E(!0), I(Ae, null, Re(e.pages, (p) => (E(), K(u, {
                key: p.id,
                page: p
              }, {
                default: fe(() => [
                  ve(l, {
                    name: "page",
                    page: p
                  }, {
                    default: fe(() => [
                      ve(s)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        ve(l, { name: "footer" })
      ], 2)
    ], 16),
    ve(c),
    ve(f)
  ], 64);
}
const WM = /* @__PURE__ */ Er(zM, [["render", HM]]), Fp = Symbol("__vc_date_picker_context__"), qM = {
  ...Op,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => _r("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => _r("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, KM = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function GM(e, { emit: t, slots: r }) {
  Ap(r, { footer: "dp-footer" });
  const n = Cp(e), { locale: a, masks: i, disabledAttribute: o } = n, s = q(!1), l = q(Symbol()), u = q(null), c = q(null), f = q(["", ""]), p = q(null), d = q(null);
  let m, g, h = !0;
  const y = O(() => e.isRange || e.modelModifiers.range === !0), _ = O(
    () => y.value && u.value != null ? u.value.start : null
  ), $ = O(
    () => y.value && u.value != null ? u.value.end : null
  ), v = O(() => e.mode.toLowerCase() === "date"), D = O(
    () => e.mode.toLowerCase() === "datetime"
  ), k = O(() => e.mode.toLowerCase() === "time"), T = O(() => !!c.value), C = O(() => {
    let b = "date";
    e.modelModifiers.number && (b = "number"), e.modelModifiers.string && (b = "string");
    const M = i.value.modelValue || "iso";
    return ge({ type: b, mask: M });
  }), V = O(
    () => Et(c.value ?? u.value)
  ), H = O(() => k.value ? e.is24hr ? i.value.inputTime24hr : i.value.inputTime : D.value ? e.is24hr ? i.value.inputDateTime24hr : i.value.inputDateTime : i.value.input), N = O(() => /[Hh]/g.test(H.value)), L = O(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(H.value)
  ), U = O(() => {
    if (N.value && L.value)
      return "dateTime";
    if (L.value)
      return "date";
    if (N.value)
      return "time";
  }), J = O(() => {
    var b;
    const M = ((b = p.value) == null ? void 0 : b.$el.previousElementSibling) ?? void 0;
    return ca({}, e.popover, _r("datePicker.popover"), {
      target: M
    });
  }), W = O(
    () => Tp({
      ...J.value,
      id: l.value
    })
  ), Q = O(() => y.value ? {
    start: f.value[0],
    end: f.value[1]
  } : f.value[0]), Y = O(() => {
    const b = ["start", "end"].map((M) => ({
      input: Ue(M),
      change: pt(M),
      keyup: wt,
      ...e.popover && W.value
    }));
    return y.value ? {
      start: b[0],
      end: b[1]
    } : b[0];
  }), pe = O(() => {
    if (!te(u.value))
      return null;
    const b = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: u.value,
      pinPage: !0
    }, { dot: M, bar: F, highlight: le, content: De } = b;
    return !M && !F && !le && !De && (b.highlight = !0), b;
  }), se = O(() => {
    if (!y.value || !te(c.value))
      return null;
    const b = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: c.value
    }, { dot: M, bar: F, highlight: le, content: De } = b;
    return !M && !F && !le && !De && (b.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), b;
  }), P = O(() => {
    const b = kt(e.attributes) ? [...e.attributes] : [];
    return se.value ? b.unshift(se.value) : pe.value && b.unshift(pe.value), b;
  }), ae = O(() => ge(
    e.rules === "auto" ? z() : e.rules ?? {}
  ));
  function z() {
    const b = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, M = v.value ? 0 : e.timeAccuracy;
    return [0, 1].map((F) => {
      switch (M) {
        case 0:
          return {
            hours: b.hr[F],
            minutes: b.min[F],
            seconds: b.sec[F],
            milliseconds: b.ms[F]
          };
        case 1:
          return {
            minutes: b.min[F],
            seconds: b.sec[F],
            milliseconds: b.ms[F]
          };
        case 3:
          return { milliseconds: b.ms[F] };
        case 4:
          return {};
        default:
          return { seconds: b.sec[F], milliseconds: b.ms[F] };
      }
    });
  }
  function ge(b) {
    return kt(b) ? b.length === 1 ? [b[0], b[0]] : b : [b, b];
  }
  function ee(b) {
    return ge(b).map(
      (M, F) => ({
        ...M,
        rules: ae.value[F]
      })
    );
  }
  function me(b) {
    return b == null ? !1 : Nt(b) ? !isNaN(b) : tn(b) ? !isNaN(b.getTime()) : Wt(b) ? b !== "" : ys(b);
  }
  function j(b) {
    return or(b) && "start" in b && "end" in b && me(b.start ?? null) && me(b.end ?? null);
  }
  function te(b) {
    return j(b) || me(b);
  }
  function de(b, M) {
    if (b == null && M == null)
      return !0;
    if (b == null || M == null)
      return !1;
    const F = tn(b), le = tn(M);
    return F && le ? b.getTime() === M.getTime() : F || le ? !1 : de(b.start, M.start) && de(b.end, M.end);
  }
  function ce(b) {
    return !te(b) || !o.value ? !1 : o.value.intersectsRange(a.value.range(b));
  }
  function Se(b, M, F, le) {
    if (!te(b))
      return null;
    if (j(b)) {
      const De = a.value.toDate(b.start, {
        ...M[0],
        fillDate: _.value ?? void 0,
        patch: F
      }), Me = a.value.toDate(b.end, {
        ...M[1],
        fillDate: $.value ?? void 0,
        patch: F
      });
      return qr({ start: De, end: Me }, le);
    }
    return a.value.toDateOrNull(b, {
      ...M[0],
      fillDate: u.value,
      patch: F
    });
  }
  function ke(b, M) {
    return j(b) ? {
      start: a.value.fromDate(b.start, M[0]),
      end: a.value.fromDate(b.end, M[1])
    } : y.value ? null : a.value.fromDate(b, M[0]);
  }
  function Oe(b, M = {}) {
    return clearTimeout(m), new Promise((F) => {
      const { debounce: le = 0, ...De } = M;
      le > 0 ? m = window.setTimeout(() => {
        F(Fe(b, De));
      }, le) : F(Fe(b, De));
    });
  }
  function Fe(b, {
    config: M = C.value,
    patch: F = "dateTime",
    clearIfEqual: le = !1,
    formatInput: De = !0,
    hidePopover: Me = !1,
    dragging: je = T.value,
    targetPriority: Rt,
    moveToValue: mt = !1
  } = {}) {
    const Fn = ee(M);
    let Ve = Se(
      b,
      Fn,
      F,
      Rt
    );
    if (ce(Ve)) {
      if (je)
        return null;
      Ve = u.value, Me = !1;
    } else
      Ve == null && e.isRequired ? Ve = u.value : (
        // Clear value if same value was passed
        Ve != null && de(u.value, Ve) && le && (Ve = null)
      );
    const Ta = je ? c : u, Vn = !de(Ta.value, Ve);
    Ta.value = Ve, je || (c.value = null);
    const Nn = ke(
      Ve,
      C.value
    );
    return Vn && (h = !1, t(je ? "drag" : "update:modelValue", Nn), mr(() => h = !0)), Me && !je && Dr(), De && ft(), mt && mr(() => Z(Rt ?? "start")), Nn;
  }
  function ft() {
    mr(() => {
      const b = ee({
        type: "string",
        mask: H.value
      }), M = ke(
        c.value ?? u.value,
        b
      );
      y.value ? f.value = [M && M.start, M && M.end] : f.value = [M, ""];
    });
  }
  function xt(b, M, F) {
    f.value.splice(M === "start" ? 0 : 1, 1, b);
    const le = y.value ? {
      start: f.value[0],
      end: f.value[1] || f.value[0]
    } : b, De = {
      type: "string",
      mask: H.value
    };
    Oe(le, {
      ...F,
      config: De,
      patch: U.value,
      targetPriority: M,
      moveToValue: !0
    });
  }
  function Ue(b) {
    return (M) => {
      e.updateOnInput && xt(M.currentTarget.value, b, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function pt(b) {
    return (M) => {
      xt(M.currentTarget.value, b, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function wt(b) {
    b.key === "Escape" && Oe(u.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function Et(b) {
    return y.value ? [
      b && b.start ? a.value.getDateParts(b.start) : null,
      b && b.end ? a.value.getDateParts(b.end) : null
    ] : [b ? a.value.getDateParts(b) : null];
  }
  function Ie() {
    c.value = null, ft();
  }
  function Ye(b) {
    t("popover-will-show", b);
  }
  function et(b) {
    t("popover-did-show", b);
  }
  function He(b) {
    Ie(), t("popover-will-hide", b);
  }
  function tt(b) {
    t("popover-did-hide", b);
  }
  function vt(b) {
    const M = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (y.value) {
      const F = !T.value;
      F ? g = { start: b.startDate, end: b.endDate } : g != null && (g.end = b.date), Oe(g, {
        ...M,
        dragging: F
      });
    } else
      Oe(b.date, {
        ...M,
        clearIfEqual: !e.isRequired
      });
  }
  function ht(b, M) {
    vt(b), t("dayclick", b, M);
  }
  function Tt(b, M) {
    switch (M.key) {
      case " ":
      case "Enter": {
        vt(b), M.preventDefault();
        break;
      }
      case "Escape":
        Dr();
    }
    t("daykeydown", b, M);
  }
  function Lt(b, M) {
    !T.value || g == null || (g.end = b.date, Oe(qr(g), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Ln(b = {}) {
    wo({
      ...J.value,
      ...b,
      isInteractive: !0,
      id: l.value
    });
  }
  function Dr(b = {}) {
    da({
      hideDelay: 10,
      force: !0,
      ...J.value,
      ...b,
      id: l.value
    });
  }
  function Rn(b) {
    Ep({
      ...J.value,
      ...b,
      isInteractive: !0,
      id: l.value
    });
  }
  function qr(b, M) {
    const { start: F, end: le } = b;
    if (F > le)
      switch (M) {
        case "start":
          return { start: F, end: F };
        case "end":
          return { start: le, end: le };
        default:
          return { start: le, end: F };
      }
    return { start: F, end: le };
  }
  async function Kr(b, M = {}) {
    return d.value == null ? !1 : d.value.move(b, M);
  }
  async function A(b, M = {}) {
    return d.value == null ? !1 : d.value.moveBy(b, M);
  }
  async function Z(b, M = {}) {
    const F = u.value;
    if (d.value == null || !te(F))
      return !1;
    const le = b !== "end", De = le ? 1 : -1, Me = j(F) ? le ? F.start : F.end : F, je = op(Me, "monthly", a.value);
    return d.value.move(je, { position: De, ...M });
  }
  be(
    () => e.isRange,
    (b) => {
      b && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), be(
    () => y.value,
    () => {
      Fe(null, { formatInput: !0 });
    }
  ), be(
    () => H.value,
    () => ft()
  ), be(
    () => e.modelValue,
    (b) => {
      h && Fe(b, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), be(
    () => ae.value,
    () => {
      or(e.rules) && Fe(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), be(
    () => e.timezone,
    () => {
      Fe(u.value, { formatInput: !0 });
    }
  );
  const oe = ge(C.value);
  u.value = Se(
    e.modelValue ?? null,
    oe,
    "dateTime"
  ), It(() => {
    Fe(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), mr(() => s.value = !0);
  const S = {
    ...n,
    showCalendar: s,
    datePickerPopoverId: l,
    popoverRef: p,
    popoverEvents: W,
    calendarRef: d,
    isRange: y,
    isTimeMode: k,
    isDateTimeMode: D,
    is24hr: xa(e, "is24hr"),
    hideTimeHeader: xa(e, "hideTimeHeader"),
    timeAccuracy: xa(e, "timeAccuracy"),
    isDragging: T,
    inputValue: Q,
    inputEvents: Y,
    dateParts: V,
    attributes: P,
    rules: ae,
    move: Kr,
    moveBy: A,
    moveToValue: Z,
    updateValue: Oe,
    showPopover: Ln,
    hidePopover: Dr,
    togglePopover: Rn,
    onDayClick: ht,
    onDayKeydown: Tt,
    onDayMouseEnter: Lt,
    onPopoverBeforeShow: Ye,
    onPopoverAfterShow: et,
    onPopoverBeforeHide: He,
    onPopoverAfterHide: tt
  };
  return wn(Fp, S), S;
}
function Ts() {
  const e = En(Fp);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const ZM = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], XM = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function JM(e) {
  const t = Ts(), {
    locale: r,
    isRange: n,
    isTimeMode: a,
    dateParts: i,
    rules: o,
    is24hr: s,
    hideTimeHeader: l,
    timeAccuracy: u,
    updateValue: c
  } = t;
  function f(L) {
    L = Object.assign(d.value, L);
    let U = null;
    if (n.value) {
      const J = p.value ? L : i.value[0], W = p.value ? i.value[1] : L;
      U = { start: J, end: W };
    } else
      U = L;
    c(U, {
      patch: "time",
      targetPriority: p.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const p = O(() => e.position === 0), d = O(
    () => i.value[e.position] || { isValid: !1 }
  ), m = O(() => ys(d.value)), g = O(() => !!d.value.isValid), h = O(() => !l.value && g.value), y = O(() => {
    if (!m.value)
      return null;
    let L = r.value.toDate(d.value);
    return d.value.hours === 24 && (L = new Date(L.getTime() - 1)), L;
  }), _ = O({
    get() {
      return d.value.hours;
    },
    set(L) {
      f({ hours: L });
    }
  }), $ = O({
    get() {
      return d.value.minutes;
    },
    set(L) {
      f({ minutes: L });
    }
  }), v = O({
    get() {
      return d.value.seconds;
    },
    set(L) {
      f({ seconds: L });
    }
  }), D = O({
    get() {
      return d.value.milliseconds;
    },
    set(L) {
      f({ milliseconds: L });
    }
  }), k = O({
    get() {
      return d.value.hours < 12;
    },
    set(L) {
      L = String(L).toLowerCase() == "true";
      let U = _.value;
      L && U >= 12 ? U -= 12 : !L && U < 12 && (U += 12), f({ hours: U });
    }
  }), T = O(
    () => m6(d.value, o.value[e.position])
  ), C = O(() => ZM.filter(
    (L) => T.value.hours.some((U) => U.value === L.value)
  )), V = O(() => XM.filter(
    (L) => T.value.hours.some((U) => U.value === L.value)
  )), H = O(() => s.value ? T.value.hours : k.value ? C.value : V.value), N = O(() => {
    const L = [];
    return nr(C.value) && L.push({ value: !0, label: "AM" }), nr(V.value) && L.push({ value: !1, label: "PM" }), L;
  });
  return {
    ...t,
    showHeader: h,
    timeAccuracy: u,
    parts: d,
    isValid: g,
    date: y,
    hours: _,
    minutes: $,
    seconds: v,
    milliseconds: D,
    options: T,
    hourOptions: H,
    isAM: k,
    isAMOptions: N,
    is24hr: s
  };
}
const QM = ["value"], e3 = ["value", "disabled"], t3 = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, r3 = {
  inheritAttrs: !1
}, zn = /* @__PURE__ */ ue({
  ...r3,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = O(() => {
      const n = t.options.find((a) => a.value === t.modelValue);
      return n == null ? void 0 : n.label;
    });
    return (n, a) => (E(), I("div", {
      class: X(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      R("select", ie(n.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: a[0] || (a[0] = (i) => n.$emit("update:modelValue", i.target.value))
      }), [
        (E(!0), I(Ae, null, Re(e.options, (i) => (E(), I("option", {
          key: i.value,
          value: i.value,
          disabled: i.disabled
        }, _e(i.label), 9, e3))), 128))
      ], 16, QM),
      e.showIcon ? (E(), K(vn, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : B("", !0),
      e.fitContent ? (E(), I("div", t3, _e(w(r)), 1)) : B("", !0)
    ], 2));
  }
}), n3 = {
  key: 0,
  class: "vc-time-header"
}, a3 = { class: "vc-time-weekday" }, i3 = { class: "vc-time-month" }, o3 = { class: "vc-time-day" }, s3 = { class: "vc-time-year" }, l3 = { class: "vc-time-select-group" }, u3 = /* @__PURE__ */ R("span", { class: "vc-time-colon" }, ":", -1), c3 = /* @__PURE__ */ R("span", { class: "vc-time-colon" }, ":", -1), d3 = /* @__PURE__ */ R("span", { class: "vc-time-decimal" }, ".", -1), Tc = /* @__PURE__ */ ue({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const n = JM(e);
    t(n);
    const {
      locale: a,
      isValid: i,
      date: o,
      hours: s,
      minutes: l,
      seconds: u,
      milliseconds: c,
      options: f,
      hourOptions: p,
      isTimeMode: d,
      isAM: m,
      isAMOptions: g,
      is24hr: h,
      showHeader: y,
      timeAccuracy: _
    } = n;
    return ($, v) => (E(), I("div", {
      class: X(["vc-time-picker", [{ "vc-invalid": !w(i), "vc-attached": !w(d) }]])
    }, [
      ve(Dt, { name: "time-header" }, {
        default: fe(() => [
          w(y) && w(o) ? (E(), I("div", n3, [
            R("span", a3, _e(w(a).formatDate(w(o), "WWW")), 1),
            R("span", i3, _e(w(a).formatDate(w(o), "MMM")), 1),
            R("span", o3, _e(w(a).formatDate(w(o), "D")), 1),
            R("span", s3, _e(w(a).formatDate(w(o), "YYYY")), 1)
          ])) : B("", !0)
        ]),
        _: 1
      }),
      R("div", l3, [
        ve(vn, {
          name: "Clock",
          size: "17"
        }),
        ve(zn, {
          modelValue: w(s),
          "onUpdate:modelValue": v[0] || (v[0] = (D) => Xe(s) ? s.value = D : null),
          modelModifiers: { number: !0 },
          options: w(p),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        w(_) > 1 ? (E(), I(Ae, { key: 0 }, [
          u3,
          ve(zn, {
            modelValue: w(l),
            "onUpdate:modelValue": v[1] || (v[1] = (D) => Xe(l) ? l.value = D : null),
            modelModifiers: { number: !0 },
            options: w(f).minutes,
            class: "vc-time-select-minutes",
            "align-left": w(_) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        w(_) > 2 ? (E(), I(Ae, { key: 1 }, [
          c3,
          ve(zn, {
            modelValue: w(u),
            "onUpdate:modelValue": v[2] || (v[2] = (D) => Xe(u) ? u.value = D : null),
            modelModifiers: { number: !0 },
            options: w(f).seconds,
            class: "vc-time-select-seconds",
            "align-left": w(_) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : B("", !0),
        w(_) > 3 ? (E(), I(Ae, { key: 2 }, [
          d3,
          ve(zn, {
            modelValue: w(c),
            "onUpdate:modelValue": v[3] || (v[3] = (D) => Xe(c) ? c.value = D : null),
            modelModifiers: { number: !0 },
            options: w(f).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : B("", !0),
        w(h) ? B("", !0) : (E(), K(zn, {
          key: 3,
          modelValue: w(m),
          "onUpdate:modelValue": v[4] || (v[4] = (D) => Xe(m) ? m.value = D : null),
          options: w(g)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), Vp = /* @__PURE__ */ ue({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: r,
      color: n,
      displayMode: a,
      isDateTimeMode: i,
      isTimeMode: o,
      isRange: s,
      onDayClick: l,
      onDayMouseEnter: u,
      onDayKeydown: c
    } = Ts(), f = s.value ? [0, 1] : [0];
    return (p, d) => w(o) ? (E(), I("div", {
      key: 0,
      class: X(`vc-container vc-bordered vc-${w(n)} vc-${w(a)}`)
    }, [
      (E(!0), I(Ae, null, Re(w(f), (m) => (E(), K(Tc, {
        key: m,
        position: m
      }, null, 8, ["position"]))), 128))
    ], 2)) : (E(), K(WM, {
      key: 1,
      attributes: w(t),
      ref_key: "calendarRef",
      ref: r,
      onDayclick: w(l),
      onDaymouseenter: w(u),
      onDaykeydown: w(c)
    }, {
      footer: fe(() => [
        w(i) ? (E(!0), I(Ae, { key: 0 }, Re(w(f), (m) => (E(), K(Tc, {
          key: m,
          position: m
        }, null, 8, ["position"]))), 128)) : B("", !0),
        ve(Dt, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), f3 = {
  inheritAttrs: !1
}, p3 = /* @__PURE__ */ ue({
  ...f3,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: r,
      displayMode: n,
      popoverRef: a,
      onPopoverBeforeShow: i,
      onPopoverAfterShow: o,
      onPopoverBeforeHide: s,
      onPopoverAfterHide: l
    } = Ts();
    return (u, c) => (E(), K(Es, {
      id: w(t),
      placement: "bottom-start",
      class: X(`vc-date-picker-content vc-${w(r)} vc-${w(n)}`),
      ref_key: "popoverRef",
      ref: a,
      onBeforeShow: w(i),
      onAfterShow: w(o),
      onBeforeHide: w(s),
      onAfterHide: w(l)
    }, {
      default: fe(() => [
        ve(Vp, he(ct(u.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), v3 = ue({
  inheritAttrs: !1,
  emits: KM,
  props: qM,
  components: { DatePickerBase: Vp, DatePickerPopover: p3 },
  setup(e, t) {
    const r = GM(e, t), n = Tn(rp(r, "calendarRef", "popoverRef"));
    return { ...r, slotCtx: n };
  }
});
function h3(e, t, r, n, a, i) {
  const o = rr("DatePickerPopover"), s = rr("DatePickerBase");
  return e.$slots.default ? (E(), I(Ae, { key: 0 }, [
    we(e.$slots, "default", he(ct(e.slotCtx))),
    ve(o, he(ct(e.$attrs)), null, 16)
  ], 64)) : (E(), K(s, he(ie({ key: 1 }, e.$attrs)), null, 16));
}
const m3 = /* @__PURE__ */ Er(v3, [["render", h3]]), g3 = ["aria-label"], y3 = ["onClick"], b3 = /* @__PURE__ */ ue({
  __name: "DateInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    placeholder: { default: "dd/mm/aaaa" },
    layout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    id: {},
    disabled: {},
    dateFormat: { default: "DD/MM/YYYY" },
    minDate: {},
    maxDate: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = q(), a = Be(e, "modelValue", {
      set: (g) => (n.value = g, g)
    }), i = (g) => {
      g.isDisabled || (a.value = (() => {
        const h = g.id.split("-").reverse();
        switch (r.dateFormat) {
          case "YYYY":
            h.splice(0, 2);
            break;
          case "MM/YYYY":
            h.splice(0, 1);
            break;
        }
        return h.join("/");
      })());
    }, { errorMessage: o, meta: s, handleBlur: l, validate: u } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    ), c = q(), f = q(), p = q({
      modelValue: r.dateFormat
    }), d = {
      mask: () => {
        switch (r.dateFormat) {
          case "YYYY":
            return "####";
          case "MM/YYYY":
            return "##/####";
          case "DD/MM/YYYY":
            return "##/##/####";
        }
      }
    }, m = q(!1);
    return t({ errorMessage: o, meta: s, validate: u }), (g, h) => (E(), K(dt, he(ct({ layout: g.layout })), {
      default: fe(() => [
        g.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: g.title, tooltip: g.tooltip, size: g.size, disabled: g.disabled })), null, 16)) : B("", !0),
        R("div", {
          class: X(["input-wrapper", {
            error: w(o)
          }]),
          ref_key: "inputWrapper",
          ref: f
        }, [
          ze(R("input", ie({
            class: [`size-${g.size}`]
          }, { id: g.id, placeholder: g.placeholder, disabled: g.disabled }, {
            dateFormat: "numeric",
            type: "text",
            "onUpdate:modelValue": h[0] || (h[0] = (y) => a.value = y),
            onFocus: h[1] || (h[1] = (y) => m.value = !1),
            onBlur: h[2] || (h[2] = (y) => w(l)(y, g.validationMode == "blur")),
            ref_key: "inputEl",
            ref: c,
            "aria-label": g.label || g.title
          }), null, 16, g3), [
            [w(vi), d],
            [Dn, a.value]
          ]),
          ve(w(m3), ie({
            modelValue: n.value,
            "onUpdate:modelValue": h[3] || (h[3] = (y) => n.value = y),
            modelModifiers: { string: !0 },
            locale: "pt"
          }, { masks: p.value, minDate: g.minDate, maxDate: g.maxDate }, {
            "is-required": "",
            "trim-weeks": "",
            "update-on-input": !1,
            onPopoverDidHide: h[4] || (h[4] = (y) => w(l)(y, g.validationMode == "blur")),
            onDayclick: h[5] || (h[5] = (y) => i(y))
          }), {
            default: fe(({ togglePopover: y }) => [
              R("button", {
                class: "datepicker-btn",
                "aria-label": "Abrir calendário",
                onClick: y
              }, h[6] || (h[6] = [
                R("span", { class: "m-cgg-icon--calendar" }, null, -1)
              ]), 8, y3)
            ]),
            _: 1
          }, 16, ["modelValue"])
        ], 2),
        w(o) && g.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: g.size, errorMessage: w(o) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const _3 = /* @__PURE__ */ ye(b3, [["__scopeId", "data-v-7e4a1ca4"]]), w3 = ["aria-label"], E3 = {
  key: 0,
  class: "text-container"
}, T3 = /* @__PURE__ */ ue({
  __name: "CheckboxInput",
  props: /* @__PURE__ */ Ne({
    label: {},
    value: {},
    disabled: {},
    name: {},
    size: { default: "md" },
    error: { type: Boolean },
    errorDisplay: { type: Boolean, default: !0 },
    validation: {},
    validationMode: { default: "change" }
  }, {
    modelValue: { type: [Boolean, String, Array], required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), K(dt, { layout: "vertical" }, {
      default: fe(() => [
        R("label", {
          class: X(["input-wrapper", [
            `size-${s.size}`,
            {
              disabled: s.disabled,
              error: s.error || w(a)
            }
          ]])
        }, [
          ze(R("input", ie({
            type: "checkbox",
            "onUpdate:modelValue": l[0] || (l[0] = (u) => n.value = u)
          }, { value: s.value, disabled: s.disabled, name: s.name }, { "aria-label": s.label }), null, 16, w3), [
            [Hc, n.value]
          ]),
          l[1] || (l[1] = R("div", { class: "checkbox-icon m-cgg-icon--check" }, null, -1)),
          s.label || s.$slots.default ? (E(), I("div", E3, [
            s.$slots.default ? we(s.$slots, "default", { key: 0 }, void 0, !0) : (E(), K(w(si), { key: 1 }, {
              default: fe(() => [
                Br(_e(s.label), 1)
              ]),
              _: 1
            }))
          ])) : B("", !0)
        ], 2),
        w(a) && s.errorDisplay ? (E(), K(Ge, he(ie({ key: 0 }, { size: s.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 3
    }));
  }
});
const Ds = /* @__PURE__ */ ye(T3, [["__scopeId", "data-v-1754cc8d"]]), D3 = /* @__PURE__ */ ue({
  __name: "CheckboxInputList",
  props: /* @__PURE__ */ Ne({
    title: {},
    tooltip: {},
    layout: { default: "vertical" },
    listLayout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    disabled: {},
    options: {},
    name: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), K(dt, he(ct({ layout: s.layout })), {
      default: fe(() => [
        s.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: s.title, tooltip: s.tooltip, size: s.size, disabled: s.disabled })), null, 16)) : B("", !0),
        s.options ? (E(), I("ul", {
          key: 1,
          class: X(["input-list", [
            `layout-${s.listLayout}`,
            {
              error: w(a)
            }
          ]])
        }, [
          (E(!0), I(Ae, null, Re(s.options, (u) => (E(), I("li", null, [
            ve(Ds, ie({ ref_for: !0 }, {
              ...u,
              name: s.name,
              size: s.size,
              disabled: s.disabled,
              error: w(a) != null
            }, {
              modelValue: n.value,
              "onUpdate:modelValue": l[0] || (l[0] = (c) => n.value = c)
            }), null, 16, ["modelValue"])
          ]))), 256))
        ], 2)) : B("", !0),
        w(a) && s.errorDisplay ? (E(), K(Ge, he(ie({ key: 2 }, { size: s.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const Np = /* @__PURE__ */ ye(D3, [["__scopeId", "data-v-bdb28320"]]), $3 = { class: "select-display" }, k3 = ["innerHTML"], O3 = ["aria-label"], C3 = ["value", "disabled"], S3 = { class: "list-wrapper" }, A3 = { key: 0 }, M3 = ["onClick", "innerHTML"], I3 = {
  key: 2,
  class: "empty-search-results"
}, P3 = /* @__PURE__ */ ue({
  __name: "SelectInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    placeholder: { default: "Selecionar" },
    layout: { default: "vertical" },
    size: { default: "md" },
    error: {},
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    id: {},
    disabled: { default: !1 },
    options: {},
    multiSelect: { type: Boolean },
    relativeEl: {},
    searchFilter: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), a = q(!1), i = q(""), o = q(), s = q(), { errorMessage: l, meta: u, handleBlur: c, validate: f } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    ), p = O(() => {
      var _;
      if (n.value !== void 0 && r.options) {
        if (r.multiSelect)
          return (_ = r.options.filter(($) => {
            var v;
            return (v = n.value) == null ? void 0 : v.includes($.value);
          })) == null ? void 0 : _.map(($) => $.altLabel || $.label).join(", ");
        {
          const $ = r.options.find((v) => v.value == n.value);
          return ($ == null ? void 0 : $.altLabel) || ($ == null ? void 0 : $.label);
        }
      }
      return "";
    }), d = O(() => {
      let _ = r.options;
      return _ != null && _.length && (i.value && (_ = _.filter(
        ($) => {
          var v;
          return $.label.toLowerCase().includes(i.value.toLowerCase()) || ((v = $.searchTags) == null ? void 0 : v.some(
            (D) => D.toLowerCase().includes(i.value.toLowerCase())
          ));
        }
      )), r.multiSelect && (_ = _.map(($) => ({
        label: $.label,
        value: $.value
      })))), _;
    }), m = (_) => {
      r.multiSelect || h(), n.value = _;
    }, g = (_) => {
      !o.value.contains(_.target) && !s.value.contains(_.target) && (_.type == "scroll" && (s.value.style.transitionDuration = "0s"), h(_));
    }, h = (_) => {
      r.disabled || (a.value = !a.value, a.value ? (window.addEventListener("click", g), window.addEventListener("scroll", g), zs(o.value).addEventListener("scroll", g)) : (setTimeout(() => {
        i.value = "";
      }, 300), window.removeEventListener("click", g), window.removeEventListener("scroll", g), zs(o.value).removeEventListener(
        "scroll",
        g
      ), c(_, r.validationMode == "blur")));
    }, y = (_) => {
      const $ = _.getBoundingClientRect(), v = (r.relativeEl || o.value).getBoundingClientRect(), D = v.y + v.height + $.height > window.innerHeight ? "bottom" : "top";
      _.style[D] = D == "bottom" ? `${window.innerHeight - v.y + 4}px` : `${v.y + v.height + 4}px`, _.style.left = `${v.left}px`, _.style.width = `${v.width}px`;
    };
    return Nr(() => {
      window.removeEventListener("click", g), window.removeEventListener("scroll", g);
    }), t({ errorMessage: l, meta: u, validate: f }), (_, $) => (E(), K(dt, he(ct({ layout: _.layout })), {
      default: fe(() => [
        _.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: _.title, tooltip: _.tooltip, size: _.size, disabled: _.disabled })), null, 16)) : B("", !0),
        R("div", {
          ref_key: "inputEl",
          ref: o,
          class: X(["input-container-select", { error: w(l) }])
        }, [
          R("div", {
            class: X(["select-toggle", [`size-${_.size}`, { open: a.value, disabled: _.disabled }]]),
            onClick: $[0] || ($[0] = (v) => h())
          }, [
            R("div", $3, [
              R("div", {
                class: X(["text-wrapper", { placeholder: !p.value }]),
                innerHTML: p.value || _.placeholder
              }, null, 10, k3)
            ]),
            $[4] || ($[4] = R("span", { class: "m-cgg-icon--chevron-down" }, null, -1))
          ], 2),
          ze(R("select", ie({
            "aria-label": _.label || _.title,
            "onUpdate:modelValue": $[1] || ($[1] = (v) => n.value = v)
          }, { disabled: _.disabled }), [
            (E(!0), I(Ae, null, Re(_.options, (v) => (E(), I("option", {
              value: v.value,
              disabled: v.disabled
            }, _e(v.label), 9, C3))), 256))
          ], 16, O3), [
            [yv, n.value]
          ]),
          (E(), K(ko, { to: "body" }, [
            ve(yr, {
              name: "fade",
              onEnter: y
            }, {
              default: fe(() => {
                var v;
                return [
                  a.value ? (E(), I("div", {
                    key: 0,
                    class: "select-collapse",
                    ref_key: "collapseEl",
                    ref: s
                  }, [
                    _.searchFilter ? (E(), K(uf, {
                      key: 0,
                      size: "sm",
                      modelValue: i.value,
                      "onUpdate:modelValue": $[2] || ($[2] = (D) => i.value = D),
                      placeholder: _.searchFilter.placeholder
                    }, null, 8, ["modelValue", "placeholder"])) : B("", !0),
                    R("div", S3, [
                      r.multiSelect ? (E(), K(Np, {
                        key: 1,
                        options: d.value,
                        name: "multiselect-input-options",
                        modelValue: n.value,
                        "onUpdate:modelValue": $[3] || ($[3] = (D) => n.value = D)
                      }, null, 8, ["options", "modelValue"])) : (E(), I("ul", A3, [
                        (E(!0), I(Ae, null, Re(d.value, (D) => (E(), I("li", {
                          key: D.value,
                          onClick: (k) => !D.disabled && m(D.value),
                          class: X({ disabled: D.disabled }),
                          innerHTML: D.label
                        }, null, 10, M3))), 128))
                      ])),
                      _.searchFilter && ((v = d.value) == null ? void 0 : v.length) == 0 ? (E(), I("div", I3, _e(_.searchFilter.noResults), 1)) : B("", !0)
                    ])
                  ], 512)) : B("", !0)
                ];
              }),
              _: 1
            })
          ]))
        ], 2),
        w(l) && _.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: _.size, errorMessage: w(l) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const Bp = /* @__PURE__ */ ye(P3, [["__scopeId", "data-v-44d62c3b"]]), x3 = ["innerHTML"], L3 = /* @__PURE__ */ ue({
  __name: "InputDescription",
  props: {
    description: {},
    size: {},
    disabled: {}
  },
  setup(e) {
    return (t, r) => (E(), I("div", {
      class: X(["input-description", [`size-${t.size}`, { disabled: t.disabled }]]),
      innerHTML: t.description
    }, null, 10, x3));
  }
});
const Yp = /* @__PURE__ */ ye(L3, [["__scopeId", "data-v-7596aaee"]]), R3 = [
  {
    value: "93",
    label: "🇦🇫 Afghanistan (+93)",
    altLabel: "🇦🇫 +93",
    searchTags: ["+93", "93", "Afghanistan"]
  },
  {
    value: "355",
    label: "🇦🇱 Albania (+355)",
    altLabel: "🇦🇱 +355",
    searchTags: ["+355", "355", "Albania"]
  },
  {
    value: "213",
    label: "🇩🇿 Algeria (+213)",
    altLabel: "🇩🇿 +213",
    searchTags: ["+213", "213", "Algeria"]
  },
  {
    value: "1684",
    label: "🇦🇸 American Samoa (+1684)",
    altLabel: "🇦🇸 +1684",
    searchTags: ["+1684", "1684", "AmericanSamoa"]
  },
  {
    value: "376",
    label: "🇦🇩 Andorra (+376)",
    altLabel: "🇦🇩 +376",
    searchTags: ["+376", "376", "Andorra"]
  },
  {
    value: "244",
    label: "🇦🇴 Angola (+244)",
    altLabel: "🇦🇴 +244",
    searchTags: ["+244", "244", "Angola"]
  },
  {
    value: "1264",
    label: "🇦🇮 Anguilla (+1264)",
    altLabel: "🇦🇮 +1264",
    searchTags: ["+1264", "1264", "Anguilla"]
  },
  {
    value: "672",
    label: "🇦🇶 Antarctica (+672)",
    altLabel: "🇦🇶 +672",
    searchTags: ["+672", "672", "Antarctica"]
  },
  {
    value: "1268",
    label: "🇦🇬 Antigua & Barbuda (+1268)",
    altLabel: "🇦🇬 +1268",
    searchTags: ["+1268", "1268", "Antigua and Barbuda"]
  },
  {
    value: "54",
    label: "🇦🇷 Argentina (+54)",
    altLabel: "🇦🇷 +54",
    searchTags: ["+54", "54", "Argentina"]
  },
  {
    value: "374",
    label: "🇦🇲 Armenia (+374)",
    altLabel: "🇦🇲 +374",
    searchTags: ["+374", "374", "Armenia"]
  },
  {
    value: "297",
    label: "🇦🇼 Aruba (+297)",
    altLabel: "🇦🇼 +297",
    searchTags: ["+297", "297", "Aruba"]
  },
  {
    value: "61",
    label: "🇦🇺 Australia (+61)",
    altLabel: "🇦🇺 +61",
    searchTags: ["+61", "61", "Australia"]
  },
  {
    value: "43",
    label: "🇦🇹 Austria (+43)",
    altLabel: "🇦🇹 +43",
    searchTags: ["+43", "43", "Austria"]
  },
  {
    value: "994",
    label: "🇦🇿 Azerbaijan (+994)",
    altLabel: "🇦🇿 +994",
    searchTags: ["+994", "994", "Azerbaijan"]
  },
  {
    value: "1242",
    label: "🇧🇸 Bahamas (+1242)",
    altLabel: "🇧🇸 +1242",
    searchTags: ["+1242", "1242", "Bahamas"]
  },
  {
    value: "973",
    label: "🇧🇭 Bahrain (+973)",
    altLabel: "🇧🇭 +973",
    searchTags: ["+973", "973", "Bahrain"]
  },
  {
    value: "880",
    label: "🇧🇩 Bangladesh (+880)",
    altLabel: "🇧🇩 +880",
    searchTags: ["+880", "880", "Bangladesh"]
  },
  {
    value: "1246",
    label: "🇧🇧 Barbados (+1246)",
    altLabel: "🇧🇧 +1246",
    searchTags: ["+1246", "1246", "Barbados"]
  },
  {
    value: "375",
    label: "🇧🇾 Belarus (+375)",
    altLabel: "🇧🇾 +375",
    searchTags: ["+375", "375", "Belarus"]
  },
  {
    value: "32",
    label: "🇧🇪 Belgium (+32)",
    altLabel: "🇧🇪 +32",
    searchTags: ["+32", "32", "Belgium"]
  },
  {
    value: "501",
    label: "🇧🇿 Belize (+501)",
    altLabel: "🇧🇿 +501",
    searchTags: ["+501", "501", "Belize"]
  },
  {
    value: "229",
    label: "🇧🇯 Benin (+229)",
    altLabel: "🇧🇯 +229",
    searchTags: ["+229", "229", "Benin"]
  },
  {
    value: "1441",
    label: "🇧🇲 Bermuda (+1441)",
    altLabel: "🇧🇲 +1441",
    searchTags: ["+1441", "1441", "Bermuda"]
  },
  {
    value: "975",
    label: "🇧🇹 Bhutan (+975)",
    altLabel: "🇧🇹 +975",
    searchTags: ["+975", "975", "Bhutan"]
  },
  {
    value: "591",
    label: "🇧🇴 Bolivia (+591)",
    altLabel: "🇧🇴 +591",
    searchTags: ["+591", "591", "Bolivia, Plurinational State of"]
  },
  {
    value: "387",
    label: "🇧🇦 Bosnia & Herzegovina (+387)",
    altLabel: "🇧🇦 +387",
    searchTags: ["+387", "387", "Bosnia and Herzegovina"]
  },
  {
    value: "267",
    label: "🇧🇼 Botswana (+267)",
    altLabel: "🇧🇼 +267",
    searchTags: ["+267", "267", "Botswana"]
  },
  {
    value: "55",
    label: "🇧🇷 Brazil (+55)",
    altLabel: "🇧🇷 +55",
    searchTags: ["+55", "55", "Brazil"]
  },
  {
    value: "246",
    label: "🇮🇴 British Indian Ocean Territory (+246)",
    altLabel: "🇮🇴 +246",
    searchTags: ["+246", "246", "British Indian Ocean Territory"]
  },
  {
    value: "673",
    label: "🇧🇳 Brunei (+673)",
    altLabel: "🇧🇳 +673",
    searchTags: ["+673", "673", "Brunei Darussalam"]
  },
  {
    value: "359",
    label: "🇧🇬 Bulgaria (+359)",
    altLabel: "🇧🇬 +359",
    searchTags: ["+359", "359", "Bulgaria"]
  },
  {
    value: "226",
    label: "🇧🇫 Burkina Faso (+226)",
    altLabel: "🇧🇫 +226",
    searchTags: ["+226", "226", "Burkina Faso"]
  },
  {
    value: "257",
    label: "🇧🇮 Burundi (+257)",
    altLabel: "🇧🇮 +257",
    searchTags: ["+257", "257", "Burundi"]
  },
  {
    value: "855",
    label: "🇰🇭 Cambodia (+855)",
    altLabel: "🇰🇭 +855",
    searchTags: ["+855", "855", "Cambodia"]
  },
  {
    value: "237",
    label: "🇨🇲 Cameroon (+237)",
    altLabel: "🇨🇲 +237",
    searchTags: ["+237", "237", "Cameroon"]
  },
  {
    value: "1",
    label: "🇨🇦 Canada (+1)",
    altLabel: "🇺🇸 +1",
    searchTags: ["+1", "1", "United States"]
  },
  {
    value: "238",
    label: "🇨🇻 Cape Verde (+238)",
    altLabel: "🇨🇻 +238",
    searchTags: ["+238", "238", "Cape Verde"]
  },
  {
    value: "236",
    label: "🇨🇫 Central African Republic (+236)",
    altLabel: "🇨🇫 +236",
    searchTags: ["+236", "236", "Central African Republic"]
  },
  {
    value: "235",
    label: "🇹🇩 Chad (+235)",
    altLabel: "🇹🇩 +235",
    searchTags: ["+235", "235", "Chad"]
  },
  {
    value: "56",
    label: "🇨🇱 Chile (+56)",
    altLabel: "🇨🇱 +56",
    searchTags: ["+56", "56", "Chile"]
  },
  {
    value: "86",
    label: "🇨🇳 China (+86)",
    altLabel: "🇨🇳 +86",
    searchTags: ["+86", "86", "China"]
  },
  {
    value: "61",
    label: "🇨🇽 Christmas Island (+61)",
    altLabel: "🇦🇺 +61",
    searchTags: ["+61", "61", "Australia"]
  },
  {
    value: "61",
    label: "🇨🇨 Cocos (Keeling) Islands (+61)",
    altLabel: "🇦🇺 +61",
    searchTags: ["+61", "61", "Australia"]
  },
  {
    value: "57",
    label: "🇨🇴 Colombia (+57)",
    altLabel: "🇨🇴 +57",
    searchTags: ["+57", "57", "Colombia"]
  },
  {
    value: "269",
    label: "🇰🇲 Comoros (+269)",
    altLabel: "🇰🇲 +269",
    searchTags: ["+269", "269", "Comoros"]
  },
  {
    value: "242",
    label: "🇨🇬 Congo - Brazzaville (+242)",
    altLabel: "🇨🇬 +242",
    searchTags: ["+242", "242", "Congo"]
  },
  {
    value: "243",
    label: "🇨🇩 Congo - Kinshasa (+243)",
    altLabel: "🇨🇩 +243",
    searchTags: ["+243", "243", "Congo, The Democratic Republic of the"]
  },
  {
    value: "682",
    label: "🇨🇰 Cook Islands (+682)",
    altLabel: "🇨🇰 +682",
    searchTags: ["+682", "682", "Cook Islands"]
  },
  {
    value: "506",
    label: "🇨🇷 Costa Rica (+506)",
    altLabel: "🇨🇷 +506",
    searchTags: ["+506", "506", "Costa Rica"]
  },
  {
    value: "225",
    label: "🇨🇮 Côte d’Ivoire (+225)",
    altLabel: "🇨🇮 +225",
    searchTags: ["+225", "225", "Cote d'Ivoire"]
  },
  {
    value: "385",
    label: "🇭🇷 Croatia (+385)",
    altLabel: "🇭🇷 +385",
    searchTags: ["+385", "385", "Croatia"]
  },
  {
    value: "53",
    label: "🇨🇺 Cuba (+53)",
    altLabel: "🇨🇺 +53",
    searchTags: ["+53", "53", "Cuba"]
  },
  {
    value: "357",
    label: "🇨🇾 Cyprus (+357)",
    altLabel: "🇨🇾 +357",
    searchTags: ["+357", "357", "Cyprus"]
  },
  {
    value: "420",
    label: "🇨🇿 Czech Republic (+420)",
    altLabel: "🇨🇿 +420",
    searchTags: ["+420", "420", "Czech Republic"]
  },
  {
    value: "599",
    label: "🇨🇼 Curaçao (+599)",
    altLabel: "🇨🇼 +599",
    searchTags: ["+599", "599", "Curaçao"]
  },
  {
    value: "34",
    label: "🇮🇨 Canary Islands (+34)",
    altLabel: "🇮🇨 +34",
    searchTags: ["+34", "34", "Canary Islands"]
  },
  {
    value: "45",
    label: "🇩🇰 Denmark (+45)",
    altLabel: "🇩🇰 +45",
    searchTags: ["+45", "45", "Denmark"]
  },
  {
    value: "253",
    label: "🇩🇯 Djibouti (+253)",
    altLabel: "🇩🇯 +253",
    searchTags: ["+253", "253", "Djibouti"]
  },
  {
    value: "1767",
    label: "🇩🇲 Dominica (+1767)",
    altLabel: "🇩🇲 +1767",
    searchTags: ["+1767", "1767", "Dominica"]
  },
  {
    value: "1809",
    label: "🇩🇴 Dominican Republic (+1809)",
    altLabel: "🇩🇴 +1809",
    searchTags: ["+1809", "1809", "Dominican Republic"]
  },
  {
    value: "593",
    label: "🇪🇨 Ecuador (+593)",
    altLabel: "🇪🇨 +593",
    searchTags: ["+593", "593", "Ecuador"]
  },
  {
    value: "20",
    label: "🇪🇬 Egypt (+20)",
    altLabel: "🇪🇬 +20",
    searchTags: ["+20", "20", "Egypt"]
  },
  {
    value: "503",
    label: "🇸🇻 El Salvador (+503)",
    altLabel: "🇸🇻 +503",
    searchTags: ["+503", "503", "El Salvador"]
  },
  {
    value: "240",
    label: "🇬🇶 Equatorial Guinea (+240)",
    altLabel: "🇬🇶 +240",
    searchTags: ["+240", "240", "Equatorial Guinea"]
  },
  {
    value: "291",
    label: "🇪🇷 Eritrea (+291)",
    altLabel: "🇪🇷 +291",
    searchTags: ["+291", "291", "Eritrea"]
  },
  {
    value: "372",
    label: "🇪🇪 Estonia (+372)",
    altLabel: "🇪🇪 +372",
    searchTags: ["+372", "372", "Estonia"]
  },
  {
    value: "251",
    label: "🇪🇹 Ethiopia (+251)",
    altLabel: "🇪🇹 +251",
    searchTags: ["+251", "251", "Ethiopia"]
  },
  {
    value: "500",
    label: "🇫🇰 Falkland Islands (+500)",
    altLabel: "🇫🇰 +500",
    searchTags: ["+500", "500", "Falkland Islands (Malvinas)"]
  },
  {
    value: "298",
    label: "🇫🇴 Faroe Islands (+298)",
    altLabel: "🇫🇴 +298",
    searchTags: ["+298", "298", "Faroe Islands"]
  },
  {
    value: "679",
    label: "🇫🇯 Fiji (+679)",
    altLabel: "🇫🇯 +679",
    searchTags: ["+679", "679", "Fiji"]
  },
  {
    value: "358",
    label: "🇫🇮 Finland (+358)",
    altLabel: "🇫🇮 +358",
    searchTags: ["+358", "358", "Finland"]
  },
  {
    value: "33",
    label: "🇫🇷 France (+33)",
    altLabel: "🇫🇷 +33",
    searchTags: ["+33", "33", "France"]
  },
  {
    value: "594",
    label: "🇬🇫 French Guiana (+594)",
    altLabel: "🇬🇫 +594",
    searchTags: ["+594", "594", "French Guiana"]
  },
  {
    value: "689",
    label: "🇵🇫 French Polynesia (+689)",
    altLabel: "🇵🇫 +689",
    searchTags: ["+689", "689", "French Polynesia"]
  },
  {
    value: "262",
    label: "🇹🇫 French Southern Territories (+262)",
    altLabel: "🇹🇫 +262",
    searchTags: ["+262", "262", "French Southern Territories"]
  },
  {
    value: "241",
    label: "🇬🇦 Gabon (+241)",
    altLabel: "🇬🇦 +241",
    searchTags: ["+241", "241", "Gabon"]
  },
  {
    value: "220",
    label: "🇬🇲 Gambia (+220)",
    altLabel: "🇬🇲 +220",
    searchTags: ["+220", "220", "Gambia"]
  },
  {
    value: "995",
    label: "🇬🇪 Georgia (+995)",
    altLabel: "🇬🇪 +995",
    searchTags: ["+995", "995", "Georgia"]
  },
  {
    value: "49",
    label: "🇩🇪 Germany (+49)",
    altLabel: "🇩🇪 +49",
    searchTags: ["+49", "49", "Germany"]
  },
  {
    value: "233",
    label: "🇬🇭 Ghana (+233)",
    altLabel: "🇬🇭 +233",
    searchTags: ["+233", "233", "Ghana"]
  },
  {
    value: "350",
    label: "🇬🇮 Gibraltar (+350)",
    altLabel: "🇬🇮 +350",
    searchTags: ["+350", "350", "Gibraltar"]
  },
  {
    value: "30",
    label: "🇬🇷 Greece (+30)",
    altLabel: "🇬🇷 +30",
    searchTags: ["+30", "30", "Greece"]
  },
  {
    value: "299",
    label: "🇬🇱 Greenland (+299)",
    altLabel: "🇬🇱 +299",
    searchTags: ["+299", "299", "Greenland"]
  },
  {
    value: "1473",
    label: "🇬🇩 Grenada (+1473)",
    altLabel: "🇬🇩 +1473",
    searchTags: ["+1473", "1473", "Grenada"]
  },
  {
    value: "590",
    label: "🇬🇵 Guadeloupe (+590)",
    altLabel: "🇬🇵 +590",
    searchTags: ["+590", "590", "Guadeloupe"]
  },
  {
    value: "1671",
    label: "🇬🇺 Guam (+1671)",
    altLabel: "🇬🇺 +1671",
    searchTags: ["+1671", "1671", "Guam"]
  },
  {
    value: "502",
    label: "🇬🇹 Guatemala (+502)",
    altLabel: "🇬🇹 +502",
    searchTags: ["+502", "502", "Guatemala"]
  },
  {
    value: "44",
    label: "🇬🇬 Guernsey (+44)",
    altLabel: "🇬🇧 +44",
    searchTags: ["+44", "44", "United Kingdom"]
  },
  {
    value: "224",
    label: "🇬🇳 Guinea (+224)",
    altLabel: "🇬🇳 +224",
    searchTags: ["+224", "224", "Guinea"]
  },
  {
    value: "245",
    label: "🇬🇼 Guinea-Bissau (+245)",
    altLabel: "🇬🇼 +245",
    searchTags: ["+245", "245", "Guinea-Bissau"]
  },
  {
    value: "592",
    label: "🇬🇾 Guyana (+592)",
    altLabel: "🇬🇾 +592",
    searchTags: ["+592", "592", "Guyana"]
  },
  {
    value: "509",
    label: "🇭🇹 Haiti (+509)",
    altLabel: "🇭🇹 +509",
    searchTags: ["+509", "509", "Haiti"]
  },
  {
    value: "672",
    label: "🇭🇲 Heard & McDonald Islands (+672)",
    altLabel: "🇦🇶 +672",
    searchTags: ["+672", "672", "Antarctica"]
  },
  {
    value: "379",
    label: "🇻🇦 Vatican City (+379)",
    altLabel: "🇻🇦 +379",
    searchTags: ["+379", "379", "Holy See (Vatican City State)"]
  },
  {
    value: "504",
    label: "🇭🇳 Honduras (+504)",
    altLabel: "🇭🇳 +504",
    searchTags: ["+504", "504", "Honduras"]
  },
  {
    value: "852",
    label: "🇭🇰 Hong Kong (+852)",
    altLabel: "🇭🇰 +852",
    searchTags: ["+852", "852", "Hong Kong"]
  },
  {
    value: "36",
    label: "🇭🇺 Hungary (+36)",
    altLabel: "🇭🇺 +36",
    searchTags: ["+36", "36", "Hungary"]
  },
  {
    value: "354",
    label: "🇮🇸 Iceland (+354)",
    altLabel: "🇮🇸 +354",
    searchTags: ["+354", "354", "Iceland"]
  },
  {
    value: "91",
    label: "🇮🇳 India (+91)",
    altLabel: "🇮🇳 +91",
    searchTags: ["+91", "91", "India"]
  },
  {
    value: "62",
    label: "🇮🇩 Indonesia (+62)",
    altLabel: "🇮🇩 +62",
    searchTags: ["+62", "62", "Indonesia"]
  },
  {
    value: "98",
    label: "🇮🇷 Iran (+98)",
    altLabel: "🇮🇷 +98",
    searchTags: ["+98", "98", "Iran, Islamic Republic of"]
  },
  {
    value: "964",
    label: "🇮🇶 Iraq (+964)",
    altLabel: "🇮🇶 +964",
    searchTags: ["+964", "964", "Iraq"]
  },
  {
    value: "353",
    label: "🇮🇪 Ireland (+353)",
    altLabel: "🇮🇪 +353",
    searchTags: ["+353", "353", "Ireland"]
  },
  {
    value: "44",
    label: "🇮🇲 Isle of Man (+44)",
    altLabel: "🇬🇧 +44",
    searchTags: ["+44", "44", "United Kingdom"]
  },
  {
    value: "972",
    label: "🇮🇱 Israel (+972)",
    altLabel: "🇮🇱 +972",
    searchTags: ["+972", "972", "Israel"]
  },
  {
    value: "39",
    label: "🇮🇹 Italy (+39)",
    altLabel: "🇮🇹 +39",
    searchTags: ["+39", "39", "Italy"]
  },
  {
    value: "1876",
    label: "🇯🇲 Jamaica (+1876)",
    altLabel: "🇯🇲 +1876",
    searchTags: ["+1876", "1876", "Jamaica"]
  },
  {
    value: "81",
    label: "🇯🇵 Japan (+81)",
    altLabel: "🇯🇵 +81",
    searchTags: ["+81", "81", "Japan"]
  },
  {
    value: "44",
    label: "🇯🇪 Jersey (+44)",
    altLabel: "🇬🇧 +44",
    searchTags: ["+44", "44", "United Kingdom"]
  },
  {
    value: "962",
    label: "🇯🇴 Jordan (+962)",
    altLabel: "🇯🇴 +962",
    searchTags: ["+962", "962", "Jordan"]
  },
  {
    value: "254",
    label: "🇰🇪 Kenya (+254)",
    altLabel: "🇰🇪 +254",
    searchTags: ["+254", "254", "Kenya"]
  },
  {
    value: "686",
    label: "🇰🇮 Kiribati (+686)",
    altLabel: "🇰🇮 +686",
    searchTags: ["+686", "686", "Kiribati"]
  },
  {
    value: "850",
    label: "🇰🇵 North Korea (+850)",
    altLabel: "🇰🇵 +850",
    searchTags: ["+850", "850", "Korea, Democratic People's Republic of"]
  },
  {
    value: "82",
    label: "🇰🇷 South Korea (+82)",
    altLabel: "🇰🇷 +82",
    searchTags: ["+82", "82", "Korea, Republic of"]
  },
  {
    value: "965",
    label: "🇰🇼 Kuwait (+965)",
    altLabel: "🇰🇼 +965",
    searchTags: ["+965", "965", "Kuwait"]
  },
  {
    value: "996",
    label: "🇰🇬 Kyrgyzstan (+996)",
    altLabel: "🇰🇬 +996",
    searchTags: ["+996", "996", "Kyrgyzstan"]
  },
  {
    value: "383",
    label: "🇽🇰 Kosovo (+383)",
    altLabel: "🇽🇰 +383",
    searchTags: ["+383", "383", "Kosovo"]
  },
  {
    value: "856",
    label: "🇱🇦 Laos (+856)",
    altLabel: "🇱🇦 +856",
    searchTags: ["+856", "856", "Lao People's Democratic Republic"]
  },
  {
    value: "371",
    label: "🇱🇻 Latvia (+371)",
    altLabel: "🇱🇻 +371",
    searchTags: ["+371", "371", "Latvia"]
  },
  {
    value: "961",
    label: "🇱🇧 Lebanon (+961)",
    altLabel: "🇱🇧 +961",
    searchTags: ["+961", "961", "Lebanon"]
  },
  {
    value: "266",
    label: "🇱🇸 Lesotho (+266)",
    altLabel: "🇱🇸 +266",
    searchTags: ["+266", "266", "Lesotho"]
  },
  {
    value: "231",
    label: "🇱🇷 Liberia (+231)",
    altLabel: "🇱🇷 +231",
    searchTags: ["+231", "231", "Liberia"]
  },
  {
    value: "218",
    label: "🇱🇾 Libya (+218)",
    altLabel: "🇱🇾 +218",
    searchTags: ["+218", "218", "Libyan Arab Jamahiriya"]
  },
  {
    value: "423",
    label: "🇱🇮 Liechtenstein (+423)",
    altLabel: "🇱🇮 +423",
    searchTags: ["+423", "423", "Liechtenstein"]
  },
  {
    value: "370",
    label: "🇱🇹 Lithuania (+370)",
    altLabel: "🇱🇹 +370",
    searchTags: ["+370", "370", "Lithuania"]
  },
  {
    value: "352",
    label: "🇱🇺 Luxembourg (+352)",
    altLabel: "🇱🇺 +352",
    searchTags: ["+352", "352", "Luxembourg"]
  },
  {
    value: "853",
    label: "🇲🇴 Macau (+853)",
    altLabel: "🇲🇴 +853",
    searchTags: ["+853", "853", "Macao"]
  },
  {
    value: "389",
    label: "🇲🇰 North Macedonia (+389)",
    altLabel: "🇲🇰 +389",
    searchTags: ["+389", "389", "Macedonia, The Former Yugoslav Republic of"]
  },
  {
    value: "261",
    label: "🇲🇬 Madagascar (+261)",
    altLabel: "🇲🇬 +261",
    searchTags: ["+261", "261", "Madagascar"]
  },
  {
    value: "265",
    label: "🇲🇼 Malawi (+265)",
    altLabel: "🇲🇼 +265",
    searchTags: ["+265", "265", "Malawi"]
  },
  {
    value: "60",
    label: "🇲🇾 Malaysia (+60)",
    altLabel: "🇲🇾 +60",
    searchTags: ["+60", "60", "Malaysia"]
  },
  {
    value: "960",
    label: "🇲🇻 Maldives (+960)",
    altLabel: "🇲🇻 +960",
    searchTags: ["+960", "960", "Maldives"]
  },
  {
    value: "223",
    label: "🇲🇱 Mali (+223)",
    altLabel: "🇲🇱 +223",
    searchTags: ["+223", "223", "Mali"]
  },
  {
    value: "356",
    label: "🇲🇹 Malta (+356)",
    altLabel: "🇲🇹 +356",
    searchTags: ["+356", "356", "Malta"]
  },
  {
    value: "692",
    label: "🇲🇭 Marshall Islands (+692)",
    altLabel: "🇲🇭 +692",
    searchTags: ["+692", "692", "Marshall Islands"]
  },
  {
    value: "596",
    label: "🇲🇶 Martinique (+596)",
    altLabel: "🇲🇶 +596",
    searchTags: ["+596", "596", "Martinique"]
  },
  {
    value: "222",
    label: "🇲🇷 Mauritania (+222)",
    altLabel: "🇲🇷 +222",
    searchTags: ["+222", "222", "Mauritania"]
  },
  {
    value: "230",
    label: "🇲🇺 Mauritius (+230)",
    altLabel: "🇲🇺 +230",
    searchTags: ["+230", "230", "Mauritius"]
  },
  {
    value: "262",
    label: "🇾🇹 Mayotte (+262)",
    altLabel: "🇹🇫 +262",
    searchTags: ["+262", "262", "French Southern Territories"]
  },
  {
    value: "52",
    label: "🇲🇽 Mexico (+52)",
    altLabel: "🇲🇽 +52",
    searchTags: ["+52", "52", "Mexico"]
  },
  {
    value: "691",
    label: "🇫🇲 Micronesia (+691)",
    altLabel: "🇫🇲 +691",
    searchTags: ["+691", "691", "Micronesia, Federated States of"]
  },
  {
    value: "373",
    label: "🇲🇩 Moldova (+373)",
    altLabel: "🇲🇩 +373",
    searchTags: ["+373", "373", "Moldova, Republic of"]
  },
  {
    value: "377",
    label: "🇲🇨 Monaco (+377)",
    altLabel: "🇲🇨 +377",
    searchTags: ["+377", "377", "Monaco"]
  },
  {
    value: "976",
    label: "🇲🇳 Mongolia (+976)",
    altLabel: "🇲🇳 +976",
    searchTags: ["+976", "976", "Mongolia"]
  },
  {
    value: "382",
    label: "🇲🇪 Montenegro (+382)",
    altLabel: "🇲🇪 +382",
    searchTags: ["+382", "382", "Montenegro"]
  },
  {
    value: "1664",
    label: "🇲🇸 Montserrat (+1664)",
    altLabel: "🇲🇸 +1664",
    searchTags: ["+1664", "1664", "Montserrat"]
  },
  {
    value: "212",
    label: "🇲🇦 Morocco (+212)",
    altLabel: "🇲🇦 +212",
    searchTags: ["+212", "212", "Morocco"]
  },
  {
    value: "258",
    label: "🇲🇿 Mozambique (+258)",
    altLabel: "🇲🇿 +258",
    searchTags: ["+258", "258", "Mozambique"]
  },
  {
    value: "95",
    label: "🇲🇲 Myanmar (Burma) (+95)",
    altLabel: "🇲🇲 +95",
    searchTags: ["+95", "95", "Myanmar"]
  },
  {
    value: "264",
    label: "🇳🇦 Namibia (+264)",
    altLabel: "🇳🇦 +264",
    searchTags: ["+264", "264", "Namibia"]
  },
  {
    value: "674",
    label: "🇳🇷 Nauru (+674)",
    altLabel: "🇳🇷 +674",
    searchTags: ["+674", "674", "Nauru"]
  },
  {
    value: "977",
    label: "🇳🇵 Nepal (+977)",
    altLabel: "🇳🇵 +977",
    searchTags: ["+977", "977", "Nepal"]
  },
  {
    value: "31",
    label: "🇳🇱 Netherlands (+31)",
    altLabel: "🇳🇱 +31",
    searchTags: ["+31", "31", "Netherlands"]
  },
  {
    value: "599",
    label: "🇧🇶 Caribbean Netherlands (+599)",
    altLabel: "🇨🇼 +599",
    searchTags: ["+599", "599", "Curaçao"]
  },
  {
    value: "687",
    label: "🇳🇨 New Caledonia (+687)",
    altLabel: "🇳🇨 +687",
    searchTags: ["+687", "687", "New Caledonia"]
  },
  {
    value: "64",
    label: "🇳🇿 New Zealand (+64)",
    altLabel: "🇳🇿 +64",
    searchTags: ["+64", "64", "New Zealand"]
  },
  {
    value: "505",
    label: "🇳🇮 Nicaragua (+505)",
    altLabel: "🇳🇮 +505",
    searchTags: ["+505", "505", "Nicaragua"]
  },
  {
    value: "227",
    label: "🇳🇪 Niger (+227)",
    altLabel: "🇳🇪 +227",
    searchTags: ["+227", "227", "Niger"]
  },
  {
    value: "234",
    label: "🇳🇬 Nigeria (+234)",
    altLabel: "🇳🇬 +234",
    searchTags: ["+234", "234", "Nigeria"]
  },
  {
    value: "683",
    label: "🇳🇺 Niue (+683)",
    altLabel: "🇳🇺 +683",
    searchTags: ["+683", "683", "Niue"]
  },
  {
    value: "672",
    label: "🇳🇫 Norfolk Island (+672)",
    altLabel: "🇦🇶 +672",
    searchTags: ["+672", "672", "Antarctica"]
  },
  {
    value: "1670",
    label: "🇲🇵 Northern Mariana Islands (+1670)",
    altLabel: "🇲🇵 +1670",
    searchTags: ["+1670", "1670", "Northern Mariana Islands"]
  },
  {
    value: "47",
    label: "🇳🇴 Norway (+47)",
    altLabel: "🇳🇴 +47",
    searchTags: ["+47", "47", "Norway"]
  },
  {
    value: "968",
    label: "🇴🇲 Oman (+968)",
    altLabel: "🇴🇲 +968",
    searchTags: ["+968", "968", "Oman"]
  },
  {
    value: "92",
    label: "🇵🇰 Pakistan (+92)",
    altLabel: "🇵🇰 +92",
    searchTags: ["+92", "92", "Pakistan"]
  },
  {
    value: "680",
    label: "🇵🇼 Palau (+680)",
    altLabel: "🇵🇼 +680",
    searchTags: ["+680", "680", "Palau"]
  },
  {
    value: "970",
    label: "🇵🇸 Palestine (+970)",
    altLabel: "🇵🇸 +970",
    searchTags: ["+970", "970", "Palestinian Territory, Occupied"]
  },
  {
    value: "507",
    label: "🇵🇦 Panama (+507)",
    altLabel: "🇵🇦 +507",
    searchTags: ["+507", "507", "Panama"]
  },
  {
    value: "675",
    label: "🇵🇬 Papua New Guinea (+675)",
    altLabel: "🇵🇬 +675",
    searchTags: ["+675", "675", "Papua New Guinea"]
  },
  {
    value: "595",
    label: "🇵🇾 Paraguay (+595)",
    altLabel: "🇵🇾 +595",
    searchTags: ["+595", "595", "Paraguay"]
  },
  {
    value: "51",
    label: "🇵🇪 Peru (+51)",
    altLabel: "🇵🇪 +51",
    searchTags: ["+51", "51", "Peru"]
  },
  {
    value: "63",
    label: "🇵🇭 Philippines (+63)",
    altLabel: "🇵🇭 +63",
    searchTags: ["+63", "63", "Philippines"]
  },
  {
    value: "48",
    label: "🇵🇱 Poland (+48)",
    altLabel: "🇵🇱 +48",
    searchTags: ["+48", "48", "Poland"]
  },
  {
    value: "351",
    label: "🇵🇹 Portugal (+351)",
    altLabel: "🇵🇹 +351",
    searchTags: ["+351", "351", "Portugal"]
  },
  {
    value: "974",
    label: "🇶🇦 Qatar (+974)",
    altLabel: "🇶🇦 +974",
    searchTags: ["+974", "974", "Qatar"]
  },
  {
    value: "40",
    label: "🇷🇴 Romania (+40)",
    altLabel: "🇷🇴 +40",
    searchTags: ["+40", "40", "Romania"]
  },
  {
    value: "7",
    label: "🇷🇺 Russia (+7)",
    altLabel: "🇷🇺 +7",
    searchTags: ["+7", "7", "Russia"]
  },
  {
    value: "250",
    label: "🇷🇼 Rwanda (+250)",
    altLabel: "🇷🇼 +250",
    searchTags: ["+250", "250", "Rwanda"]
  },
  {
    value: "262",
    label: "🇷🇪 Réunion (+262)",
    altLabel: "🇹🇫 +262",
    searchTags: ["+262", "262", "French Southern Territories"]
  },
  {
    value: "590",
    label: "🇧🇱 St Barthélemy (+590)",
    altLabel: "🇬🇵 +590",
    searchTags: ["+590", "590", "Guadeloupe"]
  },
  {
    value: "290",
    label: "🇸🇭 St Helena (+290)",
    altLabel: "🇸🇭 +290",
    searchTags: ["+290", "290", "Saint Helena, Ascension and Tristan Da Cunha"]
  },
  {
    value: "1869",
    label: "🇰🇳 St Kitts & Nevis (+1869)",
    altLabel: "🇰🇳 +1869",
    searchTags: ["+1869", "1869", "Saint Kitts and Nevis"]
  },
  {
    value: "1758",
    label: "🇱🇨 St Lucia (+1758)",
    altLabel: "🇱🇨 +1758",
    searchTags: ["+1758", "1758", "Saint Lucia"]
  },
  {
    value: "590",
    label: "🇲🇫 St Martin (+590)",
    altLabel: "🇬🇵 +590",
    searchTags: ["+590", "590", "Guadeloupe"]
  },
  {
    value: "508",
    label: "🇵🇲 St Pierre & Miquelon (+508)",
    altLabel: "🇵🇲 +508",
    searchTags: ["+508", "508", "Saint Pierre and Miquelon"]
  },
  {
    value: "1784",
    label: "🇻🇨 St Vincent & Grenadines (+1784)",
    altLabel: "🇻🇨 +1784",
    searchTags: ["+1784", "1784", "Saint Vincent and the Grenadines"]
  },
  {
    value: "685",
    label: "🇼🇸 Samoa (+685)",
    altLabel: "🇼🇸 +685",
    searchTags: ["+685", "685", "Samoa"]
  },
  {
    value: "378",
    label: "🇸🇲 San Marino (+378)",
    altLabel: "🇸🇲 +378",
    searchTags: ["+378", "378", "San Marino"]
  },
  {
    value: "239",
    label: "🇸🇹 São Tomé & Príncipe (+239)",
    altLabel: "🇸🇹 +239",
    searchTags: ["+239", "239", "Sao Tome and Principe"]
  },
  {
    value: "966",
    label: "🇸🇦 Saudi Arabia (+966)",
    altLabel: "🇸🇦 +966",
    searchTags: ["+966", "966", "Saudi Arabia"]
  },
  {
    value: "221",
    label: "🇸🇳 Senegal (+221)",
    altLabel: "🇸🇳 +221",
    searchTags: ["+221", "221", "Senegal"]
  },
  {
    value: "381",
    label: "🇷🇸 Serbia (+381)",
    altLabel: "🇷🇸 +381",
    searchTags: ["+381", "381", "Serbia"]
  },
  {
    value: "248",
    label: "🇸🇨 Seychelles (+248)",
    altLabel: "🇸🇨 +248",
    searchTags: ["+248", "248", "Seychelles"]
  },
  {
    value: "232",
    label: "🇸🇱 Sierra Leone (+232)",
    altLabel: "🇸🇱 +232",
    searchTags: ["+232", "232", "Sierra Leone"]
  },
  {
    value: "65",
    label: "🇸🇬 Singapore (+65)",
    altLabel: "🇸🇬 +65",
    searchTags: ["+65", "65", "Singapore"]
  },
  {
    value: "421",
    label: "🇸🇰 Slovakia (+421)",
    altLabel: "🇸🇰 +421",
    searchTags: ["+421", "421", "Slovakia"]
  },
  {
    value: "386",
    label: "🇸🇮 Slovenia (+386)",
    altLabel: "🇸🇮 +386",
    searchTags: ["+386", "386", "Slovenia"]
  },
  {
    value: "677",
    label: "🇸🇧 Solomon Islands (+677)",
    altLabel: "🇸🇧 +677",
    searchTags: ["+677", "677", "Solomon Islands"]
  },
  {
    value: "252",
    label: "🇸🇴 Somalia (+252)",
    altLabel: "🇸🇴 +252",
    searchTags: ["+252", "252", "Somalia"]
  },
  {
    value: "27",
    label: "🇿🇦 South Africa (+27)",
    altLabel: "🇿🇦 +27",
    searchTags: ["+27", "27", "South Africa"]
  },
  {
    value: "500",
    label: "🇬🇸 South Georgia and the South Sandwich Islands (+500)",
    altLabel: "🇫🇰 +500",
    searchTags: ["+500", "500", "Falkland Islands (Malvinas)"]
  },
  {
    value: "34",
    label: "🇪🇸 Spain (+34)",
    altLabel: "🇮🇨 +34",
    searchTags: ["+34", "34", "Canary Islands"]
  },
  {
    value: "94",
    label: "🇱🇰 Sri Lanka (+94)",
    altLabel: "🇱🇰 +94",
    searchTags: ["+94", "94", "Sri Lanka"]
  },
  {
    value: "249",
    label: "🇸🇩 Sudan (+249)",
    altLabel: "🇸🇩 +249",
    searchTags: ["+249", "249", "Sudan"]
  },
  {
    value: "211",
    label: "🇸🇸 South Sudan (+211)",
    altLabel: "🇸🇸 +211",
    searchTags: ["+211", "211", "South Sudan"]
  },
  {
    value: "597",
    label: "🇸🇷 Suriname (+597)",
    altLabel: "🇸🇷 +597",
    searchTags: ["+597", "597", "Suriname"]
  },
  {
    value: "47",
    label: "🇸🇯 Svalbard & Jan Mayen (+47)",
    altLabel: "🇳🇴 +47",
    searchTags: ["+47", "47", "Norway"]
  },
  {
    value: "268",
    label: "🇸🇿 Eswatini (+268)",
    altLabel: "🇸🇿 +268",
    searchTags: ["+268", "268", "Swaziland"]
  },
  {
    value: "46",
    label: "🇸🇪 Sweden (+46)",
    altLabel: "🇸🇪 +46",
    searchTags: ["+46", "46", "Sweden"]
  },
  {
    value: "41",
    label: "🇨🇭 Switzerland (+41)",
    altLabel: "🇨🇭 +41",
    searchTags: ["+41", "41", "Switzerland"]
  },
  {
    value: "963",
    label: "🇸🇾 Syria (+963)",
    altLabel: "🇸🇾 +963",
    searchTags: ["+963", "963", "Syrian Arab Republic"]
  },
  {
    value: "886",
    label: "🇹🇼 Taiwan (+886)",
    altLabel: "🇹🇼 +886",
    searchTags: ["+886", "886", "Taiwan, Province of China"]
  },
  {
    value: "992",
    label: "🇹🇯 Tajikistan (+992)",
    altLabel: "🇹🇯 +992",
    searchTags: ["+992", "992", "Tajikistan"]
  },
  {
    value: "255",
    label: "🇹🇿 Tanzania (+255)",
    altLabel: "🇹🇿 +255",
    searchTags: ["+255", "255", "Tanzania, United Republic of"]
  },
  {
    value: "66",
    label: "🇹🇭 Thailand (+66)",
    altLabel: "🇹🇭 +66",
    searchTags: ["+66", "66", "Thailand"]
  },
  {
    value: "670",
    label: "🇹🇱 Timor-Leste (+670)",
    altLabel: "🇹🇱 +670",
    searchTags: ["+670", "670", "Timor-Leste"]
  },
  {
    value: "228",
    label: "🇹🇬 Togo (+228)",
    altLabel: "🇹🇬 +228",
    searchTags: ["+228", "228", "Togo"]
  },
  {
    value: "690",
    label: "🇹🇰 Tokelau (+690)",
    altLabel: "🇹🇰 +690",
    searchTags: ["+690", "690", "Tokelau"]
  },
  {
    value: "676",
    label: "🇹🇴 Tonga (+676)",
    altLabel: "🇹🇴 +676",
    searchTags: ["+676", "676", "Tonga"]
  },
  {
    value: "1868",
    label: "🇹🇹 Trinidad & Tobago (+1868)",
    altLabel: "🇹🇹 +1868",
    searchTags: ["+1868", "1868", "Trinidad and Tobago"]
  },
  {
    value: "216",
    label: "🇹🇳 Tunisia (+216)",
    altLabel: "🇹🇳 +216",
    searchTags: ["+216", "216", "Tunisia"]
  },
  {
    value: "90",
    label: "🇹🇷 Turkey (+90)",
    altLabel: "🇹🇷 +90",
    searchTags: ["+90", "90", "Turkey"]
  },
  {
    value: "993",
    label: "🇹🇲 Turkmenistan (+993)",
    altLabel: "🇹🇲 +993",
    searchTags: ["+993", "993", "Turkmenistan"]
  },
  {
    value: "1649",
    label: "🇹🇨 Turks & Caicos Islands (+1649)",
    altLabel: "🇹🇨 +1649",
    searchTags: ["+1649", "1649", "Turks and Caicos Islands"]
  },
  {
    value: "688",
    label: "🇹🇻 Tuvalu (+688)",
    altLabel: "🇹🇻 +688",
    searchTags: ["+688", "688", "Tuvalu"]
  },
  {
    value: "256",
    label: "🇺🇬 Uganda (+256)",
    altLabel: "🇺🇬 +256",
    searchTags: ["+256", "256", "Uganda"]
  },
  {
    value: "380",
    label: "🇺🇦 Ukraine (+380)",
    altLabel: "🇺🇦 +380",
    searchTags: ["+380", "380", "Ukraine"]
  },
  {
    value: "971",
    label: "🇦🇪 United Arab Emirates (+971)",
    altLabel: "🇦🇪 +971",
    searchTags: ["+971", "971", "United Arab Emirates"]
  },
  {
    value: "44",
    label: "🇬🇧 United Kingdom (+44)",
    altLabel: "🇬🇧 +44",
    searchTags: ["+44", "44", "United Kingdom"]
  },
  {
    value: "1",
    label: "🇺🇸 United States (+1)",
    altLabel: "🇺🇸 +1",
    searchTags: ["+1", "1", "United States"]
  },
  {
    value: "598",
    label: "🇺🇾 Uruguay (+598)",
    altLabel: "🇺🇾 +598",
    searchTags: ["+598", "598", "Uruguay"]
  },
  {
    value: "998",
    label: "🇺🇿 Uzbekistan (+998)",
    altLabel: "🇺🇿 +998",
    searchTags: ["+998", "998", "Uzbekistan"]
  },
  {
    value: "678",
    label: "🇻🇺 Vanuatu (+678)",
    altLabel: "🇻🇺 +678",
    searchTags: ["+678", "678", "Vanuatu"]
  },
  {
    value: "58",
    label: "🇻🇪 Venezuela (+58)",
    altLabel: "🇻🇪 +58",
    searchTags: ["+58", "58", "Venezuela, Bolivarian Republic of"]
  },
  {
    value: "84",
    label: "🇻🇳 Vietnam (+84)",
    altLabel: "🇻🇳 +84",
    searchTags: ["+84", "84", "Viet Nam"]
  },
  {
    value: "1284",
    label: "🇻🇬 British Virgin Islands (+1284)",
    altLabel: "🇻🇬 +1284",
    searchTags: ["+1284", "1284", "Virgin Islands, British"]
  },
  {
    value: "1340",
    label: "🇻🇮 US Virgin Islands (+1340)",
    altLabel: "🇻🇮 +1340",
    searchTags: ["+1340", "1340", "Virgin Islands, U.S."]
  },
  {
    value: "681",
    label: "🇼🇫 Wallis & Futuna (+681)",
    altLabel: "🇼🇫 +681",
    searchTags: ["+681", "681", "Wallis and Futuna"]
  },
  {
    value: "212",
    label: "🇪🇭 Western Sahara (+212)",
    altLabel: "🇲🇦 +212",
    searchTags: ["+212", "212", "Morocco"]
  },
  {
    value: "967",
    label: "🇾🇪 Yemen (+967)",
    altLabel: "🇾🇪 +967",
    searchTags: ["+967", "967", "Yemen"]
  },
  {
    value: "260",
    label: "🇿🇲 Zambia (+260)",
    altLabel: "🇿🇲 +260",
    searchTags: ["+260", "260", "Zambia"]
  },
  {
    value: "263",
    label: "🇿🇼 Zimbabwe (+263)",
    altLabel: "🇿🇼 +263",
    searchTags: ["+263", "263", "Zimbabwe"]
  },
  {
    value: "358",
    label: "🇦🇽 Åland Islands (+358)",
    altLabel: "🇫🇮 +358",
    searchTags: ["+358", "358", "Finland"]
  }
], F3 = ["maxlength", "aria-label"], V3 = /* @__PURE__ */ ue({
  __name: "PhoneInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    description: {},
    placeholder: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "blur" },
    errorDisplay: { type: Boolean, default: !0 },
    countryCode: {},
    id: {},
    disabled: {},
    autocomplete: {}
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {},
    countryCode: {
      default: "351"
    },
    countryCodeModifiers: {}
  }),
  emits: ["update:modelValue", "update:countryCode"],
  setup(e, { expose: t }) {
    const r = e, n = q(), a = q(), i = Be(e, "modelValue"), o = O(() => ({
      mask: () => {
        let d = "";
        for (let m = 0; m < Ui[s.value]; m++)
          d += "#";
        return d;
      }
    })), s = Be(e, "countryCode"), { value: l, errorMessage: u, meta: c, handleBlur: f, validate: p } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    );
    return t({ errorMessage: u, meta: c, validate: p }), (d, m) => (E(), K(dt, he(ct({ layout: d.layout })), {
      default: fe(() => [
        d.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: d.title, tooltip: d.tooltip, size: d.size, disabled: d.disabled })), null, 16)) : B("", !0),
        R("div", {
          ref_key: "inputWrapper",
          ref: a,
          class: X(["input-wrapper", { error: w(u) }])
        }, [
          ve(Bp, ie({ class: "input-country-code" }, { size: d.size, disabled: d.disabled }, {
            options: w(R3),
            modelValue: s.value,
            "onUpdate:modelValue": m[0] || (m[0] = (g) => s.value = g),
            "search-filter": {
              placeholder: "Pesquise o seu indicativo",
              noResults: "Não foram encontrados indicativos"
            },
            "relative-el": a.value,
            "resize-on-update": !0
          }), null, 16, ["options", "modelValue", "relative-el"]),
          ze(R("input", ie({
            class: [`size-${d.size}`],
            ref_key: "inputEl",
            ref: n
          }, { id: d.id, disabled: d.disabled, autocomplete: d.autocomplete, placeholder: d.placeholder }, {
            type: "tel",
            inputmode: "numeric",
            "onUpdate:modelValue": m[1] || (m[1] = (g) => i.value = g),
            maxlength: w(Ui)[s.value],
            onBlur: m[2] || (m[2] = (g) => w(f)(g, d.validationMode == "blur")),
            "aria-label": d.label || d.title
          }), null, 16, F3), [
            [Dn, i.value],
            [w(vi), o.value]
          ])
        ], 2),
        d.description ? (E(), K(Yp, he(ie({ key: 1 }, { description: d.description, size: d.size, disabled: d.disabled })), null, 16)) : B("", !0),
        w(u) && d.errorDisplay ? (E(), K(Ge, he(ie({ key: 2 }, { size: d.size, errorMessage: w(u) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const N3 = /* @__PURE__ */ ye(V3, [["__scopeId", "data-v-498bd57c"]]), B3 = { class: "input-container" }, Y3 = ["name", "aria-label"], j3 = {
  key: 0,
  class: "text-container"
}, z3 = /* @__PURE__ */ ue({
  __name: "RadioInput",
  props: /* @__PURE__ */ Ne({
    name: {},
    value: {},
    label: {},
    disabled: {},
    size: {},
    error: { type: Boolean },
    errorDisplay: { type: Boolean, default: !0 },
    validation: {},
    validationMode: {},
    radioStyle: { default: "default" }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), I("div", B3, [
      R("label", {
        class: X(["input-wrapper", [
          `radio-style-${s.radioStyle}`,
          `size-${s.size}`,
          {
            checked: n.value == s.value,
            disabled: s.disabled,
            error: s.error || w(a)
          }
        ]])
      }, [
        ze(R("input", ie({ type: "radio" }, { name: s.name, value: s.value, disabled: s.disabled }, {
          name: s.name,
          "onUpdate:modelValue": l[0] || (l[0] = (u) => n.value = u),
          "aria-label": s.label
        }), null, 16, Y3), [
          [bv, n.value]
        ]),
        l[1] || (l[1] = R("div", { class: "radio-icon" }, null, -1)),
        s.label || s.$slots.default ? (E(), I("div", j3, [
          s.$slots.default ? we(s.$slots, "default", { key: 0 }, void 0, !0) : (E(), K(si, { key: 1 }, {
            default: fe(() => [
              Br(_e(s.label), 1)
            ]),
            _: 1
          }))
        ])) : B("", !0)
      ], 2),
      w(a) && s.errorDisplay ? (E(), K(Ge, he(ie({ key: 0 }, { size: s.size, errorMessage: w(a) })), null, 16)) : B("", !0)
    ]));
  }
});
const jp = /* @__PURE__ */ ye(z3, [["__scopeId", "data-v-89dfa70c"]]), U3 = /* @__PURE__ */ ue({
  __name: "RadioInputList",
  props: /* @__PURE__ */ Ne({
    title: {},
    tooltip: {},
    layout: { default: "vertical" },
    listLayout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    disabled: {},
    options: {},
    name: {},
    radioStyle: { default: () => ({
      variant: "default"
    }) }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    }), s = O(() => {
      const l = [];
      return ["xs", "sm", "md", "lg", "xl"].forEach((c, f, p) => {
        var g, h;
        const d = (h = (g = r.radioStyle) == null ? void 0 : g.breakDisplay) == null ? void 0 : h[c];
        let m = d || 1;
        !d && f > 0 && l[f - 1] && (m = l[f - 1][1]), l.push([`--${c}-columns`, m]);
      }), Object.fromEntries(l);
    });
    return t({ errorMessage: a, meta: i, validate: o }), (l, u) => (E(), K(dt, he(ct({ layout: l.layout })), {
      default: fe(() => [
        l.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: l.title, tooltip: l.tooltip, size: l.size, disabled: l.disabled })), null, 16)) : B("", !0),
        l.options ? (E(), I("ul", {
          key: 1,
          class: X(["input-list", [
            `size-${l.size}`,
            `layout-${l.listLayout}`,
            `radio-style-${l.radioStyle.variant}`,
            {
              error: w(a)
            }
          ]]),
          style: it(s.value)
        }, [
          (E(!0), I(Ae, null, Re(l.options, (c) => (E(), I("li", null, [
            ve(jp, ie({ ref_for: !0 }, {
              ...c,
              name: l.name,
              size: l.size,
              disabled: l.disabled,
              error: w(a) != null,
              errorDisplay: !1,
              radioStyle: l.radioStyle.variant
            }, {
              modelValue: n.value,
              "onUpdate:modelValue": u[0] || (u[0] = (f) => n.value = f)
            }), null, 16, ["modelValue"])
          ]))), 256))
        ], 6)) : B("", !0),
        w(a) && l.errorDisplay ? (E(), K(Ge, he(ie({ key: 2 }, { size: l.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const H3 = /* @__PURE__ */ ye(U3, [["__scopeId", "data-v-f96cac6f"]]), W3 = {
  key: 0,
  class: "tile-image"
}, q3 = ["src"], K3 = { class: "tile-label" }, G3 = {
  key: 1,
  class: "tile-description"
}, Z3 = { class: "tile-checkbox" }, X3 = /* @__PURE__ */ ue({
  __name: "TileCheckboxInput",
  props: /* @__PURE__ */ Ne({
    image: {},
    value: {},
    label: {},
    description: {},
    disabled: {},
    errorDisplay: { type: Boolean, default: !0 },
    validation: {},
    validationMode: { default: "change" }
  }, {
    modelValue: { type: [Boolean, Array], required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), I("label", {
      class: X(["tile-checkbox-container", {
        checked: typeof n.value == "boolean" ? n.value : n.value.includes(s.value)
      }])
    }, [
      s.image ? (E(), I("div", W3, [
        R("img", { src: s.image }, null, 8, q3)
      ])) : B("", !0),
      R("div", K3, _e(s.label), 1),
      s.description || s.$slots.default ? (E(), I("div", G3, [
        s.$slots.default ? we(s.$slots, "default", { key: 0 }, void 0, !0) : B("", !0),
        Br(" " + _e(s.description), 1)
      ])) : B("", !0),
      R("div", Z3, [
        ve(Ds, ie({
          modelValue: n.value,
          "onUpdate:modelValue": l[0] || (l[0] = (u) => n.value = u)
        }, { value: s.value }), null, 16, ["modelValue"])
      ])
    ], 2));
  }
});
const J3 = /* @__PURE__ */ ye(X3, [["__scopeId", "data-v-b30a9730"]]), Q3 = {
  key: 0,
  class: "m-cgg-icon--document"
}, eI = { class: "input-text-wrapper" }, tI = { class: "input-text" }, rI = { class: "icon-wrapper" }, nI = {
  key: 0,
  class: "m-cgg-icon--upload"
}, aI = {
  key: 2,
  class: "m-cgg-icon--change"
}, iI = ["aria-label", "accept"], oI = /* @__PURE__ */ ue({
  __name: "FileInput",
  props: /* @__PURE__ */ Ne({
    id: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    title: {},
    label: {},
    tooltip: {},
    placeholder: { default: "Anexar ficheiro" },
    errorDisplay: { type: Boolean, default: !0 },
    description: {},
    disabled: {},
    validation: {},
    validationMode: { default: "change" },
    variant: { default: "white" },
    accept: {},
    hasDelete: { type: Boolean }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["update:delete"], ["update:modelValue"]),
  setup(e, { expose: t, emit: r }) {
    const n = e, a = Be(e, "modelValue"), i = q(), { errorMessage: o, meta: s, validate: l } = Ke("input", n.validation, {
      validateOnValueUpdate: n.validationMode == "change",
      syncVModel: !0
    }), u = () => {
      n.disabled || i.value.click();
    }, c = () => {
      const d = i.value.files[0];
      a.value = {
        name: d.name.match(/^.+(?=\..+)/g)[0],
        extension: d.name.match(/[^.]+$/g)[0],
        file: d
      };
    }, f = () => {
      i.value.value = null, a.value = void 0, p("update:delete");
    }, p = r;
    return t({
      errorMessage: o,
      meta: s,
      validate: l,
      handleInput: u,
      updateFile: c,
      inputElement: i
    }), (d, m) => (E(), K(dt, he(ct({ layout: d.layout })), {
      default: fe(() => {
        var g, h, y, _, $, v, D;
        return [
          d.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: d.title, tooltip: d.tooltip, size: d.size, disabled: d.disabled })), null, 16)) : B("", !0),
          R("div", {
            class: X(["input-wrapper", [
              `size-${d.size}`,
              `variant-${d.variant}`,
              {
                error: w(o),
                success: (g = a.value) == null ? void 0 : g.name,
                disabled: d.disabled
              }
            ]]),
            onClick: u
          }, [
            d.variant == "white" ? (E(), I("span", Q3)) : B("", !0),
            R("div", eI, [
              R("div", tI, _e((h = a.value) != null && h.name && ((y = a.value) != null && y.extension) ? `${a.value.name}.${a.value.extension}` : d.placeholder), 1)
            ]),
            R("div", rI, [
              (_ = a.value) != null && _.name ? ($ = a.value) != null && $.name && d.hasDelete ? (E(), I("span", {
                key: 1,
                class: "m-cgg-icon--cross",
                onClick: Oo(f, ["stop"])
              })) : (v = a.value) != null && v.name ? (E(), I("span", aI)) : B("", !0) : (E(), I("span", nI))
            ])
          ], 2),
          R("input", ie({ id: d.id }, {
            ref_key: "inputElement",
            ref: i,
            type: "file",
            name: "file-input",
            onChange: c,
            "aria-label": d.label || d.title,
            accept: (D = d.accept) == null ? void 0 : D.map((k) => `.${k}`).join(",")
          }), null, 16, iI),
          d.description ? (E(), K(Yp, he(ie({ key: 1 }, { description: d.description, size: d.size, disabled: d.disabled })), null, 16)) : B("", !0),
          w(o) && d.errorDisplay ? (E(), K(Ge, he(ie({ key: 2 }, { size: d.size, errorMessage: w(o) })), null, 16)) : B("", !0)
        ];
      }),
      _: 1
    }, 16));
  }
});
const sI = /* @__PURE__ */ ye(oI, [["__scopeId", "data-v-dbf3da3d"]]), lI = { class: "number-input-container" }, uI = ["aria-label"], cI = ["disabled"], dI = ["disabled"], fI = /* @__PURE__ */ ue({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    max: {},
    min: { default: 0 },
    step: { default: 1 },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    disabled: {}
  }, {
    modelValue: {
      required: !0,
      default: 0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), K(dt, he(ct({ layout: s.layout })), {
      default: fe(() => [
        s.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: s.title, tooltip: s.tooltip, size: s.size, disabled: s.disabled })), null, 16)) : B("", !0),
        R("div", lI, [
          ze(R("input", ie({
            type: "number",
            "onUpdate:modelValue": l[0] || (l[0] = (u) => n.value = u)
          }, { min: s.min, max: s.max, step: s.step, disabled: s.disabled }, {
            "aria-label": s.label || s.title
          }), null, 16, uI), [
            [Dn, n.value]
          ]),
          R("button", {
            class: "btn-minus",
            disabled: s.disabled || n.value - s.step < s.min,
            onClick: l[1] || (l[1] = (u) => s.$emit("update:modelValue", n.value - s.step)),
            "aria-hidden": ""
          }, null, 8, cI),
          R("div", {
            class: X(["value", { disabled: s.disabled }])
          }, _e(n.value), 3),
          R("button", {
            class: "btn-plus",
            disabled: s.disabled || (s.max ? n.value + s.step > s.max : !1),
            onClick: l[2] || (l[2] = (u) => s.$emit("update:modelValue", n.value + s.step)),
            "aria-hidden": ""
          }, null, 8, dI)
        ]),
        w(a) && s.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: s.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const pI = /* @__PURE__ */ ye(fI, [["__scopeId", "data-v-99fe6c58"]]), vI = { class: "text-container" }, hI = ["aria-label"], mI = /* @__PURE__ */ ue({
  __name: "ToggleInput",
  props: /* @__PURE__ */ Ne({
    size: { default: "md" },
    value: {},
    disabled: {},
    name: {},
    label: {},
    fullWidth: { type: Boolean, default: !0 },
    validation: {},
    errorDisplay: { type: Boolean, default: !0 },
    validationMode: { default: "change" }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    return t({ errorMessage: a, meta: i, validate: o }), (s, l) => (E(), K(dt, { layout: "vertical" }, {
      default: fe(() => [
        R("label", {
          class: X(["input-wrapper", [`size-${s.size}`, { disabled: s.disabled, "full-width": s.fullWidth }]])
        }, [
          R("div", vI, [
            s.$slots.default ? we(s.$slots, "default", { key: 0 }, void 0, !0) : (E(), K(si, { key: 1 }, {
              default: fe(() => [
                Br(_e(s.label), 1)
              ]),
              _: 1
            }))
          ]),
          ze(R("input", ie({
            type: "checkbox",
            "onUpdate:modelValue": l[0] || (l[0] = (u) => n.value = u)
          }, { value: s.value, disabled: s.disabled, name: s.name }, { "aria-label": s.label }), null, 16, hI), [
            [Hc, n.value]
          ]),
          l[1] || (l[1] = R("div", { class: "switch" }, [
            R("div", { class: "thumb" })
          ], -1))
        ], 2),
        w(a) && s.errorDisplay ? (E(), K(Ge, he(ie({ key: 0 }, { size: s.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 3
    }));
  }
});
const gI = /* @__PURE__ */ ye(mI, [["__scopeId", "data-v-f3d2f3e2"]]), yI = ["aria-label"], bI = {
  key: 0,
  class: "label-container"
}, _I = {
  key: 0,
  class: "min"
}, wI = {
  key: 1,
  class: "max"
}, EI = /* @__PURE__ */ ue({
  __name: "SliderInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    disabled: {},
    min: {},
    max: {},
    step: {},
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      required: !0,
      default: 0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), { errorMessage: a, meta: i, validate: o } = Ke("input", r.validation, {
      validateOnValueUpdate: r.validationMode == "change",
      syncVModel: !0
    });
    t({ errorMessage: a, meta: i, validate: o });
    const s = q(), l = O(() => ({
      "--slider-progress-value": (Math.round(n.value / r.step * r.step) - r.min) / (r.max - r.min)
    }));
    return (u, c) => (E(), K(dt, he(ct({ layout: u.layout })), {
      default: fe(() => [
        u.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: u.title, tooltip: u.tooltip, size: u.size, disabled: u.disabled })), null, 16)) : B("", !0),
        R("div", {
          class: X(["input-wrapper", {
            error: w(a)
          }]),
          style: it(l.value)
        }, [
          ze(R("input", ie({
            ref_key: "inputEl",
            ref: s,
            type: "range"
          }, { min: u.min, max: u.max, step: u.step, disabled: u.disabled }, {
            "onUpdate:modelValue": c[0] || (c[0] = (f) => n.value = f),
            "aria-label": u.label || u.title
          }), null, 16, yI), [
            [Dn, n.value]
          ]),
          u.$slots.max || u.$slots.min ? (E(), I("div", bI, [
            u.$slots.min ? (E(), I("div", _I, [
              we(u.$slots, "min", {}, void 0, !0)
            ])) : B("", !0),
            u.$slots.max ? (E(), I("div", wI, [
              we(u.$slots, "max", {}, void 0, !0)
            ])) : B("", !0)
          ])) : B("", !0)
        ], 6),
        w(a) && u.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: u.size, errorMessage: w(a) })), null, 16)) : B("", !0)
      ]),
      _: 3
    }, 16));
  }
});
const TI = /* @__PURE__ */ ye(EI, [["__scopeId", "data-v-b3460d5a"]]), DI = ["aria-label"], $I = { class: "input-currency" }, kI = /* @__PURE__ */ ue({
  __name: "CurrencyInput",
  props: /* @__PURE__ */ Ne({
    title: {},
    label: {},
    tooltip: {},
    placeholder: {},
    layout: { default: "vertical" },
    size: { default: "md" },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 },
    id: {},
    disabled: {},
    currency: { default: "€" }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const r = e, n = Be(e, "modelValue"), a = q(
      typeof n.value == "number" ? Intl.NumberFormat("de").format(n.value) : ""
    );
    be(n, (c) => {
      typeof n.value == "number" && (a.value = Intl.NumberFormat("de").format(c));
    });
    const i = Tn({
      onMaska: (c) => {
        const f = c.unmasked;
        n.value = f && typeof f == "string" ? parseFloat(f) : void 0;
      },
      number: {
        locale: "de",
        fraction: 2,
        unsigned: !0
      }
    }), { errorMessage: o, meta: s, validate: l, handleBlur: u } = Ke(
      "input",
      r.validation,
      {
        validateOnValueUpdate: r.validationMode == "change",
        syncVModel: !0
      }
    );
    return t({ errorMessage: o, meta: s, validate: l }), (c, f) => (E(), K(dt, he(ct({ layout: c.layout })), {
      default: fe(() => [
        c.title ? (E(), K(Pt, he(ie({ key: 0 }, { title: c.title, tooltip: c.tooltip, size: c.size, disabled: c.disabled })), null, 16)) : B("", !0),
        R("div", {
          class: X(["input-wrapper", {
            error: w(o)
          }])
        }, [
          ze(R("input", ie({
            class: [`size-${c.size}`],
            type: "text",
            inputmode: "decimal"
          }, { id: c.id, placeholder: c.placeholder, disabled: c.disabled }, {
            "onUpdate:modelValue": f[0] || (f[0] = (p) => a.value = p),
            onBlur: f[1] || (f[1] = (p) => w(u)(p, c.validationMode == "blur")),
            "aria-label": c.label || c.title
          }), null, 16, DI), [
            [Dn, a.value],
            [w(vi), i]
          ]),
          R("span", $I, _e(c.currency), 1)
        ], 2),
        w(o) && c.errorDisplay ? (E(), K(Ge, he(ie({ key: 1 }, { size: c.size, errorMessage: w(o) })), null, 16)) : B("", !0)
      ]),
      _: 1
    }, 16));
  }
});
const OI = /* @__PURE__ */ ye(kI, [["__scopeId", "data-v-984727f6"]]), CI = ["onClick"], SI = ["type", "value", "checked", "aria-label"], AI = {
  key: 0,
  class: "image-container"
}, MI = ["src", "alt"], II = {
  key: 1,
  class: "text-wrapper"
}, PI = { class: "upper-text" }, xI = { class: "title" }, LI = {
  key: 0,
  class: "description"
}, RI = ["innerHTML"], FI = /* @__PURE__ */ ue({
  __name: "SelectionTiles",
  props: /* @__PURE__ */ Ne({
    name: {},
    icon: { default: "m-cgg-icon--chevron-right" },
    layout: { default: "list" },
    options: {},
    gridColumns: {},
    size: { default: "md" },
    multiselect: { type: Boolean },
    validation: {},
    validationMode: { default: "change" },
    errorDisplay: { type: Boolean, default: !0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["click:option"], ["update:modelValue"]),
  setup(e, { expose: t, emit: r }) {
    const n = e, a = Be(e, "modelValue"), i = O(() => {
      var p, d, m, g, h;
      return {
        "--xs-grid-columns": (p = n.gridColumns) == null ? void 0 : p.xs,
        "--sm-grid-columns": (d = n.gridColumns) == null ? void 0 : d.sm,
        "--md-grid-columns": (m = n.gridColumns) == null ? void 0 : m.md,
        "--lg-grid-columns": (g = n.gridColumns) == null ? void 0 : g.lg,
        "--xl-grid-columns": (h = n.gridColumns) == null ? void 0 : h.xl
      };
    }), { value: o, errorMessage: s, meta: l, validate: u } = Ke(
      "input",
      n.validation,
      {
        validateOnValueUpdate: n.validationMode == "change",
        syncVModel: !0
      }
    ), c = (p) => {
      a.value = (() => {
        if (n.multiselect) {
          const d = [...a.value];
          return d.includes(p) ? d.splice(d.indexOf(p), 1) : d.push(p), d;
        }
        return p;
      })(), f("click:option", p);
    };
    t({ errorMessage: s, meta: l, validate: u });
    const f = r;
    return (p, d) => {
      const m = So("tippy");
      return E(), K(dt, { layout: "vertical" }, {
        default: fe(() => [
          R("div", {
            class: X(["tiles-container", [`layout-${p.layout}`, `size-${p.size}`]]),
            style: it(i.value)
          }, [
            p.options ? (E(!0), I(Ae, { key: 0 }, Re(p.options, (g, h) => ze((E(), I("div", {
              key: h,
              class: X(["tile", {
                active: n.multiselect ? a.value.includes(g.value) : g.value == w(o),
                "has-image": g.image
              }]),
              onClick: (y) => c(g.value)
            }, [
              R("input", ie({
                type: p.multiselect ? "checkbox" : "radio",
                value: g.value,
                checked: p.multiselect ? a.value.includes(g.value) : a.value == g.value,
                "aria-label": g.label,
                ref_for: !0
              }, { name: p.name }), null, 16, SI),
              g.image ? (E(), I("div", AI, [
                R("img", {
                  src: g.image,
                  alt: g.label
                }, null, 8, MI)
              ])) : B("", !0),
              p.layout != "image" || p.layout == "image" && !g.image ? (E(), I("div", II, [
                R("div", PI, [
                  R("span", xI, _e(g.label), 1),
                  g.description ? (E(), I("span", LI, _e(g.description), 1)) : B("", !0)
                ]),
                g.descriptionLong && p.layout == "list" ? (E(), I("div", {
                  key: 0,
                  class: "long-description",
                  innerHTML: g.descriptionLong
                }, null, 8, RI)) : B("", !0)
              ])) : B("", !0),
              p.layout == "list" && p.icon ? (E(), I("span", {
                key: 2,
                class: X([p.icon, "icon"])
              }, null, 2)) : B("", !0)
            ], 10, CI)), [
              [m, g.tooltip ? { content: g.tooltip } : void 0]
            ])), 128)) : B("", !0)
          ], 6),
          w(s) && p.errorDisplay ? (E(), K(Ge, he(ie({ key: 0 }, { errorMessage: w(s) })), null, 16)) : B("", !0)
        ]),
        _: 1
      });
    };
  }
});
const VI = /* @__PURE__ */ ye(FI, [["__scopeId", "data-v-065f08d2"]]), Dc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CheckboxInput: Ds,
  CheckboxInputList: Np,
  CjaButton: Pv,
  CollapseContainer: ah,
  ContentTabs: Yv,
  CurrencyInput: OI,
  DateInput: _3,
  Drawer: Cv,
  FileInput: sI,
  FixedContainer: oh,
  GridContainer: Qv,
  GridItem: th,
  InfoMessage: qv,
  InputError: Ge,
  InputTitle: Pt,
  LoadingSpinner: Lv,
  Modal: kv,
  NumberInput: pI,
  PhoneInput: N3,
  RadioInput: jp,
  RadioInputList: H3,
  Scaffold: si,
  SelectInput: Bp,
  SelectionTiles: VI,
  SliderInput: TI,
  StickyContainer: fm,
  TextInput: uf,
  TextareaInput: $y,
  TileCheckboxInput: J3,
  ToggleInput: gI
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * vue-tippy v6.5.0
  * (c) 2024 
  * @license MIT
  */
var lt = "top", At = "bottom", Mt = "right", ut = "left", $s = "auto", wa = [lt, At, Mt, ut], hn = "start", fa = "end", NI = "clippingParents", zp = "viewport", Un = "popper", BI = "reference", $c = /* @__PURE__ */ wa.reduce(function(e, t) {
  return e.concat([t + "-" + hn, t + "-" + fa]);
}, []), Up = /* @__PURE__ */ [].concat(wa, [$s]).reduce(function(e, t) {
  return e.concat([t, t + "-" + hn, t + "-" + fa]);
}, []), YI = "beforeRead", jI = "read", zI = "afterRead", UI = "beforeMain", HI = "main", WI = "afterMain", qI = "beforeWrite", KI = "write", GI = "afterWrite", ZI = [YI, jI, zI, UI, HI, WI, qI, KI, GI];
function Xt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function jt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function mn(e) {
  var t = jt(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ot(e) {
  var t = jt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Hp(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = jt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function XI(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !Ot(i) || !Xt(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function JI(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Ot(a) || !Xt(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
var Wp = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: XI,
  effect: JI,
  requires: ["computeStyles"]
};
function Gt(e) {
  return e.split("-")[0];
}
var Pr = Math.max, ii = Math.min, gn = Math.round;
function yn(e, t) {
  t === void 0 && (t = !1);
  var r = e.getBoundingClientRect(), n = 1, a = 1;
  if (Ot(e) && t) {
    var i = e.offsetHeight, o = e.offsetWidth;
    o > 0 && (n = gn(r.width) / o || 1), i > 0 && (a = gn(r.height) / i || 1);
  }
  return {
    width: r.width / n,
    height: r.height / a,
    top: r.top / a,
    right: r.right / n,
    bottom: r.bottom / a,
    left: r.left / n,
    x: r.left / n,
    y: r.top / a
  };
}
function ks(e) {
  var t = yn(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function qp(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Hp(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Jt(e) {
  return jt(e).getComputedStyle(e);
}
function QI(e) {
  return ["table", "td", "th"].indexOf(Xt(e)) >= 0;
}
function Tr(e) {
  return ((mn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ti(e) {
  return Xt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Hp(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Tr(e)
  );
}
function kc(e) {
  return !Ot(e) || // https://github.com/popperjs/popper-core/issues/837
  Jt(e).position === "fixed" ? null : e.offsetParent;
}
function eP(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && Ot(e)) {
    var n = Jt(e);
    if (n.position === "fixed")
      return null;
  }
  for (var a = Ti(e); Ot(a) && ["html", "body"].indexOf(Xt(a)) < 0; ) {
    var i = Jt(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Ea(e) {
  for (var t = jt(e), r = kc(e); r && QI(r) && Jt(r).position === "static"; )
    r = kc(r);
  return r && (Xt(r) === "html" || Xt(r) === "body" && Jt(r).position === "static") ? t : r || eP(e) || t;
}
function Os(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function ta(e, t, r) {
  return Pr(e, ii(t, r));
}
function tP(e, t, r) {
  var n = ta(e, t, r);
  return n > r ? r : n;
}
function Kp() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Gp(e) {
  return Object.assign({}, Kp(), e);
}
function Zp(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var rP = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Gp(typeof t != "number" ? t : Zp(t, wa));
};
function nP(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = Gt(r.placement), l = Os(s), u = [ut, Mt].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var f = rP(a.padding, r), p = ks(i), d = l === "y" ? lt : ut, m = l === "y" ? At : Mt, g = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], h = o[l] - r.rects.reference[l], y = Ea(i), _ = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, $ = g / 2 - h / 2, v = f[d], D = _ - p[c] - f[m], k = _ / 2 - p[c] / 2 + $, T = ta(v, k, D), C = l;
    r.modifiersData[n] = (t = {}, t[C] = T, t.centerOffset = T - k, t);
  }
}
function aP(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || qp(t.elements.popper, a) && (t.elements.arrow = a));
}
var iP = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: nP,
  effect: aP,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function bn(e) {
  return e.split("-")[1];
}
var oP = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function sP(e) {
  var t = e.x, r = e.y, n = window, a = n.devicePixelRatio || 1;
  return {
    x: gn(t * a) / a || 0,
    y: gn(r * a) / a || 0
  };
}
function Oc(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, f = e.isFixed, p = c === !0 ? sP(o) : typeof c == "function" ? c(o) : o, d = p.x, m = d === void 0 ? 0 : d, g = p.y, h = g === void 0 ? 0 : g, y = o.hasOwnProperty("x"), _ = o.hasOwnProperty("y"), $ = ut, v = lt, D = window;
  if (u) {
    var k = Ea(r), T = "clientHeight", C = "clientWidth";
    if (k === jt(r) && (k = Tr(r), Jt(k).position !== "static" && s === "absolute" && (T = "scrollHeight", C = "scrollWidth")), k = k, a === lt || (a === ut || a === Mt) && i === fa) {
      v = At;
      var V = f && D.visualViewport ? D.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[T]
      );
      h -= V - n.height, h *= l ? 1 : -1;
    }
    if (a === ut || (a === lt || a === At) && i === fa) {
      $ = Mt;
      var H = f && D.visualViewport ? D.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[C]
      );
      m -= H - n.width, m *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: s
  }, u && oP);
  if (l) {
    var L;
    return Object.assign({}, N, (L = {}, L[v] = _ ? "0" : "", L[$] = y ? "0" : "", L.transform = (D.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + h + "px)" : "translate3d(" + m + "px, " + h + "px, 0)", L));
  }
  return Object.assign({}, N, (t = {}, t[v] = _ ? h + "px" : "", t[$] = y ? m + "px" : "", t.transform = "", t));
}
function lP(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Gt(t.placement),
    variation: bn(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Oc(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Oc(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var uP = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: lP,
  data: {}
}, Ma = {
  passive: !0
};
function cP(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, s = o === void 0 ? !0 : o, l = jt(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", r.update, Ma);
  }), s && l.addEventListener("resize", r.update, Ma), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", r.update, Ma);
    }), s && l.removeEventListener("resize", r.update, Ma);
  };
}
var dP = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: cP,
  data: {}
}, fP = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ua(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return fP[t];
  });
}
var pP = {
  start: "end",
  end: "start"
};
function Cc(e) {
  return e.replace(/start|end/g, function(t) {
    return pP[t];
  });
}
function Cs(e) {
  var t = jt(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Ss(e) {
  return yn(Tr(e)).left + Cs(e).scrollLeft;
}
function vP(e) {
  var t = jt(e), r = Tr(e), n = t.visualViewport, a = r.clientWidth, i = r.clientHeight, o = 0, s = 0;
  return n && (a = n.width, i = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (o = n.offsetLeft, s = n.offsetTop)), {
    width: a,
    height: i,
    x: o + Ss(e),
    y: s
  };
}
function hP(e) {
  var t, r = Tr(e), n = Cs(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Pr(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Pr(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + Ss(e), l = -n.scrollTop;
  return Jt(a || r).direction === "rtl" && (s += Pr(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function As(e) {
  var t = Jt(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function Xp(e) {
  return ["html", "body", "#document"].indexOf(Xt(e)) >= 0 ? e.ownerDocument.body : Ot(e) && As(e) ? e : Xp(Ti(e));
}
function ra(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Xp(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = jt(n), o = a ? [i].concat(i.visualViewport || [], As(n) ? n : []) : n, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(ra(Ti(o)))
  );
}
function Eo(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function mP(e) {
  var t = yn(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Sc(e, t) {
  return t === zp ? Eo(vP(e)) : mn(t) ? mP(t) : Eo(hP(Tr(e)));
}
function gP(e) {
  var t = ra(Ti(e)), r = ["absolute", "fixed"].indexOf(Jt(e).position) >= 0, n = r && Ot(e) ? Ea(e) : e;
  return mn(n) ? t.filter(function(a) {
    return mn(a) && qp(a, n) && Xt(a) !== "body" && (r ? Jt(a).position !== "static" : !0);
  }) : [];
}
function yP(e, t, r) {
  var n = t === "clippingParents" ? gP(e) : [].concat(t), a = [].concat(n, [r]), i = a[0], o = a.reduce(function(s, l) {
    var u = Sc(e, l);
    return s.top = Pr(u.top, s.top), s.right = ii(u.right, s.right), s.bottom = ii(u.bottom, s.bottom), s.left = Pr(u.left, s.left), s;
  }, Sc(e, i));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function Jp(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? Gt(n) : null, i = n ? bn(n) : null, o = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (a) {
    case lt:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case At:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Mt:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case ut:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = a ? Os(a) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case hn:
        l[u] = l[u] - (t[c] / 2 - r[c] / 2);
        break;
      case fa:
        l[u] = l[u] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function pa(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.boundary, o = i === void 0 ? NI : i, s = r.rootBoundary, l = s === void 0 ? zp : s, u = r.elementContext, c = u === void 0 ? Un : u, f = r.altBoundary, p = f === void 0 ? !1 : f, d = r.padding, m = d === void 0 ? 0 : d, g = Gp(typeof m != "number" ? m : Zp(m, wa)), h = c === Un ? BI : Un, y = e.rects.popper, _ = e.elements[p ? h : c], $ = yP(mn(_) ? _ : _.contextElement || Tr(e.elements.popper), o, l), v = yn(e.elements.reference), D = Jp({
    reference: v,
    element: y,
    strategy: "absolute",
    placement: a
  }), k = Eo(Object.assign({}, y, D)), T = c === Un ? k : v, C = {
    top: $.top - T.top + g.top,
    bottom: T.bottom - $.bottom + g.bottom,
    left: $.left - T.left + g.left,
    right: T.right - $.right + g.right
  }, V = e.modifiersData.offset;
  if (c === Un && V) {
    var H = V[a];
    Object.keys(C).forEach(function(N) {
      var L = [Mt, At].indexOf(N) >= 0 ? 1 : -1, U = [lt, At].indexOf(N) >= 0 ? "y" : "x";
      C[N] += H[U] * L;
    });
  }
  return C;
}
function bP(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, u = l === void 0 ? Up : l, c = bn(n), f = c ? s ? $c : $c.filter(function(m) {
    return bn(m) === c;
  }) : wa, p = f.filter(function(m) {
    return u.indexOf(m) >= 0;
  });
  p.length === 0 && (p = f);
  var d = p.reduce(function(m, g) {
    return m[g] = pa(e, {
      placement: g,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[Gt(g)], m;
  }, {});
  return Object.keys(d).sort(function(m, g) {
    return d[m] - d[g];
  });
}
function _P(e) {
  if (Gt(e) === $s)
    return [];
  var t = Ua(e);
  return [Cc(e), t, Cc(t)];
}
function wP(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !0 : o, l = r.fallbackPlacements, u = r.padding, c = r.boundary, f = r.rootBoundary, p = r.altBoundary, d = r.flipVariations, m = d === void 0 ? !0 : d, g = r.allowedAutoPlacements, h = t.options.placement, y = Gt(h), _ = y === h, $ = l || (_ || !m ? [Ua(h)] : _P(h)), v = [h].concat($).reduce(function(ee, me) {
      return ee.concat(Gt(me) === $s ? bP(t, {
        placement: me,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : me);
    }, []), D = t.rects.reference, k = t.rects.popper, T = /* @__PURE__ */ new Map(), C = !0, V = v[0], H = 0; H < v.length; H++) {
      var N = v[H], L = Gt(N), U = bn(N) === hn, J = [lt, At].indexOf(L) >= 0, W = J ? "width" : "height", Q = pa(t, {
        placement: N,
        boundary: c,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), Y = J ? U ? Mt : ut : U ? At : lt;
      D[W] > k[W] && (Y = Ua(Y));
      var pe = Ua(Y), se = [];
      if (i && se.push(Q[L] <= 0), s && se.push(Q[Y] <= 0, Q[pe] <= 0), se.every(function(ee) {
        return ee;
      })) {
        V = N, C = !1;
        break;
      }
      T.set(N, se);
    }
    if (C)
      for (var P = m ? 3 : 1, ae = function(me) {
        var j = v.find(function(te) {
          var de = T.get(te);
          if (de)
            return de.slice(0, me).every(function(ce) {
              return ce;
            });
        });
        if (j)
          return V = j, "break";
      }, z = P; z > 0; z--) {
        var ge = ae(z);
        if (ge === "break")
          break;
      }
    t.placement !== V && (t.modifiersData[n]._skip = !0, t.placement = V, t.reset = !0);
  }
}
var EP = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: wP,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ac(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Mc(e) {
  return [lt, Mt, At, ut].some(function(t) {
    return e[t] >= 0;
  });
}
function TP(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = pa(t, {
    elementContext: "reference"
  }), s = pa(t, {
    altBoundary: !0
  }), l = Ac(o, n), u = Ac(s, a, i), c = Mc(l), f = Mc(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
var DP = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: TP
};
function $P(e, t, r) {
  var n = Gt(e), a = [ut, lt].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [ut, Mt].indexOf(n) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function kP(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = Up.reduce(function(c, f) {
    return c[f] = $P(f, t.rects, i), c;
  }, {}), s = o[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = o;
}
var OP = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: kP
};
function CP(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Jp({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
var SP = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: CP,
  data: {}
};
function AP(e) {
  return e === "x" ? "y" : "x";
}
function MP(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !1 : o, l = r.boundary, u = r.rootBoundary, c = r.altBoundary, f = r.padding, p = r.tether, d = p === void 0 ? !0 : p, m = r.tetherOffset, g = m === void 0 ? 0 : m, h = pa(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), y = Gt(t.placement), _ = bn(t.placement), $ = !_, v = Os(y), D = AP(v), k = t.modifiersData.popperOffsets, T = t.rects.reference, C = t.rects.popper, V = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, H = typeof V == "number" ? {
    mainAxis: V,
    altAxis: V
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, V), N = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var U, J = v === "y" ? lt : ut, W = v === "y" ? At : Mt, Q = v === "y" ? "height" : "width", Y = k[v], pe = Y + h[J], se = Y - h[W], P = d ? -C[Q] / 2 : 0, ae = _ === hn ? T[Q] : C[Q], z = _ === hn ? -C[Q] : -T[Q], ge = t.elements.arrow, ee = d && ge ? ks(ge) : {
        width: 0,
        height: 0
      }, me = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Kp(), j = me[J], te = me[W], de = ta(0, T[Q], ee[Q]), ce = $ ? T[Q] / 2 - P - de - j - H.mainAxis : ae - de - j - H.mainAxis, Se = $ ? -T[Q] / 2 + P + de + te + H.mainAxis : z + de + te + H.mainAxis, ke = t.elements.arrow && Ea(t.elements.arrow), Oe = ke ? v === "y" ? ke.clientTop || 0 : ke.clientLeft || 0 : 0, Fe = (U = N == null ? void 0 : N[v]) != null ? U : 0, ft = Y + ce - Fe - Oe, xt = Y + Se - Fe, Ue = ta(d ? ii(pe, ft) : pe, Y, d ? Pr(se, xt) : se);
      k[v] = Ue, L[v] = Ue - Y;
    }
    if (s) {
      var pt, wt = v === "x" ? lt : ut, Et = v === "x" ? At : Mt, Ie = k[D], Ye = D === "y" ? "height" : "width", et = Ie + h[wt], He = Ie - h[Et], tt = [lt, ut].indexOf(y) !== -1, vt = (pt = N == null ? void 0 : N[D]) != null ? pt : 0, ht = tt ? et : Ie - T[Ye] - C[Ye] - vt + H.altAxis, Tt = tt ? Ie + T[Ye] + C[Ye] - vt - H.altAxis : He, Lt = d && tt ? tP(ht, Ie, Tt) : ta(d ? ht : et, Ie, d ? Tt : He);
      k[D] = Lt, L[D] = Lt - Ie;
    }
    t.modifiersData[n] = L;
  }
}
var IP = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: MP,
  requiresIfExists: ["offset"]
};
function PP(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function xP(e) {
  return e === jt(e) || !Ot(e) ? Cs(e) : PP(e);
}
function LP(e) {
  var t = e.getBoundingClientRect(), r = gn(t.width) / e.offsetWidth || 1, n = gn(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function RP(e, t, r) {
  r === void 0 && (r = !1);
  var n = Ot(t), a = Ot(t) && LP(t), i = Tr(t), o = yn(e, a), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Xt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  As(i)) && (s = xP(t)), Ot(t) ? (l = yn(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Ss(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function FP(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function VP(e) {
  var t = FP(e);
  return ZI.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function NP(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function BP(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ic = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Pc() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function YP(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? Ic : a;
  return function(s, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ic, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, d = {
      state: c,
      setOptions: function(y) {
        var _ = typeof y == "function" ? y(c.options) : y;
        g(), c.options = Object.assign({}, i, c.options, _), c.scrollParents = {
          reference: mn(s) ? ra(s) : s.contextElement ? ra(s.contextElement) : [],
          popper: ra(l)
        };
        var $ = VP(BP([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = $.filter(function(v) {
          return v.enabled;
        }), m(), d.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var y = c.elements, _ = y.reference, $ = y.popper;
          if (Pc(_, $)) {
            c.rects = {
              reference: RP(_, Ea($), c.options.strategy === "fixed"),
              popper: ks($)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(H) {
              return c.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var D = c.orderedModifiers[v], k = D.fn, T = D.options, C = T === void 0 ? {} : T, V = D.name;
              typeof k == "function" && (c = k({
                state: c,
                options: C,
                name: V,
                instance: d
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: NP(function() {
        return new Promise(function(h) {
          d.forceUpdate(), h(c);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!Pc(s, l))
      return d;
    d.setOptions(u).then(function(h) {
      !p && u.onFirstUpdate && u.onFirstUpdate(h);
    });
    function m() {
      c.orderedModifiers.forEach(function(h) {
        var y = h.name, _ = h.options, $ = _ === void 0 ? {} : _, v = h.effect;
        if (typeof v == "function") {
          var D = v({
            state: c,
            name: y,
            instance: d,
            options: $
          }), k = function() {
          };
          f.push(D || k);
        }
      });
    }
    function g() {
      f.forEach(function(h) {
        return h();
      }), f = [];
    }
    return d;
  };
}
var jP = [dP, SP, uP, Wp, OP, EP, IP, iP, DP], zP = /* @__PURE__ */ YP({
  defaultModifiers: jP
}), UP = "tippy-box", Qp = "tippy-content", ev = "tippy-backdrop", tv = "tippy-arrow", rv = "tippy-svg-arrow", kr = {
  passive: !0,
  capture: !0
}, nv = function() {
  return document.body;
};
function Bi(e, t, r) {
  if (Array.isArray(e)) {
    var n = e[t];
    return n ?? (Array.isArray(r) ? r[t] : r);
  }
  return e;
}
function Ms(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function av(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function xc(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(n) {
    clearTimeout(r), r = setTimeout(function() {
      e(n);
    }, t);
  };
}
function HP(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(n) {
    delete r[n];
  }), r;
}
function WP(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Or(e) {
  return [].concat(e);
}
function Lc(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function qP(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function iv(e) {
  return e.split("-")[0];
}
function _n(e) {
  return [].slice.call(e);
}
function Rc(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function xr() {
  return document.createElement("div");
}
function Di(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Ms(e, t);
  });
}
function KP(e) {
  return Ms(e, "NodeList");
}
function Is(e) {
  return Ms(e, "MouseEvent");
}
function GP(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function ZP(e) {
  return Di(e) ? [e] : KP(e) ? _n(e) : Array.isArray(e) ? e : _n(document.querySelectorAll(e));
}
function Yi(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function va(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function ov(e) {
  var t, r = Or(e), n = r[0];
  return n != null && (t = n.ownerDocument) != null && t.body ? n.ownerDocument : document;
}
function XP(e, t) {
  var r = t.clientX, n = t.clientY;
  return e.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, l = s.interactiveBorder, u = iv(o.placement), c = o.modifiersData.offset;
    if (!c)
      return !0;
    var f = u === "bottom" ? c.top.y : 0, p = u === "top" ? c.bottom.y : 0, d = u === "right" ? c.left.x : 0, m = u === "left" ? c.right.x : 0, g = i.top - n + f > l, h = n - i.bottom - p > l, y = i.left - r + d > l, _ = r - i.right - m > l;
    return g || h || y || _;
  });
}
function ji(e, t, r) {
  var n = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    e[n](a, r);
  });
}
function Fc(e, t) {
  for (var r = t; r; ) {
    var n;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (n = r.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var Ht = {
  isTouch: !1
}, Vc = 0;
function JP() {
  Ht.isTouch || (Ht.isTouch = !0, window.performance && document.addEventListener("mousemove", sv));
}
function sv() {
  var e = performance.now();
  e - Vc < 20 && (Ht.isTouch = !1, document.removeEventListener("mousemove", sv)), Vc = e;
}
function QP() {
  var e = document.activeElement;
  if (GP(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function e4() {
  document.addEventListener("touchstart", JP, kr), window.addEventListener("blur", QP);
}
var t4 = typeof window < "u" && typeof document < "u", r4 = t4 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, n4 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, a4 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Vt = Object.assign({
  appendTo: nv,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, n4, a4), i4 = Object.keys(Vt), o4 = function(t) {
  var r = Object.keys(t);
  r.forEach(function(n) {
    Vt[n] = t[n];
  });
};
function lv(e) {
  var t = e.plugins || [], r = t.reduce(function(n, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      n[i] = e[i] !== void 0 ? e[i] : (s = Vt[i]) != null ? s : o;
    }
    return n;
  }, {});
  return Object.assign({}, e, r);
}
function s4(e, t) {
  var r = t ? Object.keys(lv(Object.assign({}, Vt, {
    plugins: t
  }))) : i4, n = r.reduce(function(a, i) {
    var o = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return n;
}
function Nc(e, t) {
  var r = Object.assign({}, t, {
    content: av(t.content, [e])
  }, t.ignoreAttributes ? {} : s4(e, t.plugins));
  return r.aria = Object.assign({}, Vt.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
var l4 = function() {
  return "innerHTML";
};
function To(e, t) {
  e[l4()] = t;
}
function Bc(e) {
  var t = xr();
  return e === !0 ? t.className = tv : (t.className = rv, Di(e) ? t.appendChild(e) : To(t, e)), t;
}
function Yc(e, t) {
  Di(t.content) ? (To(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? To(e, t.content) : e.textContent = t.content);
}
function oi(e) {
  var t = e.firstElementChild, r = _n(t.children);
  return {
    box: t,
    content: r.find(function(n) {
      return n.classList.contains(Qp);
    }),
    arrow: r.find(function(n) {
      return n.classList.contains(tv) || n.classList.contains(rv);
    }),
    backdrop: r.find(function(n) {
      return n.classList.contains(ev);
    })
  };
}
function uv(e) {
  var t = xr(), r = xr();
  r.className = UP, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var n = xr();
  n.className = Qp, n.setAttribute("data-state", "hidden"), Yc(n, e.props), t.appendChild(r), r.appendChild(n), a(e.props, e.props);
  function a(i, o) {
    var s = oi(t), l = s.box, u = s.content, c = s.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (i.content !== o.content || i.allowHTML !== o.allowHTML) && Yc(u, e.props), o.arrow ? c ? i.arrow !== o.arrow && (l.removeChild(c), l.appendChild(Bc(o.arrow))) : l.appendChild(Bc(o.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: t,
    onUpdate: a
  };
}
uv.$$tippy = !0;
var u4 = 1, Ia = [], zi = [];
function c4(e, t) {
  var r = Nc(e, Object.assign({}, Vt, lv(Rc(t)))), n, a, i, o = !1, s = !1, l = !1, u = !1, c, f, p, d = [], m = xc(ft, r.interactiveDebounce), g, h = u4++, y = null, _ = qP(r.plugins), $ = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, v = {
    // properties
    id: h,
    reference: e,
    popper: xr(),
    popperInstance: y,
    props: r,
    state: $,
    plugins: _,
    // methods
    clearDelayTimeouts: ht,
    setProps: Tt,
    setContent: Lt,
    show: Ln,
    hide: Dr,
    hideWithInteractivity: Rn,
    enable: tt,
    disable: vt,
    unmount: qr,
    destroy: Kr
  };
  if (!r.render)
    return v;
  var D = r.render(v), k = D.popper, T = D.onUpdate;
  k.setAttribute("data-tippy-root", ""), k.id = "tippy-" + v.id, v.popper = k, e._tippy = v, k._tippy = v;
  var C = _.map(function(A) {
    return A.fn(v);
  }), V = e.hasAttribute("aria-expanded");
  return ke(), P(), Y(), pe("onCreate", [v]), r.showOnCreate && et(), k.addEventListener("mouseenter", function() {
    v.props.interactive && v.state.isVisible && v.clearDelayTimeouts();
  }), k.addEventListener("mouseleave", function() {
    v.props.interactive && v.props.trigger.indexOf("mouseenter") >= 0 && J().addEventListener("mousemove", m);
  }), v;
  function H() {
    var A = v.props.touch;
    return Array.isArray(A) ? A : [A, 0];
  }
  function N() {
    return H()[0] === "hold";
  }
  function L() {
    var A;
    return !!((A = v.props.render) != null && A.$$tippy);
  }
  function U() {
    return g || e;
  }
  function J() {
    var A = U().parentNode;
    return A ? ov(A) : document;
  }
  function W() {
    return oi(k);
  }
  function Q(A) {
    return v.state.isMounted && !v.state.isVisible || Ht.isTouch || c && c.type === "focus" ? 0 : Bi(v.props.delay, A ? 0 : 1, Vt.delay);
  }
  function Y(A) {
    A === void 0 && (A = !1), k.style.pointerEvents = v.props.interactive && !A ? "" : "none", k.style.zIndex = "" + v.props.zIndex;
  }
  function pe(A, Z, oe) {
    if (oe === void 0 && (oe = !0), C.forEach(function(b) {
      b[A] && b[A].apply(b, Z);
    }), oe) {
      var S;
      (S = v.props)[A].apply(S, Z);
    }
  }
  function se() {
    var A = v.props.aria;
    if (A.content) {
      var Z = "aria-" + A.content, oe = k.id, S = Or(v.props.triggerTarget || e);
      S.forEach(function(b) {
        var M = b.getAttribute(Z);
        if (v.state.isVisible)
          b.setAttribute(Z, M ? M + " " + oe : oe);
        else {
          var F = M && M.replace(oe, "").trim();
          F ? b.setAttribute(Z, F) : b.removeAttribute(Z);
        }
      });
    }
  }
  function P() {
    if (!(V || !v.props.aria.expanded)) {
      var A = Or(v.props.triggerTarget || e);
      A.forEach(function(Z) {
        v.props.interactive ? Z.setAttribute("aria-expanded", v.state.isVisible && Z === U() ? "true" : "false") : Z.removeAttribute("aria-expanded");
      });
    }
  }
  function ae() {
    J().removeEventListener("mousemove", m), Ia = Ia.filter(function(A) {
      return A !== m;
    });
  }
  function z(A) {
    if (!(Ht.isTouch && (l || A.type === "mousedown"))) {
      var Z = A.composedPath && A.composedPath()[0] || A.target;
      if (!(v.props.interactive && Fc(k, Z))) {
        if (Or(v.props.triggerTarget || e).some(function(oe) {
          return Fc(oe, Z);
        })) {
          if (Ht.isTouch || v.state.isVisible && v.props.trigger.indexOf("click") >= 0)
            return;
        } else
          pe("onClickOutside", [v, A]);
        v.props.hideOnClick === !0 && (v.clearDelayTimeouts(), v.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), v.state.isMounted || j());
      }
    }
  }
  function ge() {
    l = !0;
  }
  function ee() {
    l = !1;
  }
  function me() {
    var A = J();
    A.addEventListener("mousedown", z, !0), A.addEventListener("touchend", z, kr), A.addEventListener("touchstart", ee, kr), A.addEventListener("touchmove", ge, kr);
  }
  function j() {
    var A = J();
    A.removeEventListener("mousedown", z, !0), A.removeEventListener("touchend", z, kr), A.removeEventListener("touchstart", ee, kr), A.removeEventListener("touchmove", ge, kr);
  }
  function te(A, Z) {
    ce(A, function() {
      !v.state.isVisible && k.parentNode && k.parentNode.contains(k) && Z();
    });
  }
  function de(A, Z) {
    ce(A, Z);
  }
  function ce(A, Z) {
    var oe = W().box;
    function S(b) {
      b.target === oe && (ji(oe, "remove", S), Z());
    }
    if (A === 0)
      return Z();
    ji(oe, "remove", f), ji(oe, "add", S), f = S;
  }
  function Se(A, Z, oe) {
    oe === void 0 && (oe = !1);
    var S = Or(v.props.triggerTarget || e);
    S.forEach(function(b) {
      b.addEventListener(A, Z, oe), d.push({
        node: b,
        eventType: A,
        handler: Z,
        options: oe
      });
    });
  }
  function ke() {
    N() && (Se("touchstart", Fe, {
      passive: !0
    }), Se("touchend", xt, {
      passive: !0
    })), WP(v.props.trigger).forEach(function(A) {
      if (A !== "manual")
        switch (Se(A, Fe), A) {
          case "mouseenter":
            Se("mouseleave", xt);
            break;
          case "focus":
            Se(r4 ? "focusout" : "blur", Ue);
            break;
          case "focusin":
            Se("focusout", Ue);
            break;
        }
    });
  }
  function Oe() {
    d.forEach(function(A) {
      var Z = A.node, oe = A.eventType, S = A.handler, b = A.options;
      Z.removeEventListener(oe, S, b);
    }), d = [];
  }
  function Fe(A) {
    var Z, oe = !1;
    if (!(!v.state.isEnabled || pt(A) || s)) {
      var S = ((Z = c) == null ? void 0 : Z.type) === "focus";
      c = A, g = A.currentTarget, P(), !v.state.isVisible && Is(A) && Ia.forEach(function(b) {
        return b(A);
      }), A.type === "click" && (v.props.trigger.indexOf("mouseenter") < 0 || o) && v.props.hideOnClick !== !1 && v.state.isVisible ? oe = !0 : et(A), A.type === "click" && (o = !oe), oe && !S && He(A);
    }
  }
  function ft(A) {
    var Z = A.target, oe = U().contains(Z) || k.contains(Z);
    if (!(A.type === "mousemove" && oe)) {
      var S = Ye().concat(k).map(function(b) {
        var M, F = b._tippy, le = (M = F.popperInstance) == null ? void 0 : M.state;
        return le ? {
          popperRect: b.getBoundingClientRect(),
          popperState: le,
          props: r
        } : null;
      }).filter(Boolean);
      XP(S, A) && (ae(), He(A));
    }
  }
  function xt(A) {
    var Z = pt(A) || v.props.trigger.indexOf("click") >= 0 && o;
    if (!Z) {
      if (v.props.interactive) {
        v.hideWithInteractivity(A);
        return;
      }
      He(A);
    }
  }
  function Ue(A) {
    v.props.trigger.indexOf("focusin") < 0 && A.target !== U() || v.props.interactive && A.relatedTarget && k.contains(A.relatedTarget) || He(A);
  }
  function pt(A) {
    return Ht.isTouch ? N() !== A.type.indexOf("touch") >= 0 : !1;
  }
  function wt() {
    Et();
    var A = v.props, Z = A.popperOptions, oe = A.placement, S = A.offset, b = A.getReferenceClientRect, M = A.moveTransition, F = L() ? oi(k).arrow : null, le = b ? {
      getBoundingClientRect: b,
      contextElement: b.contextElement || U()
    } : e, De = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Rt) {
        var mt = Rt.state;
        if (L()) {
          var Fn = W(), Ve = Fn.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(cr) {
            cr === "placement" ? Ve.setAttribute("data-placement", mt.placement) : mt.attributes.popper["data-popper-" + cr] ? Ve.setAttribute("data-" + cr, "") : Ve.removeAttribute("data-" + cr);
          }), mt.attributes.popper = {};
        }
      }
    }, Me = [{
      name: "offset",
      options: {
        offset: S
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !M
      }
    }, De];
    L() && F && Me.push({
      name: "arrow",
      options: {
        element: F,
        padding: 3
      }
    }), Me.push.apply(Me, (Z == null ? void 0 : Z.modifiers) || []), v.popperInstance = zP(le, k, Object.assign({}, Z, {
      placement: oe,
      onFirstUpdate: p,
      modifiers: Me
    }));
  }
  function Et() {
    v.popperInstance && (v.popperInstance.destroy(), v.popperInstance = null);
  }
  function Ie() {
    var A = v.props.appendTo, Z, oe = U();
    v.props.interactive && A === nv || A === "parent" ? Z = oe.parentNode : Z = av(A, [oe]), Z.contains(k) || Z.appendChild(k), v.state.isMounted = !0, wt();
  }
  function Ye() {
    return _n(k.querySelectorAll("[data-tippy-root]"));
  }
  function et(A) {
    v.clearDelayTimeouts(), A && pe("onTrigger", [v, A]), me();
    var Z = Q(!0), oe = H(), S = oe[0], b = oe[1];
    Ht.isTouch && S === "hold" && b && (Z = b), Z ? n = setTimeout(function() {
      v.show();
    }, Z) : v.show();
  }
  function He(A) {
    if (v.clearDelayTimeouts(), pe("onUntrigger", [v, A]), !v.state.isVisible) {
      j();
      return;
    }
    if (!(v.props.trigger.indexOf("mouseenter") >= 0 && v.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(A.type) >= 0 && o)) {
      var Z = Q(!1);
      Z ? a = setTimeout(function() {
        v.state.isVisible && v.hide();
      }, Z) : i = requestAnimationFrame(function() {
        v.hide();
      });
    }
  }
  function tt() {
    v.state.isEnabled = !0;
  }
  function vt() {
    v.hide(), v.state.isEnabled = !1;
  }
  function ht() {
    clearTimeout(n), clearTimeout(a), cancelAnimationFrame(i);
  }
  function Tt(A) {
    if (!v.state.isDestroyed) {
      pe("onBeforeUpdate", [v, A]), Oe();
      var Z = v.props, oe = Nc(e, Object.assign({}, Z, Rc(A), {
        ignoreAttributes: !0
      }));
      v.props = oe, ke(), Z.interactiveDebounce !== oe.interactiveDebounce && (ae(), m = xc(ft, oe.interactiveDebounce)), Z.triggerTarget && !oe.triggerTarget ? Or(Z.triggerTarget).forEach(function(S) {
        S.removeAttribute("aria-expanded");
      }) : oe.triggerTarget && e.removeAttribute("aria-expanded"), P(), Y(), T && T(Z, oe), v.popperInstance && (wt(), Ye().forEach(function(S) {
        requestAnimationFrame(S._tippy.popperInstance.forceUpdate);
      })), pe("onAfterUpdate", [v, A]);
    }
  }
  function Lt(A) {
    v.setProps({
      content: A
    });
  }
  function Ln() {
    var A = v.state.isVisible, Z = v.state.isDestroyed, oe = !v.state.isEnabled, S = Ht.isTouch && !v.props.touch, b = Bi(v.props.duration, 0, Vt.duration);
    if (!(A || Z || oe || S) && !U().hasAttribute("disabled") && (pe("onShow", [v], !1), v.props.onShow(v) !== !1)) {
      if (v.state.isVisible = !0, L() && (k.style.visibility = "visible"), Y(), me(), v.state.isMounted || (k.style.transition = "none"), L()) {
        var M = W(), F = M.box, le = M.content;
        Yi([F, le], 0);
      }
      p = function() {
        var Me;
        if (!(!v.state.isVisible || u)) {
          if (u = !0, k.offsetHeight, k.style.transition = v.props.moveTransition, L() && v.props.animation) {
            var je = W(), Rt = je.box, mt = je.content;
            Yi([Rt, mt], b), va([Rt, mt], "visible");
          }
          se(), P(), Lc(zi, v), (Me = v.popperInstance) == null || Me.forceUpdate(), pe("onMount", [v]), v.props.animation && L() && de(b, function() {
            v.state.isShown = !0, pe("onShown", [v]);
          });
        }
      }, Ie();
    }
  }
  function Dr() {
    var A = !v.state.isVisible, Z = v.state.isDestroyed, oe = !v.state.isEnabled, S = Bi(v.props.duration, 1, Vt.duration);
    if (!(A || Z || oe) && (pe("onHide", [v], !1), v.props.onHide(v) !== !1)) {
      if (v.state.isVisible = !1, v.state.isShown = !1, u = !1, o = !1, L() && (k.style.visibility = "hidden"), ae(), j(), Y(!0), L()) {
        var b = W(), M = b.box, F = b.content;
        v.props.animation && (Yi([M, F], S), va([M, F], "hidden"));
      }
      se(), P(), v.props.animation ? L() && te(S, v.unmount) : v.unmount();
    }
  }
  function Rn(A) {
    J().addEventListener("mousemove", m), Lc(Ia, m), m(A);
  }
  function qr() {
    v.state.isVisible && v.hide(), v.state.isMounted && (Et(), Ye().forEach(function(A) {
      A._tippy.unmount();
    }), k.parentNode && k.parentNode.removeChild(k), zi = zi.filter(function(A) {
      return A !== v;
    }), v.state.isMounted = !1, pe("onHidden", [v]));
  }
  function Kr() {
    v.state.isDestroyed || (v.clearDelayTimeouts(), v.unmount(), Oe(), delete e._tippy, v.state.isDestroyed = !0, pe("onDestroy", [v]));
  }
}
function re(e, t) {
  t === void 0 && (t = {});
  var r = Vt.plugins.concat(t.plugins || []);
  e4();
  var n = Object.assign({}, t, {
    plugins: r
  }), a = ZP(e), i = a.reduce(function(o, s) {
    var l = s && c4(s, n);
    return l && o.push(l), o;
  }, []);
  return Di(e) ? i[0] : i;
}
re.defaultProps = Vt;
re.setDefaultProps = o4;
re.currentInput = Ht;
var d4 = Object.assign({}, Wp, {
  effect: function(t) {
    var r = t.state, n = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow);
  }
}), f4 = function(t, r) {
  var n;
  r === void 0 && (r = {});
  var a = t, i = [], o = [], s, l = r.overrides, u = [], c = !1;
  function f() {
    o = a.map(function(v) {
      return Or(v.props.triggerTarget || v.reference);
    }).reduce(function(v, D) {
      return v.concat(D);
    }, []);
  }
  function p() {
    i = a.map(function(v) {
      return v.reference;
    });
  }
  function d(v) {
    a.forEach(function(D) {
      v ? D.enable() : D.disable();
    });
  }
  function m(v) {
    return a.map(function(D) {
      var k = D.setProps;
      return D.setProps = function(T) {
        k(T), D.reference === s && v.setProps(T);
      }, function() {
        D.setProps = k;
      };
    });
  }
  function g(v, D) {
    var k = o.indexOf(D);
    if (D !== s) {
      s = D;
      var T = (l || []).concat("content").reduce(function(C, V) {
        return C[V] = a[k].props[V], C;
      }, {});
      v.setProps(Object.assign({}, T, {
        getReferenceClientRect: typeof T.getReferenceClientRect == "function" ? T.getReferenceClientRect : function() {
          var C;
          return (C = i[k]) == null ? void 0 : C.getBoundingClientRect();
        }
      }));
    }
  }
  d(!1), p(), f();
  var h = {
    fn: function() {
      return {
        onDestroy: function() {
          d(!0);
        },
        onHidden: function() {
          s = null;
        },
        onClickOutside: function(k) {
          k.props.showOnCreate && !c && (c = !0, s = null);
        },
        onShow: function(k) {
          k.props.showOnCreate && !c && (c = !0, g(k, i[0]));
        },
        onTrigger: function(k, T) {
          g(k, T.currentTarget);
        }
      };
    }
  }, y = re(xr(), Object.assign({}, HP(r, ["overrides"]), {
    plugins: [h].concat(r.plugins || []),
    triggerTarget: o,
    popperOptions: Object.assign({}, r.popperOptions, {
      modifiers: [].concat(((n = r.popperOptions) == null ? void 0 : n.modifiers) || [], [d4])
    })
  })), _ = y.show;
  y.show = function(v) {
    if (_(), !s && v == null)
      return g(y, i[0]);
    if (!(s && v == null)) {
      if (typeof v == "number")
        return i[v] && g(y, i[v]);
      if (a.indexOf(v) >= 0) {
        var D = v.reference;
        return g(y, D);
      }
      if (i.indexOf(v) >= 0)
        return g(y, v);
    }
  }, y.showNext = function() {
    var v = i[0];
    if (!s)
      return y.show(0);
    var D = i.indexOf(s);
    y.show(i[D + 1] || v);
  }, y.showPrevious = function() {
    var v = i[i.length - 1];
    if (!s)
      return y.show(v);
    var D = i.indexOf(s), k = i[D - 1] || v;
    y.show(k);
  };
  var $ = y.setProps;
  return y.setProps = function(v) {
    l = v.overrides || l, $(v);
  }, y.setInstances = function(v) {
    d(!0), u.forEach(function(D) {
      return D();
    }), a = v, d(!1), p(), f(), u = m(y), y.setProps({
      triggerTarget: o
    });
  }, u = m(y), y;
}, p4 = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(t) {
    var r;
    if (!((r = t.props.render) != null && r.$$tippy))
      return {};
    var n = oi(t.popper), a = n.box, i = n.content, o = t.props.animateFill ? v4() : null;
    return {
      onCreate: function() {
        o && (a.insertBefore(o, a.firstElementChild), a.setAttribute("data-animatefill", ""), a.style.overflow = "hidden", t.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (o) {
          var l = a.style.transitionDuration, u = Number(l.replace("ms", ""));
          i.style.transitionDelay = Math.round(u / 10) + "ms", o.style.transitionDuration = l, va([o], "visible");
        }
      },
      onShow: function() {
        o && (o.style.transitionDuration = "0ms");
      },
      onHide: function() {
        o && va([o], "hidden");
      }
    };
  }
};
function v4() {
  var e = xr();
  return e.className = ev, va([e], "hidden"), e;
}
var Do = {
  clientX: 0,
  clientY: 0
}, Pa = [];
function cv(e) {
  var t = e.clientX, r = e.clientY;
  Do = {
    clientX: t,
    clientY: r
  };
}
function h4(e) {
  e.addEventListener("mousemove", cv);
}
function m4(e) {
  e.removeEventListener("mousemove", cv);
}
var g4 = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference, n = ov(t.props.triggerTarget || r), a = !1, i = !1, o = !0, s = t.props;
    function l() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function u() {
      n.addEventListener("mousemove", p);
    }
    function c() {
      n.removeEventListener("mousemove", p);
    }
    function f() {
      a = !0, t.setProps({
        getReferenceClientRect: null
      }), a = !1;
    }
    function p(g) {
      var h = g.target ? r.contains(g.target) : !0, y = t.props.followCursor, _ = g.clientX, $ = g.clientY, v = r.getBoundingClientRect(), D = _ - v.left, k = $ - v.top;
      (h || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var C = r.getBoundingClientRect(), V = _, H = $;
          y === "initial" && (V = C.left + D, H = C.top + k);
          var N = y === "horizontal" ? C.top : H, L = y === "vertical" ? C.right : V, U = y === "horizontal" ? C.bottom : H, J = y === "vertical" ? C.left : V;
          return {
            width: L - J,
            height: U - N,
            top: N,
            right: L,
            bottom: U,
            left: J
          };
        }
      });
    }
    function d() {
      t.props.followCursor && (Pa.push({
        instance: t,
        doc: n
      }), h4(n));
    }
    function m() {
      Pa = Pa.filter(function(g) {
        return g.instance !== t;
      }), Pa.filter(function(g) {
        return g.doc === n;
      }).length === 0 && m4(n);
    }
    return {
      onCreate: d,
      onDestroy: m,
      onBeforeUpdate: function() {
        s = t.props;
      },
      onAfterUpdate: function(h, y) {
        var _ = y.followCursor;
        a || _ !== void 0 && s.followCursor !== _ && (m(), _ ? (d(), t.state.isMounted && !i && !l() && u()) : (c(), f()));
      },
      onMount: function() {
        t.props.followCursor && !i && (o && (p(Do), o = !1), l() || u());
      },
      onTrigger: function(h, y) {
        Is(y) && (Do = {
          clientX: y.clientX,
          clientY: y.clientY
        }), i = y.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (f(), c(), o = !0);
      }
    };
  }
};
function y4(e, t) {
  var r;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((r = e.popperOptions) == null ? void 0 : r.modifiers) || []).filter(function(n) {
        var a = n.name;
        return a !== t.name;
      }), [t])
    })
  };
}
var b4 = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference;
    function n() {
      return !!t.props.inlinePositioning;
    }
    var a, i = -1, o = !1, s = [], l = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(d) {
        var m = d.state;
        n() && (s.indexOf(m.placement) !== -1 && (s = []), a !== m.placement && s.indexOf(m.placement) === -1 && (s.push(m.placement), t.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return u(m.placement);
          }
        })), a = m.placement);
      }
    };
    function u(p) {
      return _4(iv(p), r.getBoundingClientRect(), _n(r.getClientRects()), i);
    }
    function c(p) {
      o = !0, t.setProps(p), o = !1;
    }
    function f() {
      o || c(y4(t.props, l));
    }
    return {
      onCreate: f,
      onAfterUpdate: f,
      onTrigger: function(d, m) {
        if (Is(m)) {
          var g = _n(t.reference.getClientRects()), h = g.find(function(_) {
            return _.left - 2 <= m.clientX && _.right + 2 >= m.clientX && _.top - 2 <= m.clientY && _.bottom + 2 >= m.clientY;
          }), y = g.indexOf(h);
          i = y > -1 ? y : i;
        }
      },
      onHidden: function() {
        i = -1;
      }
    };
  }
};
function _4(e, t, r, n) {
  if (r.length < 2 || e === null)
    return t;
  if (r.length === 2 && n >= 0 && r[0].left > r[1].right)
    return r[n] || t;
  switch (e) {
    case "top":
    case "bottom": {
      var a = r[0], i = r[r.length - 1], o = e === "top", s = a.top, l = i.bottom, u = o ? a.left : i.left, c = o ? a.right : i.right, f = c - u, p = l - s;
      return {
        top: s,
        bottom: l,
        left: u,
        right: c,
        width: f,
        height: p
      };
    }
    case "left":
    case "right": {
      var d = Math.min.apply(Math, r.map(function(k) {
        return k.left;
      })), m = Math.max.apply(Math, r.map(function(k) {
        return k.right;
      })), g = r.filter(function(k) {
        return e === "left" ? k.left === d : k.right === m;
      }), h = g[0].top, y = g[g.length - 1].bottom, _ = d, $ = m, v = $ - _, D = y - h;
      return {
        top: h,
        bottom: y,
        left: _,
        right: $,
        width: v,
        height: D
      };
    }
    default:
      return t;
  }
}
var w4 = {
  name: "sticky",
  defaultValue: !1,
  fn: function(t) {
    var r = t.reference, n = t.popper;
    function a() {
      return t.popperInstance ? t.popperInstance.state.elements.reference : r;
    }
    function i(u) {
      return t.props.sticky === !0 || t.props.sticky === u;
    }
    var o = null, s = null;
    function l() {
      var u = i("reference") ? a().getBoundingClientRect() : null, c = i("popper") ? n.getBoundingClientRect() : null;
      (u && jc(o, u) || c && jc(s, c)) && t.popperInstance && t.popperInstance.update(), o = u, s = c, t.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        t.props.sticky && l();
      }
    };
  }
};
function jc(e, t) {
  return e && t ? e.top !== t.top || e.right !== t.right || e.bottom !== t.bottom || e.left !== t.left : !0;
}
re.setDefaultProps({
  render: uv
});
re.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
function dv(e, t = {}, r = { mount: !0, appName: "Tippy" }) {
  r = Object.assign({ mount: !0, appName: "Tippy" }, r);
  const n = Lr(), a = q(), i = q({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }), o = _v();
  let s = null;
  const l = () => s || (s = document.createDocumentFragment(), s), u = (T) => {
    let C, V = Xe(T) ? T.value : T;
    return wv(V) ? (o.value || (o.value = Ls({
      name: r.appName,
      setup: () => () => Xe(T) ? T.value : T
    }), n && Object.assign(o.value._context, n.appContext), o.value.mount(l())), C = () => l()) : typeof V == "object" ? (o.value || (o.value = Ls({
      name: r.appName,
      setup: () => () => Xr(Xe(T) ? T.value : T)
    }), n && Object.assign(o.value._context, n.appContext), o.value.mount(l())), C = () => l()) : C = V, C;
  }, c = (T) => {
    let C = {};
    return Xe(T) ? C = T.value || {} : xs(T) ? C = { ...T } : C = { ...T }, C.content && (C.content = u(C.content)), C.triggerTarget && (C.triggerTarget = Xe(C.triggerTarget) ? C.triggerTarget.value : C.triggerTarget), (!C.plugins || !Array.isArray(C.plugins)) && (C.plugins = []), C.plugins = C.plugins.filter((V) => V.name !== "vueTippyReactiveState"), C.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          i.value.isEnabled = !0;
        },
        onMount() {
          i.value.isMounted = !0;
        },
        onShow() {
          i.value.isMounted = !0, i.value.isVisible = !0;
        },
        onShown() {
          i.value.isShown = !0;
        },
        onHide() {
          i.value.isMounted = !1, i.value.isVisible = !1;
        },
        onHidden() {
          i.value.isShown = !1;
        },
        onUnmounted() {
          i.value.isMounted = !1;
        },
        onDestroy() {
          i.value.isDestroyed = !0;
        }
      })
    }), C;
  }, f = () => {
    a.value && a.value.setProps(c(t));
  }, p = () => {
    !a.value || !t.content || a.value.setContent(u(t.content));
  }, d = (T) => {
    var C;
    (C = a.value) === null || C === void 0 || C.setContent(u(T));
  }, m = (T) => {
    var C;
    (C = a.value) === null || C === void 0 || C.setProps(c(T));
  }, g = () => {
    var T;
    a.value && (a.value.destroy(), a.value = void 0), s = null, (T = o.value) === null || T === void 0 || T.unmount(), o.value = void 0;
  }, h = () => {
    var T;
    (T = a.value) === null || T === void 0 || T.show();
  }, y = () => {
    var T;
    (T = a.value) === null || T === void 0 || T.hide();
  }, _ = () => {
    var T;
    (T = a.value) === null || T === void 0 || T.disable(), i.value.isEnabled = !1;
  }, $ = () => {
    var T;
    (T = a.value) === null || T === void 0 || T.enable(), i.value.isEnabled = !0;
  }, v = () => {
    var T;
    (T = a.value) === null || T === void 0 || T.unmount();
  }, D = () => {
    if (!e)
      return;
    let T = Xe(e) ? e.value : e;
    typeof T == "function" && (T = T()), T && (a.value = re(T, c(t)), T.$tippy = k);
  }, k = {
    tippy: a,
    refresh: f,
    refreshContent: p,
    setContent: d,
    setProps: m,
    destroy: g,
    hide: y,
    show: h,
    disable: _,
    enable: $,
    unmount: v,
    mount: D,
    state: i
  };
  return r.mount && (n ? n.isMounted ? D() : It(D) : D()), n && Nr(() => {
    g();
  }), Xe(t) || xs(t) ? be(t, f, { immediate: !1 }) : Xe(t.content) && be(t.content, p, { immediate: !1 }), k;
}
function E4(e, t) {
  const r = q();
  return It(() => {
    const a = (Array.isArray(e) ? e.map((i) => i.value) : typeof e == "function" ? e() : e.value).map((i) => i instanceof Element ? i._tippy : i).filter(Boolean);
    r.value = f4(a, t ? { allowHTML: !0, ...t } : { allowHTML: !0 });
  }), {
    singleton: r
  };
}
function T4(e) {
  return typeof e == "function" ? e() : w(e);
}
function D4(e) {
  var t, r;
  const n = T4(e);
  return (r = (t = n) === null || t === void 0 ? void 0 : t.$el) !== null && r !== void 0 ? r : n;
}
const $4 = ue({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => re.defaultProps.appendTo },
    aria: { default: () => re.defaultProps.aria },
    delay: { default: () => re.defaultProps.delay },
    duration: { default: () => re.defaultProps.duration },
    getReferenceClientRect: { default: () => re.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => re.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => re.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => re.defaultProps.interactive },
    interactiveBorder: { default: () => re.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => re.defaultProps.interactiveDebounce },
    moveTransition: { default: () => re.defaultProps.moveTransition },
    offset: { default: () => re.defaultProps.offset },
    onAfterUpdate: { default: () => re.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => re.defaultProps.onBeforeUpdate },
    onCreate: { default: () => re.defaultProps.onCreate },
    onDestroy: { default: () => re.defaultProps.onDestroy },
    onHidden: { default: () => re.defaultProps.onHidden },
    onHide: { default: () => re.defaultProps.onHide },
    onMount: { default: () => re.defaultProps.onMount },
    onShow: { default: () => re.defaultProps.onShow },
    onShown: { default: () => re.defaultProps.onShown },
    onTrigger: { default: () => re.defaultProps.onTrigger },
    onUntrigger: { default: () => re.defaultProps.onUntrigger },
    onClickOutside: { default: () => re.defaultProps.onClickOutside },
    placement: { default: () => re.defaultProps.placement },
    plugins: { default: () => re.defaultProps.plugins },
    popperOptions: { default: () => re.defaultProps.popperOptions },
    render: { default: () => re.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => re.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => re.defaultProps.touch },
    trigger: { default: () => re.defaultProps.trigger },
    triggerTarget: { default: () => re.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => re.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => re.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => re.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => re.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => re.defaultProps.allowHTML },
    animation: { default: () => re.defaultProps.animation },
    arrow: { default: () => re.defaultProps.arrow },
    content: { default: () => re.defaultProps.content },
    inertia: { default: () => re.defaultProps.inertia },
    maxWidth: { default: () => re.defaultProps.maxWidth },
    role: { default: () => re.defaultProps.role },
    theme: { default: () => re.defaultProps.theme },
    zIndex: { default: () => re.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: t, emit: r, expose: n }) {
    const a = q(), i = q(), o = q(), s = q(!1), l = () => {
      let d = { ...e };
      for (const m of ["to", "tag", "contentTag", "contentClass"])
        d.hasOwnProperty(m) && delete d[m];
      return d;
    };
    let u = () => D4(a);
    e.to && (typeof Element < "u" && e.to instanceof Element ? u = () => e.to : e.to === "parent" ? u = () => {
      let d = a.value;
      return d || (d = a.value = i.value.parentElement), d;
    } : (typeof e.to == "string" || e.to instanceof String) && (u = () => document.querySelector(e.to)));
    const c = dv(u, l());
    let f = t.content;
    !f && e.to === "parent" && (f = t.default), It(() => {
      s.value = !0, mr(() => {
        f && c.setContent(() => o.value);
      });
    }), be(c.state, () => {
      r("state", w(c.state));
    }, { immediate: !0, deep: !0 }), be(() => e, () => {
      c.setProps(l()), f && c.setContent(() => o.value);
    }, { deep: !0 });
    let p = Tn({
      elem: a,
      contentElem: o,
      mounted: s,
      ...c
    });
    return n(p), () => {
      const d = (typeof e.contentTag == "string", e.contentTag), m = f ? Xr(d, {
        ref: o,
        style: { display: s.value ? "inherit" : "none" },
        class: e.contentClass
      }, f(p)) : null;
      if (e.to === "parent") {
        const y = [];
        if (!a.value) {
          const _ = Xr("span", {
            ref: i,
            "data-v-tippy": "",
            style: { display: "none" }
          });
          y.push(_);
        }
        return m && y.push(m), y;
      }
      const g = t.default ? t.default(p) : [];
      if (!e.tag) {
        const y = Xr(g[0], {
          ref: a,
          "data-v-tippy": ""
        });
        return m ? [y, m] : y;
      }
      const h = (typeof e.tag == "string", e.tag);
      return Xr(h, { ref: a, "data-v-tippy": "" }, m ? [g, m] : g);
    };
  }
}), k4 = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let $o = {};
Object.keys(re.defaultProps).forEach((e) => {
  k4.includes(e) ? $o[e] = {
    type: Boolean,
    default: function() {
      return re.defaultProps[e];
    }
  } : $o[e] = {
    default: function() {
      return re.defaultProps[e];
    }
  };
});
const O4 = ue({
  props: $o,
  setup(e) {
    const t = q([]), { singleton: r } = E4(t, e);
    return { instances: t, singleton: r };
  },
  mounted() {
    var e;
    const r = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(r).map((n) => n._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return Xr(() => e);
  }
}), C4 = {
  mounted(e, t, r) {
    const n = typeof t.value == "string" ? { content: t.value } : t.value || {}, a = Object.keys(t.modifiers || {}), i = a.find((s) => s !== "arrow"), o = a.findIndex((s) => s === "arrow") !== -1;
    i && (n.placement = n.placement || i), o && (n.arrow = n.arrow !== void 0 ? n.arrow : !0), r.props && r.props.onTippyShow && (n.onShow = function(...s) {
      var l;
      return (l = r.props) === null || l === void 0 ? void 0 : l.onTippyShow(...s);
    }), r.props && r.props.onTippyShown && (n.onShown = function(...s) {
      var l;
      return (l = r.props) === null || l === void 0 ? void 0 : l.onTippyShown(...s);
    }), r.props && r.props.onTippyHidden && (n.onHidden = function(...s) {
      var l;
      return (l = r.props) === null || l === void 0 ? void 0 : l.onTippyHidden(...s);
    }), r.props && r.props.onTippyHide && (n.onHide = function(...s) {
      var l;
      return (l = r.props) === null || l === void 0 ? void 0 : l.onTippyHide(...s);
    }), r.props && r.props.onTippyMount && (n.onMount = function(...s) {
      var l;
      return (l = r.props) === null || l === void 0 ? void 0 : l.onTippyMount(...s);
    }), e.getAttribute("title") && !n.content && (n.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !n.content && (n.content = e.getAttribute("content")), dv(e, n);
  },
  unmounted(e) {
    e.$tippy ? e.$tippy.destroy() : e._tippy && e._tippy.destroy();
  },
  updated(e, t) {
    const r = typeof t.value == "string" ? { content: t.value } : t.value || {};
    e.getAttribute("title") && !r.content && (r.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !r.content && (r.content = e.getAttribute("content")), e.$tippy ? e.$tippy.setProps(r || {}) : e._tippy && e._tippy.setProps(r || {});
  }
}, S4 = {
  install(e, t = {}) {
    re.setDefaultProps(t.defaultProps || {}), e.directive(t.directive || "tippy", C4), e.component(t.component || "tippy", $4), e.component(t.componentSingleton || "tippy-singleton", O4);
  }
}, A4 = re.setDefaultProps;
A4({
  ignoreAttributes: !0,
  plugins: [w4, b4, g4, p4]
});
const M4 = S4;
const Q4 = {
  xxs: {
    max: 419
  },
  xs: {
    min: 420,
    max: 559
  },
  sm: {
    min: 560,
    max: 767
  },
  md: {
    min: 768,
    max: 1023
  },
  lg: {
    min: 1024,
    max: 1199
  },
  xl: {
    min: 1200,
    max: 1439
  },
  xxl: {
    min: 1440
  }
}, I4 = (e) => {
  for (const t in Dc)
    e.component(t, Dc[t]);
  e.use(M4, {
    defaultProps: { theme: "light-border", allowHTML: !0 }
  });
}, ex = { install: I4 };
export {
  Ds as CheckboxInput,
  Np as CheckboxInputList,
  Pv as CjaButton,
  ah as CollapseContainer,
  Yv as ContentTabs,
  OI as CurrencyInput,
  _3 as DateInput,
  Cv as Drawer,
  sI as FileInput,
  oh as FixedContainer,
  Qv as GridContainer,
  th as GridItem,
  qv as InfoMessage,
  Ge as InputError,
  Pt as InputTitle,
  Lv as LoadingSpinner,
  kv as Modal,
  pI as NumberInput,
  N3 as PhoneInput,
  jp as RadioInput,
  H3 as RadioInputList,
  si as Scaffold,
  Bp as SelectInput,
  VI as SelectionTiles,
  TI as SliderInput,
  fm as StickyContainer,
  uf as TextInput,
  $y as TextareaInput,
  J3 as TileCheckboxInput,
  gI as ToggleInput,
  J4 as applyProductData,
  X4 as buildFunnelStructure,
  L4 as convertDate,
  ex as default,
  zs as findScrollAncestor,
  x4 as formValidation,
  q4 as formatCurrency,
  G4 as formatDateString,
  K4 as formatPercent,
  Z4 as formatPositiveNumber,
  V4 as getCalendarUrl,
  H4 as getCjaRouter,
  W4 as getCjaStore,
  Y4 as getFromUrl,
  F4 as jsonReviver,
  Q4 as mediaBreakpoints,
  j4 as removeFromUrl,
  Wc as toggleScroll,
  N4 as updateForm,
  B4 as updateMarketingConsent,
  z4 as uploadFile,
  U4 as useCjaGtm,
  cm as useHeaderHeight,
  R4 as useValidateForm
};
